/* tslint:disable */
/* eslint-disable */
/**
 * Pulse Food API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import axios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBearerAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { QFood, BASE_PATH } from './base';
const axiosInstance = axios.create({
    baseURL: QFood.BASE_URL,
    withCredentials: true,
    headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
    },
});
const getToken = () => localStorage.getItem("qfood-api-token") || "";
const setToken = (token) => localStorage.setItem("qfood-api-token", token);
const globalAxios = axiosInstance;
export { setToken, getToken, globalAxios };
export const AbstractLabelTemplateModuleEnum = {
    Core: 'CORE',
    Finance: 'FINANCE',
    Production: 'PRODUCTION',
    Purchasing: 'PURCHASING',
    Sales: 'SALES',
    Stock: 'STOCK',
    Income: 'INCOME',
    Outcome: 'OUTCOME'
};
export const AbstractLabelTemplateTypeEnum = {
    SalesOrderConfirmationWithoutPrices: 'SALES_ORDER_CONFIRMATION_WITHOUT_PRICES',
    SalesOrderConfirmation: 'SALES_ORDER_CONFIRMATION',
    SalesInvoice: 'SALES_INVOICE',
    SalesPackingSlip: 'SALES_PACKING_SLIP',
    SalesDeliveryReceiptWithoutPrices: 'SALES_DELIVERY_RECEIPT_WITHOUT_PRICES',
    SalesDeliveryReceipt: 'SALES_DELIVERY_RECEIPT',
    SalesTransportDocument: 'SALES_TRANSPORT_DOCUMENT',
    SalesOrderPalletLabel: 'SALES_ORDER_PALLET_LABEL',
    SalesBoxLabel: 'SALES_BOX_LABEL',
    SalesWeightLabel: 'SALES_WEIGHT_LABEL',
    SalesList: 'SALES_LIST',
    SalesOther: 'SALES_OTHER',
    PriceList: 'PRICE_LIST',
    StockBoxLabel: 'STOCK_BOX_LABEL',
    StockDocument: 'STOCK_DOCUMENT',
    StockList: 'STOCK_LIST',
    PurchasingOrderConfirmation: 'PURCHASING_ORDER_CONFIRMATION',
    PurchasingIncomingLotDocument: 'PURCHASING_INCOMING_LOT_DOCUMENT',
    PurchasingUnloadDocument: 'PURCHASING_UNLOAD_DOCUMENT',
    PurchasingList: 'PURCHASING_LIST',
    PurchasingOther: 'PURCHASING_OTHER',
    ProductionBoxLabel: 'PRODUCTION_BOX_LABEL',
    ProductionOrderConfirmation: 'PRODUCTION_ORDER_CONFIRMATION',
    ProductionList: 'PRODUCTION_LIST',
    ProductionOther: 'PRODUCTION_OTHER'
};
export const ActionTypeEnum = {
    Delete: 'DELETE',
    None: 'NONE'
};
export const BartenderLabelTemplateTypeEnum = {
    SalesOrderConfirmationWithoutPrices: 'SALES_ORDER_CONFIRMATION_WITHOUT_PRICES',
    SalesOrderConfirmation: 'SALES_ORDER_CONFIRMATION',
    SalesInvoice: 'SALES_INVOICE',
    SalesPackingSlip: 'SALES_PACKING_SLIP',
    SalesDeliveryReceiptWithoutPrices: 'SALES_DELIVERY_RECEIPT_WITHOUT_PRICES',
    SalesDeliveryReceipt: 'SALES_DELIVERY_RECEIPT',
    SalesTransportDocument: 'SALES_TRANSPORT_DOCUMENT',
    SalesOrderPalletLabel: 'SALES_ORDER_PALLET_LABEL',
    SalesBoxLabel: 'SALES_BOX_LABEL',
    SalesWeightLabel: 'SALES_WEIGHT_LABEL',
    SalesList: 'SALES_LIST',
    SalesOther: 'SALES_OTHER',
    PriceList: 'PRICE_LIST',
    StockBoxLabel: 'STOCK_BOX_LABEL',
    StockDocument: 'STOCK_DOCUMENT',
    StockList: 'STOCK_LIST',
    PurchasingOrderConfirmation: 'PURCHASING_ORDER_CONFIRMATION',
    PurchasingIncomingLotDocument: 'PURCHASING_INCOMING_LOT_DOCUMENT',
    PurchasingUnloadDocument: 'PURCHASING_UNLOAD_DOCUMENT',
    PurchasingList: 'PURCHASING_LIST',
    PurchasingOther: 'PURCHASING_OTHER',
    ProductionBoxLabel: 'PRODUCTION_BOX_LABEL',
    ProductionOrderConfirmation: 'PRODUCTION_ORDER_CONFIRMATION',
    ProductionList: 'PRODUCTION_LIST',
    ProductionOther: 'PRODUCTION_OTHER'
};
export const ChartDataRequestTypeEnum = {
    Latency: 'LATENCY',
    Stats: 'STATS'
};
export const ChartDataRequestAggregationTypeEnum = {
    Daily: 'DAILY',
    Weekly: 'WEEKLY',
    Monthly: 'MONTHLY'
};
export const ChartDataRequestDateTypesEnum = {
    Successful: 'SUCCESSFUL',
    Discarded: 'DISCARDED',
    MovedToDlq: 'MOVED_TO_DLQ',
    Retried: 'RETRIED',
    Execution: 'EXECUTION'
};
export const CompanyDefaultStockStorageTypeEnum = {
    PerKg: 'PER_KG',
    PerLot: 'PER_LOT'
};
export const CompanyReportPreferenceDataCategoryEnum = {
    SalesOrderConfirmationWithoutPrices: 'SALES_ORDER_CONFIRMATION_WITHOUT_PRICES',
    SalesOrderConfirmation: 'SALES_ORDER_CONFIRMATION',
    SalesInvoice: 'SALES_INVOICE',
    SalesPackingSlip: 'SALES_PACKING_SLIP',
    SalesDeliveryReceiptWithoutPrices: 'SALES_DELIVERY_RECEIPT_WITHOUT_PRICES',
    SalesDeliveryReceipt: 'SALES_DELIVERY_RECEIPT',
    SalesTransportDocument: 'SALES_TRANSPORT_DOCUMENT',
    SalesOrderPalletLabel: 'SALES_ORDER_PALLET_LABEL',
    SalesBoxLabel: 'SALES_BOX_LABEL',
    SalesWeightLabel: 'SALES_WEIGHT_LABEL',
    SalesList: 'SALES_LIST',
    SalesOther: 'SALES_OTHER',
    PriceList: 'PRICE_LIST',
    StockBoxLabel: 'STOCK_BOX_LABEL',
    StockDocument: 'STOCK_DOCUMENT',
    StockList: 'STOCK_LIST',
    PurchasingOrderConfirmation: 'PURCHASING_ORDER_CONFIRMATION',
    PurchasingIncomingLotDocument: 'PURCHASING_INCOMING_LOT_DOCUMENT',
    PurchasingUnloadDocument: 'PURCHASING_UNLOAD_DOCUMENT',
    PurchasingList: 'PURCHASING_LIST',
    PurchasingOther: 'PURCHASING_OTHER',
    ProductionBoxLabel: 'PRODUCTION_BOX_LABEL',
    ProductionOrderConfirmation: 'PRODUCTION_ORDER_CONFIRMATION',
    ProductionList: 'PRODUCTION_LIST',
    ProductionOther: 'PRODUCTION_OTHER'
};
export const ConnectWeightsToLotsDataModeEnum = {
    Inclusive: 'INCLUSIVE',
    Exclusive: 'EXCLUSIVE'
};
export const CostTypeModulesEnum = {
    Core: 'CORE',
    Finance: 'FINANCE',
    Production: 'PRODUCTION',
    Purchasing: 'PURCHASING',
    Sales: 'SALES',
    Stock: 'STOCK',
    Income: 'INCOME',
    Outcome: 'OUTCOME'
};
export const CostTypeCategoryEnum = {
    TransportCostType: 'TRANSPORT_COST_TYPE',
    FobCostType: 'FOB_COST_TYPE',
    OtherCostType: 'OTHER_COST_TYPE',
    SeaFreightCostType: 'SEA_FREIGHT_COST_TYPE'
};
export const CreateAddressDataTypesEnum = {
    Postal: 'POSTAL',
    Invoice: 'INVOICE',
    Delivery: 'DELIVERY'
};
export const CreateBartenderDocumentDataModuleEnum = {
    Core: 'CORE',
    Finance: 'FINANCE',
    Production: 'PRODUCTION',
    Purchasing: 'PURCHASING',
    Sales: 'SALES',
    Stock: 'STOCK',
    Income: 'INCOME',
    Outcome: 'OUTCOME'
};
export const CreateBartenderDocumentDataTypeEnum = {
    SalesOrderConfirmationWithoutPrices: 'SALES_ORDER_CONFIRMATION_WITHOUT_PRICES',
    SalesOrderConfirmation: 'SALES_ORDER_CONFIRMATION',
    SalesInvoice: 'SALES_INVOICE',
    SalesPackingSlip: 'SALES_PACKING_SLIP',
    SalesDeliveryReceiptWithoutPrices: 'SALES_DELIVERY_RECEIPT_WITHOUT_PRICES',
    SalesDeliveryReceipt: 'SALES_DELIVERY_RECEIPT',
    SalesTransportDocument: 'SALES_TRANSPORT_DOCUMENT',
    SalesOrderPalletLabel: 'SALES_ORDER_PALLET_LABEL',
    SalesBoxLabel: 'SALES_BOX_LABEL',
    SalesWeightLabel: 'SALES_WEIGHT_LABEL',
    SalesList: 'SALES_LIST',
    SalesOther: 'SALES_OTHER',
    PriceList: 'PRICE_LIST',
    StockBoxLabel: 'STOCK_BOX_LABEL',
    StockDocument: 'STOCK_DOCUMENT',
    StockList: 'STOCK_LIST',
    PurchasingOrderConfirmation: 'PURCHASING_ORDER_CONFIRMATION',
    PurchasingIncomingLotDocument: 'PURCHASING_INCOMING_LOT_DOCUMENT',
    PurchasingUnloadDocument: 'PURCHASING_UNLOAD_DOCUMENT',
    PurchasingList: 'PURCHASING_LIST',
    PurchasingOther: 'PURCHASING_OTHER',
    ProductionBoxLabel: 'PRODUCTION_BOX_LABEL',
    ProductionOrderConfirmation: 'PRODUCTION_ORDER_CONFIRMATION',
    ProductionList: 'PRODUCTION_LIST',
    ProductionOther: 'PRODUCTION_OTHER'
};
export const CreateCompanyDataDefaultStockStorageTypeEnum = {
    PerKg: 'PER_KG',
    PerLot: 'PER_LOT'
};
export const CreateCostTypeDataCategoryEnum = {
    TransportCostType: 'TRANSPORT_COST_TYPE',
    FobCostType: 'FOB_COST_TYPE',
    OtherCostType: 'OTHER_COST_TYPE',
    SeaFreightCostType: 'SEA_FREIGHT_COST_TYPE'
};
export const CreateCostTypeDataModulesEnum = {
    Core: 'CORE',
    Finance: 'FINANCE',
    Production: 'PRODUCTION',
    Purchasing: 'PURCHASING',
    Sales: 'SALES',
    Stock: 'STOCK',
    Income: 'INCOME',
    Outcome: 'OUTCOME'
};
export const CreateEmailAccountDataTypeEnum = {
    Generic: 'GENERIC',
    Microsoft: 'MICROSOFT'
};
export const CreateExchangeRateDataTypeEnum = {
    Sales: 'SALES',
    Purchasing: 'PURCHASING'
};
export const CreateNetworkScaleDataProtocolEnum = {
    ScanvaegtCso: 'SCANVAEGT_CSO',
    ScanvaegtSv3: 'SCANVAEGT_SV3',
    OhausRs232: 'OHAUS_RS232'
};
export const CreateNextNumberSerieDataTypeEnum = {
    Sales: 'SALES',
    Invoice: 'INVOICE',
    Purchase: 'PURCHASE',
    Production: 'PRODUCTION',
    LotWeight: 'LOT_WEIGHT'
};
export const CreateNotificationDataTypeEnum = {
    Error: 'ERROR',
    Warning: 'WARNING',
    Info: 'INFO',
    Success: 'SUCCESS'
};
export const CreateOrUpdateEmailTemplateDataModuleEnum = {
    Core: 'CORE',
    Finance: 'FINANCE',
    Production: 'PRODUCTION',
    Purchasing: 'PURCHASING',
    Sales: 'SALES',
    Stock: 'STOCK',
    Income: 'INCOME',
    Outcome: 'OUTCOME'
};
export const CreateOrUpdateEmailTemplateDataRecipientsEnum = {
    Customer: 'CUSTOMER',
    Supplier: 'SUPPLIER',
    Agent: 'AGENT',
    Transporter: 'TRANSPORTER',
    Producer: 'PRODUCER',
    Owner: 'OWNER',
    Company: 'COMPANY'
};
export const CreateOrUpdateEmailTemplateDataCategoriesEnum = {
    SalesOrderConfirmationWithoutPrices: 'SALES_ORDER_CONFIRMATION_WITHOUT_PRICES',
    SalesOrderConfirmation: 'SALES_ORDER_CONFIRMATION',
    SalesInvoice: 'SALES_INVOICE',
    SalesPackingSlip: 'SALES_PACKING_SLIP',
    SalesDeliveryReceiptWithoutPrices: 'SALES_DELIVERY_RECEIPT_WITHOUT_PRICES',
    SalesDeliveryReceipt: 'SALES_DELIVERY_RECEIPT',
    SalesTransportDocument: 'SALES_TRANSPORT_DOCUMENT',
    SalesOrderPalletLabel: 'SALES_ORDER_PALLET_LABEL',
    SalesBoxLabel: 'SALES_BOX_LABEL',
    SalesWeightLabel: 'SALES_WEIGHT_LABEL',
    SalesList: 'SALES_LIST',
    SalesOther: 'SALES_OTHER',
    PriceList: 'PRICE_LIST',
    StockBoxLabel: 'STOCK_BOX_LABEL',
    StockDocument: 'STOCK_DOCUMENT',
    StockList: 'STOCK_LIST',
    PurchasingOrderConfirmation: 'PURCHASING_ORDER_CONFIRMATION',
    PurchasingIncomingLotDocument: 'PURCHASING_INCOMING_LOT_DOCUMENT',
    PurchasingUnloadDocument: 'PURCHASING_UNLOAD_DOCUMENT',
    PurchasingList: 'PURCHASING_LIST',
    PurchasingOther: 'PURCHASING_OTHER',
    ProductionBoxLabel: 'PRODUCTION_BOX_LABEL',
    ProductionOrderConfirmation: 'PRODUCTION_ORDER_CONFIRMATION',
    ProductionList: 'PRODUCTION_LIST',
    ProductionOther: 'PRODUCTION_OTHER'
};
export const CreateOrUpdateReservationDataStatusEnum = {
    Open: 'OPEN',
    Processed: 'PROCESSED'
};
export const CreateOrUpdateSerialPortScaleDataParityEnum = {
    Odd: 'ODD',
    Even: 'EVEN',
    None: 'NONE',
    Space: 'SPACE',
    Mark: 'MARK'
};
export const CreateOrUpdateSerialPortScaleDataProtocolEnum = {
    ScanvaegtCso: 'SCANVAEGT_CSO',
    ScanvaegtSv3: 'SCANVAEGT_SV3',
    OhausRs232: 'OHAUS_RS232'
};
export const CreateOrUpdateSerialPortScannerDataParityEnum = {
    Odd: 'ODD',
    Even: 'EVEN',
    None: 'NONE',
    Space: 'SPACE',
    Mark: 'MARK'
};
export const CreateProductCategoryDataVatTypeEnum = {
    Low: 'LOW',
    High: 'HIGH',
    None: 'NONE'
};
export const CreateProductDataStorageTypeEnum = {
    Fresh: 'FRESH',
    Frozen: 'FROZEN'
};
export const CreateProductDataVatTypeEnum = {
    Low: 'LOW',
    High: 'HIGH',
    None: 'NONE'
};
export const CreateProductionOrderTemplateDataTypeEnum = {
    PerLot: 'PER_LOT',
    PerPackaging: 'PER_PACKAGING'
};
export const CreateProductionStepCostTemplateDataPricePerEnum = {
    Kilograms: 'KILOGRAMS',
    Packages: 'PACKAGES',
    Units: 'UNITS'
};
export const CreateProductionStepTemplateDataCostTypeEnum = {
    StartWeight: 'START_WEIGHT',
    EndWeight: 'END_WEIGHT'
};
export const CreatePurchaseOrderDataStatusEnum = {
    Concept: 'CONCEPT',
    Open: 'OPEN',
    InProcess: 'IN_PROCESS',
    Closed: 'CLOSED',
    SyncingWithAccountingSoftware: 'SYNCING_WITH_ACCOUNTING_SOFTWARE',
    Synced: 'SYNCED'
};
export const CreatePurchaseOrderRowDataPricePerEnum = {
    Kilograms: 'KILOGRAMS',
    Packages: 'PACKAGES',
    Units: 'UNITS'
};
export const CreatePurchaseOrderRowDataStatusEnum = {
    Concept: 'CONCEPT',
    Open: 'OPEN',
    InProcess: 'IN_PROCESS',
    Closed: 'CLOSED'
};
export const CreatePurchaseOrderRowTemplateDataPricePerEnum = {
    Kilograms: 'KILOGRAMS',
    Packages: 'PACKAGES',
    Units: 'UNITS'
};
export const CreatePurchaseOrderRowTemplateDataStatusEnum = {
    Concept: 'CONCEPT',
    Open: 'OPEN',
    InProcess: 'IN_PROCESS',
    Closed: 'CLOSED'
};
export const CreatePurchaseOrderTemplateDataStatusEnum = {
    Concept: 'CONCEPT',
    Open: 'OPEN',
    InProcess: 'IN_PROCESS',
    Closed: 'CLOSED',
    SyncingWithAccountingSoftware: 'SYNCING_WITH_ACCOUNTING_SOFTWARE',
    Synced: 'SYNCED'
};
export const CreateRelationDataTypesEnum = {
    Customer: 'CUSTOMER',
    Supplier: 'SUPPLIER',
    Agent: 'AGENT',
    Transporter: 'TRANSPORTER',
    Producer: 'PRODUCER',
    Owner: 'OWNER',
    Company: 'COMPANY'
};
export const CreateRelationDataDefaultStockStorageTypeEnum = {
    PerKg: 'PER_KG',
    PerLot: 'PER_LOT'
};
export const CreateRelationDataSalesReportsToPrintEnum = {
    SalesOrderConfirmationWithoutPrices: 'SALES_ORDER_CONFIRMATION_WITHOUT_PRICES',
    SalesOrderConfirmation: 'SALES_ORDER_CONFIRMATION',
    SalesInvoice: 'SALES_INVOICE',
    SalesPackingSlip: 'SALES_PACKING_SLIP',
    SalesDeliveryReceiptWithoutPrices: 'SALES_DELIVERY_RECEIPT_WITHOUT_PRICES',
    SalesDeliveryReceipt: 'SALES_DELIVERY_RECEIPT',
    SalesTransportDocument: 'SALES_TRANSPORT_DOCUMENT',
    SalesOrderPalletLabel: 'SALES_ORDER_PALLET_LABEL',
    SalesBoxLabel: 'SALES_BOX_LABEL',
    SalesWeightLabel: 'SALES_WEIGHT_LABEL',
    SalesList: 'SALES_LIST',
    SalesOther: 'SALES_OTHER',
    PriceList: 'PRICE_LIST',
    StockBoxLabel: 'STOCK_BOX_LABEL',
    StockDocument: 'STOCK_DOCUMENT',
    StockList: 'STOCK_LIST',
    PurchasingOrderConfirmation: 'PURCHASING_ORDER_CONFIRMATION',
    PurchasingIncomingLotDocument: 'PURCHASING_INCOMING_LOT_DOCUMENT',
    PurchasingUnloadDocument: 'PURCHASING_UNLOAD_DOCUMENT',
    PurchasingList: 'PURCHASING_LIST',
    PurchasingOther: 'PURCHASING_OTHER',
    ProductionBoxLabel: 'PRODUCTION_BOX_LABEL',
    ProductionOrderConfirmation: 'PRODUCTION_ORDER_CONFIRMATION',
    ProductionList: 'PRODUCTION_LIST',
    ProductionOther: 'PRODUCTION_OTHER'
};
export const CreateReportDesignDataModuleEnum = {
    Core: 'CORE',
    Finance: 'FINANCE',
    Production: 'PRODUCTION',
    Purchasing: 'PURCHASING',
    Sales: 'SALES',
    Stock: 'STOCK',
    Income: 'INCOME',
    Outcome: 'OUTCOME'
};
export const CreateReportDesignDataDefaultFormatEnum = {
    Csv: 'CSV',
    Excel: 'EXCEL',
    Pdf: 'PDF',
    Png: 'PNG'
};
export const CreateReportDesignDataCategoryEnum = {
    SalesOrderConfirmationWithoutPrices: 'SALES_ORDER_CONFIRMATION_WITHOUT_PRICES',
    SalesOrderConfirmation: 'SALES_ORDER_CONFIRMATION',
    SalesInvoice: 'SALES_INVOICE',
    SalesPackingSlip: 'SALES_PACKING_SLIP',
    SalesDeliveryReceiptWithoutPrices: 'SALES_DELIVERY_RECEIPT_WITHOUT_PRICES',
    SalesDeliveryReceipt: 'SALES_DELIVERY_RECEIPT',
    SalesTransportDocument: 'SALES_TRANSPORT_DOCUMENT',
    SalesOrderPalletLabel: 'SALES_ORDER_PALLET_LABEL',
    SalesBoxLabel: 'SALES_BOX_LABEL',
    SalesWeightLabel: 'SALES_WEIGHT_LABEL',
    SalesList: 'SALES_LIST',
    SalesOther: 'SALES_OTHER',
    PriceList: 'PRICE_LIST',
    StockBoxLabel: 'STOCK_BOX_LABEL',
    StockDocument: 'STOCK_DOCUMENT',
    StockList: 'STOCK_LIST',
    PurchasingOrderConfirmation: 'PURCHASING_ORDER_CONFIRMATION',
    PurchasingIncomingLotDocument: 'PURCHASING_INCOMING_LOT_DOCUMENT',
    PurchasingUnloadDocument: 'PURCHASING_UNLOAD_DOCUMENT',
    PurchasingList: 'PURCHASING_LIST',
    PurchasingOther: 'PURCHASING_OTHER',
    ProductionBoxLabel: 'PRODUCTION_BOX_LABEL',
    ProductionOrderConfirmation: 'PRODUCTION_ORDER_CONFIRMATION',
    ProductionList: 'PRODUCTION_LIST',
    ProductionOther: 'PRODUCTION_OTHER'
};
export const CreateReportDesignDocumentDataModuleEnum = {
    Core: 'CORE',
    Finance: 'FINANCE',
    Production: 'PRODUCTION',
    Purchasing: 'PURCHASING',
    Sales: 'SALES',
    Stock: 'STOCK',
    Income: 'INCOME',
    Outcome: 'OUTCOME'
};
export const CreateReportDesignDocumentDataTypeEnum = {
    SalesOrderConfirmationWithoutPrices: 'SALES_ORDER_CONFIRMATION_WITHOUT_PRICES',
    SalesOrderConfirmation: 'SALES_ORDER_CONFIRMATION',
    SalesInvoice: 'SALES_INVOICE',
    SalesPackingSlip: 'SALES_PACKING_SLIP',
    SalesDeliveryReceiptWithoutPrices: 'SALES_DELIVERY_RECEIPT_WITHOUT_PRICES',
    SalesDeliveryReceipt: 'SALES_DELIVERY_RECEIPT',
    SalesTransportDocument: 'SALES_TRANSPORT_DOCUMENT',
    SalesOrderPalletLabel: 'SALES_ORDER_PALLET_LABEL',
    SalesBoxLabel: 'SALES_BOX_LABEL',
    SalesWeightLabel: 'SALES_WEIGHT_LABEL',
    SalesList: 'SALES_LIST',
    SalesOther: 'SALES_OTHER',
    PriceList: 'PRICE_LIST',
    StockBoxLabel: 'STOCK_BOX_LABEL',
    StockDocument: 'STOCK_DOCUMENT',
    StockList: 'STOCK_LIST',
    PurchasingOrderConfirmation: 'PURCHASING_ORDER_CONFIRMATION',
    PurchasingIncomingLotDocument: 'PURCHASING_INCOMING_LOT_DOCUMENT',
    PurchasingUnloadDocument: 'PURCHASING_UNLOAD_DOCUMENT',
    PurchasingList: 'PURCHASING_LIST',
    PurchasingOther: 'PURCHASING_OTHER',
    ProductionBoxLabel: 'PRODUCTION_BOX_LABEL',
    ProductionOrderConfirmation: 'PRODUCTION_ORDER_CONFIRMATION',
    ProductionList: 'PRODUCTION_LIST',
    ProductionOther: 'PRODUCTION_OTHER'
};
export const CreateReportDesignDocumentDataDefaultFormatEnum = {
    Csv: 'CSV',
    Excel: 'EXCEL',
    Pdf: 'PDF',
    Png: 'PNG'
};
export const CreateSalesOrderDataStatusEnum = {
    CustomerEnquiry: 'CUSTOMER_ENQUIRY',
    Concept: 'CONCEPT',
    Open: 'OPEN',
    InProcess: 'IN_PROCESS',
    InProduction: 'IN_PRODUCTION',
    Closed: 'CLOSED',
    Billed: 'BILLED'
};
export const CreateSalesOrderDataReportsToPrintEnum = {
    SalesOrderConfirmationWithoutPrices: 'SALES_ORDER_CONFIRMATION_WITHOUT_PRICES',
    SalesOrderConfirmation: 'SALES_ORDER_CONFIRMATION',
    SalesInvoice: 'SALES_INVOICE',
    SalesPackingSlip: 'SALES_PACKING_SLIP',
    SalesDeliveryReceiptWithoutPrices: 'SALES_DELIVERY_RECEIPT_WITHOUT_PRICES',
    SalesDeliveryReceipt: 'SALES_DELIVERY_RECEIPT',
    SalesTransportDocument: 'SALES_TRANSPORT_DOCUMENT',
    SalesOrderPalletLabel: 'SALES_ORDER_PALLET_LABEL',
    SalesBoxLabel: 'SALES_BOX_LABEL',
    SalesWeightLabel: 'SALES_WEIGHT_LABEL',
    SalesList: 'SALES_LIST',
    SalesOther: 'SALES_OTHER',
    PriceList: 'PRICE_LIST',
    StockBoxLabel: 'STOCK_BOX_LABEL',
    StockDocument: 'STOCK_DOCUMENT',
    StockList: 'STOCK_LIST',
    PurchasingOrderConfirmation: 'PURCHASING_ORDER_CONFIRMATION',
    PurchasingIncomingLotDocument: 'PURCHASING_INCOMING_LOT_DOCUMENT',
    PurchasingUnloadDocument: 'PURCHASING_UNLOAD_DOCUMENT',
    PurchasingList: 'PURCHASING_LIST',
    PurchasingOther: 'PURCHASING_OTHER',
    ProductionBoxLabel: 'PRODUCTION_BOX_LABEL',
    ProductionOrderConfirmation: 'PRODUCTION_ORDER_CONFIRMATION',
    ProductionList: 'PRODUCTION_LIST',
    ProductionOther: 'PRODUCTION_OTHER'
};
export const CreateSalesOrderRowDataPricePerEnum = {
    Kilograms: 'KILOGRAMS',
    Packages: 'PACKAGES',
    Units: 'UNITS'
};
export const CreateSalesOrderRowDataStatusEnum = {
    Concept: 'CONCEPT',
    Open: 'OPEN',
    InProcess: 'IN_PROCESS',
    Closed: 'CLOSED',
    InProduction: 'IN_PRODUCTION'
};
export const CreateSalesOrderRowTemplateDataPricePerEnum = {
    Kilograms: 'KILOGRAMS',
    Packages: 'PACKAGES',
    Units: 'UNITS'
};
export const CreateSalesOrderRowTemplateDataStatusEnum = {
    Concept: 'CONCEPT',
    Open: 'OPEN',
    InProcess: 'IN_PROCESS',
    Closed: 'CLOSED',
    InProduction: 'IN_PRODUCTION'
};
export const CreateSalesOrderTemplateDataStatusEnum = {
    CustomerEnquiry: 'CUSTOMER_ENQUIRY',
    Concept: 'CONCEPT',
    Open: 'OPEN',
    InProcess: 'IN_PROCESS',
    InProduction: 'IN_PRODUCTION',
    Closed: 'CLOSED',
    Billed: 'BILLED'
};
export const CreateSalesOrderTemplateDataReportsToPrintEnum = {
    SalesOrderConfirmationWithoutPrices: 'SALES_ORDER_CONFIRMATION_WITHOUT_PRICES',
    SalesOrderConfirmation: 'SALES_ORDER_CONFIRMATION',
    SalesInvoice: 'SALES_INVOICE',
    SalesPackingSlip: 'SALES_PACKING_SLIP',
    SalesDeliveryReceiptWithoutPrices: 'SALES_DELIVERY_RECEIPT_WITHOUT_PRICES',
    SalesDeliveryReceipt: 'SALES_DELIVERY_RECEIPT',
    SalesTransportDocument: 'SALES_TRANSPORT_DOCUMENT',
    SalesOrderPalletLabel: 'SALES_ORDER_PALLET_LABEL',
    SalesBoxLabel: 'SALES_BOX_LABEL',
    SalesWeightLabel: 'SALES_WEIGHT_LABEL',
    SalesList: 'SALES_LIST',
    SalesOther: 'SALES_OTHER',
    PriceList: 'PRICE_LIST',
    StockBoxLabel: 'STOCK_BOX_LABEL',
    StockDocument: 'STOCK_DOCUMENT',
    StockList: 'STOCK_LIST',
    PurchasingOrderConfirmation: 'PURCHASING_ORDER_CONFIRMATION',
    PurchasingIncomingLotDocument: 'PURCHASING_INCOMING_LOT_DOCUMENT',
    PurchasingUnloadDocument: 'PURCHASING_UNLOAD_DOCUMENT',
    PurchasingList: 'PURCHASING_LIST',
    PurchasingOther: 'PURCHASING_OTHER',
    ProductionBoxLabel: 'PRODUCTION_BOX_LABEL',
    ProductionOrderConfirmation: 'PRODUCTION_ORDER_CONFIRMATION',
    ProductionList: 'PRODUCTION_LIST',
    ProductionOther: 'PRODUCTION_OTHER'
};
export const CreateTagDataTypesEnum = {
    Production: 'PRODUCTION'
};
export const CreateVatRateDataVatTypeEnum = {
    Low: 'LOW',
    High: 'HIGH',
    None: 'NONE'
};
export const CreateVatRateDataUseTypeEnum = {
    Purchase: 'PURCHASE',
    Sales: 'SALES',
    Production: 'PRODUCTION'
};
export const CupsPrinterStateEnum = {
    Idle: 'IDLE',
    Printing: 'PRINTING',
    Stopped: 'STOPPED'
};
export const CustomsInfoCustomsRegulationStatusEnum = {
    CustomsWarehouse: 'CUSTOMS_WAREHOUSE',
    EndUseProcedure: 'END_USE_PROCEDURE'
};
export const CustomsInfoDataCustomsRegulationStatusEnum = {
    CustomsWarehouse: 'CUSTOMS_WAREHOUSE',
    EndUseProcedure: 'END_USE_PROCEDURE'
};
export const DateViewRequestTypeEnum = {
    None: 'NONE',
    List: 'LIST',
    Zset: 'ZSET',
    Key: 'KEY',
    Set: 'SET'
};
export const EmailAccountTypeEnum = {
    Generic: 'GENERIC',
    Microsoft: 'MICROSOFT'
};
export const EmailLogStatusEnum = {
    InQueue: 'IN_QUEUE',
    Success: 'SUCCESS',
    Failed: 'FAILED'
};
export const EmailLogModuleEnum = {
    Core: 'CORE',
    Finance: 'FINANCE',
    Production: 'PRODUCTION',
    Purchasing: 'PURCHASING',
    Sales: 'SALES',
    Stock: 'STOCK',
    Income: 'INCOME',
    Outcome: 'OUTCOME'
};
export const EmailLogReportDesignCategoriesEnum = {
    SalesOrderConfirmationWithoutPrices: 'SALES_ORDER_CONFIRMATION_WITHOUT_PRICES',
    SalesOrderConfirmation: 'SALES_ORDER_CONFIRMATION',
    SalesInvoice: 'SALES_INVOICE',
    SalesPackingSlip: 'SALES_PACKING_SLIP',
    SalesDeliveryReceiptWithoutPrices: 'SALES_DELIVERY_RECEIPT_WITHOUT_PRICES',
    SalesDeliveryReceipt: 'SALES_DELIVERY_RECEIPT',
    SalesTransportDocument: 'SALES_TRANSPORT_DOCUMENT',
    SalesOrderPalletLabel: 'SALES_ORDER_PALLET_LABEL',
    SalesBoxLabel: 'SALES_BOX_LABEL',
    SalesWeightLabel: 'SALES_WEIGHT_LABEL',
    SalesList: 'SALES_LIST',
    SalesOther: 'SALES_OTHER',
    PriceList: 'PRICE_LIST',
    StockBoxLabel: 'STOCK_BOX_LABEL',
    StockDocument: 'STOCK_DOCUMENT',
    StockList: 'STOCK_LIST',
    PurchasingOrderConfirmation: 'PURCHASING_ORDER_CONFIRMATION',
    PurchasingIncomingLotDocument: 'PURCHASING_INCOMING_LOT_DOCUMENT',
    PurchasingUnloadDocument: 'PURCHASING_UNLOAD_DOCUMENT',
    PurchasingList: 'PURCHASING_LIST',
    PurchasingOther: 'PURCHASING_OTHER',
    ProductionBoxLabel: 'PRODUCTION_BOX_LABEL',
    ProductionOrderConfirmation: 'PRODUCTION_ORDER_CONFIRMATION',
    ProductionList: 'PRODUCTION_LIST',
    ProductionOther: 'PRODUCTION_OTHER'
};
export const EmailTemplateModuleEnum = {
    Core: 'CORE',
    Finance: 'FINANCE',
    Production: 'PRODUCTION',
    Purchasing: 'PURCHASING',
    Sales: 'SALES',
    Stock: 'STOCK',
    Income: 'INCOME',
    Outcome: 'OUTCOME'
};
export const EmailTemplateRecipientsEnum = {
    Customer: 'CUSTOMER',
    Supplier: 'SUPPLIER',
    Agent: 'AGENT',
    Transporter: 'TRANSPORTER',
    Producer: 'PRODUCER',
    Owner: 'OWNER',
    Company: 'COMPANY'
};
export const EmailTemplateCategoriesEnum = {
    SalesOrderConfirmationWithoutPrices: 'SALES_ORDER_CONFIRMATION_WITHOUT_PRICES',
    SalesOrderConfirmation: 'SALES_ORDER_CONFIRMATION',
    SalesInvoice: 'SALES_INVOICE',
    SalesPackingSlip: 'SALES_PACKING_SLIP',
    SalesDeliveryReceiptWithoutPrices: 'SALES_DELIVERY_RECEIPT_WITHOUT_PRICES',
    SalesDeliveryReceipt: 'SALES_DELIVERY_RECEIPT',
    SalesTransportDocument: 'SALES_TRANSPORT_DOCUMENT',
    SalesOrderPalletLabel: 'SALES_ORDER_PALLET_LABEL',
    SalesBoxLabel: 'SALES_BOX_LABEL',
    SalesWeightLabel: 'SALES_WEIGHT_LABEL',
    SalesList: 'SALES_LIST',
    SalesOther: 'SALES_OTHER',
    PriceList: 'PRICE_LIST',
    StockBoxLabel: 'STOCK_BOX_LABEL',
    StockDocument: 'STOCK_DOCUMENT',
    StockList: 'STOCK_LIST',
    PurchasingOrderConfirmation: 'PURCHASING_ORDER_CONFIRMATION',
    PurchasingIncomingLotDocument: 'PURCHASING_INCOMING_LOT_DOCUMENT',
    PurchasingUnloadDocument: 'PURCHASING_UNLOAD_DOCUMENT',
    PurchasingList: 'PURCHASING_LIST',
    PurchasingOther: 'PURCHASING_OTHER',
    ProductionBoxLabel: 'PRODUCTION_BOX_LABEL',
    ProductionOrderConfirmation: 'PRODUCTION_ORDER_CONFIRMATION',
    ProductionList: 'PRODUCTION_LIST',
    ProductionOther: 'PRODUCTION_OTHER'
};
export const EmailTemplateModelWithoutNestedModuleEnum = {
    Core: 'CORE',
    Finance: 'FINANCE',
    Production: 'PRODUCTION',
    Purchasing: 'PURCHASING',
    Sales: 'SALES',
    Stock: 'STOCK',
    Income: 'INCOME',
    Outcome: 'OUTCOME'
};
export const EmailTemplateModelWithoutNestedRecipientsEnum = {
    Customer: 'CUSTOMER',
    Supplier: 'SUPPLIER',
    Agent: 'AGENT',
    Transporter: 'TRANSPORTER',
    Producer: 'PRODUCER',
    Owner: 'OWNER',
    Company: 'COMPANY'
};
export const ExchangeRateTypeEnum = {
    Sales: 'SALES',
    Purchasing: 'PURCHASING'
};
export const ExternalJobTypeEnum = {
    BartenderPrintJob: 'BARTENDER_PRINT_JOB',
    CupsPrintJob: 'CUPS_PRINT_JOB'
};
export const ExternalJobStatusEnum = {
    Pending: 'PENDING',
    Running: 'RUNNING',
    Failed: 'FAILED',
    Completed: 'COMPLETED'
};
export const GridColumnDefinitionTypeEnum = {
    DefaultColumn: 'DefaultColumn',
    IdColumn: 'IdColumn',
    TextColumn: 'TextColumn',
    NumberColumn: 'NumberColumn',
    DateColumn: 'DateColumn',
    DateTimeColumn: 'DateTimeColumn',
    BooleanColumn: 'BooleanColumn',
    SetColumn: 'SetColumn',
    CurrencyColumn: 'CurrencyColumn',
    UserColumn: 'UserColumn',
    OneToManyColumn: 'OneToManyColumn',
    UuidColumn: 'UUIDColumn'
};
export const InvoiceStatusEnum = {
    Billed: 'BILLED',
    SyncingWithAccountingSoftware: 'SYNCING_WITH_ACCOUNTING_SOFTWARE',
    Synced: 'SYNCED'
};
export const InvoiceRowPricePerEnum = {
    Kilograms: 'KILOGRAMS',
    Packages: 'PACKAGES',
    Units: 'UNITS'
};
export const InvoiceRowStatusEnum = {
    Draft: 'DRAFT',
    Final: 'FINAL'
};
export const LogSeverityEnum = {
    Warning: 'WARNING',
    Error: 'ERROR'
};
export const LogTypeEnum = {
    BartenderOther: 'BARTENDER_OTHER',
    BartenderPrinterNotFound: 'BARTENDER_PRINTER_NOT_FOUND',
    BartenderRecordSetNotFound: 'BARTENDER_RECORD_SET_NOT_FOUND',
    BartenderDocumentNotFound: 'BARTENDER_DOCUMENT_NOT_FOUND',
    BartenderDatabasefieldsNotPresent: 'BARTENDER_DATABASEFIELDS_NOT_PRESENT',
    AccountviewOther: 'ACCOUNTVIEW_OTHER',
    AccountviewCompanyNotFound: 'ACCOUNTVIEW_COMPANY_NOT_FOUND'
};
export const LotIndexStatusEnum = {
    Blocked: 'BLOCKED',
    Used: 'USED',
    Reserved: 'RESERVED',
    PartiallyReserved: 'PARTIALLY_RESERVED',
    Expected: 'EXPECTED',
    EnRoute: 'EN_ROUTE',
    Available: 'AVAILABLE'
};
export const LotMutationTypeEnum = {
    Inbound: 'INBOUND',
    Outbound: 'OUTBOUND',
    Revaluation: 'REVALUATION',
    Weight: 'WEIGHT',
    Location: 'LOCATION',
    MergedTo: 'MERGED_TO',
    MergedFrom: 'MERGED_FROM',
    SplitTo: 'SPLIT_TO',
    SplitFrom: 'SPLIT_FROM'
};
export const MessageMoveRequestSrcTypeEnum = {
    None: 'NONE',
    List: 'LIST',
    Zset: 'ZSET',
    Key: 'KEY',
    Set: 'SET'
};
export const MessageMoveRequestDstTypeEnum = {
    None: 'NONE',
    List: 'LIST',
    Zset: 'ZSET',
    Key: 'KEY',
    Set: 'SET'
};
export const NetworkScaleProtocolEnum = {
    ScanvaegtCso: 'SCANVAEGT_CSO',
    ScanvaegtSv3: 'SCANVAEGT_SV3',
    OhausRs232: 'OHAUS_RS232'
};
export const NextNumberSerieTypeEnum = {
    Sales: 'SALES',
    Invoice: 'INVOICE',
    Purchase: 'PURCHASE',
    Production: 'PRODUCTION',
    LotWeight: 'LOT_WEIGHT'
};
export const NextNumberSerieTargetDatesDataNextNumberSerieTypeEnum = {
    Sales: 'SALES',
    Invoice: 'INVOICE',
    Purchase: 'PURCHASE',
    Production: 'PRODUCTION',
    LotWeight: 'LOT_WEIGHT'
};
export const NextNumberSerieTargetDatesDataNextNumberSerieTargetDateEnum = {
    Now: 'NOW',
    OrderDate: 'ORDER_DATE',
    DeliveryDate: 'DELIVERY_DATE',
    InvoiceDate: 'INVOICE_DATE',
    ProductionDate: 'PRODUCTION_DATE'
};
export const NotificationTypeEnum = {
    Error: 'ERROR',
    Warning: 'WARNING',
    Info: 'INFO',
    Success: 'SUCCESS'
};
export const PreviewReportDataCategoryEnum = {
    SalesOrderConfirmationWithoutPrices: 'SALES_ORDER_CONFIRMATION_WITHOUT_PRICES',
    SalesOrderConfirmation: 'SALES_ORDER_CONFIRMATION',
    SalesInvoice: 'SALES_INVOICE',
    SalesPackingSlip: 'SALES_PACKING_SLIP',
    SalesDeliveryReceiptWithoutPrices: 'SALES_DELIVERY_RECEIPT_WITHOUT_PRICES',
    SalesDeliveryReceipt: 'SALES_DELIVERY_RECEIPT',
    SalesTransportDocument: 'SALES_TRANSPORT_DOCUMENT',
    SalesOrderPalletLabel: 'SALES_ORDER_PALLET_LABEL',
    SalesBoxLabel: 'SALES_BOX_LABEL',
    SalesWeightLabel: 'SALES_WEIGHT_LABEL',
    SalesList: 'SALES_LIST',
    SalesOther: 'SALES_OTHER',
    PriceList: 'PRICE_LIST',
    StockBoxLabel: 'STOCK_BOX_LABEL',
    StockDocument: 'STOCK_DOCUMENT',
    StockList: 'STOCK_LIST',
    PurchasingOrderConfirmation: 'PURCHASING_ORDER_CONFIRMATION',
    PurchasingIncomingLotDocument: 'PURCHASING_INCOMING_LOT_DOCUMENT',
    PurchasingUnloadDocument: 'PURCHASING_UNLOAD_DOCUMENT',
    PurchasingList: 'PURCHASING_LIST',
    PurchasingOther: 'PURCHASING_OTHER',
    ProductionBoxLabel: 'PRODUCTION_BOX_LABEL',
    ProductionOrderConfirmation: 'PRODUCTION_ORDER_CONFIRMATION',
    ProductionList: 'PRODUCTION_LIST',
    ProductionOther: 'PRODUCTION_OTHER'
};
export const PrintMultipleResourcesDataCategoryEnum = {
    SalesOrderConfirmationWithoutPrices: 'SALES_ORDER_CONFIRMATION_WITHOUT_PRICES',
    SalesOrderConfirmation: 'SALES_ORDER_CONFIRMATION',
    SalesInvoice: 'SALES_INVOICE',
    SalesPackingSlip: 'SALES_PACKING_SLIP',
    SalesDeliveryReceiptWithoutPrices: 'SALES_DELIVERY_RECEIPT_WITHOUT_PRICES',
    SalesDeliveryReceipt: 'SALES_DELIVERY_RECEIPT',
    SalesTransportDocument: 'SALES_TRANSPORT_DOCUMENT',
    SalesOrderPalletLabel: 'SALES_ORDER_PALLET_LABEL',
    SalesBoxLabel: 'SALES_BOX_LABEL',
    SalesWeightLabel: 'SALES_WEIGHT_LABEL',
    SalesList: 'SALES_LIST',
    SalesOther: 'SALES_OTHER',
    PriceList: 'PRICE_LIST',
    StockBoxLabel: 'STOCK_BOX_LABEL',
    StockDocument: 'STOCK_DOCUMENT',
    StockList: 'STOCK_LIST',
    PurchasingOrderConfirmation: 'PURCHASING_ORDER_CONFIRMATION',
    PurchasingIncomingLotDocument: 'PURCHASING_INCOMING_LOT_DOCUMENT',
    PurchasingUnloadDocument: 'PURCHASING_UNLOAD_DOCUMENT',
    PurchasingList: 'PURCHASING_LIST',
    PurchasingOther: 'PURCHASING_OTHER',
    ProductionBoxLabel: 'PRODUCTION_BOX_LABEL',
    ProductionOrderConfirmation: 'PRODUCTION_ORDER_CONFIRMATION',
    ProductionList: 'PRODUCTION_LIST',
    ProductionOther: 'PRODUCTION_OTHER'
};
export const PrintMultipleResourcesDataModuleEnum = {
    Core: 'CORE',
    Finance: 'FINANCE',
    Production: 'PRODUCTION',
    Purchasing: 'PURCHASING',
    Sales: 'SALES',
    Stock: 'STOCK',
    Income: 'INCOME',
    Outcome: 'OUTCOME'
};
export const PrintSalesOrdersByCriteriaDataCategoryEnum = {
    SalesOrderConfirmationWithoutPrices: 'SALES_ORDER_CONFIRMATION_WITHOUT_PRICES',
    SalesOrderConfirmation: 'SALES_ORDER_CONFIRMATION',
    SalesInvoice: 'SALES_INVOICE',
    SalesPackingSlip: 'SALES_PACKING_SLIP',
    SalesDeliveryReceiptWithoutPrices: 'SALES_DELIVERY_RECEIPT_WITHOUT_PRICES',
    SalesDeliveryReceipt: 'SALES_DELIVERY_RECEIPT',
    SalesTransportDocument: 'SALES_TRANSPORT_DOCUMENT',
    SalesOrderPalletLabel: 'SALES_ORDER_PALLET_LABEL',
    SalesBoxLabel: 'SALES_BOX_LABEL',
    SalesWeightLabel: 'SALES_WEIGHT_LABEL',
    SalesList: 'SALES_LIST',
    SalesOther: 'SALES_OTHER',
    PriceList: 'PRICE_LIST',
    StockBoxLabel: 'STOCK_BOX_LABEL',
    StockDocument: 'STOCK_DOCUMENT',
    StockList: 'STOCK_LIST',
    PurchasingOrderConfirmation: 'PURCHASING_ORDER_CONFIRMATION',
    PurchasingIncomingLotDocument: 'PURCHASING_INCOMING_LOT_DOCUMENT',
    PurchasingUnloadDocument: 'PURCHASING_UNLOAD_DOCUMENT',
    PurchasingList: 'PURCHASING_LIST',
    PurchasingOther: 'PURCHASING_OTHER',
    ProductionBoxLabel: 'PRODUCTION_BOX_LABEL',
    ProductionOrderConfirmation: 'PRODUCTION_ORDER_CONFIRMATION',
    ProductionList: 'PRODUCTION_LIST',
    ProductionOther: 'PRODUCTION_OTHER'
};
export const PrinterPreferenceCategoryEnum = {
    SalesOrderConfirmationWithoutPrices: 'SALES_ORDER_CONFIRMATION_WITHOUT_PRICES',
    SalesOrderConfirmation: 'SALES_ORDER_CONFIRMATION',
    SalesInvoice: 'SALES_INVOICE',
    SalesPackingSlip: 'SALES_PACKING_SLIP',
    SalesDeliveryReceiptWithoutPrices: 'SALES_DELIVERY_RECEIPT_WITHOUT_PRICES',
    SalesDeliveryReceipt: 'SALES_DELIVERY_RECEIPT',
    SalesTransportDocument: 'SALES_TRANSPORT_DOCUMENT',
    SalesOrderPalletLabel: 'SALES_ORDER_PALLET_LABEL',
    SalesBoxLabel: 'SALES_BOX_LABEL',
    SalesWeightLabel: 'SALES_WEIGHT_LABEL',
    SalesList: 'SALES_LIST',
    SalesOther: 'SALES_OTHER',
    PriceList: 'PRICE_LIST',
    StockBoxLabel: 'STOCK_BOX_LABEL',
    StockDocument: 'STOCK_DOCUMENT',
    StockList: 'STOCK_LIST',
    PurchasingOrderConfirmation: 'PURCHASING_ORDER_CONFIRMATION',
    PurchasingIncomingLotDocument: 'PURCHASING_INCOMING_LOT_DOCUMENT',
    PurchasingUnloadDocument: 'PURCHASING_UNLOAD_DOCUMENT',
    PurchasingList: 'PURCHASING_LIST',
    PurchasingOther: 'PURCHASING_OTHER',
    ProductionBoxLabel: 'PRODUCTION_BOX_LABEL',
    ProductionOrderConfirmation: 'PRODUCTION_ORDER_CONFIRMATION',
    ProductionList: 'PRODUCTION_LIST',
    ProductionOther: 'PRODUCTION_OTHER'
};
export const ProductStorageTypeEnum = {
    Fresh: 'FRESH',
    Frozen: 'FROZEN'
};
export const ProductVatTypeEnum = {
    Low: 'LOW',
    High: 'HIGH',
    None: 'NONE'
};
export const ProductWithoutNestedVatTypeEnum = {
    Low: 'LOW',
    High: 'HIGH',
    None: 'NONE'
};
export const ProductionOrderStatusEnum = {
    Open: 'OPEN',
    InProcess: 'IN_PROCESS',
    Closed: 'CLOSED',
    Billed: 'BILLED',
    SyncingWithAccountingSoftware: 'SYNCING_WITH_ACCOUNTING_SOFTWARE',
    Synced: 'SYNCED'
};
export const ProductionOrderTypeEnum = {
    PerLot: 'PER_LOT',
    PerPackaging: 'PER_PACKAGING'
};
export const ProductionOrderTemplateTypeEnum = {
    PerLot: 'PER_LOT',
    PerPackaging: 'PER_PACKAGING'
};
export const ProductionStepStatusEnum = {
    Open: 'OPEN',
    InProcess: 'IN_PROCESS',
    Closed: 'CLOSED'
};
export const ProductionStepCostTypeEnum = {
    StartWeight: 'START_WEIGHT',
    EndWeight: 'END_WEIGHT'
};
export const ProductionStepCostDataCostTypeEnum = {
    StartWeight: 'START_WEIGHT',
    EndWeight: 'END_WEIGHT'
};
export const ProductionStepCostTemplatePricePerEnum = {
    Kilograms: 'KILOGRAMS',
    Packages: 'PACKAGES',
    Units: 'UNITS'
};
export const ProductionStepCostTemplateWithoutNestedPricePerEnum = {
    Kilograms: 'KILOGRAMS',
    Packages: 'PACKAGES',
    Units: 'UNITS'
};
export const ProductionStepCostWithoutProductionStepCostTypeEnum = {
    StartWeight: 'START_WEIGHT',
    EndWeight: 'END_WEIGHT'
};
export const ProductionStepIndexStatusEnum = {
    Open: 'OPEN',
    InProcess: 'IN_PROCESS',
    Closed: 'CLOSED'
};
export const ProductionStepIndexCostTypeEnum = {
    StartWeight: 'START_WEIGHT',
    EndWeight: 'END_WEIGHT'
};
export const ProductionStepModelWithoutNestedObjectsStatusEnum = {
    Open: 'OPEN',
    InProcess: 'IN_PROCESS',
    Closed: 'CLOSED'
};
export const ProductionStepResultLotStatusEnum = {
    Open: 'OPEN',
    Closed: 'CLOSED'
};
export const ProductionStepResultLotModelWithoutNestedObjectsStatusEnum = {
    Open: 'OPEN',
    Closed: 'CLOSED'
};
export const ProductionStepResultLotWithoutNestedStatusEnum = {
    Open: 'OPEN',
    Closed: 'CLOSED'
};
export const ProductionStepResultLotWithoutNestedUserStatusEnum = {
    Open: 'OPEN',
    Closed: 'CLOSED'
};
export const ProductionStepTemplateCostTypeEnum = {
    StartWeight: 'START_WEIGHT',
    EndWeight: 'END_WEIGHT'
};
export const PurchaseOrderStatusEnum = {
    Concept: 'CONCEPT',
    Open: 'OPEN',
    InProcess: 'IN_PROCESS',
    Closed: 'CLOSED',
    SyncingWithAccountingSoftware: 'SYNCING_WITH_ACCOUNTING_SOFTWARE',
    Synced: 'SYNCED'
};
export const PurchaseOrderIndexStatusEnum = {
    Concept: 'CONCEPT',
    Open: 'OPEN',
    InProcess: 'IN_PROCESS',
    Closed: 'CLOSED',
    SyncingWithAccountingSoftware: 'SYNCING_WITH_ACCOUNTING_SOFTWARE',
    Synced: 'SYNCED'
};
export const PurchaseOrderRowPricePerEnum = {
    Kilograms: 'KILOGRAMS',
    Packages: 'PACKAGES',
    Units: 'UNITS'
};
export const PurchaseOrderRowStatusEnum = {
    Concept: 'CONCEPT',
    Open: 'OPEN',
    InProcess: 'IN_PROCESS',
    Closed: 'CLOSED'
};
export const PurchaseOrderTemplateStatusEnum = {
    Concept: 'CONCEPT',
    Open: 'OPEN',
    InProcess: 'IN_PROCESS',
    Closed: 'CLOSED',
    SyncingWithAccountingSoftware: 'SYNCING_WITH_ACCOUNTING_SOFTWARE',
    Synced: 'SYNCED'
};
export const PurchaseOrderWithoutNestedStatusEnum = {
    Concept: 'CONCEPT',
    Open: 'OPEN',
    InProcess: 'IN_PROCESS',
    Closed: 'CLOSED',
    SyncingWithAccountingSoftware: 'SYNCING_WITH_ACCOUNTING_SOFTWARE',
    Synced: 'SYNCED'
};
export const QueueExploreRequestTypeEnum = {
    None: 'NONE',
    List: 'LIST',
    Zset: 'ZSET',
    Key: 'KEY',
    Set: 'SET'
};
export const RecentSalesPricePricePerEnum = {
    Kilograms: 'KILOGRAMS',
    Packages: 'PACKAGES',
    Units: 'UNITS'
};
export const RelationTypesEnum = {
    Customer: 'CUSTOMER',
    Supplier: 'SUPPLIER',
    Agent: 'AGENT',
    Transporter: 'TRANSPORTER',
    Producer: 'PRODUCER',
    Owner: 'OWNER',
    Company: 'COMPANY'
};
export const RelationDefaultStockStorageTypeEnum = {
    PerKg: 'PER_KG',
    PerLot: 'PER_LOT'
};
export const RelationSalesReportsToPrintEnum = {
    SalesOrderConfirmationWithoutPrices: 'SALES_ORDER_CONFIRMATION_WITHOUT_PRICES',
    SalesOrderConfirmation: 'SALES_ORDER_CONFIRMATION',
    SalesInvoice: 'SALES_INVOICE',
    SalesPackingSlip: 'SALES_PACKING_SLIP',
    SalesDeliveryReceiptWithoutPrices: 'SALES_DELIVERY_RECEIPT_WITHOUT_PRICES',
    SalesDeliveryReceipt: 'SALES_DELIVERY_RECEIPT',
    SalesTransportDocument: 'SALES_TRANSPORT_DOCUMENT',
    SalesOrderPalletLabel: 'SALES_ORDER_PALLET_LABEL',
    SalesBoxLabel: 'SALES_BOX_LABEL',
    SalesWeightLabel: 'SALES_WEIGHT_LABEL',
    SalesList: 'SALES_LIST',
    SalesOther: 'SALES_OTHER',
    PriceList: 'PRICE_LIST',
    StockBoxLabel: 'STOCK_BOX_LABEL',
    StockDocument: 'STOCK_DOCUMENT',
    StockList: 'STOCK_LIST',
    PurchasingOrderConfirmation: 'PURCHASING_ORDER_CONFIRMATION',
    PurchasingIncomingLotDocument: 'PURCHASING_INCOMING_LOT_DOCUMENT',
    PurchasingUnloadDocument: 'PURCHASING_UNLOAD_DOCUMENT',
    PurchasingList: 'PURCHASING_LIST',
    PurchasingOther: 'PURCHASING_OTHER',
    ProductionBoxLabel: 'PRODUCTION_BOX_LABEL',
    ProductionOrderConfirmation: 'PRODUCTION_ORDER_CONFIRMATION',
    ProductionList: 'PRODUCTION_LIST',
    ProductionOther: 'PRODUCTION_OTHER'
};
export const RelationIndexTypesEnum = {
    Customer: 'CUSTOMER',
    Supplier: 'SUPPLIER',
    Agent: 'AGENT',
    Transporter: 'TRANSPORTER',
    Producer: 'PRODUCER',
    Owner: 'OWNER',
    Company: 'COMPANY'
};
export const RelationIndexDefaultStockStorageTypeEnum = {
    PerKg: 'PER_KG',
    PerLot: 'PER_LOT'
};
export const RelationReportPreferenceCategoryEnum = {
    SalesOrderConfirmationWithoutPrices: 'SALES_ORDER_CONFIRMATION_WITHOUT_PRICES',
    SalesOrderConfirmation: 'SALES_ORDER_CONFIRMATION',
    SalesInvoice: 'SALES_INVOICE',
    SalesPackingSlip: 'SALES_PACKING_SLIP',
    SalesDeliveryReceiptWithoutPrices: 'SALES_DELIVERY_RECEIPT_WITHOUT_PRICES',
    SalesDeliveryReceipt: 'SALES_DELIVERY_RECEIPT',
    SalesTransportDocument: 'SALES_TRANSPORT_DOCUMENT',
    SalesOrderPalletLabel: 'SALES_ORDER_PALLET_LABEL',
    SalesBoxLabel: 'SALES_BOX_LABEL',
    SalesWeightLabel: 'SALES_WEIGHT_LABEL',
    SalesList: 'SALES_LIST',
    SalesOther: 'SALES_OTHER',
    PriceList: 'PRICE_LIST',
    StockBoxLabel: 'STOCK_BOX_LABEL',
    StockDocument: 'STOCK_DOCUMENT',
    StockList: 'STOCK_LIST',
    PurchasingOrderConfirmation: 'PURCHASING_ORDER_CONFIRMATION',
    PurchasingIncomingLotDocument: 'PURCHASING_INCOMING_LOT_DOCUMENT',
    PurchasingUnloadDocument: 'PURCHASING_UNLOAD_DOCUMENT',
    PurchasingList: 'PURCHASING_LIST',
    PurchasingOther: 'PURCHASING_OTHER',
    ProductionBoxLabel: 'PRODUCTION_BOX_LABEL',
    ProductionOrderConfirmation: 'PRODUCTION_ORDER_CONFIRMATION',
    ProductionList: 'PRODUCTION_LIST',
    ProductionOther: 'PRODUCTION_OTHER'
};
export const RelationReportPreferenceDataCategoryEnum = {
    SalesOrderConfirmationWithoutPrices: 'SALES_ORDER_CONFIRMATION_WITHOUT_PRICES',
    SalesOrderConfirmation: 'SALES_ORDER_CONFIRMATION',
    SalesInvoice: 'SALES_INVOICE',
    SalesPackingSlip: 'SALES_PACKING_SLIP',
    SalesDeliveryReceiptWithoutPrices: 'SALES_DELIVERY_RECEIPT_WITHOUT_PRICES',
    SalesDeliveryReceipt: 'SALES_DELIVERY_RECEIPT',
    SalesTransportDocument: 'SALES_TRANSPORT_DOCUMENT',
    SalesOrderPalletLabel: 'SALES_ORDER_PALLET_LABEL',
    SalesBoxLabel: 'SALES_BOX_LABEL',
    SalesWeightLabel: 'SALES_WEIGHT_LABEL',
    SalesList: 'SALES_LIST',
    SalesOther: 'SALES_OTHER',
    PriceList: 'PRICE_LIST',
    StockBoxLabel: 'STOCK_BOX_LABEL',
    StockDocument: 'STOCK_DOCUMENT',
    StockList: 'STOCK_LIST',
    PurchasingOrderConfirmation: 'PURCHASING_ORDER_CONFIRMATION',
    PurchasingIncomingLotDocument: 'PURCHASING_INCOMING_LOT_DOCUMENT',
    PurchasingUnloadDocument: 'PURCHASING_UNLOAD_DOCUMENT',
    PurchasingList: 'PURCHASING_LIST',
    PurchasingOther: 'PURCHASING_OTHER',
    ProductionBoxLabel: 'PRODUCTION_BOX_LABEL',
    ProductionOrderConfirmation: 'PRODUCTION_ORDER_CONFIRMATION',
    ProductionList: 'PRODUCTION_LIST',
    ProductionOther: 'PRODUCTION_OTHER'
};
export const RelationWithoutNestedTypesEnum = {
    Customer: 'CUSTOMER',
    Supplier: 'SUPPLIER',
    Agent: 'AGENT',
    Transporter: 'TRANSPORTER',
    Producer: 'PRODUCER',
    Owner: 'OWNER',
    Company: 'COMPANY'
};
export const RelationWithoutNestedAndWithoutAclFilterTypesEnum = {
    Customer: 'CUSTOMER',
    Supplier: 'SUPPLIER',
    Agent: 'AGENT',
    Transporter: 'TRANSPORTER',
    Producer: 'PRODUCER',
    Owner: 'OWNER',
    Company: 'COMPANY'
};
export const ReportDesignModuleEnum = {
    Core: 'CORE',
    Finance: 'FINANCE',
    Production: 'PRODUCTION',
    Purchasing: 'PURCHASING',
    Sales: 'SALES',
    Stock: 'STOCK',
    Income: 'INCOME',
    Outcome: 'OUTCOME'
};
export const ReportDesignCategoryEnum = {
    SalesOrderConfirmationWithoutPrices: 'SALES_ORDER_CONFIRMATION_WITHOUT_PRICES',
    SalesOrderConfirmation: 'SALES_ORDER_CONFIRMATION',
    SalesInvoice: 'SALES_INVOICE',
    SalesPackingSlip: 'SALES_PACKING_SLIP',
    SalesDeliveryReceiptWithoutPrices: 'SALES_DELIVERY_RECEIPT_WITHOUT_PRICES',
    SalesDeliveryReceipt: 'SALES_DELIVERY_RECEIPT',
    SalesTransportDocument: 'SALES_TRANSPORT_DOCUMENT',
    SalesOrderPalletLabel: 'SALES_ORDER_PALLET_LABEL',
    SalesBoxLabel: 'SALES_BOX_LABEL',
    SalesWeightLabel: 'SALES_WEIGHT_LABEL',
    SalesList: 'SALES_LIST',
    SalesOther: 'SALES_OTHER',
    PriceList: 'PRICE_LIST',
    StockBoxLabel: 'STOCK_BOX_LABEL',
    StockDocument: 'STOCK_DOCUMENT',
    StockList: 'STOCK_LIST',
    PurchasingOrderConfirmation: 'PURCHASING_ORDER_CONFIRMATION',
    PurchasingIncomingLotDocument: 'PURCHASING_INCOMING_LOT_DOCUMENT',
    PurchasingUnloadDocument: 'PURCHASING_UNLOAD_DOCUMENT',
    PurchasingList: 'PURCHASING_LIST',
    PurchasingOther: 'PURCHASING_OTHER',
    ProductionBoxLabel: 'PRODUCTION_BOX_LABEL',
    ProductionOrderConfirmation: 'PRODUCTION_ORDER_CONFIRMATION',
    ProductionList: 'PRODUCTION_LIST',
    ProductionOther: 'PRODUCTION_OTHER'
};
export const ReportDesignDefaultFormatEnum = {
    Csv: 'CSV',
    Excel: 'EXCEL',
    Pdf: 'PDF',
    Png: 'PNG'
};
export const ReportDesignDocumentModuleEnum = {
    Core: 'CORE',
    Finance: 'FINANCE',
    Production: 'PRODUCTION',
    Purchasing: 'PURCHASING',
    Sales: 'SALES',
    Stock: 'STOCK',
    Income: 'INCOME',
    Outcome: 'OUTCOME'
};
export const ReportDesignDocumentTypeEnum = {
    SalesOrderConfirmationWithoutPrices: 'SALES_ORDER_CONFIRMATION_WITHOUT_PRICES',
    SalesOrderConfirmation: 'SALES_ORDER_CONFIRMATION',
    SalesInvoice: 'SALES_INVOICE',
    SalesPackingSlip: 'SALES_PACKING_SLIP',
    SalesDeliveryReceiptWithoutPrices: 'SALES_DELIVERY_RECEIPT_WITHOUT_PRICES',
    SalesDeliveryReceipt: 'SALES_DELIVERY_RECEIPT',
    SalesTransportDocument: 'SALES_TRANSPORT_DOCUMENT',
    SalesOrderPalletLabel: 'SALES_ORDER_PALLET_LABEL',
    SalesBoxLabel: 'SALES_BOX_LABEL',
    SalesWeightLabel: 'SALES_WEIGHT_LABEL',
    SalesList: 'SALES_LIST',
    SalesOther: 'SALES_OTHER',
    PriceList: 'PRICE_LIST',
    StockBoxLabel: 'STOCK_BOX_LABEL',
    StockDocument: 'STOCK_DOCUMENT',
    StockList: 'STOCK_LIST',
    PurchasingOrderConfirmation: 'PURCHASING_ORDER_CONFIRMATION',
    PurchasingIncomingLotDocument: 'PURCHASING_INCOMING_LOT_DOCUMENT',
    PurchasingUnloadDocument: 'PURCHASING_UNLOAD_DOCUMENT',
    PurchasingList: 'PURCHASING_LIST',
    PurchasingOther: 'PURCHASING_OTHER',
    ProductionBoxLabel: 'PRODUCTION_BOX_LABEL',
    ProductionOrderConfirmation: 'PRODUCTION_ORDER_CONFIRMATION',
    ProductionList: 'PRODUCTION_LIST',
    ProductionOther: 'PRODUCTION_OTHER'
};
export const ReportDesignDocumentIndexModuleEnum = {
    Core: 'CORE',
    Finance: 'FINANCE',
    Production: 'PRODUCTION',
    Purchasing: 'PURCHASING',
    Sales: 'SALES',
    Stock: 'STOCK',
    Income: 'INCOME',
    Outcome: 'OUTCOME'
};
export const ReportDesignDocumentIndexTypeEnum = {
    SalesOrderConfirmationWithoutPrices: 'SALES_ORDER_CONFIRMATION_WITHOUT_PRICES',
    SalesOrderConfirmation: 'SALES_ORDER_CONFIRMATION',
    SalesInvoice: 'SALES_INVOICE',
    SalesPackingSlip: 'SALES_PACKING_SLIP',
    SalesDeliveryReceiptWithoutPrices: 'SALES_DELIVERY_RECEIPT_WITHOUT_PRICES',
    SalesDeliveryReceipt: 'SALES_DELIVERY_RECEIPT',
    SalesTransportDocument: 'SALES_TRANSPORT_DOCUMENT',
    SalesOrderPalletLabel: 'SALES_ORDER_PALLET_LABEL',
    SalesBoxLabel: 'SALES_BOX_LABEL',
    SalesWeightLabel: 'SALES_WEIGHT_LABEL',
    SalesList: 'SALES_LIST',
    SalesOther: 'SALES_OTHER',
    PriceList: 'PRICE_LIST',
    StockBoxLabel: 'STOCK_BOX_LABEL',
    StockDocument: 'STOCK_DOCUMENT',
    StockList: 'STOCK_LIST',
    PurchasingOrderConfirmation: 'PURCHASING_ORDER_CONFIRMATION',
    PurchasingIncomingLotDocument: 'PURCHASING_INCOMING_LOT_DOCUMENT',
    PurchasingUnloadDocument: 'PURCHASING_UNLOAD_DOCUMENT',
    PurchasingList: 'PURCHASING_LIST',
    PurchasingOther: 'PURCHASING_OTHER',
    ProductionBoxLabel: 'PRODUCTION_BOX_LABEL',
    ProductionOrderConfirmation: 'PRODUCTION_ORDER_CONFIRMATION',
    ProductionList: 'PRODUCTION_LIST',
    ProductionOther: 'PRODUCTION_OTHER'
};
export const ReportDesignIndexModuleEnum = {
    Core: 'CORE',
    Finance: 'FINANCE',
    Production: 'PRODUCTION',
    Purchasing: 'PURCHASING',
    Sales: 'SALES',
    Stock: 'STOCK',
    Income: 'INCOME',
    Outcome: 'OUTCOME'
};
export const ReportDesignIndexCategoryEnum = {
    SalesOrderConfirmationWithoutPrices: 'SALES_ORDER_CONFIRMATION_WITHOUT_PRICES',
    SalesOrderConfirmation: 'SALES_ORDER_CONFIRMATION',
    SalesInvoice: 'SALES_INVOICE',
    SalesPackingSlip: 'SALES_PACKING_SLIP',
    SalesDeliveryReceiptWithoutPrices: 'SALES_DELIVERY_RECEIPT_WITHOUT_PRICES',
    SalesDeliveryReceipt: 'SALES_DELIVERY_RECEIPT',
    SalesTransportDocument: 'SALES_TRANSPORT_DOCUMENT',
    SalesOrderPalletLabel: 'SALES_ORDER_PALLET_LABEL',
    SalesBoxLabel: 'SALES_BOX_LABEL',
    SalesWeightLabel: 'SALES_WEIGHT_LABEL',
    SalesList: 'SALES_LIST',
    SalesOther: 'SALES_OTHER',
    PriceList: 'PRICE_LIST',
    StockBoxLabel: 'STOCK_BOX_LABEL',
    StockDocument: 'STOCK_DOCUMENT',
    StockList: 'STOCK_LIST',
    PurchasingOrderConfirmation: 'PURCHASING_ORDER_CONFIRMATION',
    PurchasingIncomingLotDocument: 'PURCHASING_INCOMING_LOT_DOCUMENT',
    PurchasingUnloadDocument: 'PURCHASING_UNLOAD_DOCUMENT',
    PurchasingList: 'PURCHASING_LIST',
    PurchasingOther: 'PURCHASING_OTHER',
    ProductionBoxLabel: 'PRODUCTION_BOX_LABEL',
    ProductionOrderConfirmation: 'PRODUCTION_ORDER_CONFIRMATION',
    ProductionList: 'PRODUCTION_LIST',
    ProductionOther: 'PRODUCTION_OTHER'
};
export const ReportDesignIndexDefaultFormatEnum = {
    Csv: 'CSV',
    Excel: 'EXCEL',
    Pdf: 'PDF',
    Png: 'PNG'
};
export const ReportPreferenceCategoryEnum = {
    SalesOrderConfirmationWithoutPrices: 'SALES_ORDER_CONFIRMATION_WITHOUT_PRICES',
    SalesOrderConfirmation: 'SALES_ORDER_CONFIRMATION',
    SalesInvoice: 'SALES_INVOICE',
    SalesPackingSlip: 'SALES_PACKING_SLIP',
    SalesDeliveryReceiptWithoutPrices: 'SALES_DELIVERY_RECEIPT_WITHOUT_PRICES',
    SalesDeliveryReceipt: 'SALES_DELIVERY_RECEIPT',
    SalesTransportDocument: 'SALES_TRANSPORT_DOCUMENT',
    SalesOrderPalletLabel: 'SALES_ORDER_PALLET_LABEL',
    SalesBoxLabel: 'SALES_BOX_LABEL',
    SalesWeightLabel: 'SALES_WEIGHT_LABEL',
    SalesList: 'SALES_LIST',
    SalesOther: 'SALES_OTHER',
    PriceList: 'PRICE_LIST',
    StockBoxLabel: 'STOCK_BOX_LABEL',
    StockDocument: 'STOCK_DOCUMENT',
    StockList: 'STOCK_LIST',
    PurchasingOrderConfirmation: 'PURCHASING_ORDER_CONFIRMATION',
    PurchasingIncomingLotDocument: 'PURCHASING_INCOMING_LOT_DOCUMENT',
    PurchasingUnloadDocument: 'PURCHASING_UNLOAD_DOCUMENT',
    PurchasingList: 'PURCHASING_LIST',
    PurchasingOther: 'PURCHASING_OTHER',
    ProductionBoxLabel: 'PRODUCTION_BOX_LABEL',
    ProductionOrderConfirmation: 'PRODUCTION_ORDER_CONFIRMATION',
    ProductionList: 'PRODUCTION_LIST',
    ProductionOther: 'PRODUCTION_OTHER'
};
export const ReportPreviewPrintDataCategoryEnum = {
    SalesOrderConfirmationWithoutPrices: 'SALES_ORDER_CONFIRMATION_WITHOUT_PRICES',
    SalesOrderConfirmation: 'SALES_ORDER_CONFIRMATION',
    SalesInvoice: 'SALES_INVOICE',
    SalesPackingSlip: 'SALES_PACKING_SLIP',
    SalesDeliveryReceiptWithoutPrices: 'SALES_DELIVERY_RECEIPT_WITHOUT_PRICES',
    SalesDeliveryReceipt: 'SALES_DELIVERY_RECEIPT',
    SalesTransportDocument: 'SALES_TRANSPORT_DOCUMENT',
    SalesOrderPalletLabel: 'SALES_ORDER_PALLET_LABEL',
    SalesBoxLabel: 'SALES_BOX_LABEL',
    SalesWeightLabel: 'SALES_WEIGHT_LABEL',
    SalesList: 'SALES_LIST',
    SalesOther: 'SALES_OTHER',
    PriceList: 'PRICE_LIST',
    StockBoxLabel: 'STOCK_BOX_LABEL',
    StockDocument: 'STOCK_DOCUMENT',
    StockList: 'STOCK_LIST',
    PurchasingOrderConfirmation: 'PURCHASING_ORDER_CONFIRMATION',
    PurchasingIncomingLotDocument: 'PURCHASING_INCOMING_LOT_DOCUMENT',
    PurchasingUnloadDocument: 'PURCHASING_UNLOAD_DOCUMENT',
    PurchasingList: 'PURCHASING_LIST',
    PurchasingOther: 'PURCHASING_OTHER',
    ProductionBoxLabel: 'PRODUCTION_BOX_LABEL',
    ProductionOrderConfirmation: 'PRODUCTION_ORDER_CONFIRMATION',
    ProductionList: 'PRODUCTION_LIST',
    ProductionOther: 'PRODUCTION_OTHER'
};
export const ReservationStatusEnum = {
    Open: 'OPEN',
    Processed: 'PROCESSED'
};
export const ReservationModelWithoutLotStatusEnum = {
    Open: 'OPEN',
    Processed: 'PROCESSED'
};
export const ReservationModelWithoutNestedStatusEnum = {
    Open: 'OPEN',
    Processed: 'PROCESSED'
};
export const ResourceModuleEnum = {
    Core: 'CORE',
    Finance: 'FINANCE',
    Production: 'PRODUCTION',
    Purchasing: 'PURCHASING',
    Sales: 'SALES',
    Stock: 'STOCK',
    Income: 'INCOME',
    Outcome: 'OUTCOME'
};
export const ResourceActionViewTypeEnum = {
    None: 'NONE',
    Grid: 'GRID',
    Form: 'FORM',
    Custom: 'CUSTOM'
};
export const RowColumnMetaTypeEnum = {
    JobsButton: 'JOBS_BUTTON'
};
export const SalesOrderStatusEnum = {
    CustomerEnquiry: 'CUSTOMER_ENQUIRY',
    Concept: 'CONCEPT',
    Open: 'OPEN',
    InProcess: 'IN_PROCESS',
    InProduction: 'IN_PRODUCTION',
    Closed: 'CLOSED',
    Billed: 'BILLED'
};
export const SalesOrderReportsToPrintEnum = {
    SalesOrderConfirmationWithoutPrices: 'SALES_ORDER_CONFIRMATION_WITHOUT_PRICES',
    SalesOrderConfirmation: 'SALES_ORDER_CONFIRMATION',
    SalesInvoice: 'SALES_INVOICE',
    SalesPackingSlip: 'SALES_PACKING_SLIP',
    SalesDeliveryReceiptWithoutPrices: 'SALES_DELIVERY_RECEIPT_WITHOUT_PRICES',
    SalesDeliveryReceipt: 'SALES_DELIVERY_RECEIPT',
    SalesTransportDocument: 'SALES_TRANSPORT_DOCUMENT',
    SalesOrderPalletLabel: 'SALES_ORDER_PALLET_LABEL',
    SalesBoxLabel: 'SALES_BOX_LABEL',
    SalesWeightLabel: 'SALES_WEIGHT_LABEL',
    SalesList: 'SALES_LIST',
    SalesOther: 'SALES_OTHER',
    PriceList: 'PRICE_LIST',
    StockBoxLabel: 'STOCK_BOX_LABEL',
    StockDocument: 'STOCK_DOCUMENT',
    StockList: 'STOCK_LIST',
    PurchasingOrderConfirmation: 'PURCHASING_ORDER_CONFIRMATION',
    PurchasingIncomingLotDocument: 'PURCHASING_INCOMING_LOT_DOCUMENT',
    PurchasingUnloadDocument: 'PURCHASING_UNLOAD_DOCUMENT',
    PurchasingList: 'PURCHASING_LIST',
    PurchasingOther: 'PURCHASING_OTHER',
    ProductionBoxLabel: 'PRODUCTION_BOX_LABEL',
    ProductionOrderConfirmation: 'PRODUCTION_ORDER_CONFIRMATION',
    ProductionList: 'PRODUCTION_LIST',
    ProductionOther: 'PRODUCTION_OTHER'
};
export const SalesOrderIndexStatusEnum = {
    CustomerEnquiry: 'CUSTOMER_ENQUIRY',
    Concept: 'CONCEPT',
    Open: 'OPEN',
    InProcess: 'IN_PROCESS',
    InProduction: 'IN_PRODUCTION',
    Closed: 'CLOSED',
    Billed: 'BILLED'
};
export const SalesOrderRowPricePerEnum = {
    Kilograms: 'KILOGRAMS',
    Packages: 'PACKAGES',
    Units: 'UNITS'
};
export const SalesOrderRowStatusEnum = {
    Concept: 'CONCEPT',
    Open: 'OPEN',
    InProcess: 'IN_PROCESS',
    Closed: 'CLOSED',
    InProduction: 'IN_PRODUCTION'
};
export const SalesOrderRowIndexPricePerEnum = {
    Kilograms: 'KILOGRAMS',
    Packages: 'PACKAGES',
    Units: 'UNITS'
};
export const SalesOrderRowIndexStatusEnum = {
    Concept: 'CONCEPT',
    Open: 'OPEN',
    InProcess: 'IN_PROCESS',
    Closed: 'CLOSED',
    InProduction: 'IN_PRODUCTION'
};
export const SalesOrderRowLabelPrintJobStatusEnum = {
    Pending: 'PENDING',
    Running: 'RUNNING',
    Completed: 'COMPLETED',
    Failed: 'FAILED',
    Cancelled: 'CANCELLED'
};
export const SalesOrderRowLabelPrintJobWithoutNestedStatusEnum = {
    Pending: 'PENDING',
    Running: 'RUNNING',
    Completed: 'COMPLETED',
    Failed: 'FAILED',
    Cancelled: 'CANCELLED'
};
export const SalesOrderRowWithoutNestedPricePerEnum = {
    Kilograms: 'KILOGRAMS',
    Packages: 'PACKAGES',
    Units: 'UNITS'
};
export const SalesOrderRowWithoutNestedStatusEnum = {
    Concept: 'CONCEPT',
    Open: 'OPEN',
    InProcess: 'IN_PROCESS',
    Closed: 'CLOSED',
    InProduction: 'IN_PRODUCTION'
};
export const SalesOrderRowWithoutReservationsStatusEnum = {
    Concept: 'CONCEPT',
    Open: 'OPEN',
    InProcess: 'IN_PROCESS',
    Closed: 'CLOSED',
    InProduction: 'IN_PRODUCTION'
};
export const SalesOrderTemplateStatusEnum = {
    CustomerEnquiry: 'CUSTOMER_ENQUIRY',
    Concept: 'CONCEPT',
    Open: 'OPEN',
    InProcess: 'IN_PROCESS',
    InProduction: 'IN_PRODUCTION',
    Closed: 'CLOSED',
    Billed: 'BILLED'
};
export const SalesOrderWithoutNestedStatusEnum = {
    CustomerEnquiry: 'CUSTOMER_ENQUIRY',
    Concept: 'CONCEPT',
    Open: 'OPEN',
    InProcess: 'IN_PROCESS',
    InProduction: 'IN_PRODUCTION',
    Closed: 'CLOSED',
    Billed: 'BILLED'
};
export const ScaleSettingsTypeEnum = {
    Com: 'COM',
    Network: 'NETWORK'
};
export const SendCriteriaMailDataRelationTypeEnum = {
    Customer: 'CUSTOMER',
    Supplier: 'SUPPLIER',
    Agent: 'AGENT',
    Transporter: 'TRANSPORTER',
    Producer: 'PRODUCER',
    Owner: 'OWNER',
    Company: 'COMPANY'
};
export const SendCriteriaMailDataModuleEnum = {
    Core: 'CORE',
    Finance: 'FINANCE',
    Production: 'PRODUCTION',
    Purchasing: 'PURCHASING',
    Sales: 'SALES',
    Stock: 'STOCK',
    Income: 'INCOME',
    Outcome: 'OUTCOME'
};
export const SendListMailDataRelationTypeEnum = {
    Customer: 'CUSTOMER',
    Supplier: 'SUPPLIER',
    Agent: 'AGENT',
    Transporter: 'TRANSPORTER',
    Producer: 'PRODUCER',
    Owner: 'OWNER',
    Company: 'COMPANY'
};
export const SendListMailDataModuleEnum = {
    Core: 'CORE',
    Finance: 'FINANCE',
    Production: 'PRODUCTION',
    Purchasing: 'PURCHASING',
    Sales: 'SALES',
    Stock: 'STOCK',
    Income: 'INCOME',
    Outcome: 'OUTCOME'
};
export const SendListMailDataReportDesignCategoryEnum = {
    SalesOrderConfirmationWithoutPrices: 'SALES_ORDER_CONFIRMATION_WITHOUT_PRICES',
    SalesOrderConfirmation: 'SALES_ORDER_CONFIRMATION',
    SalesInvoice: 'SALES_INVOICE',
    SalesPackingSlip: 'SALES_PACKING_SLIP',
    SalesDeliveryReceiptWithoutPrices: 'SALES_DELIVERY_RECEIPT_WITHOUT_PRICES',
    SalesDeliveryReceipt: 'SALES_DELIVERY_RECEIPT',
    SalesTransportDocument: 'SALES_TRANSPORT_DOCUMENT',
    SalesOrderPalletLabel: 'SALES_ORDER_PALLET_LABEL',
    SalesBoxLabel: 'SALES_BOX_LABEL',
    SalesWeightLabel: 'SALES_WEIGHT_LABEL',
    SalesList: 'SALES_LIST',
    SalesOther: 'SALES_OTHER',
    PriceList: 'PRICE_LIST',
    StockBoxLabel: 'STOCK_BOX_LABEL',
    StockDocument: 'STOCK_DOCUMENT',
    StockList: 'STOCK_LIST',
    PurchasingOrderConfirmation: 'PURCHASING_ORDER_CONFIRMATION',
    PurchasingIncomingLotDocument: 'PURCHASING_INCOMING_LOT_DOCUMENT',
    PurchasingUnloadDocument: 'PURCHASING_UNLOAD_DOCUMENT',
    PurchasingList: 'PURCHASING_LIST',
    PurchasingOther: 'PURCHASING_OTHER',
    ProductionBoxLabel: 'PRODUCTION_BOX_LABEL',
    ProductionOrderConfirmation: 'PRODUCTION_ORDER_CONFIRMATION',
    ProductionList: 'PRODUCTION_LIST',
    ProductionOther: 'PRODUCTION_OTHER'
};
export const SendMailDataModuleEnum = {
    Core: 'CORE',
    Finance: 'FINANCE',
    Production: 'PRODUCTION',
    Purchasing: 'PURCHASING',
    Sales: 'SALES',
    Stock: 'STOCK',
    Income: 'INCOME',
    Outcome: 'OUTCOME'
};
export const SendMailDataReportDesignCategoryEnum = {
    SalesOrderConfirmationWithoutPrices: 'SALES_ORDER_CONFIRMATION_WITHOUT_PRICES',
    SalesOrderConfirmation: 'SALES_ORDER_CONFIRMATION',
    SalesInvoice: 'SALES_INVOICE',
    SalesPackingSlip: 'SALES_PACKING_SLIP',
    SalesDeliveryReceiptWithoutPrices: 'SALES_DELIVERY_RECEIPT_WITHOUT_PRICES',
    SalesDeliveryReceipt: 'SALES_DELIVERY_RECEIPT',
    SalesTransportDocument: 'SALES_TRANSPORT_DOCUMENT',
    SalesOrderPalletLabel: 'SALES_ORDER_PALLET_LABEL',
    SalesBoxLabel: 'SALES_BOX_LABEL',
    SalesWeightLabel: 'SALES_WEIGHT_LABEL',
    SalesList: 'SALES_LIST',
    SalesOther: 'SALES_OTHER',
    PriceList: 'PRICE_LIST',
    StockBoxLabel: 'STOCK_BOX_LABEL',
    StockDocument: 'STOCK_DOCUMENT',
    StockList: 'STOCK_LIST',
    PurchasingOrderConfirmation: 'PURCHASING_ORDER_CONFIRMATION',
    PurchasingIncomingLotDocument: 'PURCHASING_INCOMING_LOT_DOCUMENT',
    PurchasingUnloadDocument: 'PURCHASING_UNLOAD_DOCUMENT',
    PurchasingList: 'PURCHASING_LIST',
    PurchasingOther: 'PURCHASING_OTHER',
    ProductionBoxLabel: 'PRODUCTION_BOX_LABEL',
    ProductionOrderConfirmation: 'PRODUCTION_ORDER_CONFIRMATION',
    ProductionList: 'PRODUCTION_LIST',
    ProductionOther: 'PRODUCTION_OTHER'
};
export const SerialPortScaleParityEnum = {
    Odd: 'ODD',
    Even: 'EVEN',
    None: 'NONE',
    Space: 'SPACE',
    Mark: 'MARK'
};
export const SerialPortScaleProtocolEnum = {
    ScanvaegtCso: 'SCANVAEGT_CSO',
    ScanvaegtSv3: 'SCANVAEGT_SV3',
    OhausRs232: 'OHAUS_RS232'
};
export const SerialPortScannerParityEnum = {
    Odd: 'ODD',
    Even: 'EVEN',
    None: 'NONE',
    Space: 'SPACE',
    Mark: 'MARK'
};
export const TableColumnTypeEnum = {
    Display: 'DISPLAY',
    Action: 'ACTION'
};
export const TagTypesEnum = {
    Production: 'PRODUCTION'
};
export const UpdateBartenderDocumentDataModuleEnum = {
    Core: 'CORE',
    Finance: 'FINANCE',
    Production: 'PRODUCTION',
    Purchasing: 'PURCHASING',
    Sales: 'SALES',
    Stock: 'STOCK',
    Income: 'INCOME',
    Outcome: 'OUTCOME'
};
export const UpdateBartenderDocumentDataTypeEnum = {
    SalesOrderConfirmationWithoutPrices: 'SALES_ORDER_CONFIRMATION_WITHOUT_PRICES',
    SalesOrderConfirmation: 'SALES_ORDER_CONFIRMATION',
    SalesInvoice: 'SALES_INVOICE',
    SalesPackingSlip: 'SALES_PACKING_SLIP',
    SalesDeliveryReceiptWithoutPrices: 'SALES_DELIVERY_RECEIPT_WITHOUT_PRICES',
    SalesDeliveryReceipt: 'SALES_DELIVERY_RECEIPT',
    SalesTransportDocument: 'SALES_TRANSPORT_DOCUMENT',
    SalesOrderPalletLabel: 'SALES_ORDER_PALLET_LABEL',
    SalesBoxLabel: 'SALES_BOX_LABEL',
    SalesWeightLabel: 'SALES_WEIGHT_LABEL',
    SalesList: 'SALES_LIST',
    SalesOther: 'SALES_OTHER',
    PriceList: 'PRICE_LIST',
    StockBoxLabel: 'STOCK_BOX_LABEL',
    StockDocument: 'STOCK_DOCUMENT',
    StockList: 'STOCK_LIST',
    PurchasingOrderConfirmation: 'PURCHASING_ORDER_CONFIRMATION',
    PurchasingIncomingLotDocument: 'PURCHASING_INCOMING_LOT_DOCUMENT',
    PurchasingUnloadDocument: 'PURCHASING_UNLOAD_DOCUMENT',
    PurchasingList: 'PURCHASING_LIST',
    PurchasingOther: 'PURCHASING_OTHER',
    ProductionBoxLabel: 'PRODUCTION_BOX_LABEL',
    ProductionOrderConfirmation: 'PRODUCTION_ORDER_CONFIRMATION',
    ProductionList: 'PRODUCTION_LIST',
    ProductionOther: 'PRODUCTION_OTHER'
};
export const UpdateCompanyDataDefaultStockStorageTypeEnum = {
    PerKg: 'PER_KG',
    PerLot: 'PER_LOT'
};
export const UpdateCostTypeDataCategoryEnum = {
    TransportCostType: 'TRANSPORT_COST_TYPE',
    FobCostType: 'FOB_COST_TYPE',
    OtherCostType: 'OTHER_COST_TYPE',
    SeaFreightCostType: 'SEA_FREIGHT_COST_TYPE'
};
export const UpdateCostTypeDataModulesEnum = {
    Core: 'CORE',
    Finance: 'FINANCE',
    Production: 'PRODUCTION',
    Purchasing: 'PURCHASING',
    Sales: 'SALES',
    Stock: 'STOCK',
    Income: 'INCOME',
    Outcome: 'OUTCOME'
};
export const UpdateEmailAccountDataTypeEnum = {
    Generic: 'GENERIC',
    Microsoft: 'MICROSOFT'
};
export const UpdateExchangeRateDataTypeEnum = {
    Sales: 'SALES',
    Purchasing: 'PURCHASING'
};
export const UpdateInvoiceStatusDataStatusEnum = {
    Billed: 'BILLED',
    SyncingWithAccountingSoftware: 'SYNCING_WITH_ACCOUNTING_SOFTWARE',
    Synced: 'SYNCED'
};
export const UpdateNetworkScaleDataProtocolEnum = {
    ScanvaegtCso: 'SCANVAEGT_CSO',
    ScanvaegtSv3: 'SCANVAEGT_SV3',
    OhausRs232: 'OHAUS_RS232'
};
export const UpdateNextNumberSerieDataTypeEnum = {
    Sales: 'SALES',
    Invoice: 'INVOICE',
    Purchase: 'PURCHASE',
    Production: 'PRODUCTION',
    LotWeight: 'LOT_WEIGHT'
};
export const UpdateProductCategoryDataVatTypeEnum = {
    Low: 'LOW',
    High: 'HIGH',
    None: 'NONE'
};
export const UpdateProductDataStorageTypeEnum = {
    Fresh: 'FRESH',
    Frozen: 'FROZEN'
};
export const UpdateProductDataVatTypeEnum = {
    Low: 'LOW',
    High: 'HIGH',
    None: 'NONE'
};
export const UpdateProductionOrderDataTypeEnum = {
    PerLot: 'PER_LOT',
    PerPackaging: 'PER_PACKAGING'
};
export const UpdateProductionOrderDataStatusEnum = {
    Open: 'OPEN',
    InProcess: 'IN_PROCESS',
    Closed: 'CLOSED',
    Billed: 'BILLED',
    SyncingWithAccountingSoftware: 'SYNCING_WITH_ACCOUNTING_SOFTWARE',
    Synced: 'SYNCED'
};
export const UpdateProductionOrderTemplateDataTypeEnum = {
    PerLot: 'PER_LOT',
    PerPackaging: 'PER_PACKAGING'
};
export const UpdateProductionStatusDataStatusEnum = {
    Open: 'OPEN',
    InProcess: 'IN_PROCESS',
    Closed: 'CLOSED',
    Billed: 'BILLED',
    SyncingWithAccountingSoftware: 'SYNCING_WITH_ACCOUNTING_SOFTWARE',
    Synced: 'SYNCED'
};
export const UpdateProductionStepCostDataCostTypeEnum = {
    StartWeight: 'START_WEIGHT',
    EndWeight: 'END_WEIGHT'
};
export const UpdateProductionStepCostTemplateDataPricePerEnum = {
    Kilograms: 'KILOGRAMS',
    Packages: 'PACKAGES',
    Units: 'UNITS'
};
export const UpdateProductionStepDataCostTypeEnum = {
    StartWeight: 'START_WEIGHT',
    EndWeight: 'END_WEIGHT'
};
export const UpdateProductionStepReservationDataStatusEnum = {
    Open: 'OPEN',
    Processed: 'PROCESSED'
};
export const UpdateProductionStepStatusDataStatusEnum = {
    Open: 'OPEN',
    InProcess: 'IN_PROCESS',
    Closed: 'CLOSED'
};
export const UpdateProductionStepTemplateDataCostTypeEnum = {
    StartWeight: 'START_WEIGHT',
    EndWeight: 'END_WEIGHT'
};
export const UpdatePurchaseOrderDataStatusEnum = {
    Concept: 'CONCEPT',
    Open: 'OPEN',
    InProcess: 'IN_PROCESS',
    Closed: 'CLOSED',
    SyncingWithAccountingSoftware: 'SYNCING_WITH_ACCOUNTING_SOFTWARE',
    Synced: 'SYNCED'
};
export const UpdatePurchaseOrderRowDataPricePerEnum = {
    Kilograms: 'KILOGRAMS',
    Packages: 'PACKAGES',
    Units: 'UNITS'
};
export const UpdatePurchaseOrderRowDataStatusEnum = {
    Concept: 'CONCEPT',
    Open: 'OPEN',
    InProcess: 'IN_PROCESS',
    Closed: 'CLOSED'
};
export const UpdatePurchaseOrderRowStatusDataStatusEnum = {
    Concept: 'CONCEPT',
    Open: 'OPEN',
    InProcess: 'IN_PROCESS',
    Closed: 'CLOSED'
};
export const UpdatePurchaseOrderRowTemplateDataPricePerEnum = {
    Kilograms: 'KILOGRAMS',
    Packages: 'PACKAGES',
    Units: 'UNITS'
};
export const UpdatePurchaseOrderRowTemplateDataStatusEnum = {
    Concept: 'CONCEPT',
    Open: 'OPEN',
    InProcess: 'IN_PROCESS',
    Closed: 'CLOSED'
};
export const UpdatePurchaseOrderStatusDataStatusEnum = {
    Concept: 'CONCEPT',
    Open: 'OPEN',
    InProcess: 'IN_PROCESS',
    Closed: 'CLOSED',
    SyncingWithAccountingSoftware: 'SYNCING_WITH_ACCOUNTING_SOFTWARE',
    Synced: 'SYNCED'
};
export const UpdatePurchaseOrderTemplateDataStatusEnum = {
    Concept: 'CONCEPT',
    Open: 'OPEN',
    InProcess: 'IN_PROCESS',
    Closed: 'CLOSED',
    SyncingWithAccountingSoftware: 'SYNCING_WITH_ACCOUNTING_SOFTWARE',
    Synced: 'SYNCED'
};
export const UpdateRelationDataTypesEnum = {
    Customer: 'CUSTOMER',
    Supplier: 'SUPPLIER',
    Agent: 'AGENT',
    Transporter: 'TRANSPORTER',
    Producer: 'PRODUCER',
    Owner: 'OWNER',
    Company: 'COMPANY'
};
export const UpdateRelationDataDefaultStockStorageTypeEnum = {
    PerKg: 'PER_KG',
    PerLot: 'PER_LOT'
};
export const UpdateRelationDataSalesReportsToPrintEnum = {
    SalesOrderConfirmationWithoutPrices: 'SALES_ORDER_CONFIRMATION_WITHOUT_PRICES',
    SalesOrderConfirmation: 'SALES_ORDER_CONFIRMATION',
    SalesInvoice: 'SALES_INVOICE',
    SalesPackingSlip: 'SALES_PACKING_SLIP',
    SalesDeliveryReceiptWithoutPrices: 'SALES_DELIVERY_RECEIPT_WITHOUT_PRICES',
    SalesDeliveryReceipt: 'SALES_DELIVERY_RECEIPT',
    SalesTransportDocument: 'SALES_TRANSPORT_DOCUMENT',
    SalesOrderPalletLabel: 'SALES_ORDER_PALLET_LABEL',
    SalesBoxLabel: 'SALES_BOX_LABEL',
    SalesWeightLabel: 'SALES_WEIGHT_LABEL',
    SalesList: 'SALES_LIST',
    SalesOther: 'SALES_OTHER',
    PriceList: 'PRICE_LIST',
    StockBoxLabel: 'STOCK_BOX_LABEL',
    StockDocument: 'STOCK_DOCUMENT',
    StockList: 'STOCK_LIST',
    PurchasingOrderConfirmation: 'PURCHASING_ORDER_CONFIRMATION',
    PurchasingIncomingLotDocument: 'PURCHASING_INCOMING_LOT_DOCUMENT',
    PurchasingUnloadDocument: 'PURCHASING_UNLOAD_DOCUMENT',
    PurchasingList: 'PURCHASING_LIST',
    PurchasingOther: 'PURCHASING_OTHER',
    ProductionBoxLabel: 'PRODUCTION_BOX_LABEL',
    ProductionOrderConfirmation: 'PRODUCTION_ORDER_CONFIRMATION',
    ProductionList: 'PRODUCTION_LIST',
    ProductionOther: 'PRODUCTION_OTHER'
};
export const UpdateReportDesignDocumentDataModuleEnum = {
    Core: 'CORE',
    Finance: 'FINANCE',
    Production: 'PRODUCTION',
    Purchasing: 'PURCHASING',
    Sales: 'SALES',
    Stock: 'STOCK',
    Income: 'INCOME',
    Outcome: 'OUTCOME'
};
export const UpdateReportDesignDocumentDataTypeEnum = {
    SalesOrderConfirmationWithoutPrices: 'SALES_ORDER_CONFIRMATION_WITHOUT_PRICES',
    SalesOrderConfirmation: 'SALES_ORDER_CONFIRMATION',
    SalesInvoice: 'SALES_INVOICE',
    SalesPackingSlip: 'SALES_PACKING_SLIP',
    SalesDeliveryReceiptWithoutPrices: 'SALES_DELIVERY_RECEIPT_WITHOUT_PRICES',
    SalesDeliveryReceipt: 'SALES_DELIVERY_RECEIPT',
    SalesTransportDocument: 'SALES_TRANSPORT_DOCUMENT',
    SalesOrderPalletLabel: 'SALES_ORDER_PALLET_LABEL',
    SalesBoxLabel: 'SALES_BOX_LABEL',
    SalesWeightLabel: 'SALES_WEIGHT_LABEL',
    SalesList: 'SALES_LIST',
    SalesOther: 'SALES_OTHER',
    PriceList: 'PRICE_LIST',
    StockBoxLabel: 'STOCK_BOX_LABEL',
    StockDocument: 'STOCK_DOCUMENT',
    StockList: 'STOCK_LIST',
    PurchasingOrderConfirmation: 'PURCHASING_ORDER_CONFIRMATION',
    PurchasingIncomingLotDocument: 'PURCHASING_INCOMING_LOT_DOCUMENT',
    PurchasingUnloadDocument: 'PURCHASING_UNLOAD_DOCUMENT',
    PurchasingList: 'PURCHASING_LIST',
    PurchasingOther: 'PURCHASING_OTHER',
    ProductionBoxLabel: 'PRODUCTION_BOX_LABEL',
    ProductionOrderConfirmation: 'PRODUCTION_ORDER_CONFIRMATION',
    ProductionList: 'PRODUCTION_LIST',
    ProductionOther: 'PRODUCTION_OTHER'
};
export const UpdateReportDesignDocumentDataDefaultFormatEnum = {
    Csv: 'CSV',
    Excel: 'EXCEL',
    Pdf: 'PDF',
    Png: 'PNG'
};
export const UpdateSalesOrderDataStatusEnum = {
    CustomerEnquiry: 'CUSTOMER_ENQUIRY',
    Concept: 'CONCEPT',
    Open: 'OPEN',
    InProcess: 'IN_PROCESS',
    InProduction: 'IN_PRODUCTION',
    Closed: 'CLOSED',
    Billed: 'BILLED'
};
export const UpdateSalesOrderDataReportsToPrintEnum = {
    SalesOrderConfirmationWithoutPrices: 'SALES_ORDER_CONFIRMATION_WITHOUT_PRICES',
    SalesOrderConfirmation: 'SALES_ORDER_CONFIRMATION',
    SalesInvoice: 'SALES_INVOICE',
    SalesPackingSlip: 'SALES_PACKING_SLIP',
    SalesDeliveryReceiptWithoutPrices: 'SALES_DELIVERY_RECEIPT_WITHOUT_PRICES',
    SalesDeliveryReceipt: 'SALES_DELIVERY_RECEIPT',
    SalesTransportDocument: 'SALES_TRANSPORT_DOCUMENT',
    SalesOrderPalletLabel: 'SALES_ORDER_PALLET_LABEL',
    SalesBoxLabel: 'SALES_BOX_LABEL',
    SalesWeightLabel: 'SALES_WEIGHT_LABEL',
    SalesList: 'SALES_LIST',
    SalesOther: 'SALES_OTHER',
    PriceList: 'PRICE_LIST',
    StockBoxLabel: 'STOCK_BOX_LABEL',
    StockDocument: 'STOCK_DOCUMENT',
    StockList: 'STOCK_LIST',
    PurchasingOrderConfirmation: 'PURCHASING_ORDER_CONFIRMATION',
    PurchasingIncomingLotDocument: 'PURCHASING_INCOMING_LOT_DOCUMENT',
    PurchasingUnloadDocument: 'PURCHASING_UNLOAD_DOCUMENT',
    PurchasingList: 'PURCHASING_LIST',
    PurchasingOther: 'PURCHASING_OTHER',
    ProductionBoxLabel: 'PRODUCTION_BOX_LABEL',
    ProductionOrderConfirmation: 'PRODUCTION_ORDER_CONFIRMATION',
    ProductionList: 'PRODUCTION_LIST',
    ProductionOther: 'PRODUCTION_OTHER'
};
export const UpdateSalesOrderRowDataPricePerEnum = {
    Kilograms: 'KILOGRAMS',
    Packages: 'PACKAGES',
    Units: 'UNITS'
};
export const UpdateSalesOrderRowDataStatusEnum = {
    Concept: 'CONCEPT',
    Open: 'OPEN',
    InProcess: 'IN_PROCESS',
    Closed: 'CLOSED',
    InProduction: 'IN_PRODUCTION'
};
export const UpdateSalesOrderRowStatusDataStatusEnum = {
    Concept: 'CONCEPT',
    Open: 'OPEN',
    InProcess: 'IN_PROCESS',
    Closed: 'CLOSED',
    InProduction: 'IN_PRODUCTION'
};
export const UpdateSalesOrderRowTemplateDataPricePerEnum = {
    Kilograms: 'KILOGRAMS',
    Packages: 'PACKAGES',
    Units: 'UNITS'
};
export const UpdateSalesOrderRowTemplateDataStatusEnum = {
    Concept: 'CONCEPT',
    Open: 'OPEN',
    InProcess: 'IN_PROCESS',
    Closed: 'CLOSED',
    InProduction: 'IN_PRODUCTION'
};
export const UpdateSalesOrderStatusDataStatusEnum = {
    CustomerEnquiry: 'CUSTOMER_ENQUIRY',
    Concept: 'CONCEPT',
    Open: 'OPEN',
    InProcess: 'IN_PROCESS',
    InProduction: 'IN_PRODUCTION',
    Closed: 'CLOSED',
    Billed: 'BILLED'
};
export const UpdateSalesOrderTemplateDataStatusEnum = {
    CustomerEnquiry: 'CUSTOMER_ENQUIRY',
    Concept: 'CONCEPT',
    Open: 'OPEN',
    InProcess: 'IN_PROCESS',
    InProduction: 'IN_PRODUCTION',
    Closed: 'CLOSED',
    Billed: 'BILLED'
};
export const UpdateSalesOrderTemplateDataReportsToPrintEnum = {
    SalesOrderConfirmationWithoutPrices: 'SALES_ORDER_CONFIRMATION_WITHOUT_PRICES',
    SalesOrderConfirmation: 'SALES_ORDER_CONFIRMATION',
    SalesInvoice: 'SALES_INVOICE',
    SalesPackingSlip: 'SALES_PACKING_SLIP',
    SalesDeliveryReceiptWithoutPrices: 'SALES_DELIVERY_RECEIPT_WITHOUT_PRICES',
    SalesDeliveryReceipt: 'SALES_DELIVERY_RECEIPT',
    SalesTransportDocument: 'SALES_TRANSPORT_DOCUMENT',
    SalesOrderPalletLabel: 'SALES_ORDER_PALLET_LABEL',
    SalesBoxLabel: 'SALES_BOX_LABEL',
    SalesWeightLabel: 'SALES_WEIGHT_LABEL',
    SalesList: 'SALES_LIST',
    SalesOther: 'SALES_OTHER',
    PriceList: 'PRICE_LIST',
    StockBoxLabel: 'STOCK_BOX_LABEL',
    StockDocument: 'STOCK_DOCUMENT',
    StockList: 'STOCK_LIST',
    PurchasingOrderConfirmation: 'PURCHASING_ORDER_CONFIRMATION',
    PurchasingIncomingLotDocument: 'PURCHASING_INCOMING_LOT_DOCUMENT',
    PurchasingUnloadDocument: 'PURCHASING_UNLOAD_DOCUMENT',
    PurchasingList: 'PURCHASING_LIST',
    PurchasingOther: 'PURCHASING_OTHER',
    ProductionBoxLabel: 'PRODUCTION_BOX_LABEL',
    ProductionOrderConfirmation: 'PRODUCTION_ORDER_CONFIRMATION',
    ProductionList: 'PRODUCTION_LIST',
    ProductionOther: 'PRODUCTION_OTHER'
};
export const UpdateTagDataTypesEnum = {
    Production: 'PRODUCTION'
};
export const UpdateVatRateDataVatTypeEnum = {
    Low: 'LOW',
    High: 'HIGH',
    None: 'NONE'
};
export const UpdateVatRateDataUseTypeEnum = {
    Purchase: 'PURCHASE',
    Sales: 'SALES',
    Production: 'PRODUCTION'
};
export const UserSettingsAutomaticRecalculationEnum = {
    Core: 'CORE',
    Finance: 'FINANCE',
    Production: 'PRODUCTION',
    Purchasing: 'PURCHASING',
    Sales: 'SALES',
    Stock: 'STOCK',
    Income: 'INCOME',
    Outcome: 'OUTCOME'
};
export const UserSettingsSmartTabsEnum = {
    Core: 'CORE',
    Finance: 'FINANCE',
    Production: 'PRODUCTION',
    Purchasing: 'PURCHASING',
    Sales: 'SALES',
    Stock: 'STOCK',
    Income: 'INCOME',
    Outcome: 'OUTCOME'
};
export const VatRateVatTypeEnum = {
    Low: 'LOW',
    High: 'HIGH',
    None: 'NONE'
};
export const VatRateUseTypeEnum = {
    Purchase: 'PURCHASE',
    Sales: 'SALES',
    Production: 'PRODUCTION'
};
export const VatRateModelWithoutNestedVatTypeEnum = {
    Low: 'LOW',
    High: 'HIGH',
    None: 'NONE'
};
export const VatRateModelWithoutNestedUseTypeEnum = {
    Purchase: 'PURCHASE',
    Sales: 'SALES',
    Production: 'PRODUCTION'
};
// @ts-nocheck
/**
 * AbstractWeightsApi - axios parameter creator
 * @export
 */
export const AbstractWeightsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {CreateAbstractWeightData} createAbstractWeightData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAbstractWeight: async (createAbstractWeightData, options = {}) => {
            // verify required parameter 'createAbstractWeightData' is not null or undefined
            assertParamExists('createAbstractWeight', 'createAbstractWeightData', createAbstractWeightData);
            const localVarPath = `/api/abstract-weights`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createAbstractWeightData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAbstractWeights: async (criteria, page, size, sort, options = {}) => {
            const localVarPath = `/api/abstract-weights/api/abstract-weights`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * AbstractWeightsApi - functional programming interface
 * @export
 */
export const AbstractWeightsApiFp = function (configuration) {
    const localVarAxiosParamCreator = AbstractWeightsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {CreateAbstractWeightData} createAbstractWeightData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAbstractWeight(createAbstractWeightData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAbstractWeight(createAbstractWeightData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAbstractWeights(criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAbstractWeights(criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * AbstractWeightsApi - factory interface
 * @export
 */
export const AbstractWeightsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AbstractWeightsApiFp(configuration);
    return {
        /**
         *
         * @param {CreateAbstractWeightData} createAbstractWeightData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAbstractWeight(createAbstractWeightData, options) {
            return localVarFp.createAbstractWeight(createAbstractWeightData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAbstractWeights(criteria, page, size, sort, options) {
            return localVarFp.getAbstractWeights(criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
        * @param {CreateAbstractWeightData} createAbstractWeightData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof AbstractWeightsApi
*/
export function createAbstractWeight(createAbstractWeightData, options) {
    return AbstractWeightsApiFp().createAbstractWeight(createAbstractWeightData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof AbstractWeightsApi
*/
export function getAbstractWeights(criteria, page, size, sort, options) {
    return AbstractWeightsApiFp().getAbstractWeights(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {CreateAbstractWeightData} createAbstractWeightData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof AbstractWeightsApi
*/
export function createAbstractWeightRaw(createAbstractWeightData, options) {
    return AbstractWeightsApiFp().createAbstractWeight(createAbstractWeightData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof AbstractWeightsApi
*/
export function getAbstractWeightsRaw(criteria, page, size, sort, options) {
    return AbstractWeightsApiFp().getAbstractWeights(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * AccountViewCallbackControllerApi - axios parameter creator
 * @export
 */
export const AccountViewCallbackControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} code
         * @param {string} [state]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountViewCallback: async (code, state, options = {}) => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('accountViewCallback', 'code', code);
            const localVarPath = `/callback/accountview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }
            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * AccountViewCallbackControllerApi - functional programming interface
 * @export
 */
export const AccountViewCallbackControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = AccountViewCallbackControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} code
         * @param {string} [state]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountViewCallback(code, state, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountViewCallback(code, state, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * AccountViewCallbackControllerApi - factory interface
 * @export
 */
export const AccountViewCallbackControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AccountViewCallbackControllerApiFp(configuration);
    return {
        /**
         *
         * @param {string} code
         * @param {string} [state]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountViewCallback(code, state, options) {
            return localVarFp.accountViewCallback(code, state, options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
        * @param {string} code
        * @param {string} [state]
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof AccountViewCallbackControllerApi
*/
export function accountViewCallback(code, state, options) {
    return AccountViewCallbackControllerApiFp().accountViewCallback(code, state, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} code
        * @param {string} [state]
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof AccountViewCallbackControllerApi
*/
export function accountViewCallbackRaw(code, state, options) {
    return AccountViewCallbackControllerApiFp().accountViewCallback(code, state, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * AccountViewClientControllerApi - axios parameter creator
 * @export
 */
export const AccountViewClientControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveAccountViewClient: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('archiveAccountViewClient', 'id', id);
            const localVarPath = `/api/accountview/clients/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectAccountViewClient: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('connectAccountViewClient', 'id', id);
            const localVarPath = `/api/accountview/clients/connect/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountViewClient: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAccountViewClient', 'id', id);
            const localVarPath = `/api/accountview/clients/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountViewClients: async (criteria, page, size, sort, options = {}) => {
            const localVarPath = `/api/accountview/clients`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncAccountViewData: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('syncAccountViewData', 'id', id);
            const localVarPath = `/api/accountview/clients/sync-data/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * AccountViewClientControllerApi - functional programming interface
 * @export
 */
export const AccountViewClientControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = AccountViewClientControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async archiveAccountViewClient(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.archiveAccountViewClient(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async connectAccountViewClient(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.connectAccountViewClient(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccountViewClient(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccountViewClient(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccountViewClients(criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccountViewClients(criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncAccountViewData(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncAccountViewData(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * AccountViewClientControllerApi - factory interface
 * @export
 */
export const AccountViewClientControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AccountViewClientControllerApiFp(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveAccountViewClient(id, options) {
            return localVarFp.archiveAccountViewClient(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectAccountViewClient(id, options) {
            return localVarFp.connectAccountViewClient(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountViewClient(id, options) {
            return localVarFp.getAccountViewClient(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountViewClients(criteria, page, size, sort, options) {
            return localVarFp.getAccountViewClients(criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncAccountViewData(id, options) {
            return localVarFp.syncAccountViewData(id, options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof AccountViewClientControllerApi
*/
export function archiveAccountViewClient(id, options) {
    return AccountViewClientControllerApiFp().archiveAccountViewClient(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof AccountViewClientControllerApi
*/
export function connectAccountViewClient(id, options) {
    return AccountViewClientControllerApiFp().connectAccountViewClient(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof AccountViewClientControllerApi
*/
export function getAccountViewClient(id, options) {
    return AccountViewClientControllerApiFp().getAccountViewClient(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof AccountViewClientControllerApi
*/
export function getAccountViewClients(criteria, page, size, sort, options) {
    return AccountViewClientControllerApiFp().getAccountViewClients(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof AccountViewClientControllerApi
*/
export function syncAccountViewData(id, options) {
    return AccountViewClientControllerApiFp().syncAccountViewData(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof AccountViewClientControllerApi
*/
export function archiveAccountViewClientRaw(id, options) {
    return AccountViewClientControllerApiFp().archiveAccountViewClient(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof AccountViewClientControllerApi
*/
export function connectAccountViewClientRaw(id, options) {
    return AccountViewClientControllerApiFp().connectAccountViewClient(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof AccountViewClientControllerApi
*/
export function getAccountViewClientRaw(id, options) {
    return AccountViewClientControllerApiFp().getAccountViewClient(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof AccountViewClientControllerApi
*/
export function getAccountViewClientsRaw(criteria, page, size, sort, options) {
    return AccountViewClientControllerApiFp().getAccountViewClients(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof AccountViewClientControllerApi
*/
export function syncAccountViewDataRaw(id, options) {
    return AccountViewClientControllerApiFp().syncAccountViewData(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * AccountViewCompanyControllerApi - axios parameter creator
 * @export
 */
export const AccountViewCompanyControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountViewCompanies: async (criteria, page, size, sort, options = {}) => {
            const localVarPath = `/api/account-view-companies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountViewCompany: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAccountViewCompany', 'id', id);
            const localVarPath = `/api/account-view-companies/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncAccountViewCompaniesForClient: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('syncAccountViewCompaniesForClient', 'id', id);
            const localVarPath = `/api/account-view-companies/sync-for-client/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * AccountViewCompanyControllerApi - functional programming interface
 * @export
 */
export const AccountViewCompanyControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = AccountViewCompanyControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccountViewCompanies(criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccountViewCompanies(criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccountViewCompany(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccountViewCompany(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncAccountViewCompaniesForClient(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncAccountViewCompaniesForClient(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * AccountViewCompanyControllerApi - factory interface
 * @export
 */
export const AccountViewCompanyControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AccountViewCompanyControllerApiFp(configuration);
    return {
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountViewCompanies(criteria, page, size, sort, options) {
            return localVarFp.getAccountViewCompanies(criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountViewCompany(id, options) {
            return localVarFp.getAccountViewCompany(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncAccountViewCompaniesForClient(id, options) {
            return localVarFp.syncAccountViewCompaniesForClient(id, options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof AccountViewCompanyControllerApi
*/
export function getAccountViewCompanies(criteria, page, size, sort, options) {
    return AccountViewCompanyControllerApiFp().getAccountViewCompanies(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof AccountViewCompanyControllerApi
*/
export function getAccountViewCompany(id, options) {
    return AccountViewCompanyControllerApiFp().getAccountViewCompany(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof AccountViewCompanyControllerApi
*/
export function syncAccountViewCompaniesForClient(id, options) {
    return AccountViewCompanyControllerApiFp().syncAccountViewCompaniesForClient(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof AccountViewCompanyControllerApi
*/
export function getAccountViewCompaniesRaw(criteria, page, size, sort, options) {
    return AccountViewCompanyControllerApiFp().getAccountViewCompanies(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof AccountViewCompanyControllerApi
*/
export function getAccountViewCompanyRaw(id, options) {
    return AccountViewCompanyControllerApiFp().getAccountViewCompany(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof AccountViewCompanyControllerApi
*/
export function syncAccountViewCompaniesForClientRaw(id, options) {
    return AccountViewCompanyControllerApiFp().syncAccountViewCompaniesForClient(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * AccountViewJournalControllerApi - axios parameter creator
 * @export
 */
export const AccountViewJournalControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountViewJournal: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAccountViewJournal', 'id', id);
            const localVarPath = `/api/account-view-journal/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountViewJournals: async (criteria, page, size, sort, options = {}) => {
            const localVarPath = `/api/account-view-journal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * AccountViewJournalControllerApi - functional programming interface
 * @export
 */
export const AccountViewJournalControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = AccountViewJournalControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccountViewJournal(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccountViewJournal(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccountViewJournals(criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccountViewJournals(criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * AccountViewJournalControllerApi - factory interface
 * @export
 */
export const AccountViewJournalControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AccountViewJournalControllerApiFp(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountViewJournal(id, options) {
            return localVarFp.getAccountViewJournal(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountViewJournals(criteria, page, size, sort, options) {
            return localVarFp.getAccountViewJournals(criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof AccountViewJournalControllerApi
*/
export function getAccountViewJournal(id, options) {
    return AccountViewJournalControllerApiFp().getAccountViewJournal(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof AccountViewJournalControllerApi
*/
export function getAccountViewJournals(criteria, page, size, sort, options) {
    return AccountViewJournalControllerApiFp().getAccountViewJournals(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof AccountViewJournalControllerApi
*/
export function getAccountViewJournalRaw(id, options) {
    return AccountViewJournalControllerApiFp().getAccountViewJournal(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof AccountViewJournalControllerApi
*/
export function getAccountViewJournalsRaw(criteria, page, size, sort, options) {
    return AccountViewJournalControllerApiFp().getAccountViewJournals(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * ActivityLogApi - axios parameter creator
 * @export
 */
export const ActivityLogApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivityLog: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getActivityLog', 'id', id);
            const localVarPath = `/api/activity-logs/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivityLogs: async (criteria, page, size, sort, options = {}) => {
            const localVarPath = `/api/activity-logs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ActivityLogApi - functional programming interface
 * @export
 */
export const ActivityLogApiFp = function (configuration) {
    const localVarAxiosParamCreator = ActivityLogApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActivityLog(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActivityLog(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActivityLogs(criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActivityLogs(criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * ActivityLogApi - factory interface
 * @export
 */
export const ActivityLogApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ActivityLogApiFp(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivityLog(id, options) {
            return localVarFp.getActivityLog(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivityLogs(criteria, page, size, sort, options) {
            return localVarFp.getActivityLogs(criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ActivityLogApi
*/
export function getActivityLog(id, options) {
    return ActivityLogApiFp().getActivityLog(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ActivityLogApi
*/
export function getActivityLogs(criteria, page, size, sort, options) {
    return ActivityLogApiFp().getActivityLogs(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ActivityLogApi
*/
export function getActivityLogRaw(id, options) {
    return ActivityLogApiFp().getActivityLog(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ActivityLogApi
*/
export function getActivityLogsRaw(criteria, page, size, sort, options) {
    return ActivityLogApiFp().getActivityLogs(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * AddressesApi - axios parameter creator
 * @export
 */
export const AddressesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {CreateAddressData} createAddressData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAddress: async (createAddressData, options = {}) => {
            // verify required parameter 'createAddressData' is not null or undefined
            assertParamExists('createAddress', 'createAddressData', createAddressData);
            const localVarPath = `/api/addresses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createAddressData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAddress: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteAddress', 'id', id);
            const localVarPath = `/api/addresses/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddress: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAddress', 'id', id);
            const localVarPath = `/api/addresses/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddresses: async (criteria, page, size, sort, options = {}) => {
            const localVarPath = `/api/addresses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {CreateOrUpdateAddressData} createOrUpdateAddressData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAddress: async (id, createOrUpdateAddressData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateAddress', 'id', id);
            // verify required parameter 'createOrUpdateAddressData' is not null or undefined
            assertParamExists('updateAddress', 'createOrUpdateAddressData', createOrUpdateAddressData);
            const localVarPath = `/api/addresses/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createOrUpdateAddressData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * AddressesApi - functional programming interface
 * @export
 */
export const AddressesApiFp = function (configuration) {
    const localVarAxiosParamCreator = AddressesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {CreateAddressData} createAddressData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAddress(createAddressData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAddress(createAddressData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAddress(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAddress(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAddress(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAddress(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAddresses(criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAddresses(criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {CreateOrUpdateAddressData} createOrUpdateAddressData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAddress(id, createOrUpdateAddressData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAddress(id, createOrUpdateAddressData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * AddressesApi - factory interface
 * @export
 */
export const AddressesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AddressesApiFp(configuration);
    return {
        /**
         *
         * @param {CreateAddressData} createAddressData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAddress(createAddressData, options) {
            return localVarFp.createAddress(createAddressData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAddress(id, options) {
            return localVarFp.deleteAddress(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddress(id, options) {
            return localVarFp.getAddress(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddresses(criteria, page, size, sort, options) {
            return localVarFp.getAddresses(criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {CreateOrUpdateAddressData} createOrUpdateAddressData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAddress(id, createOrUpdateAddressData, options) {
            return localVarFp.updateAddress(id, createOrUpdateAddressData, options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
        * @param {CreateAddressData} createAddressData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof AddressesApi
*/
export function createAddress(createAddressData, options) {
    return AddressesApiFp().createAddress(createAddressData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof AddressesApi
*/
export function deleteAddress(id, options) {
    return AddressesApiFp().deleteAddress(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof AddressesApi
*/
export function getAddress(id, options) {
    return AddressesApiFp().getAddress(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof AddressesApi
*/
export function getAddresses(criteria, page, size, sort, options) {
    return AddressesApiFp().getAddresses(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {CreateOrUpdateAddressData} createOrUpdateAddressData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof AddressesApi
*/
export function updateAddress(id, createOrUpdateAddressData, options) {
    return AddressesApiFp().updateAddress(id, createOrUpdateAddressData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {CreateAddressData} createAddressData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof AddressesApi
*/
export function createAddressRaw(createAddressData, options) {
    return AddressesApiFp().createAddress(createAddressData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof AddressesApi
*/
export function deleteAddressRaw(id, options) {
    return AddressesApiFp().deleteAddress(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof AddressesApi
*/
export function getAddressRaw(id, options) {
    return AddressesApiFp().getAddress(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof AddressesApi
*/
export function getAddressesRaw(criteria, page, size, sort, options) {
    return AddressesApiFp().getAddresses(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {CreateOrUpdateAddressData} createOrUpdateAddressData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof AddressesApi
*/
export function updateAddressRaw(id, createOrUpdateAddressData, options) {
    return AddressesApiFp().updateAddress(id, createOrUpdateAddressData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * AdminApi - axios parameter creator
 * @export
 */
export const AdminApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIndexedEntities: async (entity, options = {}) => {
            // verify required parameter 'entity' is not null or undefined
            assertParamExists('getIndexedEntities', 'entity', entity);
            const localVarPath = `/api/admin-panel/index-stats/{entity}`
                .replace(`{${"entity"}}`, encodeURIComponent(String(entity)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {File} file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importProductCategories: async (file, options = {}) => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('importProductCategories', 'file', file);
            const localVarPath = `/api/admin-panel/import-subcategories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (file !== undefined) {
                localVarFormParams.append('file', file);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        indexSearch: async (options = {}) => {
            const localVarPath = `/api/admin-panel/index-search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        indexSearchForEntity: async (entity, options = {}) => {
            // verify required parameter 'entity' is not null or undefined
            assertParamExists('indexSearchForEntity', 'entity', entity);
            const localVarPath = `/api/admin-panel/index-search/{entity}`
                .replace(`{${"entity"}}`, encodeURIComponent(String(entity)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshCompanyCache: async (options = {}) => {
            const localVarPath = `/api/admin-panel/refresh-company`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshLabelCache: async (options = {}) => {
            const localVarPath = `/api/admin-panel/refresh-label`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshProductionStepCache: async (options = {}) => {
            const localVarPath = `/api/admin-panel/refresh-production-step`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshRoleCache: async (options = {}) => {
            const localVarPath = `/api/admin-panel/refresh-role`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * AdminApi - functional programming interface
 * @export
 */
export const AdminApiFp = function (configuration) {
    const localVarAxiosParamCreator = AdminApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIndexedEntities(entity, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIndexedEntities(entity, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {File} file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importProductCategories(file, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importProductCategories(file, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async indexSearch(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.indexSearch(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async indexSearchForEntity(entity, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.indexSearchForEntity(entity, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refreshCompanyCache(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refreshCompanyCache(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refreshLabelCache(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refreshLabelCache(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refreshProductionStepCache(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refreshProductionStepCache(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refreshRoleCache(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refreshRoleCache(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * AdminApi - factory interface
 * @export
 */
export const AdminApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AdminApiFp(configuration);
    return {
        /**
         *
         * @param {string} entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIndexedEntities(entity, options) {
            return localVarFp.getIndexedEntities(entity, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {File} file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importProductCategories(file, options) {
            return localVarFp.importProductCategories(file, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        indexSearch(options) {
            return localVarFp.indexSearch(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        indexSearchForEntity(entity, options) {
            return localVarFp.indexSearchForEntity(entity, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshCompanyCache(options) {
            return localVarFp.refreshCompanyCache(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshLabelCache(options) {
            return localVarFp.refreshLabelCache(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshProductionStepCache(options) {
            return localVarFp.refreshProductionStepCache(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshRoleCache(options) {
            return localVarFp.refreshRoleCache(options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
        * @param {string} entity
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof AdminApi
*/
export function getIndexedEntities(entity, options) {
    return AdminApiFp().getIndexedEntities(entity, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {File} file
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof AdminApi
*/
export function importProductCategories(file, options) {
    return AdminApiFp().importProductCategories(file, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof AdminApi
*/
export function indexSearch(options) {
    return AdminApiFp().indexSearch(options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} entity
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof AdminApi
*/
export function indexSearchForEntity(entity, options) {
    return AdminApiFp().indexSearchForEntity(entity, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof AdminApi
*/
export function refreshCompanyCache(options) {
    return AdminApiFp().refreshCompanyCache(options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof AdminApi
*/
export function refreshLabelCache(options) {
    return AdminApiFp().refreshLabelCache(options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof AdminApi
*/
export function refreshProductionStepCache(options) {
    return AdminApiFp().refreshProductionStepCache(options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof AdminApi
*/
export function refreshRoleCache(options) {
    return AdminApiFp().refreshRoleCache(options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} entity
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof AdminApi
*/
export function getIndexedEntitiesRaw(entity, options) {
    return AdminApiFp().getIndexedEntities(entity, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {File} file
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof AdminApi
*/
export function importProductCategoriesRaw(file, options) {
    return AdminApiFp().importProductCategories(file, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof AdminApi
*/
export function indexSearchRaw(options) {
    return AdminApiFp().indexSearch(options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} entity
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof AdminApi
*/
export function indexSearchForEntityRaw(entity, options) {
    return AdminApiFp().indexSearchForEntity(entity, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof AdminApi
*/
export function refreshCompanyCacheRaw(options) {
    return AdminApiFp().refreshCompanyCache(options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof AdminApi
*/
export function refreshLabelCacheRaw(options) {
    return AdminApiFp().refreshLabelCache(options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof AdminApi
*/
export function refreshProductionStepCacheRaw(options) {
    return AdminApiFp().refreshProductionStepCache(options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof AdminApi
*/
export function refreshRoleCacheRaw(options) {
    return AdminApiFp().refreshRoleCache(options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * ApplicationApi - axios parameter creator
 * @export
 */
export const ApplicationApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableResources: async (options = {}) => {
            const localVarPath = `/api/application/resources`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCreateForm: async (name, options = {}) => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('getCreateForm', 'name', name);
            const localVarPath = `/api/application/forms/{name}`
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getForms: async (options = {}) => {
            const localVarPath = `/api/application/forms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSingleGridColumnDefinition: async (resource, options = {}) => {
            // verify required parameter 'resource' is not null or undefined
            assertParamExists('getSingleGridColumnDefinition', 'resource', resource);
            const localVarPath = `/api/application/grid-column-definition/{resource}`
                .replace(`{${"resource"}}`, encodeURIComponent(String(resource)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [localeCode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTranslations: async (localeCode, options = {}) => {
            const localVarPath = `/api/application/translations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (localeCode !== undefined) {
                localVarQueryParameter['localeCode'] = localeCode;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} name
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUpdateForm: async (name, id, options = {}) => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('getUpdateForm', 'name', name);
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getUpdateForm', 'id', id);
            const localVarPath = `/api/application/forms/{name}/{id}`
                .replace(`{${"name"}}`, encodeURIComponent(String(name)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshApplicationCaches: async (options = {}) => {
            const localVarPath = `/api/admin/refresh-cache`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ApplicationApi - functional programming interface
 * @export
 */
export const ApplicationApiFp = function (configuration) {
    const localVarAxiosParamCreator = ApplicationApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAvailableResources(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAvailableResources(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCreateForm(name, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCreateForm(name, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getForms(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getForms(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSingleGridColumnDefinition(resource, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSingleGridColumnDefinition(resource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} [localeCode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTranslations(localeCode, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTranslations(localeCode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} name
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUpdateForm(name, id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUpdateForm(name, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refreshApplicationCaches(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refreshApplicationCaches(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * ApplicationApi - factory interface
 * @export
 */
export const ApplicationApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ApplicationApiFp(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableResources(options) {
            return localVarFp.getAvailableResources(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCreateForm(name, options) {
            return localVarFp.getCreateForm(name, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getForms(options) {
            return localVarFp.getForms(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSingleGridColumnDefinition(resource, options) {
            return localVarFp.getSingleGridColumnDefinition(resource, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [localeCode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTranslations(localeCode, options) {
            return localVarFp.getTranslations(localeCode, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} name
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUpdateForm(name, id, options) {
            return localVarFp.getUpdateForm(name, id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshApplicationCaches(options) {
            return localVarFp.refreshApplicationCaches(options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ApplicationApi
*/
export function getAvailableResources(options) {
    return ApplicationApiFp().getAvailableResources(options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} name
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ApplicationApi
*/
export function getCreateForm(name, options) {
    return ApplicationApiFp().getCreateForm(name, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ApplicationApi
*/
export function getForms(options) {
    return ApplicationApiFp().getForms(options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} resource
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ApplicationApi
*/
export function getSingleGridColumnDefinition(resource, options) {
    return ApplicationApiFp().getSingleGridColumnDefinition(resource, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} [localeCode]
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ApplicationApi
*/
export function getTranslations(localeCode, options) {
    return ApplicationApiFp().getTranslations(localeCode, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} name
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ApplicationApi
*/
export function getUpdateForm(name, id, options) {
    return ApplicationApiFp().getUpdateForm(name, id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ApplicationApi
*/
export function refreshApplicationCaches(options) {
    return ApplicationApiFp().refreshApplicationCaches(options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ApplicationApi
*/
export function getAvailableResourcesRaw(options) {
    return ApplicationApiFp().getAvailableResources(options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} name
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ApplicationApi
*/
export function getCreateFormRaw(name, options) {
    return ApplicationApiFp().getCreateForm(name, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ApplicationApi
*/
export function getFormsRaw(options) {
    return ApplicationApiFp().getForms(options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} resource
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ApplicationApi
*/
export function getSingleGridColumnDefinitionRaw(resource, options) {
    return ApplicationApiFp().getSingleGridColumnDefinition(resource, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} [localeCode]
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ApplicationApi
*/
export function getTranslationsRaw(localeCode, options) {
    return ApplicationApiFp().getTranslations(localeCode, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} name
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ApplicationApi
*/
export function getUpdateFormRaw(name, id, options) {
    return ApplicationApiFp().getUpdateForm(name, id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ApplicationApi
*/
export function refreshApplicationCachesRaw(options) {
    return ApplicationApiFp().refreshApplicationCaches(options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * BartenderIntegrationApi - axios parameter creator
 * @export
 */
export const BartenderIntegrationApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {'CORE' | 'FINANCE' | 'PRODUCTION' | 'PURCHASING' | 'SALES' | 'STOCK' | 'INCOME' | 'OUTCOME'} module
         * @param {string} entityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBartenderSampleFile: async (module, entityId, options = {}) => {
            // verify required parameter 'module' is not null or undefined
            assertParamExists('getBartenderSampleFile', 'module', module);
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('getBartenderSampleFile', 'entityId', entityId);
            const localVarPath = `/api/integrations/bartender/sample-file`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (module !== undefined) {
                localVarQueryParameter['module'] = module;
            }
            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * BartenderIntegrationApi - functional programming interface
 * @export
 */
export const BartenderIntegrationApiFp = function (configuration) {
    const localVarAxiosParamCreator = BartenderIntegrationApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {'CORE' | 'FINANCE' | 'PRODUCTION' | 'PURCHASING' | 'SALES' | 'STOCK' | 'INCOME' | 'OUTCOME'} module
         * @param {string} entityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBartenderSampleFile(module, entityId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBartenderSampleFile(module, entityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * BartenderIntegrationApi - factory interface
 * @export
 */
export const BartenderIntegrationApiFactory = function (configuration, basePath, axios) {
    const localVarFp = BartenderIntegrationApiFp(configuration);
    return {
        /**
         *
         * @param {'CORE' | 'FINANCE' | 'PRODUCTION' | 'PURCHASING' | 'SALES' | 'STOCK' | 'INCOME' | 'OUTCOME'} module
         * @param {string} entityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBartenderSampleFile(module, entityId, options) {
            return localVarFp.getBartenderSampleFile(module, entityId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
        * @param {'CORE' | 'FINANCE' | 'PRODUCTION' | 'PURCHASING' | 'SALES' | 'STOCK' | 'INCOME' | 'OUTCOME'} module
        * @param {string} entityId
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof BartenderIntegrationApi
*/
export function getBartenderSampleFile(module, entityId, options) {
    return BartenderIntegrationApiFp().getBartenderSampleFile(module, entityId, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {'CORE' | 'FINANCE' | 'PRODUCTION' | 'PURCHASING' | 'SALES' | 'STOCK' | 'INCOME' | 'OUTCOME'} module
        * @param {string} entityId
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof BartenderIntegrationApi
*/
export function getBartenderSampleFileRaw(module, entityId, options) {
    return BartenderIntegrationApiFp().getBartenderSampleFile(module, entityId, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * BartenderLabelTemplateControllerApi - axios parameter creator
 * @export
 */
export const BartenderLabelTemplateControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {CreateBartenderDocumentData} createBartenderDocumentData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBartenderLabelTemplate: async (createBartenderDocumentData, options = {}) => {
            // verify required parameter 'createBartenderDocumentData' is not null or undefined
            assertParamExists('createBartenderLabelTemplate', 'createBartenderDocumentData', createBartenderDocumentData);
            const localVarPath = `/api/bartender-documents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createBartenderDocumentData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBartenderLabelTemplate: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteBartenderLabelTemplate', 'id', id);
            const localVarPath = `/api/bartender-documents/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBartenderLabelTemplate: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getBartenderLabelTemplate', 'id', id);
            const localVarPath = `/api/bartender-documents/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBartenderLabelTemplates: async (criteria, page, size, sort, options = {}) => {
            const localVarPath = `/api/bartender-documents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {UpdateBartenderDocumentData} updateBartenderDocumentData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBartenderLabelTemplate: async (id, updateBartenderDocumentData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateBartenderLabelTemplate', 'id', id);
            // verify required parameter 'updateBartenderDocumentData' is not null or undefined
            assertParamExists('updateBartenderLabelTemplate', 'updateBartenderDocumentData', updateBartenderDocumentData);
            const localVarPath = `/api/bartender-documents/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(updateBartenderDocumentData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * BartenderLabelTemplateControllerApi - functional programming interface
 * @export
 */
export const BartenderLabelTemplateControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = BartenderLabelTemplateControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {CreateBartenderDocumentData} createBartenderDocumentData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createBartenderLabelTemplate(createBartenderDocumentData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createBartenderLabelTemplate(createBartenderDocumentData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteBartenderLabelTemplate(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteBartenderLabelTemplate(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBartenderLabelTemplate(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBartenderLabelTemplate(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBartenderLabelTemplates(criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBartenderLabelTemplates(criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {UpdateBartenderDocumentData} updateBartenderDocumentData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateBartenderLabelTemplate(id, updateBartenderDocumentData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateBartenderLabelTemplate(id, updateBartenderDocumentData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * BartenderLabelTemplateControllerApi - factory interface
 * @export
 */
export const BartenderLabelTemplateControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = BartenderLabelTemplateControllerApiFp(configuration);
    return {
        /**
         *
         * @param {CreateBartenderDocumentData} createBartenderDocumentData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBartenderLabelTemplate(createBartenderDocumentData, options) {
            return localVarFp.createBartenderLabelTemplate(createBartenderDocumentData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBartenderLabelTemplate(id, options) {
            return localVarFp.deleteBartenderLabelTemplate(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBartenderLabelTemplate(id, options) {
            return localVarFp.getBartenderLabelTemplate(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBartenderLabelTemplates(criteria, page, size, sort, options) {
            return localVarFp.getBartenderLabelTemplates(criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {UpdateBartenderDocumentData} updateBartenderDocumentData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBartenderLabelTemplate(id, updateBartenderDocumentData, options) {
            return localVarFp.updateBartenderLabelTemplate(id, updateBartenderDocumentData, options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
        * @param {CreateBartenderDocumentData} createBartenderDocumentData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof BartenderLabelTemplateControllerApi
*/
export function createBartenderLabelTemplate(createBartenderDocumentData, options) {
    return BartenderLabelTemplateControllerApiFp().createBartenderLabelTemplate(createBartenderDocumentData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof BartenderLabelTemplateControllerApi
*/
export function deleteBartenderLabelTemplate(id, options) {
    return BartenderLabelTemplateControllerApiFp().deleteBartenderLabelTemplate(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof BartenderLabelTemplateControllerApi
*/
export function getBartenderLabelTemplate(id, options) {
    return BartenderLabelTemplateControllerApiFp().getBartenderLabelTemplate(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof BartenderLabelTemplateControllerApi
*/
export function getBartenderLabelTemplates(criteria, page, size, sort, options) {
    return BartenderLabelTemplateControllerApiFp().getBartenderLabelTemplates(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {UpdateBartenderDocumentData} updateBartenderDocumentData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof BartenderLabelTemplateControllerApi
*/
export function updateBartenderLabelTemplate(id, updateBartenderDocumentData, options) {
    return BartenderLabelTemplateControllerApiFp().updateBartenderLabelTemplate(id, updateBartenderDocumentData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {CreateBartenderDocumentData} createBartenderDocumentData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof BartenderLabelTemplateControllerApi
*/
export function createBartenderLabelTemplateRaw(createBartenderDocumentData, options) {
    return BartenderLabelTemplateControllerApiFp().createBartenderLabelTemplate(createBartenderDocumentData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof BartenderLabelTemplateControllerApi
*/
export function deleteBartenderLabelTemplateRaw(id, options) {
    return BartenderLabelTemplateControllerApiFp().deleteBartenderLabelTemplate(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof BartenderLabelTemplateControllerApi
*/
export function getBartenderLabelTemplateRaw(id, options) {
    return BartenderLabelTemplateControllerApiFp().getBartenderLabelTemplate(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof BartenderLabelTemplateControllerApi
*/
export function getBartenderLabelTemplatesRaw(criteria, page, size, sort, options) {
    return BartenderLabelTemplateControllerApiFp().getBartenderLabelTemplates(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {UpdateBartenderDocumentData} updateBartenderDocumentData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof BartenderLabelTemplateControllerApi
*/
export function updateBartenderLabelTemplateRaw(id, updateBartenderDocumentData, options) {
    return BartenderLabelTemplateControllerApiFp().updateBartenderLabelTemplate(id, updateBartenderDocumentData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * CompaniesApi - axios parameter creator
 * @export
 */
export const CompaniesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveCompany: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('archiveCompany', 'id', id);
            const localVarPath = `/api/companies/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {CreateCompanyData} createCompanyData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCompany: async (createCompanyData, options = {}) => {
            // verify required parameter 'createCompanyData' is not null or undefined
            assertParamExists('createCompany', 'createCompanyData', createCompanyData);
            const localVarPath = `/api/companies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createCompanyData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanies: async (criteria, page, size, sort, options = {}) => {
            const localVarPath = `/api/companies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompany: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCompany', 'id', id);
            const localVarPath = `/api/companies/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentCompany: async (options = {}) => {
            const localVarPath = `/api/companies/current`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {UpdateCompanyData} data
         * @param {File} [files]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompany: async (id, data, files, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateCompany', 'id', id);
            // verify required parameter 'data' is not null or undefined
            assertParamExists('updateCompany', 'data', data);
            const localVarPath = `/api/companies/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (data !== undefined) {
                localVarFormParams.append('data', new Blob([JSON.stringify(data)], { type: "application/json", }));
            }
            if (files !== undefined) {
                localVarFormParams.append('files', files);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * CompaniesApi - functional programming interface
 * @export
 */
export const CompaniesApiFp = function (configuration) {
    const localVarAxiosParamCreator = CompaniesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async archiveCompany(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.archiveCompany(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {CreateCompanyData} createCompanyData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCompany(createCompanyData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCompany(createCompanyData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompanies(criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompanies(criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompany(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompany(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrentCompany(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrentCompany(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {UpdateCompanyData} data
         * @param {File} [files]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCompany(id, data, files, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCompany(id, data, files, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * CompaniesApi - factory interface
 * @export
 */
export const CompaniesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CompaniesApiFp(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveCompany(id, options) {
            return localVarFp.archiveCompany(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CreateCompanyData} createCompanyData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCompany(createCompanyData, options) {
            return localVarFp.createCompany(createCompanyData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanies(criteria, page, size, sort, options) {
            return localVarFp.getCompanies(criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompany(id, options) {
            return localVarFp.getCompany(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentCompany(options) {
            return localVarFp.getCurrentCompany(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {UpdateCompanyData} data
         * @param {File} [files]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompany(id, data, files, options) {
            return localVarFp.updateCompany(id, data, files, options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof CompaniesApi
*/
export function archiveCompany(id, options) {
    return CompaniesApiFp().archiveCompany(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {CreateCompanyData} createCompanyData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof CompaniesApi
*/
export function createCompany(createCompanyData, options) {
    return CompaniesApiFp().createCompany(createCompanyData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof CompaniesApi
*/
export function getCompanies(criteria, page, size, sort, options) {
    return CompaniesApiFp().getCompanies(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof CompaniesApi
*/
export function getCompany(id, options) {
    return CompaniesApiFp().getCompany(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof CompaniesApi
*/
export function getCurrentCompany(options) {
    return CompaniesApiFp().getCurrentCompany(options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {UpdateCompanyData} data
        * @param {File} [files]
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof CompaniesApi
*/
export function updateCompany(id, data, files, options) {
    return CompaniesApiFp().updateCompany(id, data, files, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof CompaniesApi
*/
export function archiveCompanyRaw(id, options) {
    return CompaniesApiFp().archiveCompany(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {CreateCompanyData} createCompanyData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof CompaniesApi
*/
export function createCompanyRaw(createCompanyData, options) {
    return CompaniesApiFp().createCompany(createCompanyData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof CompaniesApi
*/
export function getCompaniesRaw(criteria, page, size, sort, options) {
    return CompaniesApiFp().getCompanies(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof CompaniesApi
*/
export function getCompanyRaw(id, options) {
    return CompaniesApiFp().getCompany(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof CompaniesApi
*/
export function getCurrentCompanyRaw(options) {
    return CompaniesApiFp().getCurrentCompany(options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {UpdateCompanyData} data
        * @param {File} [files]
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof CompaniesApi
*/
export function updateCompanyRaw(id, data, files, options) {
    return CompaniesApiFp().updateCompany(id, data, files, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * ContactsApi - axios parameter creator
 * @export
 */
export const ContactsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {CreateContactData} createContactData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createContact: async (createContactData, options = {}) => {
            // verify required parameter 'createContactData' is not null or undefined
            assertParamExists('createContact', 'createContactData', createContactData);
            const localVarPath = `/api/contacts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createContactData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteContact: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteContact', 'id', id);
            const localVarPath = `/api/contacts/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContact: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getContact', 'id', id);
            const localVarPath = `/api/contacts/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContacts: async (criteria, page, size, sort, options = {}) => {
            const localVarPath = `/api/contacts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {UpdateContactData} updateContactData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateContact: async (id, updateContactData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateContact', 'id', id);
            // verify required parameter 'updateContactData' is not null or undefined
            assertParamExists('updateContact', 'updateContactData', updateContactData);
            const localVarPath = `/api/contacts/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(updateContactData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ContactsApi - functional programming interface
 * @export
 */
export const ContactsApiFp = function (configuration) {
    const localVarAxiosParamCreator = ContactsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {CreateContactData} createContactData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createContact(createContactData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createContact(createContactData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteContact(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteContact(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getContact(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getContact(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getContacts(criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getContacts(criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {UpdateContactData} updateContactData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateContact(id, updateContactData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateContact(id, updateContactData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * ContactsApi - factory interface
 * @export
 */
export const ContactsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ContactsApiFp(configuration);
    return {
        /**
         *
         * @param {CreateContactData} createContactData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createContact(createContactData, options) {
            return localVarFp.createContact(createContactData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteContact(id, options) {
            return localVarFp.deleteContact(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContact(id, options) {
            return localVarFp.getContact(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContacts(criteria, page, size, sort, options) {
            return localVarFp.getContacts(criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {UpdateContactData} updateContactData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateContact(id, updateContactData, options) {
            return localVarFp.updateContact(id, updateContactData, options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
        * @param {CreateContactData} createContactData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ContactsApi
*/
export function createContact(createContactData, options) {
    return ContactsApiFp().createContact(createContactData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ContactsApi
*/
export function deleteContact(id, options) {
    return ContactsApiFp().deleteContact(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ContactsApi
*/
export function getContact(id, options) {
    return ContactsApiFp().getContact(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ContactsApi
*/
export function getContacts(criteria, page, size, sort, options) {
    return ContactsApiFp().getContacts(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {UpdateContactData} updateContactData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ContactsApi
*/
export function updateContact(id, updateContactData, options) {
    return ContactsApiFp().updateContact(id, updateContactData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {CreateContactData} createContactData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ContactsApi
*/
export function createContactRaw(createContactData, options) {
    return ContactsApiFp().createContact(createContactData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ContactsApi
*/
export function deleteContactRaw(id, options) {
    return ContactsApiFp().deleteContact(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ContactsApi
*/
export function getContactRaw(id, options) {
    return ContactsApiFp().getContact(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ContactsApi
*/
export function getContactsRaw(criteria, page, size, sort, options) {
    return ContactsApiFp().getContacts(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {UpdateContactData} updateContactData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ContactsApi
*/
export function updateContactRaw(id, updateContactData, options) {
    return ContactsApiFp().updateContact(id, updateContactData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * CostTypesApi - axios parameter creator
 * @export
 */
export const CostTypesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveCostType: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('archiveCostType', 'id', id);
            const localVarPath = `/api/cost-types/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {CreateCostTypeData} createCostTypeData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCostType: async (createCostTypeData, options = {}) => {
            // verify required parameter 'createCostTypeData' is not null or undefined
            assertParamExists('createCostType', 'createCostTypeData', createCostTypeData);
            const localVarPath = `/api/cost-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createCostTypeData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCostType: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCostType', 'id', id);
            const localVarPath = `/api/cost-types/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCostTypes: async (criteria, page, size, sort, options = {}) => {
            const localVarPath = `/api/cost-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {UpdateCostTypeData} updateCostTypeData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCostType: async (id, updateCostTypeData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateCostType', 'id', id);
            // verify required parameter 'updateCostTypeData' is not null or undefined
            assertParamExists('updateCostType', 'updateCostTypeData', updateCostTypeData);
            const localVarPath = `/api/cost-types/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(updateCostTypeData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * CostTypesApi - functional programming interface
 * @export
 */
export const CostTypesApiFp = function (configuration) {
    const localVarAxiosParamCreator = CostTypesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async archiveCostType(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.archiveCostType(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {CreateCostTypeData} createCostTypeData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCostType(createCostTypeData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCostType(createCostTypeData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCostType(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCostType(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCostTypes(criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCostTypes(criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {UpdateCostTypeData} updateCostTypeData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCostType(id, updateCostTypeData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCostType(id, updateCostTypeData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * CostTypesApi - factory interface
 * @export
 */
export const CostTypesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CostTypesApiFp(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveCostType(id, options) {
            return localVarFp.archiveCostType(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CreateCostTypeData} createCostTypeData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCostType(createCostTypeData, options) {
            return localVarFp.createCostType(createCostTypeData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCostType(id, options) {
            return localVarFp.getCostType(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCostTypes(criteria, page, size, sort, options) {
            return localVarFp.getCostTypes(criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {UpdateCostTypeData} updateCostTypeData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCostType(id, updateCostTypeData, options) {
            return localVarFp.updateCostType(id, updateCostTypeData, options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof CostTypesApi
*/
export function archiveCostType(id, options) {
    return CostTypesApiFp().archiveCostType(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {CreateCostTypeData} createCostTypeData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof CostTypesApi
*/
export function createCostType(createCostTypeData, options) {
    return CostTypesApiFp().createCostType(createCostTypeData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof CostTypesApi
*/
export function getCostType(id, options) {
    return CostTypesApiFp().getCostType(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof CostTypesApi
*/
export function getCostTypes(criteria, page, size, sort, options) {
    return CostTypesApiFp().getCostTypes(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {UpdateCostTypeData} updateCostTypeData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof CostTypesApi
*/
export function updateCostType(id, updateCostTypeData, options) {
    return CostTypesApiFp().updateCostType(id, updateCostTypeData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof CostTypesApi
*/
export function archiveCostTypeRaw(id, options) {
    return CostTypesApiFp().archiveCostType(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {CreateCostTypeData} createCostTypeData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof CostTypesApi
*/
export function createCostTypeRaw(createCostTypeData, options) {
    return CostTypesApiFp().createCostType(createCostTypeData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof CostTypesApi
*/
export function getCostTypeRaw(id, options) {
    return CostTypesApiFp().getCostType(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof CostTypesApi
*/
export function getCostTypesRaw(criteria, page, size, sort, options) {
    return CostTypesApiFp().getCostTypes(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {UpdateCostTypeData} updateCostTypeData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof CostTypesApi
*/
export function updateCostTypeRaw(id, updateCostTypeData, options) {
    return CostTypesApiFp().updateCostType(id, updateCostTypeData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * CountriesApi - axios parameter creator
 * @export
 */
export const CountriesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCountries: async (criteria, page, size, sort, options = {}) => {
            const localVarPath = `/api/countries/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountries: async (criteria, page, size, sort, options = {}) => {
            const localVarPath = `/api/countries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountry: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCountry', 'id', id);
            const localVarPath = `/api/countries/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * CountriesApi - functional programming interface
 * @export
 */
export const CountriesApiFp = function (configuration) {
    const localVarAxiosParamCreator = CountriesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllCountries(criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllCountries(criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCountries(criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCountries(criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCountry(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCountry(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * CountriesApi - factory interface
 * @export
 */
export const CountriesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CountriesApiFp(configuration);
    return {
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCountries(criteria, page, size, sort, options) {
            return localVarFp.getAllCountries(criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountries(criteria, page, size, sort, options) {
            return localVarFp.getCountries(criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountry(id, options) {
            return localVarFp.getCountry(id, options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof CountriesApi
*/
export function getAllCountries(criteria, page, size, sort, options) {
    return CountriesApiFp().getAllCountries(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof CountriesApi
*/
export function getCountries(criteria, page, size, sort, options) {
    return CountriesApiFp().getCountries(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof CountriesApi
*/
export function getCountry(id, options) {
    return CountriesApiFp().getCountry(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof CountriesApi
*/
export function getAllCountriesRaw(criteria, page, size, sort, options) {
    return CountriesApiFp().getAllCountries(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof CountriesApi
*/
export function getCountriesRaw(criteria, page, size, sort, options) {
    return CountriesApiFp().getCountries(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof CountriesApi
*/
export function getCountryRaw(id, options) {
    return CountriesApiFp().getCountry(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * CreditNotesApi - axios parameter creator
 * @export
 */
export const CreditNotesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {CreateCreditNoteData} createCreditNoteData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCreditNote: async (createCreditNoteData, options = {}) => {
            // verify required parameter 'createCreditNoteData' is not null or undefined
            assertParamExists('createCreditNote', 'createCreditNoteData', createCreditNoteData);
            const localVarPath = `/api/credit-notes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createCreditNoteData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * CreditNotesApi - functional programming interface
 * @export
 */
export const CreditNotesApiFp = function (configuration) {
    const localVarAxiosParamCreator = CreditNotesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {CreateCreditNoteData} createCreditNoteData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCreditNote(createCreditNoteData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCreditNote(createCreditNoteData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * CreditNotesApi - factory interface
 * @export
 */
export const CreditNotesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CreditNotesApiFp(configuration);
    return {
        /**
         *
         * @param {CreateCreditNoteData} createCreditNoteData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCreditNote(createCreditNoteData, options) {
            return localVarFp.createCreditNote(createCreditNoteData, options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
        * @param {CreateCreditNoteData} createCreditNoteData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof CreditNotesApi
*/
export function createCreditNote(createCreditNoteData, options) {
    return CreditNotesApiFp().createCreditNote(createCreditNoteData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {CreateCreditNoteData} createCreditNoteData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof CreditNotesApi
*/
export function createCreditNoteRaw(createCreditNoteData, options) {
    return CreditNotesApiFp().createCreditNote(createCreditNoteData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * CurrenciesApi - axios parameter creator
 * @export
 */
export const CurrenciesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCurrencies: async (criteria, page, size, sort, options = {}) => {
            const localVarPath = `/api/currencies/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrencies: async (criteria, page, size, sort, options = {}) => {
            const localVarPath = `/api/currencies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrency: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCurrency', 'id', id);
            const localVarPath = `/api/currencies/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * CurrenciesApi - functional programming interface
 * @export
 */
export const CurrenciesApiFp = function (configuration) {
    const localVarAxiosParamCreator = CurrenciesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllCurrencies(criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllCurrencies(criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrencies(criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrencies(criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrency(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrency(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * CurrenciesApi - factory interface
 * @export
 */
export const CurrenciesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CurrenciesApiFp(configuration);
    return {
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCurrencies(criteria, page, size, sort, options) {
            return localVarFp.getAllCurrencies(criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrencies(criteria, page, size, sort, options) {
            return localVarFp.getCurrencies(criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrency(id, options) {
            return localVarFp.getCurrency(id, options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof CurrenciesApi
*/
export function getAllCurrencies(criteria, page, size, sort, options) {
    return CurrenciesApiFp().getAllCurrencies(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof CurrenciesApi
*/
export function getCurrencies(criteria, page, size, sort, options) {
    return CurrenciesApiFp().getCurrencies(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof CurrenciesApi
*/
export function getCurrency(id, options) {
    return CurrenciesApiFp().getCurrency(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof CurrenciesApi
*/
export function getAllCurrenciesRaw(criteria, page, size, sort, options) {
    return CurrenciesApiFp().getAllCurrencies(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof CurrenciesApi
*/
export function getCurrenciesRaw(criteria, page, size, sort, options) {
    return CurrenciesApiFp().getCurrencies(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof CurrenciesApi
*/
export function getCurrencyRaw(id, options) {
    return CurrenciesApiFp().getCurrency(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * CurrentUserApi - axios parameter creator
 * @export
 */
export const CurrentUserApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {CreateOrUpdateGridPresetData} createOrUpdateGridPresetData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGridPreset: async (createOrUpdateGridPresetData, options = {}) => {
            // verify required parameter 'createOrUpdateGridPresetData' is not null or undefined
            assertParamExists('createGridPreset', 'createOrUpdateGridPresetData', createOrUpdateGridPresetData);
            const localVarPath = `/api/myself/settings/grid-presets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createOrUpdateGridPresetData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        currentSession: async (options = {}) => {
            const localVarPath = `/api/myself/session`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGridPreset: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteGridPreset', 'id', id);
            const localVarPath = `/api/myself/settings/grid-presets/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveCompany: async (options = {}) => {
            const localVarPath = `/api/myself/active-company`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveCompanyLogo: async (options = {}) => {
            const localVarPath = `/api/myself/active-company-logo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} gridKey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDefaultGridPreset: async (gridKey, options = {}) => {
            // verify required parameter 'gridKey' is not null or undefined
            assertParamExists('getDefaultGridPreset', 'gridKey', gridKey);
            const localVarPath = `/api/myself/settings/grid-presets/{gridKey}/default`
                .replace(`{${"gridKey"}}`, encodeURIComponent(String(gridKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} gridKey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGridColumnState: async (gridKey, options = {}) => {
            // verify required parameter 'gridKey' is not null or undefined
            assertParamExists('getGridColumnState', 'gridKey', gridKey);
            const localVarPath = `/api/myself/settings/grid-state/{gridKey}`
                .replace(`{${"gridKey"}}`, encodeURIComponent(String(gridKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} gridKey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGridPaneSize: async (gridKey, options = {}) => {
            // verify required parameter 'gridKey' is not null or undefined
            assertParamExists('getGridPaneSize', 'gridKey', gridKey);
            const localVarPath = `/api/myself/settings/pane-size/{gridKey}`
                .replace(`{${"gridKey"}}`, encodeURIComponent(String(gridKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} gridKey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGridPresets: async (gridKey, options = {}) => {
            // verify required parameter 'gridKey' is not null or undefined
            assertParamExists('getGridPresets', 'gridKey', gridKey);
            const localVarPath = `/api/myself/settings/grid-presets/{gridKey}`
                .replace(`{${"gridKey"}}`, encodeURIComponent(String(gridKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMenuItems: async (options = {}) => {
            const localVarPath = `/api/myself/menu`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserBookmarks: async (options = {}) => {
            const localVarPath = `/api/myself/settings/page-bookmarks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserCompanies: async (options = {}) => {
            const localVarPath = `/api/myself/companies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} gridKey
         * @param {string} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveGridColumnState: async (gridKey, body, options = {}) => {
            // verify required parameter 'gridKey' is not null or undefined
            assertParamExists('saveGridColumnState', 'gridKey', gridKey);
            // verify required parameter 'body' is not null or undefined
            assertParamExists('saveGridColumnState', 'body', body);
            const localVarPath = `/api/myself/settings/grid-state/{gridKey}`
                .replace(`{${"gridKey"}}`, encodeURIComponent(String(gridKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} gridKey
         * @param {UpdatePaneSizeData} updatePaneSizeData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveGridPaneSize: async (gridKey, updatePaneSizeData, options = {}) => {
            // verify required parameter 'gridKey' is not null or undefined
            assertParamExists('saveGridPaneSize', 'gridKey', gridKey);
            // verify required parameter 'updatePaneSizeData' is not null or undefined
            assertParamExists('saveGridPaneSize', 'updatePaneSizeData', updatePaneSizeData);
            const localVarPath = `/api/myself/settings/pane-size/{gridKey}`
                .replace(`{${"gridKey"}}`, encodeURIComponent(String(gridKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(updatePaneSizeData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<string>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveUserBookmarks: async (requestBody, options = {}) => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('saveUserBookmarks', 'requestBody', requestBody);
            const localVarPath = `/api/myself/settings/page-bookmarks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setActiveCompany: async (companyId, options = {}) => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('setActiveCompany', 'companyId', companyId);
            const localVarPath = `/api/myself/active-company`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setDefaultGridPreset: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('setDefaultGridPreset', 'id', id);
            const localVarPath = `/api/myself/settings/grid-presets/{id}/default`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shareGridPreset: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('shareGridPreset', 'id', id);
            const localVarPath = `/api/myself/settings/grid-presets/{id}/share`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {CreateOrUpdateGridPresetData} createOrUpdateGridPresetData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGridPreset: async (id, createOrUpdateGridPresetData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateGridPreset', 'id', id);
            // verify required parameter 'createOrUpdateGridPresetData' is not null or undefined
            assertParamExists('updateGridPreset', 'createOrUpdateGridPresetData', createOrUpdateGridPresetData);
            const localVarPath = `/api/myself/settings/grid-presets/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createOrUpdateGridPresetData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {UpdateStateGridPresetData} updateStateGridPresetData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePresetState: async (id, updateStateGridPresetData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updatePresetState', 'id', id);
            // verify required parameter 'updateStateGridPresetData' is not null or undefined
            assertParamExists('updatePresetState', 'updateStateGridPresetData', updateStateGridPresetData);
            const localVarPath = `/api/myself/settings/grid-presets/{id}/overwrite`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(updateStateGridPresetData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * CurrentUserApi - functional programming interface
 * @export
 */
export const CurrentUserApiFp = function (configuration) {
    const localVarAxiosParamCreator = CurrentUserApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {CreateOrUpdateGridPresetData} createOrUpdateGridPresetData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createGridPreset(createOrUpdateGridPresetData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createGridPreset(createOrUpdateGridPresetData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async currentSession(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.currentSession(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteGridPreset(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteGridPreset(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActiveCompany(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActiveCompany(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActiveCompanyLogo(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActiveCompanyLogo(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} gridKey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDefaultGridPreset(gridKey, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDefaultGridPreset(gridKey, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} gridKey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGridColumnState(gridKey, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGridColumnState(gridKey, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} gridKey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGridPaneSize(gridKey, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGridPaneSize(gridKey, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} gridKey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGridPresets(gridKey, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGridPresets(gridKey, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMenuItems(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMenuItems(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserBookmarks(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserBookmarks(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserCompanies(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserCompanies(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} gridKey
         * @param {string} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveGridColumnState(gridKey, body, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveGridColumnState(gridKey, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} gridKey
         * @param {UpdatePaneSizeData} updatePaneSizeData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveGridPaneSize(gridKey, updatePaneSizeData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveGridPaneSize(gridKey, updatePaneSizeData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {Array<string>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveUserBookmarks(requestBody, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveUserBookmarks(requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setActiveCompany(companyId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setActiveCompany(companyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setDefaultGridPreset(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setDefaultGridPreset(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async shareGridPreset(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.shareGridPreset(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {CreateOrUpdateGridPresetData} createOrUpdateGridPresetData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateGridPreset(id, createOrUpdateGridPresetData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateGridPreset(id, createOrUpdateGridPresetData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {UpdateStateGridPresetData} updateStateGridPresetData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePresetState(id, updateStateGridPresetData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePresetState(id, updateStateGridPresetData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * CurrentUserApi - factory interface
 * @export
 */
export const CurrentUserApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CurrentUserApiFp(configuration);
    return {
        /**
         *
         * @param {CreateOrUpdateGridPresetData} createOrUpdateGridPresetData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGridPreset(createOrUpdateGridPresetData, options) {
            return localVarFp.createGridPreset(createOrUpdateGridPresetData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        currentSession(options) {
            return localVarFp.currentSession(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGridPreset(id, options) {
            return localVarFp.deleteGridPreset(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveCompany(options) {
            return localVarFp.getActiveCompany(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveCompanyLogo(options) {
            return localVarFp.getActiveCompanyLogo(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} gridKey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDefaultGridPreset(gridKey, options) {
            return localVarFp.getDefaultGridPreset(gridKey, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} gridKey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGridColumnState(gridKey, options) {
            return localVarFp.getGridColumnState(gridKey, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} gridKey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGridPaneSize(gridKey, options) {
            return localVarFp.getGridPaneSize(gridKey, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} gridKey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGridPresets(gridKey, options) {
            return localVarFp.getGridPresets(gridKey, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMenuItems(options) {
            return localVarFp.getMenuItems(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserBookmarks(options) {
            return localVarFp.getUserBookmarks(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserCompanies(options) {
            return localVarFp.getUserCompanies(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} gridKey
         * @param {string} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveGridColumnState(gridKey, body, options) {
            return localVarFp.saveGridColumnState(gridKey, body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} gridKey
         * @param {UpdatePaneSizeData} updatePaneSizeData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveGridPaneSize(gridKey, updatePaneSizeData, options) {
            return localVarFp.saveGridPaneSize(gridKey, updatePaneSizeData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<string>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveUserBookmarks(requestBody, options) {
            return localVarFp.saveUserBookmarks(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setActiveCompany(companyId, options) {
            return localVarFp.setActiveCompany(companyId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setDefaultGridPreset(id, options) {
            return localVarFp.setDefaultGridPreset(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shareGridPreset(id, options) {
            return localVarFp.shareGridPreset(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {CreateOrUpdateGridPresetData} createOrUpdateGridPresetData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGridPreset(id, createOrUpdateGridPresetData, options) {
            return localVarFp.updateGridPreset(id, createOrUpdateGridPresetData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {UpdateStateGridPresetData} updateStateGridPresetData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePresetState(id, updateStateGridPresetData, options) {
            return localVarFp.updatePresetState(id, updateStateGridPresetData, options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
        * @param {CreateOrUpdateGridPresetData} createOrUpdateGridPresetData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof CurrentUserApi
*/
export function createGridPreset(createOrUpdateGridPresetData, options) {
    return CurrentUserApiFp().createGridPreset(createOrUpdateGridPresetData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof CurrentUserApi
*/
export function currentSession(options) {
    return CurrentUserApiFp().currentSession(options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof CurrentUserApi
*/
export function deleteGridPreset(id, options) {
    return CurrentUserApiFp().deleteGridPreset(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof CurrentUserApi
*/
export function getActiveCompany(options) {
    return CurrentUserApiFp().getActiveCompany(options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof CurrentUserApi
*/
export function getActiveCompanyLogo(options) {
    return CurrentUserApiFp().getActiveCompanyLogo(options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} gridKey
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof CurrentUserApi
*/
export function getDefaultGridPreset(gridKey, options) {
    return CurrentUserApiFp().getDefaultGridPreset(gridKey, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} gridKey
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof CurrentUserApi
*/
export function getGridColumnState(gridKey, options) {
    return CurrentUserApiFp().getGridColumnState(gridKey, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} gridKey
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof CurrentUserApi
*/
export function getGridPaneSize(gridKey, options) {
    return CurrentUserApiFp().getGridPaneSize(gridKey, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} gridKey
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof CurrentUserApi
*/
export function getGridPresets(gridKey, options) {
    return CurrentUserApiFp().getGridPresets(gridKey, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof CurrentUserApi
*/
export function getMenuItems(options) {
    return CurrentUserApiFp().getMenuItems(options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof CurrentUserApi
*/
export function getUserBookmarks(options) {
    return CurrentUserApiFp().getUserBookmarks(options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof CurrentUserApi
*/
export function getUserCompanies(options) {
    return CurrentUserApiFp().getUserCompanies(options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} gridKey
        * @param {string} body
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof CurrentUserApi
*/
export function saveGridColumnState(gridKey, body, options) {
    return CurrentUserApiFp().saveGridColumnState(gridKey, body, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} gridKey
        * @param {UpdatePaneSizeData} updatePaneSizeData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof CurrentUserApi
*/
export function saveGridPaneSize(gridKey, updatePaneSizeData, options) {
    return CurrentUserApiFp().saveGridPaneSize(gridKey, updatePaneSizeData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {Array<string>} requestBody
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof CurrentUserApi
*/
export function saveUserBookmarks(requestBody, options) {
    return CurrentUserApiFp().saveUserBookmarks(requestBody, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} companyId
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof CurrentUserApi
*/
export function setActiveCompany(companyId, options) {
    return CurrentUserApiFp().setActiveCompany(companyId, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof CurrentUserApi
*/
export function setDefaultGridPreset(id, options) {
    return CurrentUserApiFp().setDefaultGridPreset(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof CurrentUserApi
*/
export function shareGridPreset(id, options) {
    return CurrentUserApiFp().shareGridPreset(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {CreateOrUpdateGridPresetData} createOrUpdateGridPresetData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof CurrentUserApi
*/
export function updateGridPreset(id, createOrUpdateGridPresetData, options) {
    return CurrentUserApiFp().updateGridPreset(id, createOrUpdateGridPresetData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {UpdateStateGridPresetData} updateStateGridPresetData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof CurrentUserApi
*/
export function updatePresetState(id, updateStateGridPresetData, options) {
    return CurrentUserApiFp().updatePresetState(id, updateStateGridPresetData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {CreateOrUpdateGridPresetData} createOrUpdateGridPresetData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof CurrentUserApi
*/
export function createGridPresetRaw(createOrUpdateGridPresetData, options) {
    return CurrentUserApiFp().createGridPreset(createOrUpdateGridPresetData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof CurrentUserApi
*/
export function currentSessionRaw(options) {
    return CurrentUserApiFp().currentSession(options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof CurrentUserApi
*/
export function deleteGridPresetRaw(id, options) {
    return CurrentUserApiFp().deleteGridPreset(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof CurrentUserApi
*/
export function getActiveCompanyRaw(options) {
    return CurrentUserApiFp().getActiveCompany(options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof CurrentUserApi
*/
export function getActiveCompanyLogoRaw(options) {
    return CurrentUserApiFp().getActiveCompanyLogo(options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} gridKey
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof CurrentUserApi
*/
export function getDefaultGridPresetRaw(gridKey, options) {
    return CurrentUserApiFp().getDefaultGridPreset(gridKey, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} gridKey
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof CurrentUserApi
*/
export function getGridColumnStateRaw(gridKey, options) {
    return CurrentUserApiFp().getGridColumnState(gridKey, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} gridKey
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof CurrentUserApi
*/
export function getGridPaneSizeRaw(gridKey, options) {
    return CurrentUserApiFp().getGridPaneSize(gridKey, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} gridKey
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof CurrentUserApi
*/
export function getGridPresetsRaw(gridKey, options) {
    return CurrentUserApiFp().getGridPresets(gridKey, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof CurrentUserApi
*/
export function getMenuItemsRaw(options) {
    return CurrentUserApiFp().getMenuItems(options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof CurrentUserApi
*/
export function getUserBookmarksRaw(options) {
    return CurrentUserApiFp().getUserBookmarks(options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof CurrentUserApi
*/
export function getUserCompaniesRaw(options) {
    return CurrentUserApiFp().getUserCompanies(options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} gridKey
        * @param {string} body
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof CurrentUserApi
*/
export function saveGridColumnStateRaw(gridKey, body, options) {
    return CurrentUserApiFp().saveGridColumnState(gridKey, body, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} gridKey
        * @param {UpdatePaneSizeData} updatePaneSizeData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof CurrentUserApi
*/
export function saveGridPaneSizeRaw(gridKey, updatePaneSizeData, options) {
    return CurrentUserApiFp().saveGridPaneSize(gridKey, updatePaneSizeData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {Array<string>} requestBody
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof CurrentUserApi
*/
export function saveUserBookmarksRaw(requestBody, options) {
    return CurrentUserApiFp().saveUserBookmarks(requestBody, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} companyId
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof CurrentUserApi
*/
export function setActiveCompanyRaw(companyId, options) {
    return CurrentUserApiFp().setActiveCompany(companyId, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof CurrentUserApi
*/
export function setDefaultGridPresetRaw(id, options) {
    return CurrentUserApiFp().setDefaultGridPreset(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof CurrentUserApi
*/
export function shareGridPresetRaw(id, options) {
    return CurrentUserApiFp().shareGridPreset(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {CreateOrUpdateGridPresetData} createOrUpdateGridPresetData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof CurrentUserApi
*/
export function updateGridPresetRaw(id, createOrUpdateGridPresetData, options) {
    return CurrentUserApiFp().updateGridPreset(id, createOrUpdateGridPresetData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {UpdateStateGridPresetData} updateStateGridPresetData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof CurrentUserApi
*/
export function updatePresetStateRaw(id, updateStateGridPresetData, options) {
    return CurrentUserApiFp().updatePresetState(id, updateStateGridPresetData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * DeliveryRequirementsApi - axios parameter creator
 * @export
 */
export const DeliveryRequirementsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {CreateDeliveryRequirementData} createDeliveryRequirementData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDeliveryRequirement: async (createDeliveryRequirementData, options = {}) => {
            // verify required parameter 'createDeliveryRequirementData' is not null or undefined
            assertParamExists('createDeliveryRequirement', 'createDeliveryRequirementData', createDeliveryRequirementData);
            const localVarPath = `/api/delivery-requirements`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createDeliveryRequirementData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDeliveryRequirement: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteDeliveryRequirement', 'id', id);
            const localVarPath = `/api/delivery-requirements/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeliveryRequirement: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getDeliveryRequirement', 'id', id);
            const localVarPath = `/api/delivery-requirements/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeliveryRequirements: async (criteria, page, size, sort, options = {}) => {
            const localVarPath = `/api/delivery-requirements`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {UpdateDeliveryRequirementData} updateDeliveryRequirementData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDeliveryRequirement: async (id, updateDeliveryRequirementData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateDeliveryRequirement', 'id', id);
            // verify required parameter 'updateDeliveryRequirementData' is not null or undefined
            assertParamExists('updateDeliveryRequirement', 'updateDeliveryRequirementData', updateDeliveryRequirementData);
            const localVarPath = `/api/delivery-requirements/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(updateDeliveryRequirementData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * DeliveryRequirementsApi - functional programming interface
 * @export
 */
export const DeliveryRequirementsApiFp = function (configuration) {
    const localVarAxiosParamCreator = DeliveryRequirementsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {CreateDeliveryRequirementData} createDeliveryRequirementData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDeliveryRequirement(createDeliveryRequirementData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDeliveryRequirement(createDeliveryRequirementData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDeliveryRequirement(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDeliveryRequirement(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDeliveryRequirement(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDeliveryRequirement(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDeliveryRequirements(criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDeliveryRequirements(criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {UpdateDeliveryRequirementData} updateDeliveryRequirementData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDeliveryRequirement(id, updateDeliveryRequirementData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDeliveryRequirement(id, updateDeliveryRequirementData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * DeliveryRequirementsApi - factory interface
 * @export
 */
export const DeliveryRequirementsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = DeliveryRequirementsApiFp(configuration);
    return {
        /**
         *
         * @param {CreateDeliveryRequirementData} createDeliveryRequirementData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDeliveryRequirement(createDeliveryRequirementData, options) {
            return localVarFp.createDeliveryRequirement(createDeliveryRequirementData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDeliveryRequirement(id, options) {
            return localVarFp.deleteDeliveryRequirement(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeliveryRequirement(id, options) {
            return localVarFp.getDeliveryRequirement(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeliveryRequirements(criteria, page, size, sort, options) {
            return localVarFp.getDeliveryRequirements(criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {UpdateDeliveryRequirementData} updateDeliveryRequirementData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDeliveryRequirement(id, updateDeliveryRequirementData, options) {
            return localVarFp.updateDeliveryRequirement(id, updateDeliveryRequirementData, options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
        * @param {CreateDeliveryRequirementData} createDeliveryRequirementData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof DeliveryRequirementsApi
*/
export function createDeliveryRequirement(createDeliveryRequirementData, options) {
    return DeliveryRequirementsApiFp().createDeliveryRequirement(createDeliveryRequirementData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof DeliveryRequirementsApi
*/
export function deleteDeliveryRequirement(id, options) {
    return DeliveryRequirementsApiFp().deleteDeliveryRequirement(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof DeliveryRequirementsApi
*/
export function getDeliveryRequirement(id, options) {
    return DeliveryRequirementsApiFp().getDeliveryRequirement(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof DeliveryRequirementsApi
*/
export function getDeliveryRequirements(criteria, page, size, sort, options) {
    return DeliveryRequirementsApiFp().getDeliveryRequirements(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {UpdateDeliveryRequirementData} updateDeliveryRequirementData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof DeliveryRequirementsApi
*/
export function updateDeliveryRequirement(id, updateDeliveryRequirementData, options) {
    return DeliveryRequirementsApiFp().updateDeliveryRequirement(id, updateDeliveryRequirementData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {CreateDeliveryRequirementData} createDeliveryRequirementData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof DeliveryRequirementsApi
*/
export function createDeliveryRequirementRaw(createDeliveryRequirementData, options) {
    return DeliveryRequirementsApiFp().createDeliveryRequirement(createDeliveryRequirementData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof DeliveryRequirementsApi
*/
export function deleteDeliveryRequirementRaw(id, options) {
    return DeliveryRequirementsApiFp().deleteDeliveryRequirement(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof DeliveryRequirementsApi
*/
export function getDeliveryRequirementRaw(id, options) {
    return DeliveryRequirementsApiFp().getDeliveryRequirement(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof DeliveryRequirementsApi
*/
export function getDeliveryRequirementsRaw(criteria, page, size, sort, options) {
    return DeliveryRequirementsApiFp().getDeliveryRequirements(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {UpdateDeliveryRequirementData} updateDeliveryRequirementData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof DeliveryRequirementsApi
*/
export function updateDeliveryRequirementRaw(id, updateDeliveryRequirementData, options) {
    return DeliveryRequirementsApiFp().updateDeliveryRequirement(id, updateDeliveryRequirementData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * DocumentTextsApi - axios parameter creator
 * @export
 */
export const DocumentTextsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {CreateDocumentTextData} createDocumentTextData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDocumentText: async (createDocumentTextData, options = {}) => {
            // verify required parameter 'createDocumentTextData' is not null or undefined
            assertParamExists('createDocumentText', 'createDocumentTextData', createDocumentTextData);
            const localVarPath = `/api/document-texts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createDocumentTextData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDocumentText: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteDocumentText', 'id', id);
            const localVarPath = `/api/document-texts/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentText: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getDocumentText', 'id', id);
            const localVarPath = `/api/document-texts/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentTexts: async (criteria, page, size, sort, options = {}) => {
            const localVarPath = `/api/document-texts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {UpdateDocumentTextData} updateDocumentTextData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDocumentText: async (id, updateDocumentTextData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateDocumentText', 'id', id);
            // verify required parameter 'updateDocumentTextData' is not null or undefined
            assertParamExists('updateDocumentText', 'updateDocumentTextData', updateDocumentTextData);
            const localVarPath = `/api/document-texts/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(updateDocumentTextData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * DocumentTextsApi - functional programming interface
 * @export
 */
export const DocumentTextsApiFp = function (configuration) {
    const localVarAxiosParamCreator = DocumentTextsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {CreateDocumentTextData} createDocumentTextData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDocumentText(createDocumentTextData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDocumentText(createDocumentTextData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDocumentText(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDocumentText(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDocumentText(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDocumentText(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDocumentTexts(criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDocumentTexts(criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {UpdateDocumentTextData} updateDocumentTextData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDocumentText(id, updateDocumentTextData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDocumentText(id, updateDocumentTextData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * DocumentTextsApi - factory interface
 * @export
 */
export const DocumentTextsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = DocumentTextsApiFp(configuration);
    return {
        /**
         *
         * @param {CreateDocumentTextData} createDocumentTextData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDocumentText(createDocumentTextData, options) {
            return localVarFp.createDocumentText(createDocumentTextData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDocumentText(id, options) {
            return localVarFp.deleteDocumentText(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentText(id, options) {
            return localVarFp.getDocumentText(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentTexts(criteria, page, size, sort, options) {
            return localVarFp.getDocumentTexts(criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {UpdateDocumentTextData} updateDocumentTextData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDocumentText(id, updateDocumentTextData, options) {
            return localVarFp.updateDocumentText(id, updateDocumentTextData, options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
        * @param {CreateDocumentTextData} createDocumentTextData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof DocumentTextsApi
*/
export function createDocumentText(createDocumentTextData, options) {
    return DocumentTextsApiFp().createDocumentText(createDocumentTextData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof DocumentTextsApi
*/
export function deleteDocumentText(id, options) {
    return DocumentTextsApiFp().deleteDocumentText(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof DocumentTextsApi
*/
export function getDocumentText(id, options) {
    return DocumentTextsApiFp().getDocumentText(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof DocumentTextsApi
*/
export function getDocumentTexts(criteria, page, size, sort, options) {
    return DocumentTextsApiFp().getDocumentTexts(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {UpdateDocumentTextData} updateDocumentTextData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof DocumentTextsApi
*/
export function updateDocumentText(id, updateDocumentTextData, options) {
    return DocumentTextsApiFp().updateDocumentText(id, updateDocumentTextData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {CreateDocumentTextData} createDocumentTextData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof DocumentTextsApi
*/
export function createDocumentTextRaw(createDocumentTextData, options) {
    return DocumentTextsApiFp().createDocumentText(createDocumentTextData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof DocumentTextsApi
*/
export function deleteDocumentTextRaw(id, options) {
    return DocumentTextsApiFp().deleteDocumentText(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof DocumentTextsApi
*/
export function getDocumentTextRaw(id, options) {
    return DocumentTextsApiFp().getDocumentText(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof DocumentTextsApi
*/
export function getDocumentTextsRaw(criteria, page, size, sort, options) {
    return DocumentTextsApiFp().getDocumentTexts(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {UpdateDocumentTextData} updateDocumentTextData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof DocumentTextsApi
*/
export function updateDocumentTextRaw(id, updateDocumentTextData, options) {
    return DocumentTextsApiFp().updateDocumentText(id, updateDocumentTextData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * DocumentsApi - axios parameter creator
 * @export
 */
export const DocumentsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveReportDesignDocument: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('archiveReportDesignDocument', 'id', id);
            const localVarPath = `/api/report-design-documents/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {CreateReportDesignDocumentData} createReportDesignDocumentData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReportDesignDocument: async (createReportDesignDocumentData, options = {}) => {
            // verify required parameter 'createReportDesignDocumentData' is not null or undefined
            assertParamExists('createReportDesignDocument', 'createReportDesignDocumentData', createReportDesignDocumentData);
            const localVarPath = `/api/report-design-documents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createReportDesignDocumentData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} criteria
         * @param {string} designId
         * @param {'CSV' | 'EXCEL' | 'PDF' | 'PNG'} [format]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadBulkDocument: async (criteria, designId, format, options = {}) => {
            // verify required parameter 'criteria' is not null or undefined
            assertParamExists('downloadBulkDocument', 'criteria', criteria);
            // verify required parameter 'designId' is not null or undefined
            assertParamExists('downloadBulkDocument', 'designId', designId);
            const localVarPath = `/api/document-export/download-bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (designId !== undefined) {
                localVarQueryParameter['designId'] = designId;
            }
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} entityId
         * @param {string} designId
         * @param {'CSV' | 'EXCEL' | 'PDF' | 'PNG'} [format]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadDocument: async (entityId, designId, format, options = {}) => {
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('downloadDocument', 'entityId', entityId);
            // verify required parameter 'designId' is not null or undefined
            assertParamExists('downloadDocument', 'designId', designId);
            const localVarPath = `/api/document-export/download`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }
            if (designId !== undefined) {
                localVarQueryParameter['designId'] = designId;
            }
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<string>} entityIds
         * @param {'SALES_ORDER_CONFIRMATION_WITHOUT_PRICES' | 'SALES_ORDER_CONFIRMATION' | 'SALES_INVOICE' | 'SALES_PACKING_SLIP' | 'SALES_DELIVERY_RECEIPT_WITHOUT_PRICES' | 'SALES_DELIVERY_RECEIPT' | 'SALES_TRANSPORT_DOCUMENT' | 'SALES_ORDER_PALLET_LABEL' | 'SALES_BOX_LABEL' | 'SALES_WEIGHT_LABEL' | 'SALES_LIST' | 'SALES_OTHER' | 'PRICE_LIST' | 'STOCK_BOX_LABEL' | 'STOCK_DOCUMENT' | 'STOCK_LIST' | 'PURCHASING_ORDER_CONFIRMATION' | 'PURCHASING_INCOMING_LOT_DOCUMENT' | 'PURCHASING_UNLOAD_DOCUMENT' | 'PURCHASING_LIST' | 'PURCHASING_OTHER' | 'PRODUCTION_BOX_LABEL' | 'PRODUCTION_ORDER_CONFIRMATION' | 'PRODUCTION_LIST' | 'PRODUCTION_OTHER'} category
         * @param {'CORE' | 'FINANCE' | 'PRODUCTION' | 'PURCHASING' | 'SALES' | 'STOCK' | 'INCOME' | 'OUTCOME'} module
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadListDocument: async (entityIds, category, module, options = {}) => {
            // verify required parameter 'entityIds' is not null or undefined
            assertParamExists('downloadListDocument', 'entityIds', entityIds);
            // verify required parameter 'category' is not null or undefined
            assertParamExists('downloadListDocument', 'category', category);
            // verify required parameter 'module' is not null or undefined
            assertParamExists('downloadListDocument', 'module', module);
            const localVarPath = `/api/document-export/download-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (entityIds) {
                localVarQueryParameter['entityIds'] = entityIds;
            }
            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }
            if (module !== undefined) {
                localVarQueryParameter['module'] = module;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportDesignDocument: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getReportDesignDocument', 'id', id);
            const localVarPath = `/api/report-design-documents/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportDesignDocuments: async (criteria, page, size, sort, options = {}) => {
            const localVarPath = `/api/report-design-documents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {string} [resourceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportFileName: async (id, resourceId, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getReportFileName', 'id', id);
            const localVarPath = `/api/report-design-documents/{id}/filename`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (resourceId !== undefined) {
                localVarQueryParameter['resourceId'] = resourceId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} criteria
         * @param {string} designId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewBulkDocument: async (criteria, designId, options = {}) => {
            // verify required parameter 'criteria' is not null or undefined
            assertParamExists('previewBulkDocument', 'criteria', criteria);
            // verify required parameter 'designId' is not null or undefined
            assertParamExists('previewBulkDocument', 'designId', designId);
            const localVarPath = `/api/document-export/preview-bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (designId !== undefined) {
                localVarQueryParameter['designId'] = designId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} entityId
         * @param {string} designId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewDocument: async (entityId, designId, options = {}) => {
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('previewDocument', 'entityId', entityId);
            // verify required parameter 'designId' is not null or undefined
            assertParamExists('previewDocument', 'designId', designId);
            const localVarPath = `/api/document-export/preview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }
            if (designId !== undefined) {
                localVarQueryParameter['designId'] = designId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<string>} resourceIds
         * @param {'CORE' | 'FINANCE' | 'PRODUCTION' | 'PURCHASING' | 'SALES' | 'STOCK' | 'INCOME' | 'OUTCOME'} module
         * @param {'SALES_ORDER_CONFIRMATION_WITHOUT_PRICES' | 'SALES_ORDER_CONFIRMATION' | 'SALES_INVOICE' | 'SALES_PACKING_SLIP' | 'SALES_DELIVERY_RECEIPT_WITHOUT_PRICES' | 'SALES_DELIVERY_RECEIPT' | 'SALES_TRANSPORT_DOCUMENT' | 'SALES_ORDER_PALLET_LABEL' | 'SALES_BOX_LABEL' | 'SALES_WEIGHT_LABEL' | 'SALES_LIST' | 'SALES_OTHER' | 'PRICE_LIST' | 'STOCK_BOX_LABEL' | 'STOCK_DOCUMENT' | 'STOCK_LIST' | 'PURCHASING_ORDER_CONFIRMATION' | 'PURCHASING_INCOMING_LOT_DOCUMENT' | 'PURCHASING_UNLOAD_DOCUMENT' | 'PURCHASING_LIST' | 'PURCHASING_OTHER' | 'PRODUCTION_BOX_LABEL' | 'PRODUCTION_ORDER_CONFIRMATION' | 'PRODUCTION_LIST' | 'PRODUCTION_OTHER'} category
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewListDocument: async (resourceIds, module, category, options = {}) => {
            // verify required parameter 'resourceIds' is not null or undefined
            assertParamExists('previewListDocument', 'resourceIds', resourceIds);
            // verify required parameter 'module' is not null or undefined
            assertParamExists('previewListDocument', 'module', module);
            // verify required parameter 'category' is not null or undefined
            assertParamExists('previewListDocument', 'category', category);
            const localVarPath = `/api/document-export/preview-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (resourceIds) {
                localVarQueryParameter['resourceIds'] = resourceIds;
            }
            if (module !== undefined) {
                localVarQueryParameter['module'] = module;
            }
            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {PreviewReportData} previewReportData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewReport: async (previewReportData, options = {}) => {
            // verify required parameter 'previewReportData' is not null or undefined
            assertParamExists('previewReport', 'previewReportData', previewReportData);
            const localVarPath = `/api/document-export/preview-report`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(previewReportData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {UpdateReportDesignDocumentData} updateReportDesignDocumentData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReportDesignDocument: async (id, updateReportDesignDocumentData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateReportDesignDocument', 'id', id);
            // verify required parameter 'updateReportDesignDocumentData' is not null or undefined
            assertParamExists('updateReportDesignDocument', 'updateReportDesignDocumentData', updateReportDesignDocumentData);
            const localVarPath = `/api/report-design-documents/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(updateReportDesignDocumentData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * DocumentsApi - functional programming interface
 * @export
 */
export const DocumentsApiFp = function (configuration) {
    const localVarAxiosParamCreator = DocumentsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async archiveReportDesignDocument(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.archiveReportDesignDocument(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {CreateReportDesignDocumentData} createReportDesignDocumentData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createReportDesignDocument(createReportDesignDocumentData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createReportDesignDocument(createReportDesignDocumentData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} criteria
         * @param {string} designId
         * @param {'CSV' | 'EXCEL' | 'PDF' | 'PNG'} [format]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadBulkDocument(criteria, designId, format, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadBulkDocument(criteria, designId, format, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} entityId
         * @param {string} designId
         * @param {'CSV' | 'EXCEL' | 'PDF' | 'PNG'} [format]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadDocument(entityId, designId, format, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadDocument(entityId, designId, format, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {Array<string>} entityIds
         * @param {'SALES_ORDER_CONFIRMATION_WITHOUT_PRICES' | 'SALES_ORDER_CONFIRMATION' | 'SALES_INVOICE' | 'SALES_PACKING_SLIP' | 'SALES_DELIVERY_RECEIPT_WITHOUT_PRICES' | 'SALES_DELIVERY_RECEIPT' | 'SALES_TRANSPORT_DOCUMENT' | 'SALES_ORDER_PALLET_LABEL' | 'SALES_BOX_LABEL' | 'SALES_WEIGHT_LABEL' | 'SALES_LIST' | 'SALES_OTHER' | 'PRICE_LIST' | 'STOCK_BOX_LABEL' | 'STOCK_DOCUMENT' | 'STOCK_LIST' | 'PURCHASING_ORDER_CONFIRMATION' | 'PURCHASING_INCOMING_LOT_DOCUMENT' | 'PURCHASING_UNLOAD_DOCUMENT' | 'PURCHASING_LIST' | 'PURCHASING_OTHER' | 'PRODUCTION_BOX_LABEL' | 'PRODUCTION_ORDER_CONFIRMATION' | 'PRODUCTION_LIST' | 'PRODUCTION_OTHER'} category
         * @param {'CORE' | 'FINANCE' | 'PRODUCTION' | 'PURCHASING' | 'SALES' | 'STOCK' | 'INCOME' | 'OUTCOME'} module
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadListDocument(entityIds, category, module, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadListDocument(entityIds, category, module, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReportDesignDocument(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReportDesignDocument(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReportDesignDocuments(criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReportDesignDocuments(criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {string} [resourceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReportFileName(id, resourceId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReportFileName(id, resourceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} criteria
         * @param {string} designId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async previewBulkDocument(criteria, designId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.previewBulkDocument(criteria, designId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} entityId
         * @param {string} designId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async previewDocument(entityId, designId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.previewDocument(entityId, designId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {Array<string>} resourceIds
         * @param {'CORE' | 'FINANCE' | 'PRODUCTION' | 'PURCHASING' | 'SALES' | 'STOCK' | 'INCOME' | 'OUTCOME'} module
         * @param {'SALES_ORDER_CONFIRMATION_WITHOUT_PRICES' | 'SALES_ORDER_CONFIRMATION' | 'SALES_INVOICE' | 'SALES_PACKING_SLIP' | 'SALES_DELIVERY_RECEIPT_WITHOUT_PRICES' | 'SALES_DELIVERY_RECEIPT' | 'SALES_TRANSPORT_DOCUMENT' | 'SALES_ORDER_PALLET_LABEL' | 'SALES_BOX_LABEL' | 'SALES_WEIGHT_LABEL' | 'SALES_LIST' | 'SALES_OTHER' | 'PRICE_LIST' | 'STOCK_BOX_LABEL' | 'STOCK_DOCUMENT' | 'STOCK_LIST' | 'PURCHASING_ORDER_CONFIRMATION' | 'PURCHASING_INCOMING_LOT_DOCUMENT' | 'PURCHASING_UNLOAD_DOCUMENT' | 'PURCHASING_LIST' | 'PURCHASING_OTHER' | 'PRODUCTION_BOX_LABEL' | 'PRODUCTION_ORDER_CONFIRMATION' | 'PRODUCTION_LIST' | 'PRODUCTION_OTHER'} category
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async previewListDocument(resourceIds, module, category, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.previewListDocument(resourceIds, module, category, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {PreviewReportData} previewReportData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async previewReport(previewReportData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.previewReport(previewReportData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {UpdateReportDesignDocumentData} updateReportDesignDocumentData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateReportDesignDocument(id, updateReportDesignDocumentData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateReportDesignDocument(id, updateReportDesignDocumentData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * DocumentsApi - factory interface
 * @export
 */
export const DocumentsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = DocumentsApiFp(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveReportDesignDocument(id, options) {
            return localVarFp.archiveReportDesignDocument(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CreateReportDesignDocumentData} createReportDesignDocumentData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReportDesignDocument(createReportDesignDocumentData, options) {
            return localVarFp.createReportDesignDocument(createReportDesignDocumentData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} criteria
         * @param {string} designId
         * @param {'CSV' | 'EXCEL' | 'PDF' | 'PNG'} [format]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadBulkDocument(criteria, designId, format, options) {
            return localVarFp.downloadBulkDocument(criteria, designId, format, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} entityId
         * @param {string} designId
         * @param {'CSV' | 'EXCEL' | 'PDF' | 'PNG'} [format]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadDocument(entityId, designId, format, options) {
            return localVarFp.downloadDocument(entityId, designId, format, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<string>} entityIds
         * @param {'SALES_ORDER_CONFIRMATION_WITHOUT_PRICES' | 'SALES_ORDER_CONFIRMATION' | 'SALES_INVOICE' | 'SALES_PACKING_SLIP' | 'SALES_DELIVERY_RECEIPT_WITHOUT_PRICES' | 'SALES_DELIVERY_RECEIPT' | 'SALES_TRANSPORT_DOCUMENT' | 'SALES_ORDER_PALLET_LABEL' | 'SALES_BOX_LABEL' | 'SALES_WEIGHT_LABEL' | 'SALES_LIST' | 'SALES_OTHER' | 'PRICE_LIST' | 'STOCK_BOX_LABEL' | 'STOCK_DOCUMENT' | 'STOCK_LIST' | 'PURCHASING_ORDER_CONFIRMATION' | 'PURCHASING_INCOMING_LOT_DOCUMENT' | 'PURCHASING_UNLOAD_DOCUMENT' | 'PURCHASING_LIST' | 'PURCHASING_OTHER' | 'PRODUCTION_BOX_LABEL' | 'PRODUCTION_ORDER_CONFIRMATION' | 'PRODUCTION_LIST' | 'PRODUCTION_OTHER'} category
         * @param {'CORE' | 'FINANCE' | 'PRODUCTION' | 'PURCHASING' | 'SALES' | 'STOCK' | 'INCOME' | 'OUTCOME'} module
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadListDocument(entityIds, category, module, options) {
            return localVarFp.downloadListDocument(entityIds, category, module, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportDesignDocument(id, options) {
            return localVarFp.getReportDesignDocument(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportDesignDocuments(criteria, page, size, sort, options) {
            return localVarFp.getReportDesignDocuments(criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {string} [resourceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportFileName(id, resourceId, options) {
            return localVarFp.getReportFileName(id, resourceId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} criteria
         * @param {string} designId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewBulkDocument(criteria, designId, options) {
            return localVarFp.previewBulkDocument(criteria, designId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} entityId
         * @param {string} designId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewDocument(entityId, designId, options) {
            return localVarFp.previewDocument(entityId, designId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<string>} resourceIds
         * @param {'CORE' | 'FINANCE' | 'PRODUCTION' | 'PURCHASING' | 'SALES' | 'STOCK' | 'INCOME' | 'OUTCOME'} module
         * @param {'SALES_ORDER_CONFIRMATION_WITHOUT_PRICES' | 'SALES_ORDER_CONFIRMATION' | 'SALES_INVOICE' | 'SALES_PACKING_SLIP' | 'SALES_DELIVERY_RECEIPT_WITHOUT_PRICES' | 'SALES_DELIVERY_RECEIPT' | 'SALES_TRANSPORT_DOCUMENT' | 'SALES_ORDER_PALLET_LABEL' | 'SALES_BOX_LABEL' | 'SALES_WEIGHT_LABEL' | 'SALES_LIST' | 'SALES_OTHER' | 'PRICE_LIST' | 'STOCK_BOX_LABEL' | 'STOCK_DOCUMENT' | 'STOCK_LIST' | 'PURCHASING_ORDER_CONFIRMATION' | 'PURCHASING_INCOMING_LOT_DOCUMENT' | 'PURCHASING_UNLOAD_DOCUMENT' | 'PURCHASING_LIST' | 'PURCHASING_OTHER' | 'PRODUCTION_BOX_LABEL' | 'PRODUCTION_ORDER_CONFIRMATION' | 'PRODUCTION_LIST' | 'PRODUCTION_OTHER'} category
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewListDocument(resourceIds, module, category, options) {
            return localVarFp.previewListDocument(resourceIds, module, category, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PreviewReportData} previewReportData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewReport(previewReportData, options) {
            return localVarFp.previewReport(previewReportData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {UpdateReportDesignDocumentData} updateReportDesignDocumentData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReportDesignDocument(id, updateReportDesignDocumentData, options) {
            return localVarFp.updateReportDesignDocument(id, updateReportDesignDocumentData, options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof DocumentsApi
*/
export function archiveReportDesignDocument(id, options) {
    return DocumentsApiFp().archiveReportDesignDocument(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {CreateReportDesignDocumentData} createReportDesignDocumentData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof DocumentsApi
*/
export function createReportDesignDocument(createReportDesignDocumentData, options) {
    return DocumentsApiFp().createReportDesignDocument(createReportDesignDocumentData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} criteria
        * @param {string} designId
        * @param {'CSV' | 'EXCEL' | 'PDF' | 'PNG'} [format]
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof DocumentsApi
*/
export function downloadBulkDocument(criteria, designId, format, options) {
    return DocumentsApiFp().downloadBulkDocument(criteria, designId, format, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} entityId
        * @param {string} designId
        * @param {'CSV' | 'EXCEL' | 'PDF' | 'PNG'} [format]
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof DocumentsApi
*/
export function downloadDocument(entityId, designId, format, options) {
    return DocumentsApiFp().downloadDocument(entityId, designId, format, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {Array<string>} entityIds
        * @param {'SALES_ORDER_CONFIRMATION_WITHOUT_PRICES' | 'SALES_ORDER_CONFIRMATION' | 'SALES_INVOICE' | 'SALES_PACKING_SLIP' | 'SALES_DELIVERY_RECEIPT_WITHOUT_PRICES' | 'SALES_DELIVERY_RECEIPT' | 'SALES_TRANSPORT_DOCUMENT' | 'SALES_ORDER_PALLET_LABEL' | 'SALES_BOX_LABEL' | 'SALES_WEIGHT_LABEL' | 'SALES_LIST' | 'SALES_OTHER' | 'PRICE_LIST' | 'STOCK_BOX_LABEL' | 'STOCK_DOCUMENT' | 'STOCK_LIST' | 'PURCHASING_ORDER_CONFIRMATION' | 'PURCHASING_INCOMING_LOT_DOCUMENT' | 'PURCHASING_UNLOAD_DOCUMENT' | 'PURCHASING_LIST' | 'PURCHASING_OTHER' | 'PRODUCTION_BOX_LABEL' | 'PRODUCTION_ORDER_CONFIRMATION' | 'PRODUCTION_LIST' | 'PRODUCTION_OTHER'} category
        * @param {'CORE' | 'FINANCE' | 'PRODUCTION' | 'PURCHASING' | 'SALES' | 'STOCK' | 'INCOME' | 'OUTCOME'} module
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof DocumentsApi
*/
export function downloadListDocument(entityIds, category, module, options) {
    return DocumentsApiFp().downloadListDocument(entityIds, category, module, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof DocumentsApi
*/
export function getReportDesignDocument(id, options) {
    return DocumentsApiFp().getReportDesignDocument(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof DocumentsApi
*/
export function getReportDesignDocuments(criteria, page, size, sort, options) {
    return DocumentsApiFp().getReportDesignDocuments(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {string} [resourceId]
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof DocumentsApi
*/
export function getReportFileName(id, resourceId, options) {
    return DocumentsApiFp().getReportFileName(id, resourceId, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} criteria
        * @param {string} designId
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof DocumentsApi
*/
export function previewBulkDocument(criteria, designId, options) {
    return DocumentsApiFp().previewBulkDocument(criteria, designId, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} entityId
        * @param {string} designId
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof DocumentsApi
*/
export function previewDocument(entityId, designId, options) {
    return DocumentsApiFp().previewDocument(entityId, designId, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {Array<string>} resourceIds
        * @param {'CORE' | 'FINANCE' | 'PRODUCTION' | 'PURCHASING' | 'SALES' | 'STOCK' | 'INCOME' | 'OUTCOME'} module
        * @param {'SALES_ORDER_CONFIRMATION_WITHOUT_PRICES' | 'SALES_ORDER_CONFIRMATION' | 'SALES_INVOICE' | 'SALES_PACKING_SLIP' | 'SALES_DELIVERY_RECEIPT_WITHOUT_PRICES' | 'SALES_DELIVERY_RECEIPT' | 'SALES_TRANSPORT_DOCUMENT' | 'SALES_ORDER_PALLET_LABEL' | 'SALES_BOX_LABEL' | 'SALES_WEIGHT_LABEL' | 'SALES_LIST' | 'SALES_OTHER' | 'PRICE_LIST' | 'STOCK_BOX_LABEL' | 'STOCK_DOCUMENT' | 'STOCK_LIST' | 'PURCHASING_ORDER_CONFIRMATION' | 'PURCHASING_INCOMING_LOT_DOCUMENT' | 'PURCHASING_UNLOAD_DOCUMENT' | 'PURCHASING_LIST' | 'PURCHASING_OTHER' | 'PRODUCTION_BOX_LABEL' | 'PRODUCTION_ORDER_CONFIRMATION' | 'PRODUCTION_LIST' | 'PRODUCTION_OTHER'} category
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof DocumentsApi
*/
export function previewListDocument(resourceIds, module, category, options) {
    return DocumentsApiFp().previewListDocument(resourceIds, module, category, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {PreviewReportData} previewReportData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof DocumentsApi
*/
export function previewReport(previewReportData, options) {
    return DocumentsApiFp().previewReport(previewReportData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {UpdateReportDesignDocumentData} updateReportDesignDocumentData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof DocumentsApi
*/
export function updateReportDesignDocument(id, updateReportDesignDocumentData, options) {
    return DocumentsApiFp().updateReportDesignDocument(id, updateReportDesignDocumentData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof DocumentsApi
*/
export function archiveReportDesignDocumentRaw(id, options) {
    return DocumentsApiFp().archiveReportDesignDocument(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {CreateReportDesignDocumentData} createReportDesignDocumentData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof DocumentsApi
*/
export function createReportDesignDocumentRaw(createReportDesignDocumentData, options) {
    return DocumentsApiFp().createReportDesignDocument(createReportDesignDocumentData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} criteria
        * @param {string} designId
        * @param {'CSV' | 'EXCEL' | 'PDF' | 'PNG'} [format]
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof DocumentsApi
*/
export function downloadBulkDocumentRaw(criteria, designId, format, options) {
    return DocumentsApiFp().downloadBulkDocument(criteria, designId, format, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} entityId
        * @param {string} designId
        * @param {'CSV' | 'EXCEL' | 'PDF' | 'PNG'} [format]
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof DocumentsApi
*/
export function downloadDocumentRaw(entityId, designId, format, options) {
    return DocumentsApiFp().downloadDocument(entityId, designId, format, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {Array<string>} entityIds
        * @param {'SALES_ORDER_CONFIRMATION_WITHOUT_PRICES' | 'SALES_ORDER_CONFIRMATION' | 'SALES_INVOICE' | 'SALES_PACKING_SLIP' | 'SALES_DELIVERY_RECEIPT_WITHOUT_PRICES' | 'SALES_DELIVERY_RECEIPT' | 'SALES_TRANSPORT_DOCUMENT' | 'SALES_ORDER_PALLET_LABEL' | 'SALES_BOX_LABEL' | 'SALES_WEIGHT_LABEL' | 'SALES_LIST' | 'SALES_OTHER' | 'PRICE_LIST' | 'STOCK_BOX_LABEL' | 'STOCK_DOCUMENT' | 'STOCK_LIST' | 'PURCHASING_ORDER_CONFIRMATION' | 'PURCHASING_INCOMING_LOT_DOCUMENT' | 'PURCHASING_UNLOAD_DOCUMENT' | 'PURCHASING_LIST' | 'PURCHASING_OTHER' | 'PRODUCTION_BOX_LABEL' | 'PRODUCTION_ORDER_CONFIRMATION' | 'PRODUCTION_LIST' | 'PRODUCTION_OTHER'} category
        * @param {'CORE' | 'FINANCE' | 'PRODUCTION' | 'PURCHASING' | 'SALES' | 'STOCK' | 'INCOME' | 'OUTCOME'} module
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof DocumentsApi
*/
export function downloadListDocumentRaw(entityIds, category, module, options) {
    return DocumentsApiFp().downloadListDocument(entityIds, category, module, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof DocumentsApi
*/
export function getReportDesignDocumentRaw(id, options) {
    return DocumentsApiFp().getReportDesignDocument(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof DocumentsApi
*/
export function getReportDesignDocumentsRaw(criteria, page, size, sort, options) {
    return DocumentsApiFp().getReportDesignDocuments(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {string} [resourceId]
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof DocumentsApi
*/
export function getReportFileNameRaw(id, resourceId, options) {
    return DocumentsApiFp().getReportFileName(id, resourceId, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} criteria
        * @param {string} designId
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof DocumentsApi
*/
export function previewBulkDocumentRaw(criteria, designId, options) {
    return DocumentsApiFp().previewBulkDocument(criteria, designId, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} entityId
        * @param {string} designId
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof DocumentsApi
*/
export function previewDocumentRaw(entityId, designId, options) {
    return DocumentsApiFp().previewDocument(entityId, designId, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {Array<string>} resourceIds
        * @param {'CORE' | 'FINANCE' | 'PRODUCTION' | 'PURCHASING' | 'SALES' | 'STOCK' | 'INCOME' | 'OUTCOME'} module
        * @param {'SALES_ORDER_CONFIRMATION_WITHOUT_PRICES' | 'SALES_ORDER_CONFIRMATION' | 'SALES_INVOICE' | 'SALES_PACKING_SLIP' | 'SALES_DELIVERY_RECEIPT_WITHOUT_PRICES' | 'SALES_DELIVERY_RECEIPT' | 'SALES_TRANSPORT_DOCUMENT' | 'SALES_ORDER_PALLET_LABEL' | 'SALES_BOX_LABEL' | 'SALES_WEIGHT_LABEL' | 'SALES_LIST' | 'SALES_OTHER' | 'PRICE_LIST' | 'STOCK_BOX_LABEL' | 'STOCK_DOCUMENT' | 'STOCK_LIST' | 'PURCHASING_ORDER_CONFIRMATION' | 'PURCHASING_INCOMING_LOT_DOCUMENT' | 'PURCHASING_UNLOAD_DOCUMENT' | 'PURCHASING_LIST' | 'PURCHASING_OTHER' | 'PRODUCTION_BOX_LABEL' | 'PRODUCTION_ORDER_CONFIRMATION' | 'PRODUCTION_LIST' | 'PRODUCTION_OTHER'} category
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof DocumentsApi
*/
export function previewListDocumentRaw(resourceIds, module, category, options) {
    return DocumentsApiFp().previewListDocument(resourceIds, module, category, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {PreviewReportData} previewReportData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof DocumentsApi
*/
export function previewReportRaw(previewReportData, options) {
    return DocumentsApiFp().previewReport(previewReportData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {UpdateReportDesignDocumentData} updateReportDesignDocumentData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof DocumentsApi
*/
export function updateReportDesignDocumentRaw(id, updateReportDesignDocumentData, options) {
    return DocumentsApiFp().updateReportDesignDocument(id, updateReportDesignDocumentData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * EMailAccountsApi - axios parameter creator
 * @export
 */
export const EMailAccountsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authorizeEmailAccount: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('authorizeEmailAccount', 'id', id);
            const localVarPath = `/api/email-accounts/{id}/authorize`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {CreateEmailAccountData} createEmailAccountData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEmailAccount: async (createEmailAccountData, options = {}) => {
            // verify required parameter 'createEmailAccountData' is not null or undefined
            assertParamExists('createEmailAccount', 'createEmailAccountData', createEmailAccountData);
            const localVarPath = `/api/email-accounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createEmailAccountData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {DeleteEmailAccountData} deleteEmailAccountData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEmailAccount: async (id, deleteEmailAccountData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteEmailAccount', 'id', id);
            // verify required parameter 'deleteEmailAccountData' is not null or undefined
            assertParamExists('deleteEmailAccount', 'deleteEmailAccountData', deleteEmailAccountData);
            const localVarPath = `/api/email-accounts/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(deleteEmailAccountData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmailAccount: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getEmailAccount', 'id', id);
            const localVarPath = `/api/email-accounts/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmailAccounts: async (criteria, page, size, sort, options = {}) => {
            const localVarPath = `/api/email-accounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {UpdateEmailAccountData} updateEmailAccountData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmailAccount: async (id, updateEmailAccountData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateEmailAccount', 'id', id);
            // verify required parameter 'updateEmailAccountData' is not null or undefined
            assertParamExists('updateEmailAccount', 'updateEmailAccountData', updateEmailAccountData);
            const localVarPath = `/api/email-accounts/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(updateEmailAccountData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * EMailAccountsApi - functional programming interface
 * @export
 */
export const EMailAccountsApiFp = function (configuration) {
    const localVarAxiosParamCreator = EMailAccountsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authorizeEmailAccount(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authorizeEmailAccount(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {CreateEmailAccountData} createEmailAccountData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEmailAccount(createEmailAccountData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEmailAccount(createEmailAccountData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {DeleteEmailAccountData} deleteEmailAccountData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEmailAccount(id, deleteEmailAccountData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEmailAccount(id, deleteEmailAccountData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmailAccount(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmailAccount(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmailAccounts(criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmailAccounts(criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {UpdateEmailAccountData} updateEmailAccountData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEmailAccount(id, updateEmailAccountData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEmailAccount(id, updateEmailAccountData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * EMailAccountsApi - factory interface
 * @export
 */
export const EMailAccountsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = EMailAccountsApiFp(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authorizeEmailAccount(id, options) {
            return localVarFp.authorizeEmailAccount(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CreateEmailAccountData} createEmailAccountData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEmailAccount(createEmailAccountData, options) {
            return localVarFp.createEmailAccount(createEmailAccountData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {DeleteEmailAccountData} deleteEmailAccountData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEmailAccount(id, deleteEmailAccountData, options) {
            return localVarFp.deleteEmailAccount(id, deleteEmailAccountData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmailAccount(id, options) {
            return localVarFp.getEmailAccount(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmailAccounts(criteria, page, size, sort, options) {
            return localVarFp.getEmailAccounts(criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {UpdateEmailAccountData} updateEmailAccountData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmailAccount(id, updateEmailAccountData, options) {
            return localVarFp.updateEmailAccount(id, updateEmailAccountData, options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof EMailAccountsApi
*/
export function authorizeEmailAccount(id, options) {
    return EMailAccountsApiFp().authorizeEmailAccount(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {CreateEmailAccountData} createEmailAccountData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof EMailAccountsApi
*/
export function createEmailAccount(createEmailAccountData, options) {
    return EMailAccountsApiFp().createEmailAccount(createEmailAccountData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {DeleteEmailAccountData} deleteEmailAccountData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof EMailAccountsApi
*/
export function deleteEmailAccount(id, deleteEmailAccountData, options) {
    return EMailAccountsApiFp().deleteEmailAccount(id, deleteEmailAccountData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof EMailAccountsApi
*/
export function getEmailAccount(id, options) {
    return EMailAccountsApiFp().getEmailAccount(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof EMailAccountsApi
*/
export function getEmailAccounts(criteria, page, size, sort, options) {
    return EMailAccountsApiFp().getEmailAccounts(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {UpdateEmailAccountData} updateEmailAccountData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof EMailAccountsApi
*/
export function updateEmailAccount(id, updateEmailAccountData, options) {
    return EMailAccountsApiFp().updateEmailAccount(id, updateEmailAccountData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof EMailAccountsApi
*/
export function authorizeEmailAccountRaw(id, options) {
    return EMailAccountsApiFp().authorizeEmailAccount(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {CreateEmailAccountData} createEmailAccountData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof EMailAccountsApi
*/
export function createEmailAccountRaw(createEmailAccountData, options) {
    return EMailAccountsApiFp().createEmailAccount(createEmailAccountData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {DeleteEmailAccountData} deleteEmailAccountData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof EMailAccountsApi
*/
export function deleteEmailAccountRaw(id, deleteEmailAccountData, options) {
    return EMailAccountsApiFp().deleteEmailAccount(id, deleteEmailAccountData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof EMailAccountsApi
*/
export function getEmailAccountRaw(id, options) {
    return EMailAccountsApiFp().getEmailAccount(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof EMailAccountsApi
*/
export function getEmailAccountsRaw(criteria, page, size, sort, options) {
    return EMailAccountsApiFp().getEmailAccounts(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {UpdateEmailAccountData} updateEmailAccountData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof EMailAccountsApi
*/
export function updateEmailAccountRaw(id, updateEmailAccountData, options) {
    return EMailAccountsApiFp().updateEmailAccount(id, updateEmailAccountData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * EMailTemplatesApi - axios parameter creator
 * @export
 */
export const EMailTemplatesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveEmailTemplate: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('archiveEmailTemplate', 'id', id);
            const localVarPath = `/api/email-templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {CreateOrUpdateEmailTemplateData} createOrUpdateEmailTemplateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEmailTemplate: async (createOrUpdateEmailTemplateData, options = {}) => {
            // verify required parameter 'createOrUpdateEmailTemplateData' is not null or undefined
            assertParamExists('createEmailTemplate', 'createOrUpdateEmailTemplateData', createOrUpdateEmailTemplateData);
            const localVarPath = `/api/email-templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createOrUpdateEmailTemplateData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmailTemplate: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getEmailTemplate', 'id', id);
            const localVarPath = `/api/email-templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmailTemplates: async (criteria, page, size, sort, options = {}) => {
            const localVarPath = `/api/email-templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {CreateOrUpdateEmailTemplateData} createOrUpdateEmailTemplateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmailTemplate: async (id, createOrUpdateEmailTemplateData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateEmailTemplate', 'id', id);
            // verify required parameter 'createOrUpdateEmailTemplateData' is not null or undefined
            assertParamExists('updateEmailTemplate', 'createOrUpdateEmailTemplateData', createOrUpdateEmailTemplateData);
            const localVarPath = `/api/email-templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createOrUpdateEmailTemplateData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * EMailTemplatesApi - functional programming interface
 * @export
 */
export const EMailTemplatesApiFp = function (configuration) {
    const localVarAxiosParamCreator = EMailTemplatesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async archiveEmailTemplate(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.archiveEmailTemplate(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {CreateOrUpdateEmailTemplateData} createOrUpdateEmailTemplateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEmailTemplate(createOrUpdateEmailTemplateData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEmailTemplate(createOrUpdateEmailTemplateData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmailTemplate(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmailTemplate(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmailTemplates(criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmailTemplates(criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {CreateOrUpdateEmailTemplateData} createOrUpdateEmailTemplateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEmailTemplate(id, createOrUpdateEmailTemplateData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEmailTemplate(id, createOrUpdateEmailTemplateData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * EMailTemplatesApi - factory interface
 * @export
 */
export const EMailTemplatesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = EMailTemplatesApiFp(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveEmailTemplate(id, options) {
            return localVarFp.archiveEmailTemplate(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CreateOrUpdateEmailTemplateData} createOrUpdateEmailTemplateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEmailTemplate(createOrUpdateEmailTemplateData, options) {
            return localVarFp.createEmailTemplate(createOrUpdateEmailTemplateData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmailTemplate(id, options) {
            return localVarFp.getEmailTemplate(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmailTemplates(criteria, page, size, sort, options) {
            return localVarFp.getEmailTemplates(criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {CreateOrUpdateEmailTemplateData} createOrUpdateEmailTemplateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmailTemplate(id, createOrUpdateEmailTemplateData, options) {
            return localVarFp.updateEmailTemplate(id, createOrUpdateEmailTemplateData, options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof EMailTemplatesApi
*/
export function archiveEmailTemplate(id, options) {
    return EMailTemplatesApiFp().archiveEmailTemplate(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {CreateOrUpdateEmailTemplateData} createOrUpdateEmailTemplateData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof EMailTemplatesApi
*/
export function createEmailTemplate(createOrUpdateEmailTemplateData, options) {
    return EMailTemplatesApiFp().createEmailTemplate(createOrUpdateEmailTemplateData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof EMailTemplatesApi
*/
export function getEmailTemplate(id, options) {
    return EMailTemplatesApiFp().getEmailTemplate(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof EMailTemplatesApi
*/
export function getEmailTemplates(criteria, page, size, sort, options) {
    return EMailTemplatesApiFp().getEmailTemplates(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {CreateOrUpdateEmailTemplateData} createOrUpdateEmailTemplateData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof EMailTemplatesApi
*/
export function updateEmailTemplate(id, createOrUpdateEmailTemplateData, options) {
    return EMailTemplatesApiFp().updateEmailTemplate(id, createOrUpdateEmailTemplateData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof EMailTemplatesApi
*/
export function archiveEmailTemplateRaw(id, options) {
    return EMailTemplatesApiFp().archiveEmailTemplate(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {CreateOrUpdateEmailTemplateData} createOrUpdateEmailTemplateData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof EMailTemplatesApi
*/
export function createEmailTemplateRaw(createOrUpdateEmailTemplateData, options) {
    return EMailTemplatesApiFp().createEmailTemplate(createOrUpdateEmailTemplateData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof EMailTemplatesApi
*/
export function getEmailTemplateRaw(id, options) {
    return EMailTemplatesApiFp().getEmailTemplate(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof EMailTemplatesApi
*/
export function getEmailTemplatesRaw(criteria, page, size, sort, options) {
    return EMailTemplatesApiFp().getEmailTemplates(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {CreateOrUpdateEmailTemplateData} createOrUpdateEmailTemplateData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof EMailTemplatesApi
*/
export function updateEmailTemplateRaw(id, createOrUpdateEmailTemplateData, options) {
    return EMailTemplatesApiFp().updateEmailTemplate(id, createOrUpdateEmailTemplateData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * EmailAccountCallbackControllerApi - axios parameter creator
 * @export
 */
export const EmailAccountCallbackControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} code
         * @param {string} [state]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailAccountCallback: async (code, state, options = {}) => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('emailAccountCallback', 'code', code);
            const localVarPath = `/callback/email-account`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }
            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * EmailAccountCallbackControllerApi - functional programming interface
 * @export
 */
export const EmailAccountCallbackControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = EmailAccountCallbackControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} code
         * @param {string} [state]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async emailAccountCallback(code, state, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.emailAccountCallback(code, state, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * EmailAccountCallbackControllerApi - factory interface
 * @export
 */
export const EmailAccountCallbackControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = EmailAccountCallbackControllerApiFp(configuration);
    return {
        /**
         *
         * @param {string} code
         * @param {string} [state]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailAccountCallback(code, state, options) {
            return localVarFp.emailAccountCallback(code, state, options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
        * @param {string} code
        * @param {string} [state]
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof EmailAccountCallbackControllerApi
*/
export function emailAccountCallback(code, state, options) {
    return EmailAccountCallbackControllerApiFp().emailAccountCallback(code, state, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} code
        * @param {string} [state]
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof EmailAccountCallbackControllerApi
*/
export function emailAccountCallbackRaw(code, state, options) {
    return EmailAccountCallbackControllerApiFp().emailAccountCallback(code, state, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * EmailLogApi - axios parameter creator
 * @export
 */
export const EmailLogApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmailLog: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getEmailLog', 'id', id);
            const localVarPath = `/api/email-logs/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmailLogFiles: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getEmailLogFiles', 'id', id);
            const localVarPath = `/api/email-logs/{id}/files`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmailLogs: async (criteria, page, size, sort, options = {}) => {
            const localVarPath = `/api/email-logs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ResendEmailLogsData} resendEmailLogsData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendEmailLogs: async (resendEmailLogsData, options = {}) => {
            // verify required parameter 'resendEmailLogsData' is not null or undefined
            assertParamExists('resendEmailLogs', 'resendEmailLogsData', resendEmailLogsData);
            const localVarPath = `/api/email-logs/resend`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(resendEmailLogsData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * EmailLogApi - functional programming interface
 * @export
 */
export const EmailLogApiFp = function (configuration) {
    const localVarAxiosParamCreator = EmailLogApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmailLog(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmailLog(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmailLogFiles(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmailLogFiles(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmailLogs(criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmailLogs(criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {ResendEmailLogsData} resendEmailLogsData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resendEmailLogs(resendEmailLogsData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resendEmailLogs(resendEmailLogsData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * EmailLogApi - factory interface
 * @export
 */
export const EmailLogApiFactory = function (configuration, basePath, axios) {
    const localVarFp = EmailLogApiFp(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmailLog(id, options) {
            return localVarFp.getEmailLog(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmailLogFiles(id, options) {
            return localVarFp.getEmailLogFiles(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmailLogs(criteria, page, size, sort, options) {
            return localVarFp.getEmailLogs(criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ResendEmailLogsData} resendEmailLogsData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendEmailLogs(resendEmailLogsData, options) {
            return localVarFp.resendEmailLogs(resendEmailLogsData, options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof EmailLogApi
*/
export function getEmailLog(id, options) {
    return EmailLogApiFp().getEmailLog(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof EmailLogApi
*/
export function getEmailLogFiles(id, options) {
    return EmailLogApiFp().getEmailLogFiles(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof EmailLogApi
*/
export function getEmailLogs(criteria, page, size, sort, options) {
    return EmailLogApiFp().getEmailLogs(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {ResendEmailLogsData} resendEmailLogsData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof EmailLogApi
*/
export function resendEmailLogs(resendEmailLogsData, options) {
    return EmailLogApiFp().resendEmailLogs(resendEmailLogsData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof EmailLogApi
*/
export function getEmailLogRaw(id, options) {
    return EmailLogApiFp().getEmailLog(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof EmailLogApi
*/
export function getEmailLogFilesRaw(id, options) {
    return EmailLogApiFp().getEmailLogFiles(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof EmailLogApi
*/
export function getEmailLogsRaw(criteria, page, size, sort, options) {
    return EmailLogApiFp().getEmailLogs(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {ResendEmailLogsData} resendEmailLogsData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof EmailLogApi
*/
export function resendEmailLogsRaw(resendEmailLogsData, options) {
    return EmailLogApiFp().resendEmailLogs(resendEmailLogsData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * ExchangeRatesApi - axios parameter creator
 * @export
 */
export const ExchangeRatesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {CreateExchangeRateData} createExchangeRateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createExchangeRate: async (createExchangeRateData, options = {}) => {
            // verify required parameter 'createExchangeRateData' is not null or undefined
            assertParamExists('createExchangeRate', 'createExchangeRateData', createExchangeRateData);
            const localVarPath = `/api/exchange-rates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createExchangeRateData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteExchangeRate: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteExchangeRate', 'id', id);
            const localVarPath = `/api/exchange-rates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExchangeRate: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getExchangeRate', 'id', id);
            const localVarPath = `/api/exchange-rates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {'SALES' | 'PURCHASING'} type
         * @param {string} currencyId
         * @param {string} toCurrencyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExchangeRateForPair: async (type, currencyId, toCurrencyId, options = {}) => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('getExchangeRateForPair', 'type', type);
            // verify required parameter 'currencyId' is not null or undefined
            assertParamExists('getExchangeRateForPair', 'currencyId', currencyId);
            // verify required parameter 'toCurrencyId' is not null or undefined
            assertParamExists('getExchangeRateForPair', 'toCurrencyId', toCurrencyId);
            const localVarPath = `/api/exchange-rates/{type}/{currencyId}/{toCurrencyId}`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"currencyId"}}`, encodeURIComponent(String(currencyId)))
                .replace(`{${"toCurrencyId"}}`, encodeURIComponent(String(toCurrencyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExchangeRates: async (criteria, page, size, sort, options = {}) => {
            const localVarPath = `/api/exchange-rates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {UpdateExchangeRateData} updateExchangeRateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateExchangeRate: async (id, updateExchangeRateData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateExchangeRate', 'id', id);
            // verify required parameter 'updateExchangeRateData' is not null or undefined
            assertParamExists('updateExchangeRate', 'updateExchangeRateData', updateExchangeRateData);
            const localVarPath = `/api/exchange-rates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(updateExchangeRateData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ExchangeRatesApi - functional programming interface
 * @export
 */
export const ExchangeRatesApiFp = function (configuration) {
    const localVarAxiosParamCreator = ExchangeRatesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {CreateExchangeRateData} createExchangeRateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createExchangeRate(createExchangeRateData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createExchangeRate(createExchangeRateData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteExchangeRate(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteExchangeRate(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExchangeRate(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExchangeRate(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {'SALES' | 'PURCHASING'} type
         * @param {string} currencyId
         * @param {string} toCurrencyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExchangeRateForPair(type, currencyId, toCurrencyId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExchangeRateForPair(type, currencyId, toCurrencyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExchangeRates(criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExchangeRates(criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {UpdateExchangeRateData} updateExchangeRateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateExchangeRate(id, updateExchangeRateData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateExchangeRate(id, updateExchangeRateData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * ExchangeRatesApi - factory interface
 * @export
 */
export const ExchangeRatesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ExchangeRatesApiFp(configuration);
    return {
        /**
         *
         * @param {CreateExchangeRateData} createExchangeRateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createExchangeRate(createExchangeRateData, options) {
            return localVarFp.createExchangeRate(createExchangeRateData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteExchangeRate(id, options) {
            return localVarFp.deleteExchangeRate(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExchangeRate(id, options) {
            return localVarFp.getExchangeRate(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {'SALES' | 'PURCHASING'} type
         * @param {string} currencyId
         * @param {string} toCurrencyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExchangeRateForPair(type, currencyId, toCurrencyId, options) {
            return localVarFp.getExchangeRateForPair(type, currencyId, toCurrencyId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExchangeRates(criteria, page, size, sort, options) {
            return localVarFp.getExchangeRates(criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {UpdateExchangeRateData} updateExchangeRateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateExchangeRate(id, updateExchangeRateData, options) {
            return localVarFp.updateExchangeRate(id, updateExchangeRateData, options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
        * @param {CreateExchangeRateData} createExchangeRateData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ExchangeRatesApi
*/
export function createExchangeRate(createExchangeRateData, options) {
    return ExchangeRatesApiFp().createExchangeRate(createExchangeRateData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ExchangeRatesApi
*/
export function deleteExchangeRate(id, options) {
    return ExchangeRatesApiFp().deleteExchangeRate(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ExchangeRatesApi
*/
export function getExchangeRate(id, options) {
    return ExchangeRatesApiFp().getExchangeRate(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {'SALES' | 'PURCHASING'} type
        * @param {string} currencyId
        * @param {string} toCurrencyId
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ExchangeRatesApi
*/
export function getExchangeRateForPair(type, currencyId, toCurrencyId, options) {
    return ExchangeRatesApiFp().getExchangeRateForPair(type, currencyId, toCurrencyId, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ExchangeRatesApi
*/
export function getExchangeRates(criteria, page, size, sort, options) {
    return ExchangeRatesApiFp().getExchangeRates(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {UpdateExchangeRateData} updateExchangeRateData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ExchangeRatesApi
*/
export function updateExchangeRate(id, updateExchangeRateData, options) {
    return ExchangeRatesApiFp().updateExchangeRate(id, updateExchangeRateData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {CreateExchangeRateData} createExchangeRateData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ExchangeRatesApi
*/
export function createExchangeRateRaw(createExchangeRateData, options) {
    return ExchangeRatesApiFp().createExchangeRate(createExchangeRateData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ExchangeRatesApi
*/
export function deleteExchangeRateRaw(id, options) {
    return ExchangeRatesApiFp().deleteExchangeRate(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ExchangeRatesApi
*/
export function getExchangeRateRaw(id, options) {
    return ExchangeRatesApiFp().getExchangeRate(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {'SALES' | 'PURCHASING'} type
        * @param {string} currencyId
        * @param {string} toCurrencyId
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ExchangeRatesApi
*/
export function getExchangeRateForPairRaw(type, currencyId, toCurrencyId, options) {
    return ExchangeRatesApiFp().getExchangeRateForPair(type, currencyId, toCurrencyId, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ExchangeRatesApi
*/
export function getExchangeRatesRaw(criteria, page, size, sort, options) {
    return ExchangeRatesApiFp().getExchangeRates(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {UpdateExchangeRateData} updateExchangeRateData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ExchangeRatesApi
*/
export function updateExchangeRateRaw(id, updateExchangeRateData, options) {
    return ExchangeRatesApiFp().updateExchangeRate(id, updateExchangeRateData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * ExternalContentApi - axios parameter creator
 * @export
 */
export const ExternalContentApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {CreateExternalContentData} createExternalContentData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createExternalContent: async (createExternalContentData, options = {}) => {
            // verify required parameter 'createExternalContentData' is not null or undefined
            assertParamExists('createExternalContent', 'createExternalContentData', createExternalContentData);
            const localVarPath = `/api/external-contents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createExternalContentData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSalesOrder1: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteSalesOrder1', 'id', id);
            const localVarPath = `/api/external-contents/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExternalContent: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getExternalContent', 'id', id);
            const localVarPath = `/api/external-contents/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExternalContent1: async (page, size, sort, options = {}) => {
            const localVarPath = `/api/external-contents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {UpdateExternalContentData} updateExternalContentData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateExternalContent: async (id, updateExternalContentData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateExternalContent', 'id', id);
            // verify required parameter 'updateExternalContentData' is not null or undefined
            assertParamExists('updateExternalContent', 'updateExternalContentData', updateExternalContentData);
            const localVarPath = `/api/external-contents/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(updateExternalContentData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ExternalContentApi - functional programming interface
 * @export
 */
export const ExternalContentApiFp = function (configuration) {
    const localVarAxiosParamCreator = ExternalContentApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {CreateExternalContentData} createExternalContentData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createExternalContent(createExternalContentData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createExternalContent(createExternalContentData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSalesOrder1(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSalesOrder1(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExternalContent(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExternalContent(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExternalContent1(page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExternalContent1(page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {UpdateExternalContentData} updateExternalContentData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateExternalContent(id, updateExternalContentData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateExternalContent(id, updateExternalContentData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * ExternalContentApi - factory interface
 * @export
 */
export const ExternalContentApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ExternalContentApiFp(configuration);
    return {
        /**
         *
         * @param {CreateExternalContentData} createExternalContentData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createExternalContent(createExternalContentData, options) {
            return localVarFp.createExternalContent(createExternalContentData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSalesOrder1(id, options) {
            return localVarFp.deleteSalesOrder1(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExternalContent(id, options) {
            return localVarFp.getExternalContent(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExternalContent1(page, size, sort, options) {
            return localVarFp.getExternalContent1(page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {UpdateExternalContentData} updateExternalContentData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateExternalContent(id, updateExternalContentData, options) {
            return localVarFp.updateExternalContent(id, updateExternalContentData, options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
        * @param {CreateExternalContentData} createExternalContentData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ExternalContentApi
*/
export function createExternalContent(createExternalContentData, options) {
    return ExternalContentApiFp().createExternalContent(createExternalContentData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ExternalContentApi
*/
export function deleteSalesOrder1(id, options) {
    return ExternalContentApiFp().deleteSalesOrder1(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ExternalContentApi
*/
export function getExternalContent(id, options) {
    return ExternalContentApiFp().getExternalContent(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ExternalContentApi
*/
export function getExternalContent1(page, size, sort, options) {
    return ExternalContentApiFp().getExternalContent1(page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {UpdateExternalContentData} updateExternalContentData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ExternalContentApi
*/
export function updateExternalContent(id, updateExternalContentData, options) {
    return ExternalContentApiFp().updateExternalContent(id, updateExternalContentData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {CreateExternalContentData} createExternalContentData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ExternalContentApi
*/
export function createExternalContentRaw(createExternalContentData, options) {
    return ExternalContentApiFp().createExternalContent(createExternalContentData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ExternalContentApi
*/
export function deleteSalesOrder1Raw(id, options) {
    return ExternalContentApiFp().deleteSalesOrder1(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ExternalContentApi
*/
export function getExternalContentRaw(id, options) {
    return ExternalContentApiFp().getExternalContent(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ExternalContentApi
*/
export function getExternalContent1Raw(page, size, sort, options) {
    return ExternalContentApiFp().getExternalContent1(page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {UpdateExternalContentData} updateExternalContentData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ExternalContentApi
*/
export function updateExternalContentRaw(id, updateExternalContentData, options) {
    return ExternalContentApiFp().updateExternalContent(id, updateExternalContentData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * ExternalJobControllerApi - axios parameter creator
 * @export
 */
export const ExternalJobControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExternalJob: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getExternalJob', 'id', id);
            const localVarPath = `/api/external-jobs/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExternalJobs: async (criteria, page, size, sort, options = {}) => {
            const localVarPath = `/api/external-jobs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ExternalJobControllerApi - functional programming interface
 * @export
 */
export const ExternalJobControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = ExternalJobControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExternalJob(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExternalJob(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExternalJobs(criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExternalJobs(criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * ExternalJobControllerApi - factory interface
 * @export
 */
export const ExternalJobControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ExternalJobControllerApiFp(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExternalJob(id, options) {
            return localVarFp.getExternalJob(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExternalJobs(criteria, page, size, sort, options) {
            return localVarFp.getExternalJobs(criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ExternalJobControllerApi
*/
export function getExternalJob(id, options) {
    return ExternalJobControllerApiFp().getExternalJob(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ExternalJobControllerApi
*/
export function getExternalJobs(criteria, page, size, sort, options) {
    return ExternalJobControllerApiFp().getExternalJobs(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ExternalJobControllerApi
*/
export function getExternalJobRaw(id, options) {
    return ExternalJobControllerApiFp().getExternalJob(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ExternalJobControllerApi
*/
export function getExternalJobsRaw(criteria, page, size, sort, options) {
    return ExternalJobControllerApiFp().getExternalJobs(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * FilesApi - axios parameter creator
 * @export
 */
export const FilesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadFile: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('downloadFile', 'id', id);
            const localVarPath = `/api/files/{id}/download`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewFile: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('previewFile', 'id', id);
            const localVarPath = `/api/files/{id}/preview-file`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewThumbnail: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('previewThumbnail', 'id', id);
            const localVarPath = `/api/files/{id}/preview-thumbnail`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * FilesApi - functional programming interface
 * @export
 */
export const FilesApiFp = function (configuration) {
    const localVarAxiosParamCreator = FilesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadFile(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadFile(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async previewFile(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.previewFile(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async previewThumbnail(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.previewThumbnail(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * FilesApi - factory interface
 * @export
 */
export const FilesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = FilesApiFp(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadFile(id, options) {
            return localVarFp.downloadFile(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewFile(id, options) {
            return localVarFp.previewFile(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewThumbnail(id, options) {
            return localVarFp.previewThumbnail(id, options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof FilesApi
*/
export function downloadFile(id, options) {
    return FilesApiFp().downloadFile(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof FilesApi
*/
export function previewFile(id, options) {
    return FilesApiFp().previewFile(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof FilesApi
*/
export function previewThumbnail(id, options) {
    return FilesApiFp().previewThumbnail(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof FilesApi
*/
export function downloadFileRaw(id, options) {
    return FilesApiFp().downloadFile(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof FilesApi
*/
export function previewFileRaw(id, options) {
    return FilesApiFp().previewFile(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof FilesApi
*/
export function previewThumbnailRaw(id, options) {
    return FilesApiFp().previewThumbnail(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * HarvestAreasApi - axios parameter creator
 * @export
 */
export const HarvestAreasApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveHarvestArea: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('archiveHarvestArea', 'id', id);
            const localVarPath = `/api/harvest-areas/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {CreateHarvestAreaData} createHarvestAreaData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createHarvestArea: async (createHarvestAreaData, options = {}) => {
            // verify required parameter 'createHarvestAreaData' is not null or undefined
            assertParamExists('createHarvestArea', 'createHarvestAreaData', createHarvestAreaData);
            const localVarPath = `/api/harvest-areas`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createHarvestAreaData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHarvestArea: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getHarvestArea', 'id', id);
            const localVarPath = `/api/harvest-areas/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHarvestAreas: async (criteria, page, size, sort, options = {}) => {
            const localVarPath = `/api/harvest-areas`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {UpdateHarvestAreaData} updateHarvestAreaData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateHarvestArea: async (id, updateHarvestAreaData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateHarvestArea', 'id', id);
            // verify required parameter 'updateHarvestAreaData' is not null or undefined
            assertParamExists('updateHarvestArea', 'updateHarvestAreaData', updateHarvestAreaData);
            const localVarPath = `/api/harvest-areas/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(updateHarvestAreaData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * HarvestAreasApi - functional programming interface
 * @export
 */
export const HarvestAreasApiFp = function (configuration) {
    const localVarAxiosParamCreator = HarvestAreasApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async archiveHarvestArea(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.archiveHarvestArea(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {CreateHarvestAreaData} createHarvestAreaData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createHarvestArea(createHarvestAreaData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createHarvestArea(createHarvestAreaData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHarvestArea(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHarvestArea(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHarvestAreas(criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHarvestAreas(criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {UpdateHarvestAreaData} updateHarvestAreaData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateHarvestArea(id, updateHarvestAreaData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateHarvestArea(id, updateHarvestAreaData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * HarvestAreasApi - factory interface
 * @export
 */
export const HarvestAreasApiFactory = function (configuration, basePath, axios) {
    const localVarFp = HarvestAreasApiFp(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveHarvestArea(id, options) {
            return localVarFp.archiveHarvestArea(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CreateHarvestAreaData} createHarvestAreaData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createHarvestArea(createHarvestAreaData, options) {
            return localVarFp.createHarvestArea(createHarvestAreaData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHarvestArea(id, options) {
            return localVarFp.getHarvestArea(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHarvestAreas(criteria, page, size, sort, options) {
            return localVarFp.getHarvestAreas(criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {UpdateHarvestAreaData} updateHarvestAreaData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateHarvestArea(id, updateHarvestAreaData, options) {
            return localVarFp.updateHarvestArea(id, updateHarvestAreaData, options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof HarvestAreasApi
*/
export function archiveHarvestArea(id, options) {
    return HarvestAreasApiFp().archiveHarvestArea(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {CreateHarvestAreaData} createHarvestAreaData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof HarvestAreasApi
*/
export function createHarvestArea(createHarvestAreaData, options) {
    return HarvestAreasApiFp().createHarvestArea(createHarvestAreaData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof HarvestAreasApi
*/
export function getHarvestArea(id, options) {
    return HarvestAreasApiFp().getHarvestArea(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof HarvestAreasApi
*/
export function getHarvestAreas(criteria, page, size, sort, options) {
    return HarvestAreasApiFp().getHarvestAreas(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {UpdateHarvestAreaData} updateHarvestAreaData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof HarvestAreasApi
*/
export function updateHarvestArea(id, updateHarvestAreaData, options) {
    return HarvestAreasApiFp().updateHarvestArea(id, updateHarvestAreaData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof HarvestAreasApi
*/
export function archiveHarvestAreaRaw(id, options) {
    return HarvestAreasApiFp().archiveHarvestArea(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {CreateHarvestAreaData} createHarvestAreaData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof HarvestAreasApi
*/
export function createHarvestAreaRaw(createHarvestAreaData, options) {
    return HarvestAreasApiFp().createHarvestArea(createHarvestAreaData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof HarvestAreasApi
*/
export function getHarvestAreaRaw(id, options) {
    return HarvestAreasApiFp().getHarvestArea(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof HarvestAreasApi
*/
export function getHarvestAreasRaw(criteria, page, size, sort, options) {
    return HarvestAreasApiFp().getHarvestAreas(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {UpdateHarvestAreaData} updateHarvestAreaData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof HarvestAreasApi
*/
export function updateHarvestAreaRaw(id, updateHarvestAreaData, options) {
    return HarvestAreasApiFp().updateHarvestArea(id, updateHarvestAreaData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * HarvestMethodsApi - axios parameter creator
 * @export
 */
export const HarvestMethodsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveHarvestMethod: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('archiveHarvestMethod', 'id', id);
            const localVarPath = `/api/harvest-methods/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {CreateHarvestMethodData} createHarvestMethodData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createHarvestMethod: async (createHarvestMethodData, options = {}) => {
            // verify required parameter 'createHarvestMethodData' is not null or undefined
            assertParamExists('createHarvestMethod', 'createHarvestMethodData', createHarvestMethodData);
            const localVarPath = `/api/harvest-methods`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createHarvestMethodData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHarvestMethod: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getHarvestMethod', 'id', id);
            const localVarPath = `/api/harvest-methods/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHarvestMethods: async (criteria, page, size, sort, options = {}) => {
            const localVarPath = `/api/harvest-methods`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {UpdateHarvestMethodData} updateHarvestMethodData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateHarvestMethod: async (id, updateHarvestMethodData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateHarvestMethod', 'id', id);
            // verify required parameter 'updateHarvestMethodData' is not null or undefined
            assertParamExists('updateHarvestMethod', 'updateHarvestMethodData', updateHarvestMethodData);
            const localVarPath = `/api/harvest-methods/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(updateHarvestMethodData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * HarvestMethodsApi - functional programming interface
 * @export
 */
export const HarvestMethodsApiFp = function (configuration) {
    const localVarAxiosParamCreator = HarvestMethodsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async archiveHarvestMethod(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.archiveHarvestMethod(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {CreateHarvestMethodData} createHarvestMethodData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createHarvestMethod(createHarvestMethodData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createHarvestMethod(createHarvestMethodData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHarvestMethod(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHarvestMethod(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHarvestMethods(criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHarvestMethods(criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {UpdateHarvestMethodData} updateHarvestMethodData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateHarvestMethod(id, updateHarvestMethodData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateHarvestMethod(id, updateHarvestMethodData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * HarvestMethodsApi - factory interface
 * @export
 */
export const HarvestMethodsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = HarvestMethodsApiFp(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveHarvestMethod(id, options) {
            return localVarFp.archiveHarvestMethod(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CreateHarvestMethodData} createHarvestMethodData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createHarvestMethod(createHarvestMethodData, options) {
            return localVarFp.createHarvestMethod(createHarvestMethodData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHarvestMethod(id, options) {
            return localVarFp.getHarvestMethod(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHarvestMethods(criteria, page, size, sort, options) {
            return localVarFp.getHarvestMethods(criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {UpdateHarvestMethodData} updateHarvestMethodData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateHarvestMethod(id, updateHarvestMethodData, options) {
            return localVarFp.updateHarvestMethod(id, updateHarvestMethodData, options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof HarvestMethodsApi
*/
export function archiveHarvestMethod(id, options) {
    return HarvestMethodsApiFp().archiveHarvestMethod(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {CreateHarvestMethodData} createHarvestMethodData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof HarvestMethodsApi
*/
export function createHarvestMethod(createHarvestMethodData, options) {
    return HarvestMethodsApiFp().createHarvestMethod(createHarvestMethodData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof HarvestMethodsApi
*/
export function getHarvestMethod(id, options) {
    return HarvestMethodsApiFp().getHarvestMethod(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof HarvestMethodsApi
*/
export function getHarvestMethods(criteria, page, size, sort, options) {
    return HarvestMethodsApiFp().getHarvestMethods(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {UpdateHarvestMethodData} updateHarvestMethodData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof HarvestMethodsApi
*/
export function updateHarvestMethod(id, updateHarvestMethodData, options) {
    return HarvestMethodsApiFp().updateHarvestMethod(id, updateHarvestMethodData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof HarvestMethodsApi
*/
export function archiveHarvestMethodRaw(id, options) {
    return HarvestMethodsApiFp().archiveHarvestMethod(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {CreateHarvestMethodData} createHarvestMethodData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof HarvestMethodsApi
*/
export function createHarvestMethodRaw(createHarvestMethodData, options) {
    return HarvestMethodsApiFp().createHarvestMethod(createHarvestMethodData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof HarvestMethodsApi
*/
export function getHarvestMethodRaw(id, options) {
    return HarvestMethodsApiFp().getHarvestMethod(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof HarvestMethodsApi
*/
export function getHarvestMethodsRaw(criteria, page, size, sort, options) {
    return HarvestMethodsApiFp().getHarvestMethods(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {UpdateHarvestMethodData} updateHarvestMethodData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof HarvestMethodsApi
*/
export function updateHarvestMethodRaw(id, updateHarvestMethodData, options) {
    return HarvestMethodsApiFp().updateHarvestMethod(id, updateHarvestMethodData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * IncomeLotsApi - axios parameter creator
 * @export
 */
export const IncomeLotsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteIncomeLot: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteIncomeLot', 'id', id);
            const localVarPath = `/api/income-lots/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIncomeLot: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getIncomeLot', 'id', id);
            const localVarPath = `/api/income-lots/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [criteria]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIncomeLotTotals: async (criteria, options = {}) => {
            const localVarPath = `/api/income-lots/totals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIncomeLots: async (criteria, page, size, sort, options = {}) => {
            const localVarPath = `/api/income-lots`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * IncomeLotsApi - functional programming interface
 * @export
 */
export const IncomeLotsApiFp = function (configuration) {
    const localVarAxiosParamCreator = IncomeLotsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteIncomeLot(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteIncomeLot(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIncomeLot(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIncomeLot(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} [criteria]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIncomeLotTotals(criteria, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIncomeLotTotals(criteria, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIncomeLots(criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIncomeLots(criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * IncomeLotsApi - factory interface
 * @export
 */
export const IncomeLotsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = IncomeLotsApiFp(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteIncomeLot(id, options) {
            return localVarFp.deleteIncomeLot(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIncomeLot(id, options) {
            return localVarFp.getIncomeLot(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [criteria]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIncomeLotTotals(criteria, options) {
            return localVarFp.getIncomeLotTotals(criteria, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIncomeLots(criteria, page, size, sort, options) {
            return localVarFp.getIncomeLots(criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof IncomeLotsApi
*/
export function deleteIncomeLot(id, options) {
    return IncomeLotsApiFp().deleteIncomeLot(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof IncomeLotsApi
*/
export function getIncomeLot(id, options) {
    return IncomeLotsApiFp().getIncomeLot(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} [criteria]
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof IncomeLotsApi
*/
export function getIncomeLotTotals(criteria, options) {
    return IncomeLotsApiFp().getIncomeLotTotals(criteria, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof IncomeLotsApi
*/
export function getIncomeLots(criteria, page, size, sort, options) {
    return IncomeLotsApiFp().getIncomeLots(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof IncomeLotsApi
*/
export function deleteIncomeLotRaw(id, options) {
    return IncomeLotsApiFp().deleteIncomeLot(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof IncomeLotsApi
*/
export function getIncomeLotRaw(id, options) {
    return IncomeLotsApiFp().getIncomeLot(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} [criteria]
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof IncomeLotsApi
*/
export function getIncomeLotTotalsRaw(criteria, options) {
    return IncomeLotsApiFp().getIncomeLotTotals(criteria, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof IncomeLotsApi
*/
export function getIncomeLotsRaw(criteria, page, size, sort, options) {
    return IncomeLotsApiFp().getIncomeLots(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * InvoiceControllerApi - axios parameter creator
 * @export
 */
export const InvoiceControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {CreateInvoicesFromSalesOrdersData} createInvoicesFromSalesOrdersData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInvoicesFromSalesOrders: async (createInvoicesFromSalesOrdersData, options = {}) => {
            // verify required parameter 'createInvoicesFromSalesOrdersData' is not null or undefined
            assertParamExists('createInvoicesFromSalesOrders', 'createInvoicesFromSalesOrdersData', createInvoicesFromSalesOrdersData);
            const localVarPath = `/api/invoices/create-from-sales-orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createInvoicesFromSalesOrdersData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoice: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getInvoice', 'id', id);
            const localVarPath = `/api/invoices/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {GetInvoiceAlertsData} getInvoiceAlertsData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoiceAlerts: async (getInvoiceAlertsData, options = {}) => {
            // verify required parameter 'getInvoiceAlertsData' is not null or undefined
            assertParamExists('getInvoiceAlerts', 'getInvoiceAlertsData', getInvoiceAlertsData);
            const localVarPath = `/api/invoices/get-alerts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(getInvoiceAlertsData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoicePdf: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getInvoicePdf', 'id', id);
            const localVarPath = `/api/invoices/{id}/pdf`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoices: async (criteria, page, size, sort, options = {}) => {
            const localVarPath = `/api/invoices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRowsForInvoice: async (id, criteria, page, size, sort, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getRowsForInvoice', 'id', id);
            const localVarPath = `/api/invoices/{id}/rows`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {CreateInvoicesFromSalesOrdersData} createInvoicesFromSalesOrdersData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewInvoices: async (createInvoicesFromSalesOrdersData, options = {}) => {
            // verify required parameter 'createInvoicesFromSalesOrdersData' is not null or undefined
            assertParamExists('previewInvoices', 'createInvoicesFromSalesOrdersData', createInvoicesFromSalesOrdersData);
            const localVarPath = `/api/invoices/preview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createInvoicesFromSalesOrdersData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {RegenerateInvoiceDocumentsData} regenerateInvoiceDocumentsData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        regenerateInvoicePdf: async (regenerateInvoiceDocumentsData, options = {}) => {
            // verify required parameter 'regenerateInvoiceDocumentsData' is not null or undefined
            assertParamExists('regenerateInvoicePdf', 'regenerateInvoiceDocumentsData', regenerateInvoiceDocumentsData);
            const localVarPath = `/api/invoices/regenerate-pdf`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(regenerateInvoiceDocumentsData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ResendInvoicesData} resendInvoicesData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendInvoices: async (resendInvoicesData, options = {}) => {
            // verify required parameter 'resendInvoicesData' is not null or undefined
            assertParamExists('resendInvoices', 'resendInvoicesData', resendInvoicesData);
            const localVarPath = `/api/invoices/resend`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(resendInvoicesData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {UpdateInvoiceStatusData} updateInvoiceStatusData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInvoiceStatus: async (id, updateInvoiceStatusData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateInvoiceStatus', 'id', id);
            // verify required parameter 'updateInvoiceStatusData' is not null or undefined
            assertParamExists('updateInvoiceStatus', 'updateInvoiceStatusData', updateInvoiceStatusData);
            const localVarPath = `/api/invoices/{id}/status`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(updateInvoiceStatusData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ValidateOrdersForInvoicingData} validateOrdersForInvoicingData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateSalesOrdersForInvoice: async (validateOrdersForInvoicingData, options = {}) => {
            // verify required parameter 'validateOrdersForInvoicingData' is not null or undefined
            assertParamExists('validateSalesOrdersForInvoice', 'validateOrdersForInvoicingData', validateOrdersForInvoicingData);
            const localVarPath = `/api/invoices/validate-sales-orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(validateOrdersForInvoicingData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * InvoiceControllerApi - functional programming interface
 * @export
 */
export const InvoiceControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = InvoiceControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {CreateInvoicesFromSalesOrdersData} createInvoicesFromSalesOrdersData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createInvoicesFromSalesOrders(createInvoicesFromSalesOrdersData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createInvoicesFromSalesOrders(createInvoicesFromSalesOrdersData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInvoice(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInvoice(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {GetInvoiceAlertsData} getInvoiceAlertsData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInvoiceAlerts(getInvoiceAlertsData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInvoiceAlerts(getInvoiceAlertsData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInvoicePdf(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInvoicePdf(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInvoices(criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInvoices(criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRowsForInvoice(id, criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRowsForInvoice(id, criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {CreateInvoicesFromSalesOrdersData} createInvoicesFromSalesOrdersData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async previewInvoices(createInvoicesFromSalesOrdersData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.previewInvoices(createInvoicesFromSalesOrdersData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {RegenerateInvoiceDocumentsData} regenerateInvoiceDocumentsData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async regenerateInvoicePdf(regenerateInvoiceDocumentsData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.regenerateInvoicePdf(regenerateInvoiceDocumentsData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {ResendInvoicesData} resendInvoicesData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resendInvoices(resendInvoicesData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resendInvoices(resendInvoicesData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {UpdateInvoiceStatusData} updateInvoiceStatusData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateInvoiceStatus(id, updateInvoiceStatusData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateInvoiceStatus(id, updateInvoiceStatusData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {ValidateOrdersForInvoicingData} validateOrdersForInvoicingData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateSalesOrdersForInvoice(validateOrdersForInvoicingData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateSalesOrdersForInvoice(validateOrdersForInvoicingData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * InvoiceControllerApi - factory interface
 * @export
 */
export const InvoiceControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = InvoiceControllerApiFp(configuration);
    return {
        /**
         *
         * @param {CreateInvoicesFromSalesOrdersData} createInvoicesFromSalesOrdersData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInvoicesFromSalesOrders(createInvoicesFromSalesOrdersData, options) {
            return localVarFp.createInvoicesFromSalesOrders(createInvoicesFromSalesOrdersData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoice(id, options) {
            return localVarFp.getInvoice(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {GetInvoiceAlertsData} getInvoiceAlertsData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoiceAlerts(getInvoiceAlertsData, options) {
            return localVarFp.getInvoiceAlerts(getInvoiceAlertsData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoicePdf(id, options) {
            return localVarFp.getInvoicePdf(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoices(criteria, page, size, sort, options) {
            return localVarFp.getInvoices(criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRowsForInvoice(id, criteria, page, size, sort, options) {
            return localVarFp.getRowsForInvoice(id, criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CreateInvoicesFromSalesOrdersData} createInvoicesFromSalesOrdersData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewInvoices(createInvoicesFromSalesOrdersData, options) {
            return localVarFp.previewInvoices(createInvoicesFromSalesOrdersData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {RegenerateInvoiceDocumentsData} regenerateInvoiceDocumentsData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        regenerateInvoicePdf(regenerateInvoiceDocumentsData, options) {
            return localVarFp.regenerateInvoicePdf(regenerateInvoiceDocumentsData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ResendInvoicesData} resendInvoicesData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendInvoices(resendInvoicesData, options) {
            return localVarFp.resendInvoices(resendInvoicesData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {UpdateInvoiceStatusData} updateInvoiceStatusData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInvoiceStatus(id, updateInvoiceStatusData, options) {
            return localVarFp.updateInvoiceStatus(id, updateInvoiceStatusData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ValidateOrdersForInvoicingData} validateOrdersForInvoicingData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateSalesOrdersForInvoice(validateOrdersForInvoicingData, options) {
            return localVarFp.validateSalesOrdersForInvoice(validateOrdersForInvoicingData, options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
        * @param {CreateInvoicesFromSalesOrdersData} createInvoicesFromSalesOrdersData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof InvoiceControllerApi
*/
export function createInvoicesFromSalesOrders(createInvoicesFromSalesOrdersData, options) {
    return InvoiceControllerApiFp().createInvoicesFromSalesOrders(createInvoicesFromSalesOrdersData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof InvoiceControllerApi
*/
export function getInvoice(id, options) {
    return InvoiceControllerApiFp().getInvoice(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {GetInvoiceAlertsData} getInvoiceAlertsData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof InvoiceControllerApi
*/
export function getInvoiceAlerts(getInvoiceAlertsData, options) {
    return InvoiceControllerApiFp().getInvoiceAlerts(getInvoiceAlertsData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof InvoiceControllerApi
*/
export function getInvoicePdf(id, options) {
    return InvoiceControllerApiFp().getInvoicePdf(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof InvoiceControllerApi
*/
export function getInvoices(criteria, page, size, sort, options) {
    return InvoiceControllerApiFp().getInvoices(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof InvoiceControllerApi
*/
export function getRowsForInvoice(id, criteria, page, size, sort, options) {
    return InvoiceControllerApiFp().getRowsForInvoice(id, criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {CreateInvoicesFromSalesOrdersData} createInvoicesFromSalesOrdersData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof InvoiceControllerApi
*/
export function previewInvoices(createInvoicesFromSalesOrdersData, options) {
    return InvoiceControllerApiFp().previewInvoices(createInvoicesFromSalesOrdersData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {RegenerateInvoiceDocumentsData} regenerateInvoiceDocumentsData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof InvoiceControllerApi
*/
export function regenerateInvoicePdf(regenerateInvoiceDocumentsData, options) {
    return InvoiceControllerApiFp().regenerateInvoicePdf(regenerateInvoiceDocumentsData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {ResendInvoicesData} resendInvoicesData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof InvoiceControllerApi
*/
export function resendInvoices(resendInvoicesData, options) {
    return InvoiceControllerApiFp().resendInvoices(resendInvoicesData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {UpdateInvoiceStatusData} updateInvoiceStatusData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof InvoiceControllerApi
*/
export function updateInvoiceStatus(id, updateInvoiceStatusData, options) {
    return InvoiceControllerApiFp().updateInvoiceStatus(id, updateInvoiceStatusData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {ValidateOrdersForInvoicingData} validateOrdersForInvoicingData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof InvoiceControllerApi
*/
export function validateSalesOrdersForInvoice(validateOrdersForInvoicingData, options) {
    return InvoiceControllerApiFp().validateSalesOrdersForInvoice(validateOrdersForInvoicingData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {CreateInvoicesFromSalesOrdersData} createInvoicesFromSalesOrdersData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof InvoiceControllerApi
*/
export function createInvoicesFromSalesOrdersRaw(createInvoicesFromSalesOrdersData, options) {
    return InvoiceControllerApiFp().createInvoicesFromSalesOrders(createInvoicesFromSalesOrdersData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof InvoiceControllerApi
*/
export function getInvoiceRaw(id, options) {
    return InvoiceControllerApiFp().getInvoice(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {GetInvoiceAlertsData} getInvoiceAlertsData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof InvoiceControllerApi
*/
export function getInvoiceAlertsRaw(getInvoiceAlertsData, options) {
    return InvoiceControllerApiFp().getInvoiceAlerts(getInvoiceAlertsData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof InvoiceControllerApi
*/
export function getInvoicePdfRaw(id, options) {
    return InvoiceControllerApiFp().getInvoicePdf(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof InvoiceControllerApi
*/
export function getInvoicesRaw(criteria, page, size, sort, options) {
    return InvoiceControllerApiFp().getInvoices(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof InvoiceControllerApi
*/
export function getRowsForInvoiceRaw(id, criteria, page, size, sort, options) {
    return InvoiceControllerApiFp().getRowsForInvoice(id, criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {CreateInvoicesFromSalesOrdersData} createInvoicesFromSalesOrdersData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof InvoiceControllerApi
*/
export function previewInvoicesRaw(createInvoicesFromSalesOrdersData, options) {
    return InvoiceControllerApiFp().previewInvoices(createInvoicesFromSalesOrdersData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {RegenerateInvoiceDocumentsData} regenerateInvoiceDocumentsData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof InvoiceControllerApi
*/
export function regenerateInvoicePdfRaw(regenerateInvoiceDocumentsData, options) {
    return InvoiceControllerApiFp().regenerateInvoicePdf(regenerateInvoiceDocumentsData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {ResendInvoicesData} resendInvoicesData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof InvoiceControllerApi
*/
export function resendInvoicesRaw(resendInvoicesData, options) {
    return InvoiceControllerApiFp().resendInvoices(resendInvoicesData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {UpdateInvoiceStatusData} updateInvoiceStatusData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof InvoiceControllerApi
*/
export function updateInvoiceStatusRaw(id, updateInvoiceStatusData, options) {
    return InvoiceControllerApiFp().updateInvoiceStatus(id, updateInvoiceStatusData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {ValidateOrdersForInvoicingData} validateOrdersForInvoicingData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof InvoiceControllerApi
*/
export function validateSalesOrdersForInvoiceRaw(validateOrdersForInvoicingData, options) {
    return InvoiceControllerApiFp().validateSalesOrdersForInvoice(validateOrdersForInvoicingData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * LabelTemplateControllerApi - axios parameter creator
 * @export
 */
export const LabelTemplateControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDefaultStockTemplate: async (options = {}) => {
            const localVarPath = `/api/documents/default-stock`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLabelTemplate: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getLabelTemplate', 'id', id);
            const localVarPath = `/api/documents/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLabelTemplates: async (criteria, page, size, sort, options = {}) => {
            const localVarPath = `/api/documents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} resourceId
         * @param {ReportPreviewPrintData} reportPreviewPrintData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        printLabelTemplate: async (resourceId, reportPreviewPrintData, options = {}) => {
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('printLabelTemplate', 'resourceId', resourceId);
            // verify required parameter 'reportPreviewPrintData' is not null or undefined
            assertParamExists('printLabelTemplate', 'reportPreviewPrintData', reportPreviewPrintData);
            const localVarPath = `/api/documents/print-labels/{resourceId}`
                .replace(`{${"resourceId"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(reportPreviewPrintData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {PrintMultipleResourcesData} printMultipleResourcesData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        printLabelTemplates: async (printMultipleResourcesData, options = {}) => {
            // verify required parameter 'printMultipleResourcesData' is not null or undefined
            assertParamExists('printLabelTemplates', 'printMultipleResourcesData', printMultipleResourcesData);
            const localVarPath = `/api/documents/print-labels/resources`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(printMultipleResourcesData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * LabelTemplateControllerApi - functional programming interface
 * @export
 */
export const LabelTemplateControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = LabelTemplateControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDefaultStockTemplate(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDefaultStockTemplate(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLabelTemplate(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLabelTemplate(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLabelTemplates(criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLabelTemplates(criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} resourceId
         * @param {ReportPreviewPrintData} reportPreviewPrintData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async printLabelTemplate(resourceId, reportPreviewPrintData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.printLabelTemplate(resourceId, reportPreviewPrintData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {PrintMultipleResourcesData} printMultipleResourcesData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async printLabelTemplates(printMultipleResourcesData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.printLabelTemplates(printMultipleResourcesData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * LabelTemplateControllerApi - factory interface
 * @export
 */
export const LabelTemplateControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = LabelTemplateControllerApiFp(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDefaultStockTemplate(options) {
            return localVarFp.getDefaultStockTemplate(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLabelTemplate(id, options) {
            return localVarFp.getLabelTemplate(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLabelTemplates(criteria, page, size, sort, options) {
            return localVarFp.getLabelTemplates(criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} resourceId
         * @param {ReportPreviewPrintData} reportPreviewPrintData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        printLabelTemplate(resourceId, reportPreviewPrintData, options) {
            return localVarFp.printLabelTemplate(resourceId, reportPreviewPrintData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PrintMultipleResourcesData} printMultipleResourcesData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        printLabelTemplates(printMultipleResourcesData, options) {
            return localVarFp.printLabelTemplates(printMultipleResourcesData, options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof LabelTemplateControllerApi
*/
export function getDefaultStockTemplate(options) {
    return LabelTemplateControllerApiFp().getDefaultStockTemplate(options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof LabelTemplateControllerApi
*/
export function getLabelTemplate(id, options) {
    return LabelTemplateControllerApiFp().getLabelTemplate(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof LabelTemplateControllerApi
*/
export function getLabelTemplates(criteria, page, size, sort, options) {
    return LabelTemplateControllerApiFp().getLabelTemplates(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} resourceId
        * @param {ReportPreviewPrintData} reportPreviewPrintData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof LabelTemplateControllerApi
*/
export function printLabelTemplate(resourceId, reportPreviewPrintData, options) {
    return LabelTemplateControllerApiFp().printLabelTemplate(resourceId, reportPreviewPrintData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {PrintMultipleResourcesData} printMultipleResourcesData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof LabelTemplateControllerApi
*/
export function printLabelTemplates(printMultipleResourcesData, options) {
    return LabelTemplateControllerApiFp().printLabelTemplates(printMultipleResourcesData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof LabelTemplateControllerApi
*/
export function getDefaultStockTemplateRaw(options) {
    return LabelTemplateControllerApiFp().getDefaultStockTemplate(options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof LabelTemplateControllerApi
*/
export function getLabelTemplateRaw(id, options) {
    return LabelTemplateControllerApiFp().getLabelTemplate(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof LabelTemplateControllerApi
*/
export function getLabelTemplatesRaw(criteria, page, size, sort, options) {
    return LabelTemplateControllerApiFp().getLabelTemplates(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} resourceId
        * @param {ReportPreviewPrintData} reportPreviewPrintData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof LabelTemplateControllerApi
*/
export function printLabelTemplateRaw(resourceId, reportPreviewPrintData, options) {
    return LabelTemplateControllerApiFp().printLabelTemplate(resourceId, reportPreviewPrintData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {PrintMultipleResourcesData} printMultipleResourcesData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof LabelTemplateControllerApi
*/
export function printLabelTemplatesRaw(printMultipleResourcesData, options) {
    return LabelTemplateControllerApiFp().printLabelTemplates(printMultipleResourcesData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * LanguagesApi - axios parameter creator
 * @export
 */
export const LanguagesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllLanguages: async (criteria, page, size, sort, options = {}) => {
            const localVarPath = `/api/languages/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLanguage: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getLanguage', 'id', id);
            const localVarPath = `/api/languages/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLanguages: async (criteria, page, size, sort, options = {}) => {
            const localVarPath = `/api/languages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * LanguagesApi - functional programming interface
 * @export
 */
export const LanguagesApiFp = function (configuration) {
    const localVarAxiosParamCreator = LanguagesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllLanguages(criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllLanguages(criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLanguage(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLanguage(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLanguages(criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLanguages(criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * LanguagesApi - factory interface
 * @export
 */
export const LanguagesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = LanguagesApiFp(configuration);
    return {
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllLanguages(criteria, page, size, sort, options) {
            return localVarFp.getAllLanguages(criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLanguage(id, options) {
            return localVarFp.getLanguage(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLanguages(criteria, page, size, sort, options) {
            return localVarFp.getLanguages(criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof LanguagesApi
*/
export function getAllLanguages(criteria, page, size, sort, options) {
    return LanguagesApiFp().getAllLanguages(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof LanguagesApi
*/
export function getLanguage(id, options) {
    return LanguagesApiFp().getLanguage(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof LanguagesApi
*/
export function getLanguages(criteria, page, size, sort, options) {
    return LanguagesApiFp().getLanguages(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof LanguagesApi
*/
export function getAllLanguagesRaw(criteria, page, size, sort, options) {
    return LanguagesApiFp().getAllLanguages(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof LanguagesApi
*/
export function getLanguageRaw(id, options) {
    return LanguagesApiFp().getLanguage(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof LanguagesApi
*/
export function getLanguagesRaw(criteria, page, size, sort, options) {
    return LanguagesApiFp().getLanguages(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * LotMutationsApi - axios parameter creator
 * @export
 */
export const LotMutationsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMutationsForLot: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getMutationsForLot', 'id', id);
            const localVarPath = `/api/lot-mutations/lot/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * LotMutationsApi - functional programming interface
 * @export
 */
export const LotMutationsApiFp = function (configuration) {
    const localVarAxiosParamCreator = LotMutationsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMutationsForLot(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMutationsForLot(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * LotMutationsApi - factory interface
 * @export
 */
export const LotMutationsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = LotMutationsApiFp(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMutationsForLot(id, options) {
            return localVarFp.getMutationsForLot(id, options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof LotMutationsApi
*/
export function getMutationsForLot(id, options) {
    return LotMutationsApiFp().getMutationsForLot(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof LotMutationsApi
*/
export function getMutationsForLotRaw(id, options) {
    return LotMutationsApiFp().getMutationsForLot(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * LotWeightsApi - axios parameter creator
 * @export
 */
export const LotWeightsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLotWeight: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteLotWeight', 'id', id);
            const localVarPath = `/api/lot-weights/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} lotNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLotWeightByLotNumber: async (lotNumber, options = {}) => {
            // verify required parameter 'lotNumber' is not null or undefined
            assertParamExists('getLotWeightByLotNumber', 'lotNumber', lotNumber);
            const localVarPath = `/api/lot-weights/lot-number/{lotNumber}`
                .replace(`{${"lotNumber"}}`, encodeURIComponent(String(lotNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLotWeights: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getLotWeights', 'id', id);
            const localVarPath = `/api/lots/{id}/weights`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLotWeights1: async (criteria, page, size, sort, options = {}) => {
            const localVarPath = `/api/lot-weights`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * LotWeightsApi - functional programming interface
 * @export
 */
export const LotWeightsApiFp = function (configuration) {
    const localVarAxiosParamCreator = LotWeightsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteLotWeight(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteLotWeight(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} lotNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLotWeightByLotNumber(lotNumber, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLotWeightByLotNumber(lotNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLotWeights(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLotWeights(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLotWeights1(criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLotWeights1(criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * LotWeightsApi - factory interface
 * @export
 */
export const LotWeightsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = LotWeightsApiFp(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLotWeight(id, options) {
            return localVarFp.deleteLotWeight(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} lotNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLotWeightByLotNumber(lotNumber, options) {
            return localVarFp.getLotWeightByLotNumber(lotNumber, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLotWeights(id, options) {
            return localVarFp.getLotWeights(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLotWeights1(criteria, page, size, sort, options) {
            return localVarFp.getLotWeights1(criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof LotWeightsApi
*/
export function deleteLotWeight(id, options) {
    return LotWeightsApiFp().deleteLotWeight(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} lotNumber
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof LotWeightsApi
*/
export function getLotWeightByLotNumber(lotNumber, options) {
    return LotWeightsApiFp().getLotWeightByLotNumber(lotNumber, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof LotWeightsApi
*/
export function getLotWeights(id, options) {
    return LotWeightsApiFp().getLotWeights(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof LotWeightsApi
*/
export function getLotWeights1(criteria, page, size, sort, options) {
    return LotWeightsApiFp().getLotWeights1(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof LotWeightsApi
*/
export function deleteLotWeightRaw(id, options) {
    return LotWeightsApiFp().deleteLotWeight(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} lotNumber
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof LotWeightsApi
*/
export function getLotWeightByLotNumberRaw(lotNumber, options) {
    return LotWeightsApiFp().getLotWeightByLotNumber(lotNumber, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof LotWeightsApi
*/
export function getLotWeightsRaw(id, options) {
    return LotWeightsApiFp().getLotWeights(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof LotWeightsApi
*/
export function getLotWeights1Raw(criteria, page, size, sort, options) {
    return LotWeightsApiFp().getLotWeights1(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * LotsApi - axios parameter creator
 * @export
 */
export const LotsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllOutcomeLotsForLot: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAllOutcomeLotsForLot', 'id', id);
            const localVarPath = `/api/lots/{id}/get-outcome-lots`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProductionStepResourceLotsForLot: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAllProductionStepResourceLotsForLot', 'id', id);
            const localVarPath = `/api/lots/{id}/get-production-step-resource-lots`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProductionStepResultLotsForLot: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAllProductionStepResultLotsForLot', 'id', id);
            const localVarPath = `/api/lots/{id}/get-production-step-result-lots`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIncomeLotForLot: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getIncomeLotForLot', 'id', id);
            const localVarPath = `/api/lots/{id}/get-income-lot`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLot: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getLot', 'id', id);
            const localVarPath = `/api/lots/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} lotNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLotByLotNumber: async (lotNumber, options = {}) => {
            // verify required parameter 'lotNumber' is not null or undefined
            assertParamExists('getLotByLotNumber', 'lotNumber', lotNumber);
            const localVarPath = `/api/lots/lot-number/{lotNumber}`
                .replace(`{${"lotNumber"}}`, encodeURIComponent(String(lotNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLotTotals: async (criteria, page, size, sort, options = {}) => {
            const localVarPath = `/api/lots/totals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLots: async (criteria, page, size, sort, options = {}) => {
            const localVarPath = `/api/lots`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTraceLotById: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTraceLotById', 'id', id);
            const localVarPath = `/api/lots/trace/id/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} lotNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTraceLotByLotNumber: async (lotNumber, options = {}) => {
            // verify required parameter 'lotNumber' is not null or undefined
            assertParamExists('getTraceLotByLotNumber', 'lotNumber', lotNumber);
            const localVarPath = `/api/lots/trace/lot-number/{lotNumber}`
                .replace(`{${"lotNumber"}}`, encodeURIComponent(String(lotNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {LotValueMutationData} lotValueMutationData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lotValueMutation: async (id, lotValueMutationData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('lotValueMutation', 'id', id);
            // verify required parameter 'lotValueMutationData' is not null or undefined
            assertParamExists('lotValueMutation', 'lotValueMutationData', lotValueMutationData);
            const localVarPath = `/api/lots/lotValueMutation/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(lotValueMutationData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {LotWeightMutationData} lotWeightMutationData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lotWeightMutation: async (id, lotWeightMutationData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('lotWeightMutation', 'id', id);
            // verify required parameter 'lotWeightMutationData' is not null or undefined
            assertParamExists('lotWeightMutation', 'lotWeightMutationData', lotWeightMutationData);
            const localVarPath = `/api/lots/lotMutation/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(lotWeightMutationData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {MergeLotData} mergeLotData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mergeLots: async (mergeLotData, options = {}) => {
            // verify required parameter 'mergeLotData' is not null or undefined
            assertParamExists('mergeLots', 'mergeLotData', mergeLotData);
            const localVarPath = `/api/lots/merge`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(mergeLotData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        packagingLotTotals: async (criteria, page, size, sort, options = {}) => {
            const localVarPath = `/api/lots/packaging-lot-total`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {PrintLotLabelData} printLotLabelData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        printLotLabels: async (printLotLabelData, options = {}) => {
            // verify required parameter 'printLotLabelData' is not null or undefined
            assertParamExists('printLotLabels', 'printLotLabelData', printLotLabelData);
            const localVarPath = `/api/lots/api/lot/print-label`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(printLotLabelData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productLotTotals: async (criteria, page, size, sort, options = {}) => {
            const localVarPath = `/api/lots/product-lot-total`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {RelocateLotData} relocateLotData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        relocateLots: async (relocateLotData, options = {}) => {
            // verify required parameter 'relocateLotData' is not null or undefined
            assertParamExists('relocateLots', 'relocateLotData', relocateLotData);
            const localVarPath = `/api/lots/relocate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(relocateLotData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {SplitLotData} splitLotData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        splitLot: async (id, splitLotData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('splitLot', 'id', id);
            // verify required parameter 'splitLotData' is not null or undefined
            assertParamExists('splitLot', 'splitLotData', splitLotData);
            const localVarPath = `/api/lots/split/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(splitLotData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {UpdateBlockAttributeOfLotData} updateBlockAttributeOfLotData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBlockAttributeOfLot: async (id, updateBlockAttributeOfLotData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateBlockAttributeOfLot', 'id', id);
            // verify required parameter 'updateBlockAttributeOfLotData' is not null or undefined
            assertParamExists('updateBlockAttributeOfLot', 'updateBlockAttributeOfLotData', updateBlockAttributeOfLotData);
            const localVarPath = `/api/lots/update-block-attribute/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(updateBlockAttributeOfLotData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {Array<File>} [files]
         * @param {UpdateLotRequest} [updateLotRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLot: async (id, files, updateLotRequest, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateLot', 'id', id);
            const localVarPath = `/api/lots/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (files) {
                localVarQueryParameter['files'] = Array.from(files);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(updateLotRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        valueLotTotals: async (criteria, page, size, sort, options = {}) => {
            const localVarPath = `/api/lots/value-lot-total`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * LotsApi - functional programming interface
 * @export
 */
export const LotsApiFp = function (configuration) {
    const localVarAxiosParamCreator = LotsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllOutcomeLotsForLot(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllOutcomeLotsForLot(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllProductionStepResourceLotsForLot(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllProductionStepResourceLotsForLot(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllProductionStepResultLotsForLot(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllProductionStepResultLotsForLot(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIncomeLotForLot(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIncomeLotForLot(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLot(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLot(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} lotNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLotByLotNumber(lotNumber, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLotByLotNumber(lotNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLotTotals(criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLotTotals(criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLots(criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLots(criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTraceLotById(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTraceLotById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} lotNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTraceLotByLotNumber(lotNumber, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTraceLotByLotNumber(lotNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {LotValueMutationData} lotValueMutationData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async lotValueMutation(id, lotValueMutationData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.lotValueMutation(id, lotValueMutationData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {LotWeightMutationData} lotWeightMutationData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async lotWeightMutation(id, lotWeightMutationData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.lotWeightMutation(id, lotWeightMutationData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {MergeLotData} mergeLotData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mergeLots(mergeLotData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mergeLots(mergeLotData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async packagingLotTotals(criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.packagingLotTotals(criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {PrintLotLabelData} printLotLabelData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async printLotLabels(printLotLabelData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.printLotLabels(printLotLabelData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productLotTotals(criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productLotTotals(criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {RelocateLotData} relocateLotData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async relocateLots(relocateLotData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.relocateLots(relocateLotData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {SplitLotData} splitLotData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async splitLot(id, splitLotData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.splitLot(id, splitLotData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {UpdateBlockAttributeOfLotData} updateBlockAttributeOfLotData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateBlockAttributeOfLot(id, updateBlockAttributeOfLotData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateBlockAttributeOfLot(id, updateBlockAttributeOfLotData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {Array<File>} [files]
         * @param {UpdateLotRequest} [updateLotRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateLot(id, files, updateLotRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateLot(id, files, updateLotRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async valueLotTotals(criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.valueLotTotals(criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * LotsApi - factory interface
 * @export
 */
export const LotsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = LotsApiFp(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllOutcomeLotsForLot(id, options) {
            return localVarFp.getAllOutcomeLotsForLot(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProductionStepResourceLotsForLot(id, options) {
            return localVarFp.getAllProductionStepResourceLotsForLot(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProductionStepResultLotsForLot(id, options) {
            return localVarFp.getAllProductionStepResultLotsForLot(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIncomeLotForLot(id, options) {
            return localVarFp.getIncomeLotForLot(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLot(id, options) {
            return localVarFp.getLot(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} lotNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLotByLotNumber(lotNumber, options) {
            return localVarFp.getLotByLotNumber(lotNumber, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLotTotals(criteria, page, size, sort, options) {
            return localVarFp.getLotTotals(criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLots(criteria, page, size, sort, options) {
            return localVarFp.getLots(criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTraceLotById(id, options) {
            return localVarFp.getTraceLotById(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} lotNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTraceLotByLotNumber(lotNumber, options) {
            return localVarFp.getTraceLotByLotNumber(lotNumber, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {LotValueMutationData} lotValueMutationData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lotValueMutation(id, lotValueMutationData, options) {
            return localVarFp.lotValueMutation(id, lotValueMutationData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {LotWeightMutationData} lotWeightMutationData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lotWeightMutation(id, lotWeightMutationData, options) {
            return localVarFp.lotWeightMutation(id, lotWeightMutationData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {MergeLotData} mergeLotData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mergeLots(mergeLotData, options) {
            return localVarFp.mergeLots(mergeLotData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        packagingLotTotals(criteria, page, size, sort, options) {
            return localVarFp.packagingLotTotals(criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PrintLotLabelData} printLotLabelData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        printLotLabels(printLotLabelData, options) {
            return localVarFp.printLotLabels(printLotLabelData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productLotTotals(criteria, page, size, sort, options) {
            return localVarFp.productLotTotals(criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {RelocateLotData} relocateLotData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        relocateLots(relocateLotData, options) {
            return localVarFp.relocateLots(relocateLotData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {SplitLotData} splitLotData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        splitLot(id, splitLotData, options) {
            return localVarFp.splitLot(id, splitLotData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {UpdateBlockAttributeOfLotData} updateBlockAttributeOfLotData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBlockAttributeOfLot(id, updateBlockAttributeOfLotData, options) {
            return localVarFp.updateBlockAttributeOfLot(id, updateBlockAttributeOfLotData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {Array<File>} [files]
         * @param {UpdateLotRequest} [updateLotRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLot(id, files, updateLotRequest, options) {
            return localVarFp.updateLot(id, files, updateLotRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        valueLotTotals(criteria, page, size, sort, options) {
            return localVarFp.valueLotTotals(criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof LotsApi
*/
export function getAllOutcomeLotsForLot(id, options) {
    return LotsApiFp().getAllOutcomeLotsForLot(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof LotsApi
*/
export function getAllProductionStepResourceLotsForLot(id, options) {
    return LotsApiFp().getAllProductionStepResourceLotsForLot(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof LotsApi
*/
export function getAllProductionStepResultLotsForLot(id, options) {
    return LotsApiFp().getAllProductionStepResultLotsForLot(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof LotsApi
*/
export function getIncomeLotForLot(id, options) {
    return LotsApiFp().getIncomeLotForLot(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof LotsApi
*/
export function getLot(id, options) {
    return LotsApiFp().getLot(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} lotNumber
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof LotsApi
*/
export function getLotByLotNumber(lotNumber, options) {
    return LotsApiFp().getLotByLotNumber(lotNumber, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof LotsApi
*/
export function getLotTotals(criteria, page, size, sort, options) {
    return LotsApiFp().getLotTotals(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof LotsApi
*/
export function getLots(criteria, page, size, sort, options) {
    return LotsApiFp().getLots(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof LotsApi
*/
export function getTraceLotById(id, options) {
    return LotsApiFp().getTraceLotById(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} lotNumber
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof LotsApi
*/
export function getTraceLotByLotNumber(lotNumber, options) {
    return LotsApiFp().getTraceLotByLotNumber(lotNumber, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {LotValueMutationData} lotValueMutationData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof LotsApi
*/
export function lotValueMutation(id, lotValueMutationData, options) {
    return LotsApiFp().lotValueMutation(id, lotValueMutationData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {LotWeightMutationData} lotWeightMutationData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof LotsApi
*/
export function lotWeightMutation(id, lotWeightMutationData, options) {
    return LotsApiFp().lotWeightMutation(id, lotWeightMutationData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {MergeLotData} mergeLotData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof LotsApi
*/
export function mergeLots(mergeLotData, options) {
    return LotsApiFp().mergeLots(mergeLotData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof LotsApi
*/
export function packagingLotTotals(criteria, page, size, sort, options) {
    return LotsApiFp().packagingLotTotals(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {PrintLotLabelData} printLotLabelData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof LotsApi
*/
export function printLotLabels(printLotLabelData, options) {
    return LotsApiFp().printLotLabels(printLotLabelData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof LotsApi
*/
export function productLotTotals(criteria, page, size, sort, options) {
    return LotsApiFp().productLotTotals(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {RelocateLotData} relocateLotData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof LotsApi
*/
export function relocateLots(relocateLotData, options) {
    return LotsApiFp().relocateLots(relocateLotData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {SplitLotData} splitLotData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof LotsApi
*/
export function splitLot(id, splitLotData, options) {
    return LotsApiFp().splitLot(id, splitLotData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {UpdateBlockAttributeOfLotData} updateBlockAttributeOfLotData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof LotsApi
*/
export function updateBlockAttributeOfLot(id, updateBlockAttributeOfLotData, options) {
    return LotsApiFp().updateBlockAttributeOfLot(id, updateBlockAttributeOfLotData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {Array<File>} [files]
        * @param {UpdateLotRequest} [updateLotRequest]
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof LotsApi
*/
export function updateLot(id, files, updateLotRequest, options) {
    return LotsApiFp().updateLot(id, files, updateLotRequest, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof LotsApi
*/
export function valueLotTotals(criteria, page, size, sort, options) {
    return LotsApiFp().valueLotTotals(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof LotsApi
*/
export function getAllOutcomeLotsForLotRaw(id, options) {
    return LotsApiFp().getAllOutcomeLotsForLot(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof LotsApi
*/
export function getAllProductionStepResourceLotsForLotRaw(id, options) {
    return LotsApiFp().getAllProductionStepResourceLotsForLot(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof LotsApi
*/
export function getAllProductionStepResultLotsForLotRaw(id, options) {
    return LotsApiFp().getAllProductionStepResultLotsForLot(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof LotsApi
*/
export function getIncomeLotForLotRaw(id, options) {
    return LotsApiFp().getIncomeLotForLot(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof LotsApi
*/
export function getLotRaw(id, options) {
    return LotsApiFp().getLot(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} lotNumber
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof LotsApi
*/
export function getLotByLotNumberRaw(lotNumber, options) {
    return LotsApiFp().getLotByLotNumber(lotNumber, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof LotsApi
*/
export function getLotTotalsRaw(criteria, page, size, sort, options) {
    return LotsApiFp().getLotTotals(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof LotsApi
*/
export function getLotsRaw(criteria, page, size, sort, options) {
    return LotsApiFp().getLots(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof LotsApi
*/
export function getTraceLotByIdRaw(id, options) {
    return LotsApiFp().getTraceLotById(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} lotNumber
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof LotsApi
*/
export function getTraceLotByLotNumberRaw(lotNumber, options) {
    return LotsApiFp().getTraceLotByLotNumber(lotNumber, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {LotValueMutationData} lotValueMutationData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof LotsApi
*/
export function lotValueMutationRaw(id, lotValueMutationData, options) {
    return LotsApiFp().lotValueMutation(id, lotValueMutationData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {LotWeightMutationData} lotWeightMutationData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof LotsApi
*/
export function lotWeightMutationRaw(id, lotWeightMutationData, options) {
    return LotsApiFp().lotWeightMutation(id, lotWeightMutationData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {MergeLotData} mergeLotData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof LotsApi
*/
export function mergeLotsRaw(mergeLotData, options) {
    return LotsApiFp().mergeLots(mergeLotData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof LotsApi
*/
export function packagingLotTotalsRaw(criteria, page, size, sort, options) {
    return LotsApiFp().packagingLotTotals(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {PrintLotLabelData} printLotLabelData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof LotsApi
*/
export function printLotLabelsRaw(printLotLabelData, options) {
    return LotsApiFp().printLotLabels(printLotLabelData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof LotsApi
*/
export function productLotTotalsRaw(criteria, page, size, sort, options) {
    return LotsApiFp().productLotTotals(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {RelocateLotData} relocateLotData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof LotsApi
*/
export function relocateLotsRaw(relocateLotData, options) {
    return LotsApiFp().relocateLots(relocateLotData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {SplitLotData} splitLotData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof LotsApi
*/
export function splitLotRaw(id, splitLotData, options) {
    return LotsApiFp().splitLot(id, splitLotData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {UpdateBlockAttributeOfLotData} updateBlockAttributeOfLotData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof LotsApi
*/
export function updateBlockAttributeOfLotRaw(id, updateBlockAttributeOfLotData, options) {
    return LotsApiFp().updateBlockAttributeOfLot(id, updateBlockAttributeOfLotData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {Array<File>} [files]
        * @param {UpdateLotRequest} [updateLotRequest]
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof LotsApi
*/
export function updateLotRaw(id, files, updateLotRequest, options) {
    return LotsApiFp().updateLot(id, files, updateLotRequest, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof LotsApi
*/
export function valueLotTotalsRaw(criteria, page, size, sort, options) {
    return LotsApiFp().valueLotTotals(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * MailApi - axios parameter creator
 * @export
 */
export const MailApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} entityId
         * @param {string} emailTemplateId
         * @param {'CORE' | 'FINANCE' | 'PRODUCTION' | 'PURCHASING' | 'SALES' | 'STOCK' | 'INCOME' | 'OUTCOME'} module
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMailAddresses: async (entityId, emailTemplateId, module, options = {}) => {
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('getMailAddresses', 'entityId', entityId);
            // verify required parameter 'emailTemplateId' is not null or undefined
            assertParamExists('getMailAddresses', 'emailTemplateId', emailTemplateId);
            // verify required parameter 'module' is not null or undefined
            assertParamExists('getMailAddresses', 'module', module);
            const localVarPath = `/api/mail-addresses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }
            if (emailTemplateId !== undefined) {
                localVarQueryParameter['emailTemplateId'] = emailTemplateId;
            }
            if (module !== undefined) {
                localVarQueryParameter['module'] = module;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {SendMailData} sendMailData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendMailAddresses: async (sendMailData, options = {}) => {
            // verify required parameter 'sendMailData' is not null or undefined
            assertParamExists('sendMailAddresses', 'sendMailData', sendMailData);
            const localVarPath = `/api/mail-addresses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(sendMailData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} criteria
         * @param {SendCriteriaMailData} sendCriteriaMailData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendMailAddressesForCriteria: async (criteria, sendCriteriaMailData, options = {}) => {
            // verify required parameter 'criteria' is not null or undefined
            assertParamExists('sendMailAddressesForCriteria', 'criteria', criteria);
            // verify required parameter 'sendCriteriaMailData' is not null or undefined
            assertParamExists('sendMailAddressesForCriteria', 'sendCriteriaMailData', sendCriteriaMailData);
            const localVarPath = `/api/mail-addresses/criteria`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(sendCriteriaMailData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {SendListMailData} sendListMailData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendMailAddressesForList: async (sendListMailData, options = {}) => {
            // verify required parameter 'sendListMailData' is not null or undefined
            assertParamExists('sendMailAddressesForList', 'sendListMailData', sendListMailData);
            const localVarPath = `/api/mail-addresses/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(sendListMailData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * MailApi - functional programming interface
 * @export
 */
export const MailApiFp = function (configuration) {
    const localVarAxiosParamCreator = MailApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} entityId
         * @param {string} emailTemplateId
         * @param {'CORE' | 'FINANCE' | 'PRODUCTION' | 'PURCHASING' | 'SALES' | 'STOCK' | 'INCOME' | 'OUTCOME'} module
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMailAddresses(entityId, emailTemplateId, module, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMailAddresses(entityId, emailTemplateId, module, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {SendMailData} sendMailData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendMailAddresses(sendMailData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendMailAddresses(sendMailData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} criteria
         * @param {SendCriteriaMailData} sendCriteriaMailData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendMailAddressesForCriteria(criteria, sendCriteriaMailData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendMailAddressesForCriteria(criteria, sendCriteriaMailData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {SendListMailData} sendListMailData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendMailAddressesForList(sendListMailData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendMailAddressesForList(sendListMailData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * MailApi - factory interface
 * @export
 */
export const MailApiFactory = function (configuration, basePath, axios) {
    const localVarFp = MailApiFp(configuration);
    return {
        /**
         *
         * @param {string} entityId
         * @param {string} emailTemplateId
         * @param {'CORE' | 'FINANCE' | 'PRODUCTION' | 'PURCHASING' | 'SALES' | 'STOCK' | 'INCOME' | 'OUTCOME'} module
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMailAddresses(entityId, emailTemplateId, module, options) {
            return localVarFp.getMailAddresses(entityId, emailTemplateId, module, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SendMailData} sendMailData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendMailAddresses(sendMailData, options) {
            return localVarFp.sendMailAddresses(sendMailData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} criteria
         * @param {SendCriteriaMailData} sendCriteriaMailData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendMailAddressesForCriteria(criteria, sendCriteriaMailData, options) {
            return localVarFp.sendMailAddressesForCriteria(criteria, sendCriteriaMailData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SendListMailData} sendListMailData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendMailAddressesForList(sendListMailData, options) {
            return localVarFp.sendMailAddressesForList(sendListMailData, options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
        * @param {string} entityId
        * @param {string} emailTemplateId
        * @param {'CORE' | 'FINANCE' | 'PRODUCTION' | 'PURCHASING' | 'SALES' | 'STOCK' | 'INCOME' | 'OUTCOME'} module
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof MailApi
*/
export function getMailAddresses(entityId, emailTemplateId, module, options) {
    return MailApiFp().getMailAddresses(entityId, emailTemplateId, module, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {SendMailData} sendMailData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof MailApi
*/
export function sendMailAddresses(sendMailData, options) {
    return MailApiFp().sendMailAddresses(sendMailData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} criteria
        * @param {SendCriteriaMailData} sendCriteriaMailData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof MailApi
*/
export function sendMailAddressesForCriteria(criteria, sendCriteriaMailData, options) {
    return MailApiFp().sendMailAddressesForCriteria(criteria, sendCriteriaMailData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {SendListMailData} sendListMailData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof MailApi
*/
export function sendMailAddressesForList(sendListMailData, options) {
    return MailApiFp().sendMailAddressesForList(sendListMailData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} entityId
        * @param {string} emailTemplateId
        * @param {'CORE' | 'FINANCE' | 'PRODUCTION' | 'PURCHASING' | 'SALES' | 'STOCK' | 'INCOME' | 'OUTCOME'} module
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof MailApi
*/
export function getMailAddressesRaw(entityId, emailTemplateId, module, options) {
    return MailApiFp().getMailAddresses(entityId, emailTemplateId, module, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {SendMailData} sendMailData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof MailApi
*/
export function sendMailAddressesRaw(sendMailData, options) {
    return MailApiFp().sendMailAddresses(sendMailData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} criteria
        * @param {SendCriteriaMailData} sendCriteriaMailData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof MailApi
*/
export function sendMailAddressesForCriteriaRaw(criteria, sendCriteriaMailData, options) {
    return MailApiFp().sendMailAddressesForCriteria(criteria, sendCriteriaMailData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {SendListMailData} sendListMailData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof MailApi
*/
export function sendMailAddressesForListRaw(sendListMailData, options) {
    return MailApiFp().sendMailAddressesForList(sendListMailData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * NetworkScalesApi - axios parameter creator
 * @export
 */
export const NetworkScalesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {CreateNetworkScaleData} createNetworkScaleData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNetworkScale: async (createNetworkScaleData, options = {}) => {
            // verify required parameter 'createNetworkScaleData' is not null or undefined
            assertParamExists('createNetworkScale', 'createNetworkScaleData', createNetworkScaleData);
            const localVarPath = `/api/network-scales`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createNetworkScaleData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateCreatingWeightsForNetworkScale: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deactivateCreatingWeightsForNetworkScale', 'id', id);
            const localVarPath = `/api/network-scales/{id}/deactivate-creating-weights-for-network-scale`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNetworkScale: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteNetworkScale', 'id', id);
            const localVarPath = `/api/network-scales/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNetworkScale: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getNetworkScale', 'id', id);
            const localVarPath = `/api/network-scales/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNetworkScales: async (criteria, page, size, sort, options = {}) => {
            const localVarPath = `/api/network-scales`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {UpdateNetworkScaleData} updateNetworkScaleData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNetworkScale: async (id, updateNetworkScaleData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateNetworkScale', 'id', id);
            // verify required parameter 'updateNetworkScaleData' is not null or undefined
            assertParamExists('updateNetworkScale', 'updateNetworkScaleData', updateNetworkScaleData);
            const localVarPath = `/api/network-scales/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(updateNetworkScaleData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * NetworkScalesApi - functional programming interface
 * @export
 */
export const NetworkScalesApiFp = function (configuration) {
    const localVarAxiosParamCreator = NetworkScalesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {CreateNetworkScaleData} createNetworkScaleData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createNetworkScale(createNetworkScaleData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createNetworkScale(createNetworkScaleData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deactivateCreatingWeightsForNetworkScale(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deactivateCreatingWeightsForNetworkScale(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteNetworkScale(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteNetworkScale(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNetworkScale(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNetworkScale(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNetworkScales(criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNetworkScales(criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {UpdateNetworkScaleData} updateNetworkScaleData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateNetworkScale(id, updateNetworkScaleData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateNetworkScale(id, updateNetworkScaleData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * NetworkScalesApi - factory interface
 * @export
 */
export const NetworkScalesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = NetworkScalesApiFp(configuration);
    return {
        /**
         *
         * @param {CreateNetworkScaleData} createNetworkScaleData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNetworkScale(createNetworkScaleData, options) {
            return localVarFp.createNetworkScale(createNetworkScaleData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateCreatingWeightsForNetworkScale(id, options) {
            return localVarFp.deactivateCreatingWeightsForNetworkScale(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNetworkScale(id, options) {
            return localVarFp.deleteNetworkScale(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNetworkScale(id, options) {
            return localVarFp.getNetworkScale(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNetworkScales(criteria, page, size, sort, options) {
            return localVarFp.getNetworkScales(criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {UpdateNetworkScaleData} updateNetworkScaleData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNetworkScale(id, updateNetworkScaleData, options) {
            return localVarFp.updateNetworkScale(id, updateNetworkScaleData, options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
        * @param {CreateNetworkScaleData} createNetworkScaleData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof NetworkScalesApi
*/
export function createNetworkScale(createNetworkScaleData, options) {
    return NetworkScalesApiFp().createNetworkScale(createNetworkScaleData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof NetworkScalesApi
*/
export function deactivateCreatingWeightsForNetworkScale(id, options) {
    return NetworkScalesApiFp().deactivateCreatingWeightsForNetworkScale(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof NetworkScalesApi
*/
export function deleteNetworkScale(id, options) {
    return NetworkScalesApiFp().deleteNetworkScale(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof NetworkScalesApi
*/
export function getNetworkScale(id, options) {
    return NetworkScalesApiFp().getNetworkScale(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof NetworkScalesApi
*/
export function getNetworkScales(criteria, page, size, sort, options) {
    return NetworkScalesApiFp().getNetworkScales(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {UpdateNetworkScaleData} updateNetworkScaleData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof NetworkScalesApi
*/
export function updateNetworkScale(id, updateNetworkScaleData, options) {
    return NetworkScalesApiFp().updateNetworkScale(id, updateNetworkScaleData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {CreateNetworkScaleData} createNetworkScaleData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof NetworkScalesApi
*/
export function createNetworkScaleRaw(createNetworkScaleData, options) {
    return NetworkScalesApiFp().createNetworkScale(createNetworkScaleData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof NetworkScalesApi
*/
export function deactivateCreatingWeightsForNetworkScaleRaw(id, options) {
    return NetworkScalesApiFp().deactivateCreatingWeightsForNetworkScale(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof NetworkScalesApi
*/
export function deleteNetworkScaleRaw(id, options) {
    return NetworkScalesApiFp().deleteNetworkScale(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof NetworkScalesApi
*/
export function getNetworkScaleRaw(id, options) {
    return NetworkScalesApiFp().getNetworkScale(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof NetworkScalesApi
*/
export function getNetworkScalesRaw(criteria, page, size, sort, options) {
    return NetworkScalesApiFp().getNetworkScales(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {UpdateNetworkScaleData} updateNetworkScaleData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof NetworkScalesApi
*/
export function updateNetworkScaleRaw(id, updateNetworkScaleData, options) {
    return NetworkScalesApiFp().updateNetworkScale(id, updateNetworkScaleData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * NetworksApi - axios parameter creator
 * @export
 */
export const NetworksApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {CreateNetworkData} createNetworkData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNetwork: async (createNetworkData, options = {}) => {
            // verify required parameter 'createNetworkData' is not null or undefined
            assertParamExists('createNetwork', 'createNetworkData', createNetworkData);
            const localVarPath = `/api/networks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createNetworkData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNetwork: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteNetwork', 'id', id);
            const localVarPath = `/api/networks/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNetwork: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getNetwork', 'id', id);
            const localVarPath = `/api/networks/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNetworks: async (criteria, page, size, sort, options = {}) => {
            const localVarPath = `/api/networks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {UpdateNetworkData} updateNetworkData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNetwork: async (id, updateNetworkData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateNetwork', 'id', id);
            // verify required parameter 'updateNetworkData' is not null or undefined
            assertParamExists('updateNetwork', 'updateNetworkData', updateNetworkData);
            const localVarPath = `/api/networks/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(updateNetworkData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * NetworksApi - functional programming interface
 * @export
 */
export const NetworksApiFp = function (configuration) {
    const localVarAxiosParamCreator = NetworksApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {CreateNetworkData} createNetworkData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createNetwork(createNetworkData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createNetwork(createNetworkData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteNetwork(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteNetwork(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNetwork(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNetwork(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNetworks(criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNetworks(criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {UpdateNetworkData} updateNetworkData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateNetwork(id, updateNetworkData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateNetwork(id, updateNetworkData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * NetworksApi - factory interface
 * @export
 */
export const NetworksApiFactory = function (configuration, basePath, axios) {
    const localVarFp = NetworksApiFp(configuration);
    return {
        /**
         *
         * @param {CreateNetworkData} createNetworkData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNetwork(createNetworkData, options) {
            return localVarFp.createNetwork(createNetworkData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNetwork(id, options) {
            return localVarFp.deleteNetwork(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNetwork(id, options) {
            return localVarFp.getNetwork(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNetworks(criteria, page, size, sort, options) {
            return localVarFp.getNetworks(criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {UpdateNetworkData} updateNetworkData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNetwork(id, updateNetworkData, options) {
            return localVarFp.updateNetwork(id, updateNetworkData, options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
        * @param {CreateNetworkData} createNetworkData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof NetworksApi
*/
export function createNetwork(createNetworkData, options) {
    return NetworksApiFp().createNetwork(createNetworkData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof NetworksApi
*/
export function deleteNetwork(id, options) {
    return NetworksApiFp().deleteNetwork(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof NetworksApi
*/
export function getNetwork(id, options) {
    return NetworksApiFp().getNetwork(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof NetworksApi
*/
export function getNetworks(criteria, page, size, sort, options) {
    return NetworksApiFp().getNetworks(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {UpdateNetworkData} updateNetworkData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof NetworksApi
*/
export function updateNetwork(id, updateNetworkData, options) {
    return NetworksApiFp().updateNetwork(id, updateNetworkData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {CreateNetworkData} createNetworkData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof NetworksApi
*/
export function createNetworkRaw(createNetworkData, options) {
    return NetworksApiFp().createNetwork(createNetworkData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof NetworksApi
*/
export function deleteNetworkRaw(id, options) {
    return NetworksApiFp().deleteNetwork(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof NetworksApi
*/
export function getNetworkRaw(id, options) {
    return NetworksApiFp().getNetwork(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof NetworksApi
*/
export function getNetworksRaw(criteria, page, size, sort, options) {
    return NetworksApiFp().getNetworks(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {UpdateNetworkData} updateNetworkData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof NetworksApi
*/
export function updateNetworkRaw(id, updateNetworkData, options) {
    return NetworksApiFp().updateNetwork(id, updateNetworkData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * NextNumberSeriesApi - axios parameter creator
 * @export
 */
export const NextNumberSeriesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveNextNumberSerie: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('archiveNextNumberSerie', 'id', id);
            const localVarPath = `/api/next-number-series/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {CreateNextNumberSerieData} createNextNumberSerieData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNextNumberSerie: async (createNextNumberSerieData, options = {}) => {
            // verify required parameter 'createNextNumberSerieData' is not null or undefined
            assertParamExists('createNextNumberSerie', 'createNextNumberSerieData', createNextNumberSerieData);
            const localVarPath = `/api/next-number-series`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createNextNumberSerieData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNextNumberSerie: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getNextNumberSerie', 'id', id);
            const localVarPath = `/api/next-number-series/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNextNumberSeries: async (criteria, page, size, sort, options = {}) => {
            const localVarPath = `/api/next-number-series`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {'SALES' | 'INVOICE' | 'PURCHASE' | 'PRODUCTION' | 'LOT_WEIGHT'} type
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNextNumberSeriesByType: async (type, page, size, sort, options = {}) => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('getNextNumberSeriesByType', 'type', type);
            const localVarPath = `/api/next-number-series/index/{type}`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {UpdateNextNumberSerieData} updateNextNumberSerieData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNextNumberSerie: async (id, updateNextNumberSerieData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateNextNumberSerie', 'id', id);
            // verify required parameter 'updateNextNumberSerieData' is not null or undefined
            assertParamExists('updateNextNumberSerie', 'updateNextNumberSerieData', updateNextNumberSerieData);
            const localVarPath = `/api/next-number-series/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(updateNextNumberSerieData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * NextNumberSeriesApi - functional programming interface
 * @export
 */
export const NextNumberSeriesApiFp = function (configuration) {
    const localVarAxiosParamCreator = NextNumberSeriesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async archiveNextNumberSerie(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.archiveNextNumberSerie(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {CreateNextNumberSerieData} createNextNumberSerieData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createNextNumberSerie(createNextNumberSerieData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createNextNumberSerie(createNextNumberSerieData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNextNumberSerie(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNextNumberSerie(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNextNumberSeries(criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNextNumberSeries(criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {'SALES' | 'INVOICE' | 'PURCHASE' | 'PRODUCTION' | 'LOT_WEIGHT'} type
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNextNumberSeriesByType(type, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNextNumberSeriesByType(type, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {UpdateNextNumberSerieData} updateNextNumberSerieData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateNextNumberSerie(id, updateNextNumberSerieData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateNextNumberSerie(id, updateNextNumberSerieData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * NextNumberSeriesApi - factory interface
 * @export
 */
export const NextNumberSeriesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = NextNumberSeriesApiFp(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveNextNumberSerie(id, options) {
            return localVarFp.archiveNextNumberSerie(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CreateNextNumberSerieData} createNextNumberSerieData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNextNumberSerie(createNextNumberSerieData, options) {
            return localVarFp.createNextNumberSerie(createNextNumberSerieData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNextNumberSerie(id, options) {
            return localVarFp.getNextNumberSerie(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNextNumberSeries(criteria, page, size, sort, options) {
            return localVarFp.getNextNumberSeries(criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {'SALES' | 'INVOICE' | 'PURCHASE' | 'PRODUCTION' | 'LOT_WEIGHT'} type
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNextNumberSeriesByType(type, page, size, sort, options) {
            return localVarFp.getNextNumberSeriesByType(type, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {UpdateNextNumberSerieData} updateNextNumberSerieData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNextNumberSerie(id, updateNextNumberSerieData, options) {
            return localVarFp.updateNextNumberSerie(id, updateNextNumberSerieData, options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof NextNumberSeriesApi
*/
export function archiveNextNumberSerie(id, options) {
    return NextNumberSeriesApiFp().archiveNextNumberSerie(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {CreateNextNumberSerieData} createNextNumberSerieData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof NextNumberSeriesApi
*/
export function createNextNumberSerie(createNextNumberSerieData, options) {
    return NextNumberSeriesApiFp().createNextNumberSerie(createNextNumberSerieData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof NextNumberSeriesApi
*/
export function getNextNumberSerie(id, options) {
    return NextNumberSeriesApiFp().getNextNumberSerie(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof NextNumberSeriesApi
*/
export function getNextNumberSeries(criteria, page, size, sort, options) {
    return NextNumberSeriesApiFp().getNextNumberSeries(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {'SALES' | 'INVOICE' | 'PURCHASE' | 'PRODUCTION' | 'LOT_WEIGHT'} type
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof NextNumberSeriesApi
*/
export function getNextNumberSeriesByType(type, page, size, sort, options) {
    return NextNumberSeriesApiFp().getNextNumberSeriesByType(type, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {UpdateNextNumberSerieData} updateNextNumberSerieData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof NextNumberSeriesApi
*/
export function updateNextNumberSerie(id, updateNextNumberSerieData, options) {
    return NextNumberSeriesApiFp().updateNextNumberSerie(id, updateNextNumberSerieData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof NextNumberSeriesApi
*/
export function archiveNextNumberSerieRaw(id, options) {
    return NextNumberSeriesApiFp().archiveNextNumberSerie(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {CreateNextNumberSerieData} createNextNumberSerieData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof NextNumberSeriesApi
*/
export function createNextNumberSerieRaw(createNextNumberSerieData, options) {
    return NextNumberSeriesApiFp().createNextNumberSerie(createNextNumberSerieData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof NextNumberSeriesApi
*/
export function getNextNumberSerieRaw(id, options) {
    return NextNumberSeriesApiFp().getNextNumberSerie(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof NextNumberSeriesApi
*/
export function getNextNumberSeriesRaw(criteria, page, size, sort, options) {
    return NextNumberSeriesApiFp().getNextNumberSeries(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {'SALES' | 'INVOICE' | 'PURCHASE' | 'PRODUCTION' | 'LOT_WEIGHT'} type
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof NextNumberSeriesApi
*/
export function getNextNumberSeriesByTypeRaw(type, page, size, sort, options) {
    return NextNumberSeriesApiFp().getNextNumberSeriesByType(type, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {UpdateNextNumberSerieData} updateNextNumberSerieData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof NextNumberSeriesApi
*/
export function updateNextNumberSerieRaw(id, updateNextNumberSerieData, options) {
    return NextNumberSeriesApiFp().updateNextNumberSerie(id, updateNextNumberSerieData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * OutcomeLotsApi - axios parameter creator
 * @export
 */
export const OutcomeLotsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOutcomeLot: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOutcomeLot', 'id', id);
            const localVarPath = `/api/outcome-lots/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOutcomeLot: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getOutcomeLot', 'id', id);
            const localVarPath = `/api/outcome-lots/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOutcomeLots: async (criteria, page, size, sort, options = {}) => {
            const localVarPath = `/api/outcome-lots`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {UpdateOutcomeLotData} updateOutcomeLotData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOutcomeLots: async (id, updateOutcomeLotData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateOutcomeLots', 'id', id);
            // verify required parameter 'updateOutcomeLotData' is not null or undefined
            assertParamExists('updateOutcomeLots', 'updateOutcomeLotData', updateOutcomeLotData);
            const localVarPath = `/api/outcome-lots/sales-order-row/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(updateOutcomeLotData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * OutcomeLotsApi - functional programming interface
 * @export
 */
export const OutcomeLotsApiFp = function (configuration) {
    const localVarAxiosParamCreator = OutcomeLotsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOutcomeLot(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOutcomeLot(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOutcomeLot(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOutcomeLot(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOutcomeLots(criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOutcomeLots(criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {UpdateOutcomeLotData} updateOutcomeLotData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOutcomeLots(id, updateOutcomeLotData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOutcomeLots(id, updateOutcomeLotData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * OutcomeLotsApi - factory interface
 * @export
 */
export const OutcomeLotsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = OutcomeLotsApiFp(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOutcomeLot(id, options) {
            return localVarFp.deleteOutcomeLot(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOutcomeLot(id, options) {
            return localVarFp.getOutcomeLot(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOutcomeLots(criteria, page, size, sort, options) {
            return localVarFp.getOutcomeLots(criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {UpdateOutcomeLotData} updateOutcomeLotData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOutcomeLots(id, updateOutcomeLotData, options) {
            return localVarFp.updateOutcomeLots(id, updateOutcomeLotData, options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof OutcomeLotsApi
*/
export function deleteOutcomeLot(id, options) {
    return OutcomeLotsApiFp().deleteOutcomeLot(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof OutcomeLotsApi
*/
export function getOutcomeLot(id, options) {
    return OutcomeLotsApiFp().getOutcomeLot(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof OutcomeLotsApi
*/
export function getOutcomeLots(criteria, page, size, sort, options) {
    return OutcomeLotsApiFp().getOutcomeLots(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {UpdateOutcomeLotData} updateOutcomeLotData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof OutcomeLotsApi
*/
export function updateOutcomeLots(id, updateOutcomeLotData, options) {
    return OutcomeLotsApiFp().updateOutcomeLots(id, updateOutcomeLotData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof OutcomeLotsApi
*/
export function deleteOutcomeLotRaw(id, options) {
    return OutcomeLotsApiFp().deleteOutcomeLot(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof OutcomeLotsApi
*/
export function getOutcomeLotRaw(id, options) {
    return OutcomeLotsApiFp().getOutcomeLot(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof OutcomeLotsApi
*/
export function getOutcomeLotsRaw(criteria, page, size, sort, options) {
    return OutcomeLotsApiFp().getOutcomeLots(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {UpdateOutcomeLotData} updateOutcomeLotData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof OutcomeLotsApi
*/
export function updateOutcomeLotsRaw(id, updateOutcomeLotData, options) {
    return OutcomeLotsApiFp().updateOutcomeLots(id, updateOutcomeLotData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * PackagingsApi - axios parameter creator
 * @export
 */
export const PackagingsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archivePackaging: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('archivePackaging', 'id', id);
            const localVarPath = `/api/packagings/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {CreatePackagingData} createPackagingData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPackaging: async (createPackagingData, options = {}) => {
            // verify required parameter 'createPackagingData' is not null or undefined
            assertParamExists('createPackaging', 'createPackagingData', createPackagingData);
            const localVarPath = `/api/packagings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createPackagingData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPackaging: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPackaging', 'id', id);
            const localVarPath = `/api/packagings/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPackagings: async (criteria, page, size, sort, options = {}) => {
            const localVarPath = `/api/packagings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {UpdatePackagingData} updatePackagingData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePackaging: async (id, updatePackagingData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updatePackaging', 'id', id);
            // verify required parameter 'updatePackagingData' is not null or undefined
            assertParamExists('updatePackaging', 'updatePackagingData', updatePackagingData);
            const localVarPath = `/api/packagings/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(updatePackagingData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * PackagingsApi - functional programming interface
 * @export
 */
export const PackagingsApiFp = function (configuration) {
    const localVarAxiosParamCreator = PackagingsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async archivePackaging(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.archivePackaging(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {CreatePackagingData} createPackagingData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPackaging(createPackagingData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPackaging(createPackagingData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPackaging(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPackaging(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPackagings(criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPackagings(criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {UpdatePackagingData} updatePackagingData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePackaging(id, updatePackagingData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePackaging(id, updatePackagingData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * PackagingsApi - factory interface
 * @export
 */
export const PackagingsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = PackagingsApiFp(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archivePackaging(id, options) {
            return localVarFp.archivePackaging(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CreatePackagingData} createPackagingData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPackaging(createPackagingData, options) {
            return localVarFp.createPackaging(createPackagingData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPackaging(id, options) {
            return localVarFp.getPackaging(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPackagings(criteria, page, size, sort, options) {
            return localVarFp.getPackagings(criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {UpdatePackagingData} updatePackagingData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePackaging(id, updatePackagingData, options) {
            return localVarFp.updatePackaging(id, updatePackagingData, options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PackagingsApi
*/
export function archivePackaging(id, options) {
    return PackagingsApiFp().archivePackaging(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {CreatePackagingData} createPackagingData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PackagingsApi
*/
export function createPackaging(createPackagingData, options) {
    return PackagingsApiFp().createPackaging(createPackagingData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PackagingsApi
*/
export function getPackaging(id, options) {
    return PackagingsApiFp().getPackaging(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PackagingsApi
*/
export function getPackagings(criteria, page, size, sort, options) {
    return PackagingsApiFp().getPackagings(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {UpdatePackagingData} updatePackagingData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PackagingsApi
*/
export function updatePackaging(id, updatePackagingData, options) {
    return PackagingsApiFp().updatePackaging(id, updatePackagingData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PackagingsApi
*/
export function archivePackagingRaw(id, options) {
    return PackagingsApiFp().archivePackaging(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {CreatePackagingData} createPackagingData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PackagingsApi
*/
export function createPackagingRaw(createPackagingData, options) {
    return PackagingsApiFp().createPackaging(createPackagingData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PackagingsApi
*/
export function getPackagingRaw(id, options) {
    return PackagingsApiFp().getPackaging(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PackagingsApi
*/
export function getPackagingsRaw(criteria, page, size, sort, options) {
    return PackagingsApiFp().getPackagings(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {UpdatePackagingData} updatePackagingData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PackagingsApi
*/
export function updatePackagingRaw(id, updatePackagingData, options) {
    return PackagingsApiFp().updatePackaging(id, updatePackagingData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * PaymentRequirementsApi - axios parameter creator
 * @export
 */
export const PaymentRequirementsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archivePaymentRequirement: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('archivePaymentRequirement', 'id', id);
            const localVarPath = `/api/payment-requirements/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {CreatePaymentRequirementData} createPaymentRequirementData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPaymentRequirement: async (createPaymentRequirementData, options = {}) => {
            // verify required parameter 'createPaymentRequirementData' is not null or undefined
            assertParamExists('createPaymentRequirement', 'createPaymentRequirementData', createPaymentRequirementData);
            const localVarPath = `/api/payment-requirements`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createPaymentRequirementData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentRequirement: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPaymentRequirement', 'id', id);
            const localVarPath = `/api/payment-requirements/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentRequirements: async (criteria, page, size, sort, options = {}) => {
            const localVarPath = `/api/payment-requirements`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {UpdatePaymentRequirementData} updatePaymentRequirementData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePaymentRequirement: async (id, updatePaymentRequirementData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updatePaymentRequirement', 'id', id);
            // verify required parameter 'updatePaymentRequirementData' is not null or undefined
            assertParamExists('updatePaymentRequirement', 'updatePaymentRequirementData', updatePaymentRequirementData);
            const localVarPath = `/api/payment-requirements/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(updatePaymentRequirementData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * PaymentRequirementsApi - functional programming interface
 * @export
 */
export const PaymentRequirementsApiFp = function (configuration) {
    const localVarAxiosParamCreator = PaymentRequirementsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async archivePaymentRequirement(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.archivePaymentRequirement(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {CreatePaymentRequirementData} createPaymentRequirementData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPaymentRequirement(createPaymentRequirementData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPaymentRequirement(createPaymentRequirementData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPaymentRequirement(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPaymentRequirement(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPaymentRequirements(criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPaymentRequirements(criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {UpdatePaymentRequirementData} updatePaymentRequirementData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePaymentRequirement(id, updatePaymentRequirementData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePaymentRequirement(id, updatePaymentRequirementData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * PaymentRequirementsApi - factory interface
 * @export
 */
export const PaymentRequirementsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = PaymentRequirementsApiFp(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archivePaymentRequirement(id, options) {
            return localVarFp.archivePaymentRequirement(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CreatePaymentRequirementData} createPaymentRequirementData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPaymentRequirement(createPaymentRequirementData, options) {
            return localVarFp.createPaymentRequirement(createPaymentRequirementData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentRequirement(id, options) {
            return localVarFp.getPaymentRequirement(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentRequirements(criteria, page, size, sort, options) {
            return localVarFp.getPaymentRequirements(criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {UpdatePaymentRequirementData} updatePaymentRequirementData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePaymentRequirement(id, updatePaymentRequirementData, options) {
            return localVarFp.updatePaymentRequirement(id, updatePaymentRequirementData, options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PaymentRequirementsApi
*/
export function archivePaymentRequirement(id, options) {
    return PaymentRequirementsApiFp().archivePaymentRequirement(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {CreatePaymentRequirementData} createPaymentRequirementData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PaymentRequirementsApi
*/
export function createPaymentRequirement(createPaymentRequirementData, options) {
    return PaymentRequirementsApiFp().createPaymentRequirement(createPaymentRequirementData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PaymentRequirementsApi
*/
export function getPaymentRequirement(id, options) {
    return PaymentRequirementsApiFp().getPaymentRequirement(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PaymentRequirementsApi
*/
export function getPaymentRequirements(criteria, page, size, sort, options) {
    return PaymentRequirementsApiFp().getPaymentRequirements(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {UpdatePaymentRequirementData} updatePaymentRequirementData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PaymentRequirementsApi
*/
export function updatePaymentRequirement(id, updatePaymentRequirementData, options) {
    return PaymentRequirementsApiFp().updatePaymentRequirement(id, updatePaymentRequirementData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PaymentRequirementsApi
*/
export function archivePaymentRequirementRaw(id, options) {
    return PaymentRequirementsApiFp().archivePaymentRequirement(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {CreatePaymentRequirementData} createPaymentRequirementData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PaymentRequirementsApi
*/
export function createPaymentRequirementRaw(createPaymentRequirementData, options) {
    return PaymentRequirementsApiFp().createPaymentRequirement(createPaymentRequirementData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PaymentRequirementsApi
*/
export function getPaymentRequirementRaw(id, options) {
    return PaymentRequirementsApiFp().getPaymentRequirement(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PaymentRequirementsApi
*/
export function getPaymentRequirementsRaw(criteria, page, size, sort, options) {
    return PaymentRequirementsApiFp().getPaymentRequirements(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {UpdatePaymentRequirementData} updatePaymentRequirementData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PaymentRequirementsApi
*/
export function updatePaymentRequirementRaw(id, updatePaymentRequirementData, options) {
    return PaymentRequirementsApiFp().updatePaymentRequirement(id, updatePaymentRequirementData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * PriceListItemsApi - axios parameter creator
 * @export
 */
export const PriceListItemsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} id
         * @param {UpdatePriceListItemData} updatePriceListItemData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePriceListItem1: async (id, updatePriceListItemData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updatePriceListItem1', 'id', id);
            // verify required parameter 'updatePriceListItemData' is not null or undefined
            assertParamExists('updatePriceListItem1', 'updatePriceListItemData', updatePriceListItemData);
            const localVarPath = `/api/price-list-items/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(updatePriceListItemData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * PriceListItemsApi - functional programming interface
 * @export
 */
export const PriceListItemsApiFp = function (configuration) {
    const localVarAxiosParamCreator = PriceListItemsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {UpdatePriceListItemData} updatePriceListItemData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePriceListItem1(id, updatePriceListItemData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePriceListItem1(id, updatePriceListItemData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * PriceListItemsApi - factory interface
 * @export
 */
export const PriceListItemsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = PriceListItemsApiFp(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {UpdatePriceListItemData} updatePriceListItemData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePriceListItem1(id, updatePriceListItemData, options) {
            return localVarFp.updatePriceListItem1(id, updatePriceListItemData, options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
        * @param {string} id
        * @param {UpdatePriceListItemData} updatePriceListItemData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PriceListItemsApi
*/
export function updatePriceListItem1(id, updatePriceListItemData, options) {
    return PriceListItemsApiFp().updatePriceListItem1(id, updatePriceListItemData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {UpdatePriceListItemData} updatePriceListItemData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PriceListItemsApi
*/
export function updatePriceListItem1Raw(id, updatePriceListItemData, options) {
    return PriceListItemsApiFp().updatePriceListItem1(id, updatePriceListItemData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * PriceListsApi - axios parameter creator
 * @export
 */
export const PriceListsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {CreatePriceListData} createPriceListData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPriceList: async (createPriceListData, options = {}) => {
            // verify required parameter 'createPriceListData' is not null or undefined
            assertParamExists('createPriceList', 'createPriceListData', createPriceListData);
            const localVarPath = `/api/price-lists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createPriceListData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} priceListId
         * @param {CreatePriceListItemData} createPriceListItemData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPriceListItem: async (priceListId, createPriceListItemData, options = {}) => {
            // verify required parameter 'priceListId' is not null or undefined
            assertParamExists('createPriceListItem', 'priceListId', priceListId);
            // verify required parameter 'createPriceListItemData' is not null or undefined
            assertParamExists('createPriceListItem', 'createPriceListItemData', createPriceListItemData);
            const localVarPath = `/api/price-lists/{priceListId}/items`
                .replace(`{${"priceListId"}}`, encodeURIComponent(String(priceListId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createPriceListItemData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePriceList: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deletePriceList', 'id', id);
            const localVarPath = `/api/price-lists/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} priceListId
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePriceListItem: async (priceListId, id, options = {}) => {
            // verify required parameter 'priceListId' is not null or undefined
            assertParamExists('deletePriceListItem', 'priceListId', priceListId);
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deletePriceListItem', 'id', id);
            const localVarPath = `/api/price-lists/{priceListId}/items/{id}`
                .replace(`{${"priceListId"}}`, encodeURIComponent(String(priceListId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPriceList: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPriceList', 'id', id);
            const localVarPath = `/api/price-lists/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPriceLists: async (criteria, page, size, sort, options = {}) => {
            const localVarPath = `/api/price-lists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        priceListItems: async (id, criteria, page, size, sort, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('priceListItems', 'id', id);
            const localVarPath = `/api/price-lists/{id}/items`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recalculatePriceLists: async (options = {}) => {
            const localVarPath = `/api/price-lists/recalculate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {SendPriceListData} sendPriceListData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendPriceList: async (sendPriceListData, options = {}) => {
            // verify required parameter 'sendPriceListData' is not null or undefined
            assertParamExists('sendPriceList', 'sendPriceListData', sendPriceListData);
            const localVarPath = `/api/price-lists/send`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(sendPriceListData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {UpdatePriceListData} updatePriceListData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePriceList: async (id, updatePriceListData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updatePriceList', 'id', id);
            // verify required parameter 'updatePriceListData' is not null or undefined
            assertParamExists('updatePriceList', 'updatePriceListData', updatePriceListData);
            const localVarPath = `/api/price-lists/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(updatePriceListData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} priceListId
         * @param {string} id
         * @param {UpdatePriceListItemData} updatePriceListItemData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePriceListItem: async (priceListId, id, updatePriceListItemData, options = {}) => {
            // verify required parameter 'priceListId' is not null or undefined
            assertParamExists('updatePriceListItem', 'priceListId', priceListId);
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updatePriceListItem', 'id', id);
            // verify required parameter 'updatePriceListItemData' is not null or undefined
            assertParamExists('updatePriceListItem', 'updatePriceListItemData', updatePriceListItemData);
            const localVarPath = `/api/price-lists/{priceListId}/items/{id}`
                .replace(`{${"priceListId"}}`, encodeURIComponent(String(priceListId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(updatePriceListItemData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * PriceListsApi - functional programming interface
 * @export
 */
export const PriceListsApiFp = function (configuration) {
    const localVarAxiosParamCreator = PriceListsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {CreatePriceListData} createPriceListData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPriceList(createPriceListData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPriceList(createPriceListData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} priceListId
         * @param {CreatePriceListItemData} createPriceListItemData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPriceListItem(priceListId, createPriceListItemData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPriceListItem(priceListId, createPriceListItemData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePriceList(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePriceList(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} priceListId
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePriceListItem(priceListId, id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePriceListItem(priceListId, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPriceList(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPriceList(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPriceLists(criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPriceLists(criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async priceListItems(id, criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.priceListItems(id, criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async recalculatePriceLists(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.recalculatePriceLists(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {SendPriceListData} sendPriceListData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendPriceList(sendPriceListData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendPriceList(sendPriceListData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {UpdatePriceListData} updatePriceListData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePriceList(id, updatePriceListData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePriceList(id, updatePriceListData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} priceListId
         * @param {string} id
         * @param {UpdatePriceListItemData} updatePriceListItemData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePriceListItem(priceListId, id, updatePriceListItemData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePriceListItem(priceListId, id, updatePriceListItemData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * PriceListsApi - factory interface
 * @export
 */
export const PriceListsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = PriceListsApiFp(configuration);
    return {
        /**
         *
         * @param {CreatePriceListData} createPriceListData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPriceList(createPriceListData, options) {
            return localVarFp.createPriceList(createPriceListData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} priceListId
         * @param {CreatePriceListItemData} createPriceListItemData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPriceListItem(priceListId, createPriceListItemData, options) {
            return localVarFp.createPriceListItem(priceListId, createPriceListItemData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePriceList(id, options) {
            return localVarFp.deletePriceList(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} priceListId
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePriceListItem(priceListId, id, options) {
            return localVarFp.deletePriceListItem(priceListId, id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPriceList(id, options) {
            return localVarFp.getPriceList(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPriceLists(criteria, page, size, sort, options) {
            return localVarFp.getPriceLists(criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        priceListItems(id, criteria, page, size, sort, options) {
            return localVarFp.priceListItems(id, criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recalculatePriceLists(options) {
            return localVarFp.recalculatePriceLists(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SendPriceListData} sendPriceListData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendPriceList(sendPriceListData, options) {
            return localVarFp.sendPriceList(sendPriceListData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {UpdatePriceListData} updatePriceListData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePriceList(id, updatePriceListData, options) {
            return localVarFp.updatePriceList(id, updatePriceListData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} priceListId
         * @param {string} id
         * @param {UpdatePriceListItemData} updatePriceListItemData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePriceListItem(priceListId, id, updatePriceListItemData, options) {
            return localVarFp.updatePriceListItem(priceListId, id, updatePriceListItemData, options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
        * @param {CreatePriceListData} createPriceListData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PriceListsApi
*/
export function createPriceList(createPriceListData, options) {
    return PriceListsApiFp().createPriceList(createPriceListData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} priceListId
        * @param {CreatePriceListItemData} createPriceListItemData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PriceListsApi
*/
export function createPriceListItem(priceListId, createPriceListItemData, options) {
    return PriceListsApiFp().createPriceListItem(priceListId, createPriceListItemData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PriceListsApi
*/
export function deletePriceList(id, options) {
    return PriceListsApiFp().deletePriceList(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} priceListId
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PriceListsApi
*/
export function deletePriceListItem(priceListId, id, options) {
    return PriceListsApiFp().deletePriceListItem(priceListId, id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PriceListsApi
*/
export function getPriceList(id, options) {
    return PriceListsApiFp().getPriceList(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PriceListsApi
*/
export function getPriceLists(criteria, page, size, sort, options) {
    return PriceListsApiFp().getPriceLists(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PriceListsApi
*/
export function priceListItems(id, criteria, page, size, sort, options) {
    return PriceListsApiFp().priceListItems(id, criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PriceListsApi
*/
export function recalculatePriceLists(options) {
    return PriceListsApiFp().recalculatePriceLists(options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {SendPriceListData} sendPriceListData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PriceListsApi
*/
export function sendPriceList(sendPriceListData, options) {
    return PriceListsApiFp().sendPriceList(sendPriceListData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {UpdatePriceListData} updatePriceListData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PriceListsApi
*/
export function updatePriceList(id, updatePriceListData, options) {
    return PriceListsApiFp().updatePriceList(id, updatePriceListData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} priceListId
        * @param {string} id
        * @param {UpdatePriceListItemData} updatePriceListItemData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PriceListsApi
*/
export function updatePriceListItem(priceListId, id, updatePriceListItemData, options) {
    return PriceListsApiFp().updatePriceListItem(priceListId, id, updatePriceListItemData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {CreatePriceListData} createPriceListData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PriceListsApi
*/
export function createPriceListRaw(createPriceListData, options) {
    return PriceListsApiFp().createPriceList(createPriceListData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} priceListId
        * @param {CreatePriceListItemData} createPriceListItemData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PriceListsApi
*/
export function createPriceListItemRaw(priceListId, createPriceListItemData, options) {
    return PriceListsApiFp().createPriceListItem(priceListId, createPriceListItemData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PriceListsApi
*/
export function deletePriceListRaw(id, options) {
    return PriceListsApiFp().deletePriceList(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} priceListId
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PriceListsApi
*/
export function deletePriceListItemRaw(priceListId, id, options) {
    return PriceListsApiFp().deletePriceListItem(priceListId, id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PriceListsApi
*/
export function getPriceListRaw(id, options) {
    return PriceListsApiFp().getPriceList(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PriceListsApi
*/
export function getPriceListsRaw(criteria, page, size, sort, options) {
    return PriceListsApiFp().getPriceLists(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PriceListsApi
*/
export function priceListItemsRaw(id, criteria, page, size, sort, options) {
    return PriceListsApiFp().priceListItems(id, criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PriceListsApi
*/
export function recalculatePriceListsRaw(options) {
    return PriceListsApiFp().recalculatePriceLists(options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {SendPriceListData} sendPriceListData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PriceListsApi
*/
export function sendPriceListRaw(sendPriceListData, options) {
    return PriceListsApiFp().sendPriceList(sendPriceListData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {UpdatePriceListData} updatePriceListData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PriceListsApi
*/
export function updatePriceListRaw(id, updatePriceListData, options) {
    return PriceListsApiFp().updatePriceList(id, updatePriceListData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} priceListId
        * @param {string} id
        * @param {UpdatePriceListItemData} updatePriceListItemData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PriceListsApi
*/
export function updatePriceListItemRaw(priceListId, id, updatePriceListItemData, options) {
    return PriceListsApiFp().updatePriceListItem(priceListId, id, updatePriceListItemData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * PrintersApi - axios parameter creator
 * @export
 */
export const PrintersApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {CreatePrinterData} createPrinterData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPrinter: async (createPrinterData, options = {}) => {
            // verify required parameter 'createPrinterData' is not null or undefined
            assertParamExists('createPrinter', 'createPrinterData', createPrinterData);
            const localVarPath = `/api/printers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createPrinterData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCupsPrinters: async (options = {}) => {
            const localVarPath = `/api/printers/cups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrinter: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPrinter', 'id', id);
            const localVarPath = `/api/printers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrinters: async (criteria, page, size, sort, options = {}) => {
            const localVarPath = `/api/printers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {UpdatePrinterData} updatePrinterData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePrinter: async (id, updatePrinterData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updatePrinter', 'id', id);
            // verify required parameter 'updatePrinterData' is not null or undefined
            assertParamExists('updatePrinter', 'updatePrinterData', updatePrinterData);
            const localVarPath = `/api/printers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(updatePrinterData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * PrintersApi - functional programming interface
 * @export
 */
export const PrintersApiFp = function (configuration) {
    const localVarAxiosParamCreator = PrintersApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {CreatePrinterData} createPrinterData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPrinter(createPrinterData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPrinter(createPrinterData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCupsPrinters(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCupsPrinters(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPrinter(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPrinter(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPrinters(criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPrinters(criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {UpdatePrinterData} updatePrinterData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePrinter(id, updatePrinterData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePrinter(id, updatePrinterData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * PrintersApi - factory interface
 * @export
 */
export const PrintersApiFactory = function (configuration, basePath, axios) {
    const localVarFp = PrintersApiFp(configuration);
    return {
        /**
         *
         * @param {CreatePrinterData} createPrinterData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPrinter(createPrinterData, options) {
            return localVarFp.createPrinter(createPrinterData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCupsPrinters(options) {
            return localVarFp.getCupsPrinters(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrinter(id, options) {
            return localVarFp.getPrinter(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrinters(criteria, page, size, sort, options) {
            return localVarFp.getPrinters(criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {UpdatePrinterData} updatePrinterData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePrinter(id, updatePrinterData, options) {
            return localVarFp.updatePrinter(id, updatePrinterData, options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
        * @param {CreatePrinterData} createPrinterData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PrintersApi
*/
export function createPrinter(createPrinterData, options) {
    return PrintersApiFp().createPrinter(createPrinterData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PrintersApi
*/
export function getCupsPrinters(options) {
    return PrintersApiFp().getCupsPrinters(options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PrintersApi
*/
export function getPrinter(id, options) {
    return PrintersApiFp().getPrinter(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PrintersApi
*/
export function getPrinters(criteria, page, size, sort, options) {
    return PrintersApiFp().getPrinters(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {UpdatePrinterData} updatePrinterData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PrintersApi
*/
export function updatePrinter(id, updatePrinterData, options) {
    return PrintersApiFp().updatePrinter(id, updatePrinterData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {CreatePrinterData} createPrinterData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PrintersApi
*/
export function createPrinterRaw(createPrinterData, options) {
    return PrintersApiFp().createPrinter(createPrinterData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PrintersApi
*/
export function getCupsPrintersRaw(options) {
    return PrintersApiFp().getCupsPrinters(options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PrintersApi
*/
export function getPrinterRaw(id, options) {
    return PrintersApiFp().getPrinter(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PrintersApi
*/
export function getPrintersRaw(criteria, page, size, sort, options) {
    return PrintersApiFp().getPrinters(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {UpdatePrinterData} updatePrinterData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PrintersApi
*/
export function updatePrinterRaw(id, updatePrinterData, options) {
    return PrintersApiFp().updatePrinter(id, updatePrinterData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * ProductCategoriesApi - axios parameter creator
 * @export
 */
export const ProductCategoriesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveSingleProductCategory: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('archiveSingleProductCategory', 'id', id);
            const localVarPath = `/api/product-categories/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {CreateProductCategoryData} createProductCategoryData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProductCategory: async (createProductCategoryData, options = {}) => {
            // verify required parameter 'createProductCategoryData' is not null or undefined
            assertParamExists('createProductCategory', 'createProductCategoryData', createProductCategoryData);
            const localVarPath = `/api/product-categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createProductCategoryData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductCategories: async (criteria, page, size, sort, options = {}) => {
            const localVarPath = `/api/product-categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductCategory: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getProductCategory', 'id', id);
            const localVarPath = `/api/product-categories/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {UpdateProductCategoryData} updateProductCategoryData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProductCategory: async (id, updateProductCategoryData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateProductCategory', 'id', id);
            // verify required parameter 'updateProductCategoryData' is not null or undefined
            assertParamExists('updateProductCategory', 'updateProductCategoryData', updateProductCategoryData);
            const localVarPath = `/api/product-categories/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(updateProductCategoryData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ProductCategoriesApi - functional programming interface
 * @export
 */
export const ProductCategoriesApiFp = function (configuration) {
    const localVarAxiosParamCreator = ProductCategoriesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async archiveSingleProductCategory(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.archiveSingleProductCategory(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {CreateProductCategoryData} createProductCategoryData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createProductCategory(createProductCategoryData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createProductCategory(createProductCategoryData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductCategories(criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductCategories(criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductCategory(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductCategory(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {UpdateProductCategoryData} updateProductCategoryData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProductCategory(id, updateProductCategoryData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProductCategory(id, updateProductCategoryData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * ProductCategoriesApi - factory interface
 * @export
 */
export const ProductCategoriesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ProductCategoriesApiFp(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveSingleProductCategory(id, options) {
            return localVarFp.archiveSingleProductCategory(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CreateProductCategoryData} createProductCategoryData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProductCategory(createProductCategoryData, options) {
            return localVarFp.createProductCategory(createProductCategoryData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductCategories(criteria, page, size, sort, options) {
            return localVarFp.getProductCategories(criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductCategory(id, options) {
            return localVarFp.getProductCategory(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {UpdateProductCategoryData} updateProductCategoryData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProductCategory(id, updateProductCategoryData, options) {
            return localVarFp.updateProductCategory(id, updateProductCategoryData, options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductCategoriesApi
*/
export function archiveSingleProductCategory(id, options) {
    return ProductCategoriesApiFp().archiveSingleProductCategory(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {CreateProductCategoryData} createProductCategoryData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductCategoriesApi
*/
export function createProductCategory(createProductCategoryData, options) {
    return ProductCategoriesApiFp().createProductCategory(createProductCategoryData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductCategoriesApi
*/
export function getProductCategories(criteria, page, size, sort, options) {
    return ProductCategoriesApiFp().getProductCategories(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductCategoriesApi
*/
export function getProductCategory(id, options) {
    return ProductCategoriesApiFp().getProductCategory(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {UpdateProductCategoryData} updateProductCategoryData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductCategoriesApi
*/
export function updateProductCategory(id, updateProductCategoryData, options) {
    return ProductCategoriesApiFp().updateProductCategory(id, updateProductCategoryData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductCategoriesApi
*/
export function archiveSingleProductCategoryRaw(id, options) {
    return ProductCategoriesApiFp().archiveSingleProductCategory(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {CreateProductCategoryData} createProductCategoryData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductCategoriesApi
*/
export function createProductCategoryRaw(createProductCategoryData, options) {
    return ProductCategoriesApiFp().createProductCategory(createProductCategoryData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductCategoriesApi
*/
export function getProductCategoriesRaw(criteria, page, size, sort, options) {
    return ProductCategoriesApiFp().getProductCategories(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductCategoriesApi
*/
export function getProductCategoryRaw(id, options) {
    return ProductCategoriesApiFp().getProductCategory(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {UpdateProductCategoryData} updateProductCategoryData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductCategoriesApi
*/
export function updateProductCategoryRaw(id, updateProductCategoryData, options) {
    return ProductCategoriesApiFp().updateProductCategory(id, updateProductCategoryData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * ProductTranslationsApi - axios parameter creator
 * @export
 */
export const ProductTranslationsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveSingleProductTranslation: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('archiveSingleProductTranslation', 'id', id);
            const localVarPath = `/api/product-translations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {CreateProductTranslationData} createProductTranslationData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProductTranslation: async (createProductTranslationData, options = {}) => {
            // verify required parameter 'createProductTranslationData' is not null or undefined
            assertParamExists('createProductTranslation', 'createProductTranslationData', createProductTranslationData);
            const localVarPath = `/api/product-translations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createProductTranslationData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductTranslation: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getProductTranslation', 'id', id);
            const localVarPath = `/api/product-translations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductTranslations: async (criteria, page, size, sort, options = {}) => {
            const localVarPath = `/api/product-translations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {UpdateProductTranslationData} updateProductTranslationData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProductTranslation: async (id, updateProductTranslationData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateProductTranslation', 'id', id);
            // verify required parameter 'updateProductTranslationData' is not null or undefined
            assertParamExists('updateProductTranslation', 'updateProductTranslationData', updateProductTranslationData);
            const localVarPath = `/api/product-translations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(updateProductTranslationData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ProductTranslationsApi - functional programming interface
 * @export
 */
export const ProductTranslationsApiFp = function (configuration) {
    const localVarAxiosParamCreator = ProductTranslationsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async archiveSingleProductTranslation(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.archiveSingleProductTranslation(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {CreateProductTranslationData} createProductTranslationData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createProductTranslation(createProductTranslationData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createProductTranslation(createProductTranslationData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductTranslation(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductTranslation(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductTranslations(criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductTranslations(criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {UpdateProductTranslationData} updateProductTranslationData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProductTranslation(id, updateProductTranslationData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProductTranslation(id, updateProductTranslationData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * ProductTranslationsApi - factory interface
 * @export
 */
export const ProductTranslationsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ProductTranslationsApiFp(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveSingleProductTranslation(id, options) {
            return localVarFp.archiveSingleProductTranslation(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CreateProductTranslationData} createProductTranslationData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProductTranslation(createProductTranslationData, options) {
            return localVarFp.createProductTranslation(createProductTranslationData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductTranslation(id, options) {
            return localVarFp.getProductTranslation(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductTranslations(criteria, page, size, sort, options) {
            return localVarFp.getProductTranslations(criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {UpdateProductTranslationData} updateProductTranslationData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProductTranslation(id, updateProductTranslationData, options) {
            return localVarFp.updateProductTranslation(id, updateProductTranslationData, options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductTranslationsApi
*/
export function archiveSingleProductTranslation(id, options) {
    return ProductTranslationsApiFp().archiveSingleProductTranslation(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {CreateProductTranslationData} createProductTranslationData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductTranslationsApi
*/
export function createProductTranslation(createProductTranslationData, options) {
    return ProductTranslationsApiFp().createProductTranslation(createProductTranslationData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductTranslationsApi
*/
export function getProductTranslation(id, options) {
    return ProductTranslationsApiFp().getProductTranslation(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductTranslationsApi
*/
export function getProductTranslations(criteria, page, size, sort, options) {
    return ProductTranslationsApiFp().getProductTranslations(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {UpdateProductTranslationData} updateProductTranslationData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductTranslationsApi
*/
export function updateProductTranslation(id, updateProductTranslationData, options) {
    return ProductTranslationsApiFp().updateProductTranslation(id, updateProductTranslationData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductTranslationsApi
*/
export function archiveSingleProductTranslationRaw(id, options) {
    return ProductTranslationsApiFp().archiveSingleProductTranslation(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {CreateProductTranslationData} createProductTranslationData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductTranslationsApi
*/
export function createProductTranslationRaw(createProductTranslationData, options) {
    return ProductTranslationsApiFp().createProductTranslation(createProductTranslationData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductTranslationsApi
*/
export function getProductTranslationRaw(id, options) {
    return ProductTranslationsApiFp().getProductTranslation(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductTranslationsApi
*/
export function getProductTranslationsRaw(criteria, page, size, sort, options) {
    return ProductTranslationsApiFp().getProductTranslations(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {UpdateProductTranslationData} updateProductTranslationData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductTranslationsApi
*/
export function updateProductTranslationRaw(id, updateProductTranslationData, options) {
    return ProductTranslationsApiFp().updateProductTranslation(id, updateProductTranslationData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * ProductionLabelTemplatePreferencesApi - axios parameter creator
 * @export
 */
export const ProductionLabelTemplatePreferencesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {CreateProductionLabelTemplatePreferenceData} createProductionLabelTemplatePreferenceData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProductionLabelTemplatePreference: async (createProductionLabelTemplatePreferenceData, options = {}) => {
            // verify required parameter 'createProductionLabelTemplatePreferenceData' is not null or undefined
            assertParamExists('createProductionLabelTemplatePreference', 'createProductionLabelTemplatePreferenceData', createProductionLabelTemplatePreferenceData);
            const localVarPath = `/api/production-label-template-preferences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createProductionLabelTemplatePreferenceData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProductionLabelTemplatePreference: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteProductionLabelTemplatePreference', 'id', id);
            const localVarPath = `/api/production-label-template-preferences/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductionLabelTemplatePreference: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getProductionLabelTemplatePreference', 'id', id);
            const localVarPath = `/api/production-label-template-preferences/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductionLabelTemplatePreferences: async (criteria, page, size, sort, options = {}) => {
            const localVarPath = `/api/production-label-template-preferences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {UpdateProductionLabelTemplatePreferenceData} updateProductionLabelTemplatePreferenceData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProductionLabelTemplatePreference: async (id, updateProductionLabelTemplatePreferenceData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateProductionLabelTemplatePreference', 'id', id);
            // verify required parameter 'updateProductionLabelTemplatePreferenceData' is not null or undefined
            assertParamExists('updateProductionLabelTemplatePreference', 'updateProductionLabelTemplatePreferenceData', updateProductionLabelTemplatePreferenceData);
            const localVarPath = `/api/production-label-template-preferences/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(updateProductionLabelTemplatePreferenceData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ProductionLabelTemplatePreferencesApi - functional programming interface
 * @export
 */
export const ProductionLabelTemplatePreferencesApiFp = function (configuration) {
    const localVarAxiosParamCreator = ProductionLabelTemplatePreferencesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {CreateProductionLabelTemplatePreferenceData} createProductionLabelTemplatePreferenceData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createProductionLabelTemplatePreference(createProductionLabelTemplatePreferenceData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createProductionLabelTemplatePreference(createProductionLabelTemplatePreferenceData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteProductionLabelTemplatePreference(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteProductionLabelTemplatePreference(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductionLabelTemplatePreference(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductionLabelTemplatePreference(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductionLabelTemplatePreferences(criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductionLabelTemplatePreferences(criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {UpdateProductionLabelTemplatePreferenceData} updateProductionLabelTemplatePreferenceData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProductionLabelTemplatePreference(id, updateProductionLabelTemplatePreferenceData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProductionLabelTemplatePreference(id, updateProductionLabelTemplatePreferenceData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * ProductionLabelTemplatePreferencesApi - factory interface
 * @export
 */
export const ProductionLabelTemplatePreferencesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ProductionLabelTemplatePreferencesApiFp(configuration);
    return {
        /**
         *
         * @param {CreateProductionLabelTemplatePreferenceData} createProductionLabelTemplatePreferenceData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProductionLabelTemplatePreference(createProductionLabelTemplatePreferenceData, options) {
            return localVarFp.createProductionLabelTemplatePreference(createProductionLabelTemplatePreferenceData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProductionLabelTemplatePreference(id, options) {
            return localVarFp.deleteProductionLabelTemplatePreference(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductionLabelTemplatePreference(id, options) {
            return localVarFp.getProductionLabelTemplatePreference(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductionLabelTemplatePreferences(criteria, page, size, sort, options) {
            return localVarFp.getProductionLabelTemplatePreferences(criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {UpdateProductionLabelTemplatePreferenceData} updateProductionLabelTemplatePreferenceData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProductionLabelTemplatePreference(id, updateProductionLabelTemplatePreferenceData, options) {
            return localVarFp.updateProductionLabelTemplatePreference(id, updateProductionLabelTemplatePreferenceData, options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
        * @param {CreateProductionLabelTemplatePreferenceData} createProductionLabelTemplatePreferenceData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionLabelTemplatePreferencesApi
*/
export function createProductionLabelTemplatePreference(createProductionLabelTemplatePreferenceData, options) {
    return ProductionLabelTemplatePreferencesApiFp().createProductionLabelTemplatePreference(createProductionLabelTemplatePreferenceData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionLabelTemplatePreferencesApi
*/
export function deleteProductionLabelTemplatePreference(id, options) {
    return ProductionLabelTemplatePreferencesApiFp().deleteProductionLabelTemplatePreference(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionLabelTemplatePreferencesApi
*/
export function getProductionLabelTemplatePreference(id, options) {
    return ProductionLabelTemplatePreferencesApiFp().getProductionLabelTemplatePreference(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionLabelTemplatePreferencesApi
*/
export function getProductionLabelTemplatePreferences(criteria, page, size, sort, options) {
    return ProductionLabelTemplatePreferencesApiFp().getProductionLabelTemplatePreferences(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {UpdateProductionLabelTemplatePreferenceData} updateProductionLabelTemplatePreferenceData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionLabelTemplatePreferencesApi
*/
export function updateProductionLabelTemplatePreference(id, updateProductionLabelTemplatePreferenceData, options) {
    return ProductionLabelTemplatePreferencesApiFp().updateProductionLabelTemplatePreference(id, updateProductionLabelTemplatePreferenceData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {CreateProductionLabelTemplatePreferenceData} createProductionLabelTemplatePreferenceData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionLabelTemplatePreferencesApi
*/
export function createProductionLabelTemplatePreferenceRaw(createProductionLabelTemplatePreferenceData, options) {
    return ProductionLabelTemplatePreferencesApiFp().createProductionLabelTemplatePreference(createProductionLabelTemplatePreferenceData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionLabelTemplatePreferencesApi
*/
export function deleteProductionLabelTemplatePreferenceRaw(id, options) {
    return ProductionLabelTemplatePreferencesApiFp().deleteProductionLabelTemplatePreference(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionLabelTemplatePreferencesApi
*/
export function getProductionLabelTemplatePreferenceRaw(id, options) {
    return ProductionLabelTemplatePreferencesApiFp().getProductionLabelTemplatePreference(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionLabelTemplatePreferencesApi
*/
export function getProductionLabelTemplatePreferencesRaw(criteria, page, size, sort, options) {
    return ProductionLabelTemplatePreferencesApiFp().getProductionLabelTemplatePreferences(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {UpdateProductionLabelTemplatePreferenceData} updateProductionLabelTemplatePreferenceData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionLabelTemplatePreferencesApi
*/
export function updateProductionLabelTemplatePreferenceRaw(id, updateProductionLabelTemplatePreferenceData, options) {
    return ProductionLabelTemplatePreferencesApiFp().updateProductionLabelTemplatePreference(id, updateProductionLabelTemplatePreferenceData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * ProductionStepCostPreferencesApi - axios parameter creator
 * @export
 */
export const ProductionStepCostPreferencesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveProductionStepCostPreference: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('archiveProductionStepCostPreference', 'id', id);
            const localVarPath = `/api/production-step-cost-preferences/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {CreateProductionStepCostPreferenceData} createProductionStepCostPreferenceData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProductionStepCostPreference: async (createProductionStepCostPreferenceData, options = {}) => {
            // verify required parameter 'createProductionStepCostPreferenceData' is not null or undefined
            assertParamExists('createProductionStepCostPreference', 'createProductionStepCostPreferenceData', createProductionStepCostPreferenceData);
            const localVarPath = `/api/production-step-cost-preferences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createProductionStepCostPreferenceData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductionStepCostPreference: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getProductionStepCostPreference', 'id', id);
            const localVarPath = `/api/production-step-cost-preferences/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductionStepCostPreferences: async (criteria, page, size, sort, options = {}) => {
            const localVarPath = `/api/production-step-cost-preferences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {UpdateProductionStepCostPreferenceData} updateProductionStepCostPreferenceData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProductionStepCostPreference: async (id, updateProductionStepCostPreferenceData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateProductionStepCostPreference', 'id', id);
            // verify required parameter 'updateProductionStepCostPreferenceData' is not null or undefined
            assertParamExists('updateProductionStepCostPreference', 'updateProductionStepCostPreferenceData', updateProductionStepCostPreferenceData);
            const localVarPath = `/api/production-step-cost-preferences/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(updateProductionStepCostPreferenceData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ProductionStepCostPreferencesApi - functional programming interface
 * @export
 */
export const ProductionStepCostPreferencesApiFp = function (configuration) {
    const localVarAxiosParamCreator = ProductionStepCostPreferencesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async archiveProductionStepCostPreference(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.archiveProductionStepCostPreference(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {CreateProductionStepCostPreferenceData} createProductionStepCostPreferenceData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createProductionStepCostPreference(createProductionStepCostPreferenceData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createProductionStepCostPreference(createProductionStepCostPreferenceData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductionStepCostPreference(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductionStepCostPreference(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductionStepCostPreferences(criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductionStepCostPreferences(criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {UpdateProductionStepCostPreferenceData} updateProductionStepCostPreferenceData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProductionStepCostPreference(id, updateProductionStepCostPreferenceData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProductionStepCostPreference(id, updateProductionStepCostPreferenceData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * ProductionStepCostPreferencesApi - factory interface
 * @export
 */
export const ProductionStepCostPreferencesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ProductionStepCostPreferencesApiFp(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveProductionStepCostPreference(id, options) {
            return localVarFp.archiveProductionStepCostPreference(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CreateProductionStepCostPreferenceData} createProductionStepCostPreferenceData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProductionStepCostPreference(createProductionStepCostPreferenceData, options) {
            return localVarFp.createProductionStepCostPreference(createProductionStepCostPreferenceData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductionStepCostPreference(id, options) {
            return localVarFp.getProductionStepCostPreference(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductionStepCostPreferences(criteria, page, size, sort, options) {
            return localVarFp.getProductionStepCostPreferences(criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {UpdateProductionStepCostPreferenceData} updateProductionStepCostPreferenceData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProductionStepCostPreference(id, updateProductionStepCostPreferenceData, options) {
            return localVarFp.updateProductionStepCostPreference(id, updateProductionStepCostPreferenceData, options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionStepCostPreferencesApi
*/
export function archiveProductionStepCostPreference(id, options) {
    return ProductionStepCostPreferencesApiFp().archiveProductionStepCostPreference(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {CreateProductionStepCostPreferenceData} createProductionStepCostPreferenceData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionStepCostPreferencesApi
*/
export function createProductionStepCostPreference(createProductionStepCostPreferenceData, options) {
    return ProductionStepCostPreferencesApiFp().createProductionStepCostPreference(createProductionStepCostPreferenceData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionStepCostPreferencesApi
*/
export function getProductionStepCostPreference(id, options) {
    return ProductionStepCostPreferencesApiFp().getProductionStepCostPreference(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionStepCostPreferencesApi
*/
export function getProductionStepCostPreferences(criteria, page, size, sort, options) {
    return ProductionStepCostPreferencesApiFp().getProductionStepCostPreferences(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {UpdateProductionStepCostPreferenceData} updateProductionStepCostPreferenceData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionStepCostPreferencesApi
*/
export function updateProductionStepCostPreference(id, updateProductionStepCostPreferenceData, options) {
    return ProductionStepCostPreferencesApiFp().updateProductionStepCostPreference(id, updateProductionStepCostPreferenceData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionStepCostPreferencesApi
*/
export function archiveProductionStepCostPreferenceRaw(id, options) {
    return ProductionStepCostPreferencesApiFp().archiveProductionStepCostPreference(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {CreateProductionStepCostPreferenceData} createProductionStepCostPreferenceData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionStepCostPreferencesApi
*/
export function createProductionStepCostPreferenceRaw(createProductionStepCostPreferenceData, options) {
    return ProductionStepCostPreferencesApiFp().createProductionStepCostPreference(createProductionStepCostPreferenceData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionStepCostPreferencesApi
*/
export function getProductionStepCostPreferenceRaw(id, options) {
    return ProductionStepCostPreferencesApiFp().getProductionStepCostPreference(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionStepCostPreferencesApi
*/
export function getProductionStepCostPreferencesRaw(criteria, page, size, sort, options) {
    return ProductionStepCostPreferencesApiFp().getProductionStepCostPreferences(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {UpdateProductionStepCostPreferenceData} updateProductionStepCostPreferenceData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionStepCostPreferencesApi
*/
export function updateProductionStepCostPreferenceRaw(id, updateProductionStepCostPreferenceData, options) {
    return ProductionStepCostPreferencesApiFp().updateProductionStepCostPreference(id, updateProductionStepCostPreferenceData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * ProductionStepCostTemplatesApi - axios parameter creator
 * @export
 */
export const ProductionStepCostTemplatesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveProductionStepCostTemplate: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('archiveProductionStepCostTemplate', 'id', id);
            const localVarPath = `/api/production-step-cost-templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {CreateProductionStepCostTemplateData} createProductionStepCostTemplateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProductionStepCostTemplate: async (createProductionStepCostTemplateData, options = {}) => {
            // verify required parameter 'createProductionStepCostTemplateData' is not null or undefined
            assertParamExists('createProductionStepCostTemplate', 'createProductionStepCostTemplateData', createProductionStepCostTemplateData);
            const localVarPath = `/api/production-step-cost-templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createProductionStepCostTemplateData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductionStepCostTemplate: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getProductionStepCostTemplate', 'id', id);
            const localVarPath = `/api/production-step-cost-templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductionStepCostTemplates: async (criteria, page, size, sort, options = {}) => {
            const localVarPath = `/api/production-step-cost-templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} productionStepCostId
         * @param {string} productionStepId
         * @param {UpdateProductionStepCostData} updateProductionStepCostData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProductionStepCost: async (productionStepCostId, productionStepId, updateProductionStepCostData, options = {}) => {
            // verify required parameter 'productionStepCostId' is not null or undefined
            assertParamExists('updateProductionStepCost', 'productionStepCostId', productionStepCostId);
            // verify required parameter 'productionStepId' is not null or undefined
            assertParamExists('updateProductionStepCost', 'productionStepId', productionStepId);
            // verify required parameter 'updateProductionStepCostData' is not null or undefined
            assertParamExists('updateProductionStepCost', 'updateProductionStepCostData', updateProductionStepCostData);
            const localVarPath = `/api/production-step-cost-templates/{productionStepCostId}/production-step/{productionStepId}`
                .replace(`{${"productionStepCostId"}}`, encodeURIComponent(String(productionStepCostId)))
                .replace(`{${"productionStepId"}}`, encodeURIComponent(String(productionStepId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(updateProductionStepCostData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {UpdateProductionStepCostTemplateData} updateProductionStepCostTemplateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProductionStepCostTemplate: async (id, updateProductionStepCostTemplateData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateProductionStepCostTemplate', 'id', id);
            // verify required parameter 'updateProductionStepCostTemplateData' is not null or undefined
            assertParamExists('updateProductionStepCostTemplate', 'updateProductionStepCostTemplateData', updateProductionStepCostTemplateData);
            const localVarPath = `/api/production-step-cost-templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(updateProductionStepCostTemplateData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ProductionStepCostTemplatesApi - functional programming interface
 * @export
 */
export const ProductionStepCostTemplatesApiFp = function (configuration) {
    const localVarAxiosParamCreator = ProductionStepCostTemplatesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async archiveProductionStepCostTemplate(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.archiveProductionStepCostTemplate(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {CreateProductionStepCostTemplateData} createProductionStepCostTemplateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createProductionStepCostTemplate(createProductionStepCostTemplateData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createProductionStepCostTemplate(createProductionStepCostTemplateData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductionStepCostTemplate(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductionStepCostTemplate(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductionStepCostTemplates(criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductionStepCostTemplates(criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} productionStepCostId
         * @param {string} productionStepId
         * @param {UpdateProductionStepCostData} updateProductionStepCostData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProductionStepCost(productionStepCostId, productionStepId, updateProductionStepCostData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProductionStepCost(productionStepCostId, productionStepId, updateProductionStepCostData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {UpdateProductionStepCostTemplateData} updateProductionStepCostTemplateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProductionStepCostTemplate(id, updateProductionStepCostTemplateData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProductionStepCostTemplate(id, updateProductionStepCostTemplateData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * ProductionStepCostTemplatesApi - factory interface
 * @export
 */
export const ProductionStepCostTemplatesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ProductionStepCostTemplatesApiFp(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveProductionStepCostTemplate(id, options) {
            return localVarFp.archiveProductionStepCostTemplate(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CreateProductionStepCostTemplateData} createProductionStepCostTemplateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProductionStepCostTemplate(createProductionStepCostTemplateData, options) {
            return localVarFp.createProductionStepCostTemplate(createProductionStepCostTemplateData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductionStepCostTemplate(id, options) {
            return localVarFp.getProductionStepCostTemplate(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductionStepCostTemplates(criteria, page, size, sort, options) {
            return localVarFp.getProductionStepCostTemplates(criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} productionStepCostId
         * @param {string} productionStepId
         * @param {UpdateProductionStepCostData} updateProductionStepCostData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProductionStepCost(productionStepCostId, productionStepId, updateProductionStepCostData, options) {
            return localVarFp.updateProductionStepCost(productionStepCostId, productionStepId, updateProductionStepCostData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {UpdateProductionStepCostTemplateData} updateProductionStepCostTemplateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProductionStepCostTemplate(id, updateProductionStepCostTemplateData, options) {
            return localVarFp.updateProductionStepCostTemplate(id, updateProductionStepCostTemplateData, options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionStepCostTemplatesApi
*/
export function archiveProductionStepCostTemplate(id, options) {
    return ProductionStepCostTemplatesApiFp().archiveProductionStepCostTemplate(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {CreateProductionStepCostTemplateData} createProductionStepCostTemplateData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionStepCostTemplatesApi
*/
export function createProductionStepCostTemplate(createProductionStepCostTemplateData, options) {
    return ProductionStepCostTemplatesApiFp().createProductionStepCostTemplate(createProductionStepCostTemplateData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionStepCostTemplatesApi
*/
export function getProductionStepCostTemplate(id, options) {
    return ProductionStepCostTemplatesApiFp().getProductionStepCostTemplate(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionStepCostTemplatesApi
*/
export function getProductionStepCostTemplates(criteria, page, size, sort, options) {
    return ProductionStepCostTemplatesApiFp().getProductionStepCostTemplates(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} productionStepCostId
        * @param {string} productionStepId
        * @param {UpdateProductionStepCostData} updateProductionStepCostData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionStepCostTemplatesApi
*/
export function updateProductionStepCost(productionStepCostId, productionStepId, updateProductionStepCostData, options) {
    return ProductionStepCostTemplatesApiFp().updateProductionStepCost(productionStepCostId, productionStepId, updateProductionStepCostData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {UpdateProductionStepCostTemplateData} updateProductionStepCostTemplateData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionStepCostTemplatesApi
*/
export function updateProductionStepCostTemplate(id, updateProductionStepCostTemplateData, options) {
    return ProductionStepCostTemplatesApiFp().updateProductionStepCostTemplate(id, updateProductionStepCostTemplateData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionStepCostTemplatesApi
*/
export function archiveProductionStepCostTemplateRaw(id, options) {
    return ProductionStepCostTemplatesApiFp().archiveProductionStepCostTemplate(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {CreateProductionStepCostTemplateData} createProductionStepCostTemplateData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionStepCostTemplatesApi
*/
export function createProductionStepCostTemplateRaw(createProductionStepCostTemplateData, options) {
    return ProductionStepCostTemplatesApiFp().createProductionStepCostTemplate(createProductionStepCostTemplateData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionStepCostTemplatesApi
*/
export function getProductionStepCostTemplateRaw(id, options) {
    return ProductionStepCostTemplatesApiFp().getProductionStepCostTemplate(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionStepCostTemplatesApi
*/
export function getProductionStepCostTemplatesRaw(criteria, page, size, sort, options) {
    return ProductionStepCostTemplatesApiFp().getProductionStepCostTemplates(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} productionStepCostId
        * @param {string} productionStepId
        * @param {UpdateProductionStepCostData} updateProductionStepCostData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionStepCostTemplatesApi
*/
export function updateProductionStepCostRaw(productionStepCostId, productionStepId, updateProductionStepCostData, options) {
    return ProductionStepCostTemplatesApiFp().updateProductionStepCost(productionStepCostId, productionStepId, updateProductionStepCostData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {UpdateProductionStepCostTemplateData} updateProductionStepCostTemplateData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionStepCostTemplatesApi
*/
export function updateProductionStepCostTemplateRaw(id, updateProductionStepCostTemplateData, options) {
    return ProductionStepCostTemplatesApiFp().updateProductionStepCostTemplate(id, updateProductionStepCostTemplateData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * ProductionStepTemplatesApi - axios parameter creator
 * @export
 */
export const ProductionStepTemplatesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveProductionStepTemplate: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('archiveProductionStepTemplate', 'id', id);
            const localVarPath = `/api/production-step-templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {CreateProductionStepTemplateData} createProductionStepTemplateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProductionStepTemplate: async (createProductionStepTemplateData, options = {}) => {
            // verify required parameter 'createProductionStepTemplateData' is not null or undefined
            assertParamExists('createProductionStepTemplate', 'createProductionStepTemplateData', createProductionStepTemplateData);
            const localVarPath = `/api/production-step-templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createProductionStepTemplateData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductionStepTemplate: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getProductionStepTemplate', 'id', id);
            const localVarPath = `/api/production-step-templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductionStepTemplates: async (criteria, page, size, sort, options = {}) => {
            const localVarPath = `/api/production-step-templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {UpdateProductionStepTemplateData} updateProductionStepTemplateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProductionStepTemplate: async (id, updateProductionStepTemplateData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateProductionStepTemplate', 'id', id);
            // verify required parameter 'updateProductionStepTemplateData' is not null or undefined
            assertParamExists('updateProductionStepTemplate', 'updateProductionStepTemplateData', updateProductionStepTemplateData);
            const localVarPath = `/api/production-step-templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(updateProductionStepTemplateData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ProductionStepTemplatesApi - functional programming interface
 * @export
 */
export const ProductionStepTemplatesApiFp = function (configuration) {
    const localVarAxiosParamCreator = ProductionStepTemplatesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async archiveProductionStepTemplate(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.archiveProductionStepTemplate(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {CreateProductionStepTemplateData} createProductionStepTemplateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createProductionStepTemplate(createProductionStepTemplateData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createProductionStepTemplate(createProductionStepTemplateData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductionStepTemplate(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductionStepTemplate(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductionStepTemplates(criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductionStepTemplates(criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {UpdateProductionStepTemplateData} updateProductionStepTemplateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProductionStepTemplate(id, updateProductionStepTemplateData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProductionStepTemplate(id, updateProductionStepTemplateData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * ProductionStepTemplatesApi - factory interface
 * @export
 */
export const ProductionStepTemplatesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ProductionStepTemplatesApiFp(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveProductionStepTemplate(id, options) {
            return localVarFp.archiveProductionStepTemplate(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CreateProductionStepTemplateData} createProductionStepTemplateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProductionStepTemplate(createProductionStepTemplateData, options) {
            return localVarFp.createProductionStepTemplate(createProductionStepTemplateData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductionStepTemplate(id, options) {
            return localVarFp.getProductionStepTemplate(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductionStepTemplates(criteria, page, size, sort, options) {
            return localVarFp.getProductionStepTemplates(criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {UpdateProductionStepTemplateData} updateProductionStepTemplateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProductionStepTemplate(id, updateProductionStepTemplateData, options) {
            return localVarFp.updateProductionStepTemplate(id, updateProductionStepTemplateData, options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionStepTemplatesApi
*/
export function archiveProductionStepTemplate(id, options) {
    return ProductionStepTemplatesApiFp().archiveProductionStepTemplate(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {CreateProductionStepTemplateData} createProductionStepTemplateData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionStepTemplatesApi
*/
export function createProductionStepTemplate(createProductionStepTemplateData, options) {
    return ProductionStepTemplatesApiFp().createProductionStepTemplate(createProductionStepTemplateData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionStepTemplatesApi
*/
export function getProductionStepTemplate(id, options) {
    return ProductionStepTemplatesApiFp().getProductionStepTemplate(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionStepTemplatesApi
*/
export function getProductionStepTemplates(criteria, page, size, sort, options) {
    return ProductionStepTemplatesApiFp().getProductionStepTemplates(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {UpdateProductionStepTemplateData} updateProductionStepTemplateData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionStepTemplatesApi
*/
export function updateProductionStepTemplate(id, updateProductionStepTemplateData, options) {
    return ProductionStepTemplatesApiFp().updateProductionStepTemplate(id, updateProductionStepTemplateData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionStepTemplatesApi
*/
export function archiveProductionStepTemplateRaw(id, options) {
    return ProductionStepTemplatesApiFp().archiveProductionStepTemplate(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {CreateProductionStepTemplateData} createProductionStepTemplateData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionStepTemplatesApi
*/
export function createProductionStepTemplateRaw(createProductionStepTemplateData, options) {
    return ProductionStepTemplatesApiFp().createProductionStepTemplate(createProductionStepTemplateData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionStepTemplatesApi
*/
export function getProductionStepTemplateRaw(id, options) {
    return ProductionStepTemplatesApiFp().getProductionStepTemplate(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionStepTemplatesApi
*/
export function getProductionStepTemplatesRaw(criteria, page, size, sort, options) {
    return ProductionStepTemplatesApiFp().getProductionStepTemplates(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {UpdateProductionStepTemplateData} updateProductionStepTemplateData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionStepTemplatesApi
*/
export function updateProductionStepTemplateRaw(id, updateProductionStepTemplateData, options) {
    return ProductionStepTemplatesApiFp().updateProductionStepTemplate(id, updateProductionStepTemplateData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * ProductionStepsApi - axios parameter creator
 * @export
 */
export const ProductionStepsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} productionStepId
         * @param {ActiveResultLotData} activeResultLotData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateResultLotForProductionStep: async (productionStepId, activeResultLotData, options = {}) => {
            // verify required parameter 'productionStepId' is not null or undefined
            assertParamExists('activateResultLotForProductionStep', 'productionStepId', productionStepId);
            // verify required parameter 'activeResultLotData' is not null or undefined
            assertParamExists('activateResultLotForProductionStep', 'activeResultLotData', activeResultLotData);
            const localVarPath = `/api/production-steps/{productionStepId}/activate-result-lot`
                .replace(`{${"productionStepId"}}`, encodeURIComponent(String(productionStepId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(activeResultLotData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {AddResourcesToProductionStepData} addResourcesToProductionStepData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addResourceReservationToProductionStep: async (id, addResourcesToProductionStepData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('addResourceReservationToProductionStep', 'id', id);
            // verify required parameter 'addResourcesToProductionStepData' is not null or undefined
            assertParamExists('addResourceReservationToProductionStep', 'addResourcesToProductionStepData', addResourcesToProductionStepData);
            const localVarPath = `/api/production-steps/{id}/add-resource-reservation`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(addResourcesToProductionStepData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        closeProductionStep: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('closeProductionStep', 'id', id);
            const localVarPath = `/api/production-steps/close/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} resultLotId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        closeResultLotForProductionStep: async (resultLotId, options = {}) => {
            // verify required parameter 'resultLotId' is not null or undefined
            assertParamExists('closeResultLotForProductionStep', 'resultLotId', resultLotId);
            const localVarPath = `/api/production-steps/result-lot/{resultLotId}/close`
                .replace(`{${"resultLotId"}}`, encodeURIComponent(String(resultLotId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} resultLotId
         * @param {Weights} weights
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLotWeightForProductionStepResultLot: async (resultLotId, weights, options = {}) => {
            // verify required parameter 'resultLotId' is not null or undefined
            assertParamExists('createLotWeightForProductionStepResultLot', 'resultLotId', resultLotId);
            // verify required parameter 'weights' is not null or undefined
            assertParamExists('createLotWeightForProductionStepResultLot', 'weights', weights);
            const localVarPath = `/api/production-steps/result-lot/{resultLotId}`
                .replace(`{${"resultLotId"}}`, encodeURIComponent(String(resultLotId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(weights, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} productionId
         * @param {CreateOrUpdateProductionOrderData} createOrUpdateProductionOrderData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrUpdateManualProductionSteps: async (productionId, createOrUpdateProductionOrderData, options = {}) => {
            // verify required parameter 'productionId' is not null or undefined
            assertParamExists('createOrUpdateManualProductionSteps', 'productionId', productionId);
            // verify required parameter 'createOrUpdateProductionOrderData' is not null or undefined
            assertParamExists('createOrUpdateManualProductionSteps', 'createOrUpdateProductionOrderData', createOrUpdateProductionOrderData);
            const localVarPath = `/api/production-steps/production/{productionId}`
                .replace(`{${"productionId"}}`, encodeURIComponent(String(productionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createOrUpdateProductionOrderData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} productionId
         * @param {string} productionStepTemplateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProductionOrderStepFromTemplate: async (productionId, productionStepTemplateId, options = {}) => {
            // verify required parameter 'productionId' is not null or undefined
            assertParamExists('createProductionOrderStepFromTemplate', 'productionId', productionId);
            // verify required parameter 'productionStepTemplateId' is not null or undefined
            assertParamExists('createProductionOrderStepFromTemplate', 'productionStepTemplateId', productionStepTemplateId);
            const localVarPath = `/api/production-steps/production/{productionId}/production-step-from-template/{productionStepTemplateId}`
                .replace(`{${"productionId"}}`, encodeURIComponent(String(productionId)))
                .replace(`{${"productionStepTemplateId"}}`, encodeURIComponent(String(productionStepTemplateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {CreateResultLotForProductionStepData} createResultLotForProductionStepData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createResultLotForProductionStep: async (id, createResultLotForProductionStepData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createResultLotForProductionStep', 'id', id);
            // verify required parameter 'createResultLotForProductionStepData' is not null or undefined
            assertParamExists('createResultLotForProductionStep', 'createResultLotForProductionStepData', createResultLotForProductionStepData);
            const localVarPath = `/api/production-steps/{id}/create-result-lot`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createResultLotForProductionStepData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} productionStepId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateResultLotForProductionStep: async (productionStepId, options = {}) => {
            // verify required parameter 'productionStepId' is not null or undefined
            assertParamExists('deactivateResultLotForProductionStep', 'productionStepId', productionStepId);
            const localVarPath = `/api/production-steps/{productionStepId}/deactivate-result-lot`
                .replace(`{${"productionStepId"}}`, encodeURIComponent(String(productionStepId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} resultLotId
         * @param {string} weightId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLotWeightForProductionStepResultLot: async (resultLotId, weightId, options = {}) => {
            // verify required parameter 'resultLotId' is not null or undefined
            assertParamExists('deleteLotWeightForProductionStepResultLot', 'resultLotId', resultLotId);
            // verify required parameter 'weightId' is not null or undefined
            assertParamExists('deleteLotWeightForProductionStepResultLot', 'weightId', weightId);
            const localVarPath = `/api/production-steps/result-lot/{resultLotId}/weight/{weightId}`
                .replace(`{${"resultLotId"}}`, encodeURIComponent(String(resultLotId)))
                .replace(`{${"weightId"}}`, encodeURIComponent(String(weightId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProductionStep: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteProductionStep', 'id', id);
            const localVarPath = `/api/production-steps/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteReservedResource: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteReservedResource', 'id', id);
            const localVarPath = `/api/production-steps/reserved-resource/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteResultLot: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteResultLot', 'id', id);
            const localVarPath = `/api/production-steps/result-lot/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {DetermineProductionStepCosts} determineProductionStepCosts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        determineProductionStepCosts: async (id, determineProductionStepCosts, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('determineProductionStepCosts', 'id', id);
            // verify required parameter 'determineProductionStepCosts' is not null or undefined
            assertParamExists('determineProductionStepCosts', 'determineProductionStepCosts', determineProductionStepCosts);
            const localVarPath = `/api/production-steps/{id}/determine-costs`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(determineProductionStepCosts, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateProductionStepCosts: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('generateProductionStepCosts', 'id', id);
            const localVarPath = `/api/production-steps/calculate-costs/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllResourcesForProductionStep: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAllResourcesForProductionStep', 'id', id);
            const localVarPath = `/api/production-steps/{id}/get-resources`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllResultsForProductionStep: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAllResultsForProductionStep', 'id', id);
            const localVarPath = `/api/production-steps/{id}/get-results`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductionOrderForProductionStep: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getProductionOrderForProductionStep', 'id', id);
            const localVarPath = `/api/production-steps/{id}/get-production-order`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductionStep: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getProductionStep', 'id', id);
            const localVarPath = `/api/production-steps/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductionStepAllowedResults: async (id, criteria, page, size, sort, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getProductionStepAllowedResults', 'id', id);
            const localVarPath = `/api/production-steps/{id}/allowed-results`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductionStepResults: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getProductionStepResults', 'id', id);
            const localVarPath = `/api/production-steps/{id}/results`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductionSteps: async (criteria, page, size, sort, options = {}) => {
            const localVarPath = `/api/production-steps`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} productionStepId
         * @param {string} productId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResultsForProductionStepByProduct: async (productionStepId, productId, options = {}) => {
            // verify required parameter 'productionStepId' is not null or undefined
            assertParamExists('getResultsForProductionStepByProduct', 'productionStepId', productionStepId);
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('getResultsForProductionStepByProduct', 'productId', productId);
            const localVarPath = `/api/production-steps/{productionStepId}/product/{productId}`
                .replace(`{${"productionStepId"}}`, encodeURIComponent(String(productionStepId)))
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} resultLotId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openResultLotForProductionStep: async (resultLotId, options = {}) => {
            // verify required parameter 'resultLotId' is not null or undefined
            assertParamExists('openResultLotForProductionStep', 'resultLotId', resultLotId);
            const localVarPath = `/api/production-steps/result-lot/{resultLotId}/open`
                .replace(`{${"resultLotId"}}`, encodeURIComponent(String(resultLotId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {UpdateProductionStepData} updateProductionStepData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProductionStep: async (id, updateProductionStepData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateProductionStep', 'id', id);
            // verify required parameter 'updateProductionStepData' is not null or undefined
            assertParamExists('updateProductionStep', 'updateProductionStepData', updateProductionStepData);
            const localVarPath = `/api/production-steps/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(updateProductionStepData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {UpdateProductionStepStatusData} updateProductionStepStatusData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProductionStepStatus: async (id, updateProductionStepStatusData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateProductionStepStatus', 'id', id);
            // verify required parameter 'updateProductionStepStatusData' is not null or undefined
            assertParamExists('updateProductionStepStatus', 'updateProductionStepStatusData', updateProductionStepStatusData);
            const localVarPath = `/api/production-steps/{id}/status`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(updateProductionStepStatusData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {UpdateResultLotData} updateResultLotData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateResultLot: async (id, updateResultLotData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateResultLot', 'id', id);
            // verify required parameter 'updateResultLotData' is not null or undefined
            assertParamExists('updateResultLot', 'updateResultLotData', updateResultLotData);
            const localVarPath = `/api/production-steps/result-lot/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(updateResultLotData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ProductionStepsApi - functional programming interface
 * @export
 */
export const ProductionStepsApiFp = function (configuration) {
    const localVarAxiosParamCreator = ProductionStepsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} productionStepId
         * @param {ActiveResultLotData} activeResultLotData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async activateResultLotForProductionStep(productionStepId, activeResultLotData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.activateResultLotForProductionStep(productionStepId, activeResultLotData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {AddResourcesToProductionStepData} addResourcesToProductionStepData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addResourceReservationToProductionStep(id, addResourcesToProductionStepData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addResourceReservationToProductionStep(id, addResourcesToProductionStepData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async closeProductionStep(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.closeProductionStep(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} resultLotId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async closeResultLotForProductionStep(resultLotId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.closeResultLotForProductionStep(resultLotId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} resultLotId
         * @param {Weights} weights
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createLotWeightForProductionStepResultLot(resultLotId, weights, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createLotWeightForProductionStepResultLot(resultLotId, weights, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} productionId
         * @param {CreateOrUpdateProductionOrderData} createOrUpdateProductionOrderData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOrUpdateManualProductionSteps(productionId, createOrUpdateProductionOrderData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOrUpdateManualProductionSteps(productionId, createOrUpdateProductionOrderData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} productionId
         * @param {string} productionStepTemplateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createProductionOrderStepFromTemplate(productionId, productionStepTemplateId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createProductionOrderStepFromTemplate(productionId, productionStepTemplateId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {CreateResultLotForProductionStepData} createResultLotForProductionStepData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createResultLotForProductionStep(id, createResultLotForProductionStepData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createResultLotForProductionStep(id, createResultLotForProductionStepData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} productionStepId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deactivateResultLotForProductionStep(productionStepId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deactivateResultLotForProductionStep(productionStepId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} resultLotId
         * @param {string} weightId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteLotWeightForProductionStepResultLot(resultLotId, weightId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteLotWeightForProductionStepResultLot(resultLotId, weightId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteProductionStep(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteProductionStep(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteReservedResource(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteReservedResource(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteResultLot(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteResultLot(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {DetermineProductionStepCosts} determineProductionStepCosts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async determineProductionStepCosts(id, determineProductionStepCosts, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.determineProductionStepCosts(id, determineProductionStepCosts, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateProductionStepCosts(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateProductionStepCosts(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllResourcesForProductionStep(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllResourcesForProductionStep(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllResultsForProductionStep(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllResultsForProductionStep(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductionOrderForProductionStep(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductionOrderForProductionStep(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductionStep(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductionStep(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductionStepAllowedResults(id, criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductionStepAllowedResults(id, criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductionStepResults(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductionStepResults(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductionSteps(criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductionSteps(criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} productionStepId
         * @param {string} productId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getResultsForProductionStepByProduct(productionStepId, productId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getResultsForProductionStepByProduct(productionStepId, productId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} resultLotId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async openResultLotForProductionStep(resultLotId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.openResultLotForProductionStep(resultLotId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {UpdateProductionStepData} updateProductionStepData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProductionStep(id, updateProductionStepData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProductionStep(id, updateProductionStepData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {UpdateProductionStepStatusData} updateProductionStepStatusData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProductionStepStatus(id, updateProductionStepStatusData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProductionStepStatus(id, updateProductionStepStatusData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {UpdateResultLotData} updateResultLotData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateResultLot(id, updateResultLotData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateResultLot(id, updateResultLotData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * ProductionStepsApi - factory interface
 * @export
 */
export const ProductionStepsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ProductionStepsApiFp(configuration);
    return {
        /**
         *
         * @param {string} productionStepId
         * @param {ActiveResultLotData} activeResultLotData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateResultLotForProductionStep(productionStepId, activeResultLotData, options) {
            return localVarFp.activateResultLotForProductionStep(productionStepId, activeResultLotData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {AddResourcesToProductionStepData} addResourcesToProductionStepData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addResourceReservationToProductionStep(id, addResourcesToProductionStepData, options) {
            return localVarFp.addResourceReservationToProductionStep(id, addResourcesToProductionStepData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        closeProductionStep(id, options) {
            return localVarFp.closeProductionStep(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} resultLotId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        closeResultLotForProductionStep(resultLotId, options) {
            return localVarFp.closeResultLotForProductionStep(resultLotId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} resultLotId
         * @param {Weights} weights
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLotWeightForProductionStepResultLot(resultLotId, weights, options) {
            return localVarFp.createLotWeightForProductionStepResultLot(resultLotId, weights, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} productionId
         * @param {CreateOrUpdateProductionOrderData} createOrUpdateProductionOrderData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrUpdateManualProductionSteps(productionId, createOrUpdateProductionOrderData, options) {
            return localVarFp.createOrUpdateManualProductionSteps(productionId, createOrUpdateProductionOrderData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} productionId
         * @param {string} productionStepTemplateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProductionOrderStepFromTemplate(productionId, productionStepTemplateId, options) {
            return localVarFp.createProductionOrderStepFromTemplate(productionId, productionStepTemplateId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {CreateResultLotForProductionStepData} createResultLotForProductionStepData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createResultLotForProductionStep(id, createResultLotForProductionStepData, options) {
            return localVarFp.createResultLotForProductionStep(id, createResultLotForProductionStepData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} productionStepId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateResultLotForProductionStep(productionStepId, options) {
            return localVarFp.deactivateResultLotForProductionStep(productionStepId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} resultLotId
         * @param {string} weightId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLotWeightForProductionStepResultLot(resultLotId, weightId, options) {
            return localVarFp.deleteLotWeightForProductionStepResultLot(resultLotId, weightId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProductionStep(id, options) {
            return localVarFp.deleteProductionStep(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteReservedResource(id, options) {
            return localVarFp.deleteReservedResource(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteResultLot(id, options) {
            return localVarFp.deleteResultLot(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {DetermineProductionStepCosts} determineProductionStepCosts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        determineProductionStepCosts(id, determineProductionStepCosts, options) {
            return localVarFp.determineProductionStepCosts(id, determineProductionStepCosts, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateProductionStepCosts(id, options) {
            return localVarFp.generateProductionStepCosts(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllResourcesForProductionStep(id, options) {
            return localVarFp.getAllResourcesForProductionStep(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllResultsForProductionStep(id, options) {
            return localVarFp.getAllResultsForProductionStep(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductionOrderForProductionStep(id, options) {
            return localVarFp.getProductionOrderForProductionStep(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductionStep(id, options) {
            return localVarFp.getProductionStep(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductionStepAllowedResults(id, criteria, page, size, sort, options) {
            return localVarFp.getProductionStepAllowedResults(id, criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductionStepResults(id, options) {
            return localVarFp.getProductionStepResults(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductionSteps(criteria, page, size, sort, options) {
            return localVarFp.getProductionSteps(criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} productionStepId
         * @param {string} productId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResultsForProductionStepByProduct(productionStepId, productId, options) {
            return localVarFp.getResultsForProductionStepByProduct(productionStepId, productId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} resultLotId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openResultLotForProductionStep(resultLotId, options) {
            return localVarFp.openResultLotForProductionStep(resultLotId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {UpdateProductionStepData} updateProductionStepData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProductionStep(id, updateProductionStepData, options) {
            return localVarFp.updateProductionStep(id, updateProductionStepData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {UpdateProductionStepStatusData} updateProductionStepStatusData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProductionStepStatus(id, updateProductionStepStatusData, options) {
            return localVarFp.updateProductionStepStatus(id, updateProductionStepStatusData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {UpdateResultLotData} updateResultLotData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateResultLot(id, updateResultLotData, options) {
            return localVarFp.updateResultLot(id, updateResultLotData, options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
        * @param {string} productionStepId
        * @param {ActiveResultLotData} activeResultLotData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionStepsApi
*/
export function activateResultLotForProductionStep(productionStepId, activeResultLotData, options) {
    return ProductionStepsApiFp().activateResultLotForProductionStep(productionStepId, activeResultLotData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {AddResourcesToProductionStepData} addResourcesToProductionStepData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionStepsApi
*/
export function addResourceReservationToProductionStep(id, addResourcesToProductionStepData, options) {
    return ProductionStepsApiFp().addResourceReservationToProductionStep(id, addResourcesToProductionStepData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionStepsApi
*/
export function closeProductionStep(id, options) {
    return ProductionStepsApiFp().closeProductionStep(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} resultLotId
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionStepsApi
*/
export function closeResultLotForProductionStep(resultLotId, options) {
    return ProductionStepsApiFp().closeResultLotForProductionStep(resultLotId, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} resultLotId
        * @param {Weights} weights
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionStepsApi
*/
export function createLotWeightForProductionStepResultLot(resultLotId, weights, options) {
    return ProductionStepsApiFp().createLotWeightForProductionStepResultLot(resultLotId, weights, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} productionId
        * @param {CreateOrUpdateProductionOrderData} createOrUpdateProductionOrderData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionStepsApi
*/
export function createOrUpdateManualProductionSteps(productionId, createOrUpdateProductionOrderData, options) {
    return ProductionStepsApiFp().createOrUpdateManualProductionSteps(productionId, createOrUpdateProductionOrderData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} productionId
        * @param {string} productionStepTemplateId
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionStepsApi
*/
export function createProductionOrderStepFromTemplate(productionId, productionStepTemplateId, options) {
    return ProductionStepsApiFp().createProductionOrderStepFromTemplate(productionId, productionStepTemplateId, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {CreateResultLotForProductionStepData} createResultLotForProductionStepData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionStepsApi
*/
export function createResultLotForProductionStep(id, createResultLotForProductionStepData, options) {
    return ProductionStepsApiFp().createResultLotForProductionStep(id, createResultLotForProductionStepData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} productionStepId
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionStepsApi
*/
export function deactivateResultLotForProductionStep(productionStepId, options) {
    return ProductionStepsApiFp().deactivateResultLotForProductionStep(productionStepId, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} resultLotId
        * @param {string} weightId
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionStepsApi
*/
export function deleteLotWeightForProductionStepResultLot(resultLotId, weightId, options) {
    return ProductionStepsApiFp().deleteLotWeightForProductionStepResultLot(resultLotId, weightId, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionStepsApi
*/
export function deleteProductionStep(id, options) {
    return ProductionStepsApiFp().deleteProductionStep(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionStepsApi
*/
export function deleteReservedResource(id, options) {
    return ProductionStepsApiFp().deleteReservedResource(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionStepsApi
*/
export function deleteResultLot(id, options) {
    return ProductionStepsApiFp().deleteResultLot(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {DetermineProductionStepCosts} determineProductionStepCosts
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionStepsApi
*/
export function determineProductionStepCosts(id, determineProductionStepCosts, options) {
    return ProductionStepsApiFp().determineProductionStepCosts(id, determineProductionStepCosts, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionStepsApi
*/
export function generateProductionStepCosts(id, options) {
    return ProductionStepsApiFp().generateProductionStepCosts(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionStepsApi
*/
export function getAllResourcesForProductionStep(id, options) {
    return ProductionStepsApiFp().getAllResourcesForProductionStep(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionStepsApi
*/
export function getAllResultsForProductionStep(id, options) {
    return ProductionStepsApiFp().getAllResultsForProductionStep(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionStepsApi
*/
export function getProductionOrderForProductionStep(id, options) {
    return ProductionStepsApiFp().getProductionOrderForProductionStep(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionStepsApi
*/
export function getProductionStep(id, options) {
    return ProductionStepsApiFp().getProductionStep(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionStepsApi
*/
export function getProductionStepAllowedResults(id, criteria, page, size, sort, options) {
    return ProductionStepsApiFp().getProductionStepAllowedResults(id, criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionStepsApi
*/
export function getProductionStepResults(id, options) {
    return ProductionStepsApiFp().getProductionStepResults(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionStepsApi
*/
export function getProductionSteps(criteria, page, size, sort, options) {
    return ProductionStepsApiFp().getProductionSteps(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} productionStepId
        * @param {string} productId
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionStepsApi
*/
export function getResultsForProductionStepByProduct(productionStepId, productId, options) {
    return ProductionStepsApiFp().getResultsForProductionStepByProduct(productionStepId, productId, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} resultLotId
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionStepsApi
*/
export function openResultLotForProductionStep(resultLotId, options) {
    return ProductionStepsApiFp().openResultLotForProductionStep(resultLotId, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {UpdateProductionStepData} updateProductionStepData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionStepsApi
*/
export function updateProductionStep(id, updateProductionStepData, options) {
    return ProductionStepsApiFp().updateProductionStep(id, updateProductionStepData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {UpdateProductionStepStatusData} updateProductionStepStatusData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionStepsApi
*/
export function updateProductionStepStatus(id, updateProductionStepStatusData, options) {
    return ProductionStepsApiFp().updateProductionStepStatus(id, updateProductionStepStatusData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {UpdateResultLotData} updateResultLotData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionStepsApi
*/
export function updateResultLot(id, updateResultLotData, options) {
    return ProductionStepsApiFp().updateResultLot(id, updateResultLotData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} productionStepId
        * @param {ActiveResultLotData} activeResultLotData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionStepsApi
*/
export function activateResultLotForProductionStepRaw(productionStepId, activeResultLotData, options) {
    return ProductionStepsApiFp().activateResultLotForProductionStep(productionStepId, activeResultLotData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {AddResourcesToProductionStepData} addResourcesToProductionStepData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionStepsApi
*/
export function addResourceReservationToProductionStepRaw(id, addResourcesToProductionStepData, options) {
    return ProductionStepsApiFp().addResourceReservationToProductionStep(id, addResourcesToProductionStepData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionStepsApi
*/
export function closeProductionStepRaw(id, options) {
    return ProductionStepsApiFp().closeProductionStep(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} resultLotId
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionStepsApi
*/
export function closeResultLotForProductionStepRaw(resultLotId, options) {
    return ProductionStepsApiFp().closeResultLotForProductionStep(resultLotId, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} resultLotId
        * @param {Weights} weights
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionStepsApi
*/
export function createLotWeightForProductionStepResultLotRaw(resultLotId, weights, options) {
    return ProductionStepsApiFp().createLotWeightForProductionStepResultLot(resultLotId, weights, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} productionId
        * @param {CreateOrUpdateProductionOrderData} createOrUpdateProductionOrderData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionStepsApi
*/
export function createOrUpdateManualProductionStepsRaw(productionId, createOrUpdateProductionOrderData, options) {
    return ProductionStepsApiFp().createOrUpdateManualProductionSteps(productionId, createOrUpdateProductionOrderData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} productionId
        * @param {string} productionStepTemplateId
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionStepsApi
*/
export function createProductionOrderStepFromTemplateRaw(productionId, productionStepTemplateId, options) {
    return ProductionStepsApiFp().createProductionOrderStepFromTemplate(productionId, productionStepTemplateId, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {CreateResultLotForProductionStepData} createResultLotForProductionStepData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionStepsApi
*/
export function createResultLotForProductionStepRaw(id, createResultLotForProductionStepData, options) {
    return ProductionStepsApiFp().createResultLotForProductionStep(id, createResultLotForProductionStepData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} productionStepId
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionStepsApi
*/
export function deactivateResultLotForProductionStepRaw(productionStepId, options) {
    return ProductionStepsApiFp().deactivateResultLotForProductionStep(productionStepId, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} resultLotId
        * @param {string} weightId
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionStepsApi
*/
export function deleteLotWeightForProductionStepResultLotRaw(resultLotId, weightId, options) {
    return ProductionStepsApiFp().deleteLotWeightForProductionStepResultLot(resultLotId, weightId, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionStepsApi
*/
export function deleteProductionStepRaw(id, options) {
    return ProductionStepsApiFp().deleteProductionStep(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionStepsApi
*/
export function deleteReservedResourceRaw(id, options) {
    return ProductionStepsApiFp().deleteReservedResource(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionStepsApi
*/
export function deleteResultLotRaw(id, options) {
    return ProductionStepsApiFp().deleteResultLot(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {DetermineProductionStepCosts} determineProductionStepCosts
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionStepsApi
*/
export function determineProductionStepCostsRaw(id, determineProductionStepCosts, options) {
    return ProductionStepsApiFp().determineProductionStepCosts(id, determineProductionStepCosts, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionStepsApi
*/
export function generateProductionStepCostsRaw(id, options) {
    return ProductionStepsApiFp().generateProductionStepCosts(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionStepsApi
*/
export function getAllResourcesForProductionStepRaw(id, options) {
    return ProductionStepsApiFp().getAllResourcesForProductionStep(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionStepsApi
*/
export function getAllResultsForProductionStepRaw(id, options) {
    return ProductionStepsApiFp().getAllResultsForProductionStep(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionStepsApi
*/
export function getProductionOrderForProductionStepRaw(id, options) {
    return ProductionStepsApiFp().getProductionOrderForProductionStep(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionStepsApi
*/
export function getProductionStepRaw(id, options) {
    return ProductionStepsApiFp().getProductionStep(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionStepsApi
*/
export function getProductionStepAllowedResultsRaw(id, criteria, page, size, sort, options) {
    return ProductionStepsApiFp().getProductionStepAllowedResults(id, criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionStepsApi
*/
export function getProductionStepResultsRaw(id, options) {
    return ProductionStepsApiFp().getProductionStepResults(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionStepsApi
*/
export function getProductionStepsRaw(criteria, page, size, sort, options) {
    return ProductionStepsApiFp().getProductionSteps(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} productionStepId
        * @param {string} productId
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionStepsApi
*/
export function getResultsForProductionStepByProductRaw(productionStepId, productId, options) {
    return ProductionStepsApiFp().getResultsForProductionStepByProduct(productionStepId, productId, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} resultLotId
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionStepsApi
*/
export function openResultLotForProductionStepRaw(resultLotId, options) {
    return ProductionStepsApiFp().openResultLotForProductionStep(resultLotId, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {UpdateProductionStepData} updateProductionStepData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionStepsApi
*/
export function updateProductionStepRaw(id, updateProductionStepData, options) {
    return ProductionStepsApiFp().updateProductionStep(id, updateProductionStepData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {UpdateProductionStepStatusData} updateProductionStepStatusData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionStepsApi
*/
export function updateProductionStepStatusRaw(id, updateProductionStepStatusData, options) {
    return ProductionStepsApiFp().updateProductionStepStatus(id, updateProductionStepStatusData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {UpdateResultLotData} updateResultLotData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionStepsApi
*/
export function updateResultLotRaw(id, updateResultLotData, options) {
    return ProductionStepsApiFp().updateResultLot(id, updateResultLotData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * ProductionTemplatesApi - axios parameter creator
 * @export
 */
export const ProductionTemplatesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveProductionOrderTemplate: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('archiveProductionOrderTemplate', 'id', id);
            const localVarPath = `/api/production-order-templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {CreateProductionOrderTemplateData} createProductionOrderTemplateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProductionOrderTemplate: async (createProductionOrderTemplateData, options = {}) => {
            // verify required parameter 'createProductionOrderTemplateData' is not null or undefined
            assertParamExists('createProductionOrderTemplate', 'createProductionOrderTemplateData', createProductionOrderTemplateData);
            const localVarPath = `/api/production-order-templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createProductionOrderTemplateData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductionOrderTemplate: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getProductionOrderTemplate', 'id', id);
            const localVarPath = `/api/production-order-templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductionOrderTemplates: async (criteria, page, size, sort, options = {}) => {
            const localVarPath = `/api/production-order-templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {UpdateProductionOrderTemplateData} updateProductionOrderTemplateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProductionOrderTemplate: async (id, updateProductionOrderTemplateData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateProductionOrderTemplate', 'id', id);
            // verify required parameter 'updateProductionOrderTemplateData' is not null or undefined
            assertParamExists('updateProductionOrderTemplate', 'updateProductionOrderTemplateData', updateProductionOrderTemplateData);
            const localVarPath = `/api/production-order-templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(updateProductionOrderTemplateData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ProductionTemplatesApi - functional programming interface
 * @export
 */
export const ProductionTemplatesApiFp = function (configuration) {
    const localVarAxiosParamCreator = ProductionTemplatesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async archiveProductionOrderTemplate(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.archiveProductionOrderTemplate(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {CreateProductionOrderTemplateData} createProductionOrderTemplateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createProductionOrderTemplate(createProductionOrderTemplateData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createProductionOrderTemplate(createProductionOrderTemplateData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductionOrderTemplate(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductionOrderTemplate(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductionOrderTemplates(criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductionOrderTemplates(criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {UpdateProductionOrderTemplateData} updateProductionOrderTemplateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProductionOrderTemplate(id, updateProductionOrderTemplateData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProductionOrderTemplate(id, updateProductionOrderTemplateData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * ProductionTemplatesApi - factory interface
 * @export
 */
export const ProductionTemplatesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ProductionTemplatesApiFp(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveProductionOrderTemplate(id, options) {
            return localVarFp.archiveProductionOrderTemplate(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CreateProductionOrderTemplateData} createProductionOrderTemplateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProductionOrderTemplate(createProductionOrderTemplateData, options) {
            return localVarFp.createProductionOrderTemplate(createProductionOrderTemplateData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductionOrderTemplate(id, options) {
            return localVarFp.getProductionOrderTemplate(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductionOrderTemplates(criteria, page, size, sort, options) {
            return localVarFp.getProductionOrderTemplates(criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {UpdateProductionOrderTemplateData} updateProductionOrderTemplateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProductionOrderTemplate(id, updateProductionOrderTemplateData, options) {
            return localVarFp.updateProductionOrderTemplate(id, updateProductionOrderTemplateData, options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionTemplatesApi
*/
export function archiveProductionOrderTemplate(id, options) {
    return ProductionTemplatesApiFp().archiveProductionOrderTemplate(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {CreateProductionOrderTemplateData} createProductionOrderTemplateData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionTemplatesApi
*/
export function createProductionOrderTemplate(createProductionOrderTemplateData, options) {
    return ProductionTemplatesApiFp().createProductionOrderTemplate(createProductionOrderTemplateData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionTemplatesApi
*/
export function getProductionOrderTemplate(id, options) {
    return ProductionTemplatesApiFp().getProductionOrderTemplate(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionTemplatesApi
*/
export function getProductionOrderTemplates(criteria, page, size, sort, options) {
    return ProductionTemplatesApiFp().getProductionOrderTemplates(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {UpdateProductionOrderTemplateData} updateProductionOrderTemplateData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionTemplatesApi
*/
export function updateProductionOrderTemplate(id, updateProductionOrderTemplateData, options) {
    return ProductionTemplatesApiFp().updateProductionOrderTemplate(id, updateProductionOrderTemplateData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionTemplatesApi
*/
export function archiveProductionOrderTemplateRaw(id, options) {
    return ProductionTemplatesApiFp().archiveProductionOrderTemplate(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {CreateProductionOrderTemplateData} createProductionOrderTemplateData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionTemplatesApi
*/
export function createProductionOrderTemplateRaw(createProductionOrderTemplateData, options) {
    return ProductionTemplatesApiFp().createProductionOrderTemplate(createProductionOrderTemplateData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionTemplatesApi
*/
export function getProductionOrderTemplateRaw(id, options) {
    return ProductionTemplatesApiFp().getProductionOrderTemplate(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionTemplatesApi
*/
export function getProductionOrderTemplatesRaw(criteria, page, size, sort, options) {
    return ProductionTemplatesApiFp().getProductionOrderTemplates(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {UpdateProductionOrderTemplateData} updateProductionOrderTemplateData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionTemplatesApi
*/
export function updateProductionOrderTemplateRaw(id, updateProductionOrderTemplateData, options) {
    return ProductionTemplatesApiFp().updateProductionOrderTemplate(id, updateProductionOrderTemplateData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * ProductionsApi - axios parameter creator
 * @export
 */
export const ProductionsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveProductionOrder: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('archiveProductionOrder', 'id', id);
            const localVarPath = `/api/production-orders/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} productionStepId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveProductionStepByProductionOrder: async (productionStepId, options = {}) => {
            // verify required parameter 'productionStepId' is not null or undefined
            assertParamExists('archiveProductionStepByProductionOrder', 'productionStepId', productionStepId);
            const localVarPath = `/api/production-orders/{id}/steps/{productionStepId}`
                .replace(`{${"productionStepId"}}`, encodeURIComponent(String(productionStepId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        closeProductionOrder: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('closeProductionOrder', 'id', id);
            const localVarPath = `/api/production-orders/close/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} productionTemplateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProductionOrderFromTemplate: async (productionTemplateId, options = {}) => {
            // verify required parameter 'productionTemplateId' is not null or undefined
            assertParamExists('createProductionOrderFromTemplate', 'productionTemplateId', productionTemplateId);
            const localVarPath = `/api/production-orders/production-from-template/{productionTemplateId}`
                .replace(`{${"productionTemplateId"}}`, encodeURIComponent(String(productionTemplateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {CreateProductionFromSalesOrderRowsData} createProductionFromSalesOrderRowsData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProductionOrderStepsFromSalesOrderRows: async (createProductionFromSalesOrderRowsData, options = {}) => {
            // verify required parameter 'createProductionFromSalesOrderRowsData' is not null or undefined
            assertParamExists('createProductionOrderStepsFromSalesOrderRows', 'createProductionFromSalesOrderRowsData', createProductionFromSalesOrderRowsData);
            const localVarPath = `/api/production-orders/production-from-sales-order-rows`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createProductionFromSalesOrderRowsData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateProductionStepCostsByProductionOrder: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('generateProductionStepCostsByProductionOrder', 'id', id);
            const localVarPath = `/api/production-orders/calculate-costs/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductionOrder: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getProductionOrder', 'id', id);
            const localVarPath = `/api/production-orders/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductionOrders: async (criteria, page, size, sort, options = {}) => {
            const localVarPath = `/api/production-orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductionOrdersQuantity: async (options = {}) => {
            const localVarPath = `/api/production-orders/production-orders-quantity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} productionId
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductionStepsByProductionOrder: async (productionId, criteria, page, size, sort, options = {}) => {
            // verify required parameter 'productionId' is not null or undefined
            assertParamExists('getProductionStepsByProductionOrder', 'productionId', productionId);
            const localVarPath = `/api/production-orders/{productionId}/steps`
                .replace(`{${"productionId"}}`, encodeURIComponent(String(productionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} resultLotId
         * @param {string} lotId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        printBoxLabel: async (resultLotId, lotId, options = {}) => {
            // verify required parameter 'resultLotId' is not null or undefined
            assertParamExists('printBoxLabel', 'resultLotId', resultLotId);
            // verify required parameter 'lotId' is not null or undefined
            assertParamExists('printBoxLabel', 'lotId', lotId);
            const localVarPath = `/api/production-orders/print-box-label/{resultLotId}/lot/{lotId}`
                .replace(`{${"resultLotId"}}`, encodeURIComponent(String(resultLotId)))
                .replace(`{${"lotId"}}`, encodeURIComponent(String(lotId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        printResultLot: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('printResultLot', 'id', id);
            const localVarPath = `/api/production-orders/print-result-lot/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {UpdateProductionOrderData} updateProductionOrderData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProductionOrder: async (id, updateProductionOrderData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateProductionOrder', 'id', id);
            // verify required parameter 'updateProductionOrderData' is not null or undefined
            assertParamExists('updateProductionOrder', 'updateProductionOrderData', updateProductionOrderData);
            const localVarPath = `/api/production-orders/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(updateProductionOrderData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {UpdateProductionStatusData} updateProductionStatusData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProductionOrderStatus: async (id, updateProductionStatusData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateProductionOrderStatus', 'id', id);
            // verify required parameter 'updateProductionStatusData' is not null or undefined
            assertParamExists('updateProductionOrderStatus', 'updateProductionStatusData', updateProductionStatusData);
            const localVarPath = `/api/production-orders/{id}/status`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(updateProductionStatusData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ProductionsApi - functional programming interface
 * @export
 */
export const ProductionsApiFp = function (configuration) {
    const localVarAxiosParamCreator = ProductionsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async archiveProductionOrder(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.archiveProductionOrder(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} productionStepId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async archiveProductionStepByProductionOrder(productionStepId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.archiveProductionStepByProductionOrder(productionStepId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async closeProductionOrder(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.closeProductionOrder(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} productionTemplateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createProductionOrderFromTemplate(productionTemplateId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createProductionOrderFromTemplate(productionTemplateId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {CreateProductionFromSalesOrderRowsData} createProductionFromSalesOrderRowsData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createProductionOrderStepsFromSalesOrderRows(createProductionFromSalesOrderRowsData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createProductionOrderStepsFromSalesOrderRows(createProductionFromSalesOrderRowsData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateProductionStepCostsByProductionOrder(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateProductionStepCostsByProductionOrder(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductionOrder(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductionOrder(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductionOrders(criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductionOrders(criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductionOrdersQuantity(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductionOrdersQuantity(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} productionId
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductionStepsByProductionOrder(productionId, criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductionStepsByProductionOrder(productionId, criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} resultLotId
         * @param {string} lotId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async printBoxLabel(resultLotId, lotId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.printBoxLabel(resultLotId, lotId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async printResultLot(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.printResultLot(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {UpdateProductionOrderData} updateProductionOrderData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProductionOrder(id, updateProductionOrderData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProductionOrder(id, updateProductionOrderData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {UpdateProductionStatusData} updateProductionStatusData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProductionOrderStatus(id, updateProductionStatusData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProductionOrderStatus(id, updateProductionStatusData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * ProductionsApi - factory interface
 * @export
 */
export const ProductionsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ProductionsApiFp(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveProductionOrder(id, options) {
            return localVarFp.archiveProductionOrder(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} productionStepId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveProductionStepByProductionOrder(productionStepId, options) {
            return localVarFp.archiveProductionStepByProductionOrder(productionStepId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        closeProductionOrder(id, options) {
            return localVarFp.closeProductionOrder(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} productionTemplateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProductionOrderFromTemplate(productionTemplateId, options) {
            return localVarFp.createProductionOrderFromTemplate(productionTemplateId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CreateProductionFromSalesOrderRowsData} createProductionFromSalesOrderRowsData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProductionOrderStepsFromSalesOrderRows(createProductionFromSalesOrderRowsData, options) {
            return localVarFp.createProductionOrderStepsFromSalesOrderRows(createProductionFromSalesOrderRowsData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateProductionStepCostsByProductionOrder(id, options) {
            return localVarFp.generateProductionStepCostsByProductionOrder(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductionOrder(id, options) {
            return localVarFp.getProductionOrder(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductionOrders(criteria, page, size, sort, options) {
            return localVarFp.getProductionOrders(criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductionOrdersQuantity(options) {
            return localVarFp.getProductionOrdersQuantity(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} productionId
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductionStepsByProductionOrder(productionId, criteria, page, size, sort, options) {
            return localVarFp.getProductionStepsByProductionOrder(productionId, criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} resultLotId
         * @param {string} lotId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        printBoxLabel(resultLotId, lotId, options) {
            return localVarFp.printBoxLabel(resultLotId, lotId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        printResultLot(id, options) {
            return localVarFp.printResultLot(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {UpdateProductionOrderData} updateProductionOrderData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProductionOrder(id, updateProductionOrderData, options) {
            return localVarFp.updateProductionOrder(id, updateProductionOrderData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {UpdateProductionStatusData} updateProductionStatusData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProductionOrderStatus(id, updateProductionStatusData, options) {
            return localVarFp.updateProductionOrderStatus(id, updateProductionStatusData, options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionsApi
*/
export function archiveProductionOrder(id, options) {
    return ProductionsApiFp().archiveProductionOrder(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} productionStepId
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionsApi
*/
export function archiveProductionStepByProductionOrder(productionStepId, options) {
    return ProductionsApiFp().archiveProductionStepByProductionOrder(productionStepId, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionsApi
*/
export function closeProductionOrder(id, options) {
    return ProductionsApiFp().closeProductionOrder(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} productionTemplateId
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionsApi
*/
export function createProductionOrderFromTemplate(productionTemplateId, options) {
    return ProductionsApiFp().createProductionOrderFromTemplate(productionTemplateId, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {CreateProductionFromSalesOrderRowsData} createProductionFromSalesOrderRowsData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionsApi
*/
export function createProductionOrderStepsFromSalesOrderRows(createProductionFromSalesOrderRowsData, options) {
    return ProductionsApiFp().createProductionOrderStepsFromSalesOrderRows(createProductionFromSalesOrderRowsData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionsApi
*/
export function generateProductionStepCostsByProductionOrder(id, options) {
    return ProductionsApiFp().generateProductionStepCostsByProductionOrder(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionsApi
*/
export function getProductionOrder(id, options) {
    return ProductionsApiFp().getProductionOrder(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionsApi
*/
export function getProductionOrders(criteria, page, size, sort, options) {
    return ProductionsApiFp().getProductionOrders(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionsApi
*/
export function getProductionOrdersQuantity(options) {
    return ProductionsApiFp().getProductionOrdersQuantity(options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} productionId
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionsApi
*/
export function getProductionStepsByProductionOrder(productionId, criteria, page, size, sort, options) {
    return ProductionsApiFp().getProductionStepsByProductionOrder(productionId, criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} resultLotId
        * @param {string} lotId
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionsApi
*/
export function printBoxLabel(resultLotId, lotId, options) {
    return ProductionsApiFp().printBoxLabel(resultLotId, lotId, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionsApi
*/
export function printResultLot(id, options) {
    return ProductionsApiFp().printResultLot(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {UpdateProductionOrderData} updateProductionOrderData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionsApi
*/
export function updateProductionOrder(id, updateProductionOrderData, options) {
    return ProductionsApiFp().updateProductionOrder(id, updateProductionOrderData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {UpdateProductionStatusData} updateProductionStatusData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionsApi
*/
export function updateProductionOrderStatus(id, updateProductionStatusData, options) {
    return ProductionsApiFp().updateProductionOrderStatus(id, updateProductionStatusData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionsApi
*/
export function archiveProductionOrderRaw(id, options) {
    return ProductionsApiFp().archiveProductionOrder(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} productionStepId
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionsApi
*/
export function archiveProductionStepByProductionOrderRaw(productionStepId, options) {
    return ProductionsApiFp().archiveProductionStepByProductionOrder(productionStepId, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionsApi
*/
export function closeProductionOrderRaw(id, options) {
    return ProductionsApiFp().closeProductionOrder(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} productionTemplateId
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionsApi
*/
export function createProductionOrderFromTemplateRaw(productionTemplateId, options) {
    return ProductionsApiFp().createProductionOrderFromTemplate(productionTemplateId, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {CreateProductionFromSalesOrderRowsData} createProductionFromSalesOrderRowsData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionsApi
*/
export function createProductionOrderStepsFromSalesOrderRowsRaw(createProductionFromSalesOrderRowsData, options) {
    return ProductionsApiFp().createProductionOrderStepsFromSalesOrderRows(createProductionFromSalesOrderRowsData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionsApi
*/
export function generateProductionStepCostsByProductionOrderRaw(id, options) {
    return ProductionsApiFp().generateProductionStepCostsByProductionOrder(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionsApi
*/
export function getProductionOrderRaw(id, options) {
    return ProductionsApiFp().getProductionOrder(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionsApi
*/
export function getProductionOrdersRaw(criteria, page, size, sort, options) {
    return ProductionsApiFp().getProductionOrders(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionsApi
*/
export function getProductionOrdersQuantityRaw(options) {
    return ProductionsApiFp().getProductionOrdersQuantity(options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} productionId
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionsApi
*/
export function getProductionStepsByProductionOrderRaw(productionId, criteria, page, size, sort, options) {
    return ProductionsApiFp().getProductionStepsByProductionOrder(productionId, criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} resultLotId
        * @param {string} lotId
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionsApi
*/
export function printBoxLabelRaw(resultLotId, lotId, options) {
    return ProductionsApiFp().printBoxLabel(resultLotId, lotId, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionsApi
*/
export function printResultLotRaw(id, options) {
    return ProductionsApiFp().printResultLot(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {UpdateProductionOrderData} updateProductionOrderData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionsApi
*/
export function updateProductionOrderRaw(id, updateProductionOrderData, options) {
    return ProductionsApiFp().updateProductionOrder(id, updateProductionOrderData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {UpdateProductionStatusData} updateProductionStatusData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductionsApi
*/
export function updateProductionOrderStatusRaw(id, updateProductionStatusData, options) {
    return ProductionsApiFp().updateProductionOrderStatus(id, updateProductionStatusData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * ProductsApi - axios parameter creator
 * @export
 */
export const ProductsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveProduct: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('archiveProduct', 'id', id);
            const localVarPath = `/api/products/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copyProduct: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('copyProduct', 'id', id);
            const localVarPath = `/api/products/{id}/copy`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {CreateProductData} createProductData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProduct: async (createProductData, options = {}) => {
            // verify required parameter 'createProductData' is not null or undefined
            assertParamExists('createProduct', 'createProductData', createProductData);
            const localVarPath = `/api/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createProductData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProduct: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getProduct', 'id', id);
            const localVarPath = `/api/products/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} productId
         * @param {string} relationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductDescription: async (productId, relationId, options = {}) => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('getProductDescription', 'productId', productId);
            // verify required parameter 'relationId' is not null or undefined
            assertParamExists('getProductDescription', 'relationId', relationId);
            const localVarPath = `/api/products/{productId}/relation/{relationId}`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)))
                .replace(`{${"relationId"}}`, encodeURIComponent(String(relationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductOption: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getProductOption', 'id', id);
            const localVarPath = `/api/products/lite/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProducts: async (criteria, page, size, sort, options = {}) => {
            const localVarPath = `/api/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductsByCategory: async (id, criteria, page, size, sort, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getProductsByCategory', 'id', id);
            const localVarPath = `/api/products/category/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {UpdateProductData} updateProductData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProduct: async (id, updateProductData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateProduct', 'id', id);
            // verify required parameter 'updateProductData' is not null or undefined
            assertParamExists('updateProduct', 'updateProductData', updateProductData);
            const localVarPath = `/api/products/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(updateProductData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ProductsApi - functional programming interface
 * @export
 */
export const ProductsApiFp = function (configuration) {
    const localVarAxiosParamCreator = ProductsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async archiveProduct(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.archiveProduct(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async copyProduct(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.copyProduct(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {CreateProductData} createProductData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createProduct(createProductData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createProduct(createProductData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProduct(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProduct(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} productId
         * @param {string} relationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductDescription(productId, relationId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductDescription(productId, relationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductOption(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductOption(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProducts(criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProducts(criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductsByCategory(id, criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductsByCategory(id, criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {UpdateProductData} updateProductData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProduct(id, updateProductData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProduct(id, updateProductData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * ProductsApi - factory interface
 * @export
 */
export const ProductsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ProductsApiFp(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveProduct(id, options) {
            return localVarFp.archiveProduct(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copyProduct(id, options) {
            return localVarFp.copyProduct(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CreateProductData} createProductData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProduct(createProductData, options) {
            return localVarFp.createProduct(createProductData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProduct(id, options) {
            return localVarFp.getProduct(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} productId
         * @param {string} relationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductDescription(productId, relationId, options) {
            return localVarFp.getProductDescription(productId, relationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductOption(id, options) {
            return localVarFp.getProductOption(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProducts(criteria, page, size, sort, options) {
            return localVarFp.getProducts(criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductsByCategory(id, criteria, page, size, sort, options) {
            return localVarFp.getProductsByCategory(id, criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {UpdateProductData} updateProductData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProduct(id, updateProductData, options) {
            return localVarFp.updateProduct(id, updateProductData, options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductsApi
*/
export function archiveProduct(id, options) {
    return ProductsApiFp().archiveProduct(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductsApi
*/
export function copyProduct(id, options) {
    return ProductsApiFp().copyProduct(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {CreateProductData} createProductData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductsApi
*/
export function createProduct(createProductData, options) {
    return ProductsApiFp().createProduct(createProductData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductsApi
*/
export function getProduct(id, options) {
    return ProductsApiFp().getProduct(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} productId
        * @param {string} relationId
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductsApi
*/
export function getProductDescription(productId, relationId, options) {
    return ProductsApiFp().getProductDescription(productId, relationId, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductsApi
*/
export function getProductOption(id, options) {
    return ProductsApiFp().getProductOption(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductsApi
*/
export function getProducts(criteria, page, size, sort, options) {
    return ProductsApiFp().getProducts(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductsApi
*/
export function getProductsByCategory(id, criteria, page, size, sort, options) {
    return ProductsApiFp().getProductsByCategory(id, criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {UpdateProductData} updateProductData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductsApi
*/
export function updateProduct(id, updateProductData, options) {
    return ProductsApiFp().updateProduct(id, updateProductData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductsApi
*/
export function archiveProductRaw(id, options) {
    return ProductsApiFp().archiveProduct(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductsApi
*/
export function copyProductRaw(id, options) {
    return ProductsApiFp().copyProduct(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {CreateProductData} createProductData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductsApi
*/
export function createProductRaw(createProductData, options) {
    return ProductsApiFp().createProduct(createProductData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductsApi
*/
export function getProductRaw(id, options) {
    return ProductsApiFp().getProduct(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} productId
        * @param {string} relationId
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductsApi
*/
export function getProductDescriptionRaw(productId, relationId, options) {
    return ProductsApiFp().getProductDescription(productId, relationId, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductsApi
*/
export function getProductOptionRaw(id, options) {
    return ProductsApiFp().getProductOption(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductsApi
*/
export function getProductsRaw(criteria, page, size, sort, options) {
    return ProductsApiFp().getProducts(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductsApi
*/
export function getProductsByCategoryRaw(id, criteria, page, size, sort, options) {
    return ProductsApiFp().getProductsByCategory(id, criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {UpdateProductData} updateProductData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ProductsApi
*/
export function updateProductRaw(id, updateProductData, options) {
    return ProductsApiFp().updateProduct(id, updateProductData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * PurchaseOrderRowTemplatesApi - axios parameter creator
 * @export
 */
export const PurchaseOrderRowTemplatesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} id
         * @param {CreatePurchaseOrderRowTemplateData} createPurchaseOrderRowTemplateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPurchaseOrderRowTemplate: async (id, createPurchaseOrderRowTemplateData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createPurchaseOrderRowTemplate', 'id', id);
            // verify required parameter 'createPurchaseOrderRowTemplateData' is not null or undefined
            assertParamExists('createPurchaseOrderRowTemplate', 'createPurchaseOrderRowTemplateData', createPurchaseOrderRowTemplateData);
            const localVarPath = `/api/purchase-order-template/{id}/rows`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createPurchaseOrderRowTemplateData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePurchaseOrderRowTemplate: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deletePurchaseOrderRowTemplate', 'id', id);
            const localVarPath = `/api/purchase-order-row-templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchaseOrderRowTemplate: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPurchaseOrderRowTemplate', 'id', id);
            const localVarPath = `/api/purchase-order-row-templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchaseOrderRowTemplates: async (criteria, page, size, sort, options = {}) => {
            const localVarPath = `/api/purchase-order-row-templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRowsForPurchaseOrderTemplate: async (id, criteria, page, size, sort, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getRowsForPurchaseOrderTemplate', 'id', id);
            const localVarPath = `/api/purchase-order-template/{id}/rows`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {UpdatePurchaseOrderRowTemplateData} updatePurchaseOrderRowTemplateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePurchaseOrderRowTemplate: async (id, updatePurchaseOrderRowTemplateData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updatePurchaseOrderRowTemplate', 'id', id);
            // verify required parameter 'updatePurchaseOrderRowTemplateData' is not null or undefined
            assertParamExists('updatePurchaseOrderRowTemplate', 'updatePurchaseOrderRowTemplateData', updatePurchaseOrderRowTemplateData);
            const localVarPath = `/api/purchase-order-row-templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(updatePurchaseOrderRowTemplateData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {UpdatePurchaseOrderRowTemplateData} updatePurchaseOrderRowTemplateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePurchaseOrderRowTemplate1: async (id, updatePurchaseOrderRowTemplateData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updatePurchaseOrderRowTemplate1', 'id', id);
            // verify required parameter 'updatePurchaseOrderRowTemplateData' is not null or undefined
            assertParamExists('updatePurchaseOrderRowTemplate1', 'updatePurchaseOrderRowTemplateData', updatePurchaseOrderRowTemplateData);
            const localVarPath = `/api/purchase-order-template/{orderId}/rows/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(updatePurchaseOrderRowTemplateData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * PurchaseOrderRowTemplatesApi - functional programming interface
 * @export
 */
export const PurchaseOrderRowTemplatesApiFp = function (configuration) {
    const localVarAxiosParamCreator = PurchaseOrderRowTemplatesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {CreatePurchaseOrderRowTemplateData} createPurchaseOrderRowTemplateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPurchaseOrderRowTemplate(id, createPurchaseOrderRowTemplateData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPurchaseOrderRowTemplate(id, createPurchaseOrderRowTemplateData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePurchaseOrderRowTemplate(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePurchaseOrderRowTemplate(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPurchaseOrderRowTemplate(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPurchaseOrderRowTemplate(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPurchaseOrderRowTemplates(criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPurchaseOrderRowTemplates(criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRowsForPurchaseOrderTemplate(id, criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRowsForPurchaseOrderTemplate(id, criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {UpdatePurchaseOrderRowTemplateData} updatePurchaseOrderRowTemplateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePurchaseOrderRowTemplate(id, updatePurchaseOrderRowTemplateData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePurchaseOrderRowTemplate(id, updatePurchaseOrderRowTemplateData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {UpdatePurchaseOrderRowTemplateData} updatePurchaseOrderRowTemplateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePurchaseOrderRowTemplate1(id, updatePurchaseOrderRowTemplateData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePurchaseOrderRowTemplate1(id, updatePurchaseOrderRowTemplateData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * PurchaseOrderRowTemplatesApi - factory interface
 * @export
 */
export const PurchaseOrderRowTemplatesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = PurchaseOrderRowTemplatesApiFp(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {CreatePurchaseOrderRowTemplateData} createPurchaseOrderRowTemplateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPurchaseOrderRowTemplate(id, createPurchaseOrderRowTemplateData, options) {
            return localVarFp.createPurchaseOrderRowTemplate(id, createPurchaseOrderRowTemplateData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePurchaseOrderRowTemplate(id, options) {
            return localVarFp.deletePurchaseOrderRowTemplate(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchaseOrderRowTemplate(id, options) {
            return localVarFp.getPurchaseOrderRowTemplate(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchaseOrderRowTemplates(criteria, page, size, sort, options) {
            return localVarFp.getPurchaseOrderRowTemplates(criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRowsForPurchaseOrderTemplate(id, criteria, page, size, sort, options) {
            return localVarFp.getRowsForPurchaseOrderTemplate(id, criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {UpdatePurchaseOrderRowTemplateData} updatePurchaseOrderRowTemplateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePurchaseOrderRowTemplate(id, updatePurchaseOrderRowTemplateData, options) {
            return localVarFp.updatePurchaseOrderRowTemplate(id, updatePurchaseOrderRowTemplateData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {UpdatePurchaseOrderRowTemplateData} updatePurchaseOrderRowTemplateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePurchaseOrderRowTemplate1(id, updatePurchaseOrderRowTemplateData, options) {
            return localVarFp.updatePurchaseOrderRowTemplate1(id, updatePurchaseOrderRowTemplateData, options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
        * @param {string} id
        * @param {CreatePurchaseOrderRowTemplateData} createPurchaseOrderRowTemplateData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrderRowTemplatesApi
*/
export function createPurchaseOrderRowTemplate(id, createPurchaseOrderRowTemplateData, options) {
    return PurchaseOrderRowTemplatesApiFp().createPurchaseOrderRowTemplate(id, createPurchaseOrderRowTemplateData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrderRowTemplatesApi
*/
export function deletePurchaseOrderRowTemplate(id, options) {
    return PurchaseOrderRowTemplatesApiFp().deletePurchaseOrderRowTemplate(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrderRowTemplatesApi
*/
export function getPurchaseOrderRowTemplate(id, options) {
    return PurchaseOrderRowTemplatesApiFp().getPurchaseOrderRowTemplate(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrderRowTemplatesApi
*/
export function getPurchaseOrderRowTemplates(criteria, page, size, sort, options) {
    return PurchaseOrderRowTemplatesApiFp().getPurchaseOrderRowTemplates(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrderRowTemplatesApi
*/
export function getRowsForPurchaseOrderTemplate(id, criteria, page, size, sort, options) {
    return PurchaseOrderRowTemplatesApiFp().getRowsForPurchaseOrderTemplate(id, criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {UpdatePurchaseOrderRowTemplateData} updatePurchaseOrderRowTemplateData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrderRowTemplatesApi
*/
export function updatePurchaseOrderRowTemplate(id, updatePurchaseOrderRowTemplateData, options) {
    return PurchaseOrderRowTemplatesApiFp().updatePurchaseOrderRowTemplate(id, updatePurchaseOrderRowTemplateData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {UpdatePurchaseOrderRowTemplateData} updatePurchaseOrderRowTemplateData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrderRowTemplatesApi
*/
export function updatePurchaseOrderRowTemplate1(id, updatePurchaseOrderRowTemplateData, options) {
    return PurchaseOrderRowTemplatesApiFp().updatePurchaseOrderRowTemplate1(id, updatePurchaseOrderRowTemplateData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {CreatePurchaseOrderRowTemplateData} createPurchaseOrderRowTemplateData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrderRowTemplatesApi
*/
export function createPurchaseOrderRowTemplateRaw(id, createPurchaseOrderRowTemplateData, options) {
    return PurchaseOrderRowTemplatesApiFp().createPurchaseOrderRowTemplate(id, createPurchaseOrderRowTemplateData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrderRowTemplatesApi
*/
export function deletePurchaseOrderRowTemplateRaw(id, options) {
    return PurchaseOrderRowTemplatesApiFp().deletePurchaseOrderRowTemplate(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrderRowTemplatesApi
*/
export function getPurchaseOrderRowTemplateRaw(id, options) {
    return PurchaseOrderRowTemplatesApiFp().getPurchaseOrderRowTemplate(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrderRowTemplatesApi
*/
export function getPurchaseOrderRowTemplatesRaw(criteria, page, size, sort, options) {
    return PurchaseOrderRowTemplatesApiFp().getPurchaseOrderRowTemplates(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrderRowTemplatesApi
*/
export function getRowsForPurchaseOrderTemplateRaw(id, criteria, page, size, sort, options) {
    return PurchaseOrderRowTemplatesApiFp().getRowsForPurchaseOrderTemplate(id, criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {UpdatePurchaseOrderRowTemplateData} updatePurchaseOrderRowTemplateData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrderRowTemplatesApi
*/
export function updatePurchaseOrderRowTemplateRaw(id, updatePurchaseOrderRowTemplateData, options) {
    return PurchaseOrderRowTemplatesApiFp().updatePurchaseOrderRowTemplate(id, updatePurchaseOrderRowTemplateData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {UpdatePurchaseOrderRowTemplateData} updatePurchaseOrderRowTemplateData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrderRowTemplatesApi
*/
export function updatePurchaseOrderRowTemplate1Raw(id, updatePurchaseOrderRowTemplateData, options) {
    return PurchaseOrderRowTemplatesApiFp().updatePurchaseOrderRowTemplate1(id, updatePurchaseOrderRowTemplateData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * PurchaseOrderRowsApi - axios parameter creator
 * @export
 */
export const PurchaseOrderRowsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        closePurchaseOrderRow: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('closePurchaseOrderRow', 'id', id);
            const localVarPath = `/api/purchase-order-rows/close/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {CreateIncomeLotData} createIncomeLotData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIncomeLot: async (id, createIncomeLotData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createIncomeLot', 'id', id);
            // verify required parameter 'createIncomeLotData' is not null or undefined
            assertParamExists('createIncomeLot', 'createIncomeLotData', createIncomeLotData);
            const localVarPath = `/api/purchase-order-row/{id}/income-lots`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createIncomeLotData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {CreatePurchaseOrderRowData} data
         * @param {Array<File>} [files]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPurchaseOrderRow: async (id, data, files, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createPurchaseOrderRow', 'id', id);
            // verify required parameter 'data' is not null or undefined
            assertParamExists('createPurchaseOrderRow', 'data', data);
            const localVarPath = `/api/purchase-order/{id}/rows`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (data !== undefined) {
                localVarFormParams.append('data', new Blob([JSON.stringify(data)], { type: "application/json", }));
            }
            if (files) {
                files.forEach((element) => {
                    localVarFormParams.append('files', element);
                });
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} purchaseOrderRowId
         * @param {string} incomeLotId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteIncomeLotByPurchaseOrderRow: async (purchaseOrderRowId, incomeLotId, options = {}) => {
            // verify required parameter 'purchaseOrderRowId' is not null or undefined
            assertParamExists('deleteIncomeLotByPurchaseOrderRow', 'purchaseOrderRowId', purchaseOrderRowId);
            // verify required parameter 'incomeLotId' is not null or undefined
            assertParamExists('deleteIncomeLotByPurchaseOrderRow', 'incomeLotId', incomeLotId);
            const localVarPath = `/api/purchase-order-row/{purchaseOrderRowId}/income-lots/{incomeLotId}`
                .replace(`{${"purchaseOrderRowId"}}`, encodeURIComponent(String(purchaseOrderRowId)))
                .replace(`{${"incomeLotId"}}`, encodeURIComponent(String(incomeLotId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePurchaseOrderRow: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deletePurchaseOrderRow', 'id', id);
            const localVarPath = `/api/purchase-order/{orderId}/rows/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePurchaseOrderRow1: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deletePurchaseOrderRow1', 'id', id);
            const localVarPath = `/api/purchase-order-rows/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExpectedLotForPurchaseOrderRow: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getExpectedLotForPurchaseOrderRow', 'id', id);
            const localVarPath = `/api/purchase-order-rows/{id}/get-expected-lot`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIncomeLotsForPurchaseOrderRow: async (id, criteria, page, size, sort, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getIncomeLotsForPurchaseOrderRow', 'id', id);
            const localVarPath = `/api/purchase-order-row/{id}/income-lots`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchaseOrderRow: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPurchaseOrderRow', 'id', id);
            const localVarPath = `/api/purchase-order-rows/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [criteria]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchaseOrderRowTotals: async (criteria, options = {}) => {
            const localVarPath = `/api/purchase-order-rows/totals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchaseOrderRows: async (criteria, page, size, sort, options = {}) => {
            const localVarPath = `/api/purchase-order-rows`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReservationsForPurchaseOrderRow: async (id, criteria, page, size, sort, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getReservationsForPurchaseOrderRow', 'id', id);
            const localVarPath = `/api/purchase-order-row/{id}/reservations`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRowsForPurchaseOrder: async (id, criteria, page, size, sort, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getRowsForPurchaseOrder', 'id', id);
            const localVarPath = `/api/purchase-order/{id}/rows`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {PrintLabelData} printLabelData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        printPurchaseOrderRowLabel: async (id, printLabelData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('printPurchaseOrderRowLabel', 'id', id);
            // verify required parameter 'printLabelData' is not null or undefined
            assertParamExists('printPurchaseOrderRowLabel', 'printLabelData', printLabelData);
            const localVarPath = `/api/purchase-order-rows/{id}/print-label`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(printLabelData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {UpdateIncomeLotData} updateIncomeLotData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIncomeLot: async (id, updateIncomeLotData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateIncomeLot', 'id', id);
            // verify required parameter 'updateIncomeLotData' is not null or undefined
            assertParamExists('updateIncomeLot', 'updateIncomeLotData', updateIncomeLotData);
            const localVarPath = `/api/income-lots/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(updateIncomeLotData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {UpdatePurchaseOrderRowData} data
         * @param {Array<File>} [files]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePurchaseOrderRow: async (id, data, files, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updatePurchaseOrderRow', 'id', id);
            // verify required parameter 'data' is not null or undefined
            assertParamExists('updatePurchaseOrderRow', 'data', data);
            const localVarPath = `/api/purchase-order/{orderId}/rows/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (data !== undefined) {
                localVarFormParams.append('data', new Blob([JSON.stringify(data)], { type: "application/json", }));
            }
            if (files) {
                files.forEach((element) => {
                    localVarFormParams.append('files', element);
                });
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {UpdatePurchaseOrderRowData} data
         * @param {Array<File>} [files]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePurchaseOrderRow1: async (id, data, files, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updatePurchaseOrderRow1', 'id', id);
            // verify required parameter 'data' is not null or undefined
            assertParamExists('updatePurchaseOrderRow1', 'data', data);
            const localVarPath = `/api/purchase-order-rows/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (data !== undefined) {
                localVarFormParams.append('data', new Blob([JSON.stringify(data)], { type: "application/json", }));
            }
            if (files) {
                files.forEach((element) => {
                    localVarFormParams.append('files', element);
                });
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {UpdatePurchaseOrderRowStatusData} updatePurchaseOrderRowStatusData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePurchaseOrderRowStatus: async (id, updatePurchaseOrderRowStatusData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updatePurchaseOrderRowStatus', 'id', id);
            // verify required parameter 'updatePurchaseOrderRowStatusData' is not null or undefined
            assertParamExists('updatePurchaseOrderRowStatus', 'updatePurchaseOrderRowStatusData', updatePurchaseOrderRowStatusData);
            const localVarPath = `/api/purchase-order-rows/{id}/status`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(updatePurchaseOrderRowStatusData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * PurchaseOrderRowsApi - functional programming interface
 * @export
 */
export const PurchaseOrderRowsApiFp = function (configuration) {
    const localVarAxiosParamCreator = PurchaseOrderRowsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async closePurchaseOrderRow(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.closePurchaseOrderRow(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {CreateIncomeLotData} createIncomeLotData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createIncomeLot(id, createIncomeLotData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createIncomeLot(id, createIncomeLotData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {CreatePurchaseOrderRowData} data
         * @param {Array<File>} [files]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPurchaseOrderRow(id, data, files, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPurchaseOrderRow(id, data, files, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} purchaseOrderRowId
         * @param {string} incomeLotId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteIncomeLotByPurchaseOrderRow(purchaseOrderRowId, incomeLotId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteIncomeLotByPurchaseOrderRow(purchaseOrderRowId, incomeLotId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePurchaseOrderRow(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePurchaseOrderRow(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePurchaseOrderRow1(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePurchaseOrderRow1(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExpectedLotForPurchaseOrderRow(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExpectedLotForPurchaseOrderRow(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIncomeLotsForPurchaseOrderRow(id, criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIncomeLotsForPurchaseOrderRow(id, criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPurchaseOrderRow(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPurchaseOrderRow(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} [criteria]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPurchaseOrderRowTotals(criteria, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPurchaseOrderRowTotals(criteria, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPurchaseOrderRows(criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPurchaseOrderRows(criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReservationsForPurchaseOrderRow(id, criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReservationsForPurchaseOrderRow(id, criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRowsForPurchaseOrder(id, criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRowsForPurchaseOrder(id, criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {PrintLabelData} printLabelData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async printPurchaseOrderRowLabel(id, printLabelData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.printPurchaseOrderRowLabel(id, printLabelData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {UpdateIncomeLotData} updateIncomeLotData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateIncomeLot(id, updateIncomeLotData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateIncomeLot(id, updateIncomeLotData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {UpdatePurchaseOrderRowData} data
         * @param {Array<File>} [files]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePurchaseOrderRow(id, data, files, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePurchaseOrderRow(id, data, files, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {UpdatePurchaseOrderRowData} data
         * @param {Array<File>} [files]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePurchaseOrderRow1(id, data, files, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePurchaseOrderRow1(id, data, files, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {UpdatePurchaseOrderRowStatusData} updatePurchaseOrderRowStatusData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePurchaseOrderRowStatus(id, updatePurchaseOrderRowStatusData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePurchaseOrderRowStatus(id, updatePurchaseOrderRowStatusData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * PurchaseOrderRowsApi - factory interface
 * @export
 */
export const PurchaseOrderRowsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = PurchaseOrderRowsApiFp(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        closePurchaseOrderRow(id, options) {
            return localVarFp.closePurchaseOrderRow(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {CreateIncomeLotData} createIncomeLotData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIncomeLot(id, createIncomeLotData, options) {
            return localVarFp.createIncomeLot(id, createIncomeLotData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {CreatePurchaseOrderRowData} data
         * @param {Array<File>} [files]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPurchaseOrderRow(id, data, files, options) {
            return localVarFp.createPurchaseOrderRow(id, data, files, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} purchaseOrderRowId
         * @param {string} incomeLotId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteIncomeLotByPurchaseOrderRow(purchaseOrderRowId, incomeLotId, options) {
            return localVarFp.deleteIncomeLotByPurchaseOrderRow(purchaseOrderRowId, incomeLotId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePurchaseOrderRow(id, options) {
            return localVarFp.deletePurchaseOrderRow(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePurchaseOrderRow1(id, options) {
            return localVarFp.deletePurchaseOrderRow1(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExpectedLotForPurchaseOrderRow(id, options) {
            return localVarFp.getExpectedLotForPurchaseOrderRow(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIncomeLotsForPurchaseOrderRow(id, criteria, page, size, sort, options) {
            return localVarFp.getIncomeLotsForPurchaseOrderRow(id, criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchaseOrderRow(id, options) {
            return localVarFp.getPurchaseOrderRow(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [criteria]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchaseOrderRowTotals(criteria, options) {
            return localVarFp.getPurchaseOrderRowTotals(criteria, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchaseOrderRows(criteria, page, size, sort, options) {
            return localVarFp.getPurchaseOrderRows(criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReservationsForPurchaseOrderRow(id, criteria, page, size, sort, options) {
            return localVarFp.getReservationsForPurchaseOrderRow(id, criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRowsForPurchaseOrder(id, criteria, page, size, sort, options) {
            return localVarFp.getRowsForPurchaseOrder(id, criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {PrintLabelData} printLabelData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        printPurchaseOrderRowLabel(id, printLabelData, options) {
            return localVarFp.printPurchaseOrderRowLabel(id, printLabelData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {UpdateIncomeLotData} updateIncomeLotData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIncomeLot(id, updateIncomeLotData, options) {
            return localVarFp.updateIncomeLot(id, updateIncomeLotData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {UpdatePurchaseOrderRowData} data
         * @param {Array<File>} [files]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePurchaseOrderRow(id, data, files, options) {
            return localVarFp.updatePurchaseOrderRow(id, data, files, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {UpdatePurchaseOrderRowData} data
         * @param {Array<File>} [files]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePurchaseOrderRow1(id, data, files, options) {
            return localVarFp.updatePurchaseOrderRow1(id, data, files, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {UpdatePurchaseOrderRowStatusData} updatePurchaseOrderRowStatusData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePurchaseOrderRowStatus(id, updatePurchaseOrderRowStatusData, options) {
            return localVarFp.updatePurchaseOrderRowStatus(id, updatePurchaseOrderRowStatusData, options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrderRowsApi
*/
export function closePurchaseOrderRow(id, options) {
    return PurchaseOrderRowsApiFp().closePurchaseOrderRow(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {CreateIncomeLotData} createIncomeLotData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrderRowsApi
*/
export function createIncomeLot(id, createIncomeLotData, options) {
    return PurchaseOrderRowsApiFp().createIncomeLot(id, createIncomeLotData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {CreatePurchaseOrderRowData} data
        * @param {Array<File>} [files]
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrderRowsApi
*/
export function createPurchaseOrderRow(id, data, files, options) {
    return PurchaseOrderRowsApiFp().createPurchaseOrderRow(id, data, files, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} purchaseOrderRowId
        * @param {string} incomeLotId
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrderRowsApi
*/
export function deleteIncomeLotByPurchaseOrderRow(purchaseOrderRowId, incomeLotId, options) {
    return PurchaseOrderRowsApiFp().deleteIncomeLotByPurchaseOrderRow(purchaseOrderRowId, incomeLotId, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrderRowsApi
*/
export function deletePurchaseOrderRow(id, options) {
    return PurchaseOrderRowsApiFp().deletePurchaseOrderRow(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrderRowsApi
*/
export function deletePurchaseOrderRow1(id, options) {
    return PurchaseOrderRowsApiFp().deletePurchaseOrderRow1(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrderRowsApi
*/
export function getExpectedLotForPurchaseOrderRow(id, options) {
    return PurchaseOrderRowsApiFp().getExpectedLotForPurchaseOrderRow(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrderRowsApi
*/
export function getIncomeLotsForPurchaseOrderRow(id, criteria, page, size, sort, options) {
    return PurchaseOrderRowsApiFp().getIncomeLotsForPurchaseOrderRow(id, criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrderRowsApi
*/
export function getPurchaseOrderRow(id, options) {
    return PurchaseOrderRowsApiFp().getPurchaseOrderRow(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} [criteria]
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrderRowsApi
*/
export function getPurchaseOrderRowTotals(criteria, options) {
    return PurchaseOrderRowsApiFp().getPurchaseOrderRowTotals(criteria, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrderRowsApi
*/
export function getPurchaseOrderRows(criteria, page, size, sort, options) {
    return PurchaseOrderRowsApiFp().getPurchaseOrderRows(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrderRowsApi
*/
export function getReservationsForPurchaseOrderRow(id, criteria, page, size, sort, options) {
    return PurchaseOrderRowsApiFp().getReservationsForPurchaseOrderRow(id, criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrderRowsApi
*/
export function getRowsForPurchaseOrder(id, criteria, page, size, sort, options) {
    return PurchaseOrderRowsApiFp().getRowsForPurchaseOrder(id, criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {PrintLabelData} printLabelData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrderRowsApi
*/
export function printPurchaseOrderRowLabel(id, printLabelData, options) {
    return PurchaseOrderRowsApiFp().printPurchaseOrderRowLabel(id, printLabelData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {UpdateIncomeLotData} updateIncomeLotData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrderRowsApi
*/
export function updateIncomeLot(id, updateIncomeLotData, options) {
    return PurchaseOrderRowsApiFp().updateIncomeLot(id, updateIncomeLotData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {UpdatePurchaseOrderRowData} data
        * @param {Array<File>} [files]
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrderRowsApi
*/
export function updatePurchaseOrderRow(id, data, files, options) {
    return PurchaseOrderRowsApiFp().updatePurchaseOrderRow(id, data, files, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {UpdatePurchaseOrderRowData} data
        * @param {Array<File>} [files]
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrderRowsApi
*/
export function updatePurchaseOrderRow1(id, data, files, options) {
    return PurchaseOrderRowsApiFp().updatePurchaseOrderRow1(id, data, files, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {UpdatePurchaseOrderRowStatusData} updatePurchaseOrderRowStatusData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrderRowsApi
*/
export function updatePurchaseOrderRowStatus(id, updatePurchaseOrderRowStatusData, options) {
    return PurchaseOrderRowsApiFp().updatePurchaseOrderRowStatus(id, updatePurchaseOrderRowStatusData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrderRowsApi
*/
export function closePurchaseOrderRowRaw(id, options) {
    return PurchaseOrderRowsApiFp().closePurchaseOrderRow(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {CreateIncomeLotData} createIncomeLotData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrderRowsApi
*/
export function createIncomeLotRaw(id, createIncomeLotData, options) {
    return PurchaseOrderRowsApiFp().createIncomeLot(id, createIncomeLotData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {CreatePurchaseOrderRowData} data
        * @param {Array<File>} [files]
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrderRowsApi
*/
export function createPurchaseOrderRowRaw(id, data, files, options) {
    return PurchaseOrderRowsApiFp().createPurchaseOrderRow(id, data, files, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} purchaseOrderRowId
        * @param {string} incomeLotId
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrderRowsApi
*/
export function deleteIncomeLotByPurchaseOrderRowRaw(purchaseOrderRowId, incomeLotId, options) {
    return PurchaseOrderRowsApiFp().deleteIncomeLotByPurchaseOrderRow(purchaseOrderRowId, incomeLotId, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrderRowsApi
*/
export function deletePurchaseOrderRowRaw(id, options) {
    return PurchaseOrderRowsApiFp().deletePurchaseOrderRow(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrderRowsApi
*/
export function deletePurchaseOrderRow1Raw(id, options) {
    return PurchaseOrderRowsApiFp().deletePurchaseOrderRow1(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrderRowsApi
*/
export function getExpectedLotForPurchaseOrderRowRaw(id, options) {
    return PurchaseOrderRowsApiFp().getExpectedLotForPurchaseOrderRow(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrderRowsApi
*/
export function getIncomeLotsForPurchaseOrderRowRaw(id, criteria, page, size, sort, options) {
    return PurchaseOrderRowsApiFp().getIncomeLotsForPurchaseOrderRow(id, criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrderRowsApi
*/
export function getPurchaseOrderRowRaw(id, options) {
    return PurchaseOrderRowsApiFp().getPurchaseOrderRow(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} [criteria]
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrderRowsApi
*/
export function getPurchaseOrderRowTotalsRaw(criteria, options) {
    return PurchaseOrderRowsApiFp().getPurchaseOrderRowTotals(criteria, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrderRowsApi
*/
export function getPurchaseOrderRowsRaw(criteria, page, size, sort, options) {
    return PurchaseOrderRowsApiFp().getPurchaseOrderRows(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrderRowsApi
*/
export function getReservationsForPurchaseOrderRowRaw(id, criteria, page, size, sort, options) {
    return PurchaseOrderRowsApiFp().getReservationsForPurchaseOrderRow(id, criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrderRowsApi
*/
export function getRowsForPurchaseOrderRaw(id, criteria, page, size, sort, options) {
    return PurchaseOrderRowsApiFp().getRowsForPurchaseOrder(id, criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {PrintLabelData} printLabelData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrderRowsApi
*/
export function printPurchaseOrderRowLabelRaw(id, printLabelData, options) {
    return PurchaseOrderRowsApiFp().printPurchaseOrderRowLabel(id, printLabelData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {UpdateIncomeLotData} updateIncomeLotData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrderRowsApi
*/
export function updateIncomeLotRaw(id, updateIncomeLotData, options) {
    return PurchaseOrderRowsApiFp().updateIncomeLot(id, updateIncomeLotData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {UpdatePurchaseOrderRowData} data
        * @param {Array<File>} [files]
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrderRowsApi
*/
export function updatePurchaseOrderRowRaw(id, data, files, options) {
    return PurchaseOrderRowsApiFp().updatePurchaseOrderRow(id, data, files, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {UpdatePurchaseOrderRowData} data
        * @param {Array<File>} [files]
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrderRowsApi
*/
export function updatePurchaseOrderRow1Raw(id, data, files, options) {
    return PurchaseOrderRowsApiFp().updatePurchaseOrderRow1(id, data, files, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {UpdatePurchaseOrderRowStatusData} updatePurchaseOrderRowStatusData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrderRowsApi
*/
export function updatePurchaseOrderRowStatusRaw(id, updatePurchaseOrderRowStatusData, options) {
    return PurchaseOrderRowsApiFp().updatePurchaseOrderRowStatus(id, updatePurchaseOrderRowStatusData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * PurchaseOrderTemplatesApi - axios parameter creator
 * @export
 */
export const PurchaseOrderTemplatesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {CreatePurchaseOrderTemplateData} createPurchaseOrderTemplateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPurchaseOrderTemplate: async (createPurchaseOrderTemplateData, options = {}) => {
            // verify required parameter 'createPurchaseOrderTemplateData' is not null or undefined
            assertParamExists('createPurchaseOrderTemplate', 'createPurchaseOrderTemplateData', createPurchaseOrderTemplateData);
            const localVarPath = `/api/purchase-order-templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createPurchaseOrderTemplateData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} purchaseOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPurchaseOrderTemplateFromOrder: async (purchaseOrderId, options = {}) => {
            // verify required parameter 'purchaseOrderId' is not null or undefined
            assertParamExists('createPurchaseOrderTemplateFromOrder', 'purchaseOrderId', purchaseOrderId);
            const localVarPath = `/api/purchase-order-template-from-order/{purchaseOrderId}`
                .replace(`{${"purchaseOrderId"}}`, encodeURIComponent(String(purchaseOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePurchaseOrderTemplate: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deletePurchaseOrderTemplate', 'id', id);
            const localVarPath = `/api/purchase-order-templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicatePurchaseOrderTemplate: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('duplicatePurchaseOrderTemplate', 'id', id);
            const localVarPath = `/api/purchase-order-templates/{id}/duplicate`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchaseOrderTemplate: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPurchaseOrderTemplate', 'id', id);
            const localVarPath = `/api/purchase-order-templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchaseOrderTemplates: async (criteria, page, size, sort, options = {}) => {
            const localVarPath = `/api/purchase-order-templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {UpdatePurchaseOrderTemplateData} updatePurchaseOrderTemplateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePurchaseOrderTemplate: async (id, updatePurchaseOrderTemplateData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updatePurchaseOrderTemplate', 'id', id);
            // verify required parameter 'updatePurchaseOrderTemplateData' is not null or undefined
            assertParamExists('updatePurchaseOrderTemplate', 'updatePurchaseOrderTemplateData', updatePurchaseOrderTemplateData);
            const localVarPath = `/api/purchase-order-templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(updatePurchaseOrderTemplateData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * PurchaseOrderTemplatesApi - functional programming interface
 * @export
 */
export const PurchaseOrderTemplatesApiFp = function (configuration) {
    const localVarAxiosParamCreator = PurchaseOrderTemplatesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {CreatePurchaseOrderTemplateData} createPurchaseOrderTemplateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPurchaseOrderTemplate(createPurchaseOrderTemplateData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPurchaseOrderTemplate(createPurchaseOrderTemplateData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} purchaseOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPurchaseOrderTemplateFromOrder(purchaseOrderId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPurchaseOrderTemplateFromOrder(purchaseOrderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePurchaseOrderTemplate(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePurchaseOrderTemplate(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async duplicatePurchaseOrderTemplate(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.duplicatePurchaseOrderTemplate(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPurchaseOrderTemplate(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPurchaseOrderTemplate(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPurchaseOrderTemplates(criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPurchaseOrderTemplates(criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {UpdatePurchaseOrderTemplateData} updatePurchaseOrderTemplateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePurchaseOrderTemplate(id, updatePurchaseOrderTemplateData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePurchaseOrderTemplate(id, updatePurchaseOrderTemplateData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * PurchaseOrderTemplatesApi - factory interface
 * @export
 */
export const PurchaseOrderTemplatesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = PurchaseOrderTemplatesApiFp(configuration);
    return {
        /**
         *
         * @param {CreatePurchaseOrderTemplateData} createPurchaseOrderTemplateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPurchaseOrderTemplate(createPurchaseOrderTemplateData, options) {
            return localVarFp.createPurchaseOrderTemplate(createPurchaseOrderTemplateData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} purchaseOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPurchaseOrderTemplateFromOrder(purchaseOrderId, options) {
            return localVarFp.createPurchaseOrderTemplateFromOrder(purchaseOrderId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePurchaseOrderTemplate(id, options) {
            return localVarFp.deletePurchaseOrderTemplate(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicatePurchaseOrderTemplate(id, options) {
            return localVarFp.duplicatePurchaseOrderTemplate(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchaseOrderTemplate(id, options) {
            return localVarFp.getPurchaseOrderTemplate(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchaseOrderTemplates(criteria, page, size, sort, options) {
            return localVarFp.getPurchaseOrderTemplates(criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {UpdatePurchaseOrderTemplateData} updatePurchaseOrderTemplateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePurchaseOrderTemplate(id, updatePurchaseOrderTemplateData, options) {
            return localVarFp.updatePurchaseOrderTemplate(id, updatePurchaseOrderTemplateData, options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
        * @param {CreatePurchaseOrderTemplateData} createPurchaseOrderTemplateData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrderTemplatesApi
*/
export function createPurchaseOrderTemplate(createPurchaseOrderTemplateData, options) {
    return PurchaseOrderTemplatesApiFp().createPurchaseOrderTemplate(createPurchaseOrderTemplateData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} purchaseOrderId
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrderTemplatesApi
*/
export function createPurchaseOrderTemplateFromOrder(purchaseOrderId, options) {
    return PurchaseOrderTemplatesApiFp().createPurchaseOrderTemplateFromOrder(purchaseOrderId, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrderTemplatesApi
*/
export function deletePurchaseOrderTemplate(id, options) {
    return PurchaseOrderTemplatesApiFp().deletePurchaseOrderTemplate(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrderTemplatesApi
*/
export function duplicatePurchaseOrderTemplate(id, options) {
    return PurchaseOrderTemplatesApiFp().duplicatePurchaseOrderTemplate(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrderTemplatesApi
*/
export function getPurchaseOrderTemplate(id, options) {
    return PurchaseOrderTemplatesApiFp().getPurchaseOrderTemplate(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrderTemplatesApi
*/
export function getPurchaseOrderTemplates(criteria, page, size, sort, options) {
    return PurchaseOrderTemplatesApiFp().getPurchaseOrderTemplates(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {UpdatePurchaseOrderTemplateData} updatePurchaseOrderTemplateData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrderTemplatesApi
*/
export function updatePurchaseOrderTemplate(id, updatePurchaseOrderTemplateData, options) {
    return PurchaseOrderTemplatesApiFp().updatePurchaseOrderTemplate(id, updatePurchaseOrderTemplateData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {CreatePurchaseOrderTemplateData} createPurchaseOrderTemplateData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrderTemplatesApi
*/
export function createPurchaseOrderTemplateRaw(createPurchaseOrderTemplateData, options) {
    return PurchaseOrderTemplatesApiFp().createPurchaseOrderTemplate(createPurchaseOrderTemplateData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} purchaseOrderId
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrderTemplatesApi
*/
export function createPurchaseOrderTemplateFromOrderRaw(purchaseOrderId, options) {
    return PurchaseOrderTemplatesApiFp().createPurchaseOrderTemplateFromOrder(purchaseOrderId, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrderTemplatesApi
*/
export function deletePurchaseOrderTemplateRaw(id, options) {
    return PurchaseOrderTemplatesApiFp().deletePurchaseOrderTemplate(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrderTemplatesApi
*/
export function duplicatePurchaseOrderTemplateRaw(id, options) {
    return PurchaseOrderTemplatesApiFp().duplicatePurchaseOrderTemplate(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrderTemplatesApi
*/
export function getPurchaseOrderTemplateRaw(id, options) {
    return PurchaseOrderTemplatesApiFp().getPurchaseOrderTemplate(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrderTemplatesApi
*/
export function getPurchaseOrderTemplatesRaw(criteria, page, size, sort, options) {
    return PurchaseOrderTemplatesApiFp().getPurchaseOrderTemplates(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {UpdatePurchaseOrderTemplateData} updatePurchaseOrderTemplateData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrderTemplatesApi
*/
export function updatePurchaseOrderTemplateRaw(id, updatePurchaseOrderTemplateData, options) {
    return PurchaseOrderTemplatesApiFp().updatePurchaseOrderTemplate(id, updatePurchaseOrderTemplateData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * PurchaseOrdersApi - axios parameter creator
 * @export
 */
export const PurchaseOrdersApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkPurchaseInvoice: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('checkPurchaseInvoice', 'id', id);
            const localVarPath = `/api/purchase-orders/{id}/check-invoice`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        closePurchaseOrder: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('closePurchaseOrder', 'id', id);
            const localVarPath = `/api/purchase-orders/close/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIncomeLotsForPurchaseOrder: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createIncomeLotsForPurchaseOrder', 'id', id);
            const localVarPath = `/api/purchase-order/{id}/income-lots`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {CreatePurchaseOrderData} data
         * @param {Array<File>} [files]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPurchaseOrder: async (data, files, options = {}) => {
            // verify required parameter 'data' is not null or undefined
            assertParamExists('createPurchaseOrder', 'data', data);
            const localVarPath = `/api/purchase-orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (data !== undefined) {
                localVarFormParams.append('data', new Blob([JSON.stringify(data)], { type: "application/json", }));
            }
            if (files) {
                files.forEach((element) => {
                    localVarFormParams.append('files', element);
                });
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} purchaseOrderTemplateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPurchaseOrderFromTemplate: async (purchaseOrderTemplateId, options = {}) => {
            // verify required parameter 'purchaseOrderTemplateId' is not null or undefined
            assertParamExists('createPurchaseOrderFromTemplate', 'purchaseOrderTemplateId', purchaseOrderTemplateId);
            const localVarPath = `/api/purchase-order-from-template/{purchaseOrderTemplateId}`
                .replace(`{${"purchaseOrderTemplateId"}}`, encodeURIComponent(String(purchaseOrderTemplateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePurchaseOrder: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deletePurchaseOrder', 'id', id);
            const localVarPath = `/api/purchase-orders/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicatePurchaseOrder: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('duplicatePurchaseOrder', 'id', id);
            const localVarPath = `/api/purchase-orders/{id}/duplicate`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIncomeLotsForPurchaseOrder: async (id, page, size, sort, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getIncomeLotsForPurchaseOrder', 'id', id);
            const localVarPath = `/api/purchase-orders/{id}/income-lots`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchaseOrder: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPurchaseOrder', 'id', id);
            const localVarPath = `/api/purchase-orders/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchaseOrders: async (criteria, page, size, sort, options = {}) => {
            const localVarPath = `/api/purchase-orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {CreateIncomeLotFromPackingListData} createIncomeLotFromPackingListData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importPackingList: async (id, createIncomeLotFromPackingListData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('importPackingList', 'id', id);
            // verify required parameter 'createIncomeLotFromPackingListData' is not null or undefined
            assertParamExists('importPackingList', 'createIncomeLotFromPackingListData', createIncomeLotFromPackingListData);
            const localVarPath = `/api/purchase-orders/{id}/import-packing-list`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createIncomeLotFromPackingListData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {File} file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        preparePackingListForImport: async (id, file, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('preparePackingListForImport', 'id', id);
            // verify required parameter 'file' is not null or undefined
            assertParamExists('preparePackingListForImport', 'file', file);
            const localVarPath = `/api/purchase-orders/{id}/prepare-import-packing-list`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (file !== undefined) {
                localVarFormParams.append('file', file);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {string} designId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewPurchaseOrderDocument: async (id, designId, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('previewPurchaseOrderDocument', 'id', id);
            // verify required parameter 'designId' is not null or undefined
            assertParamExists('previewPurchaseOrderDocument', 'designId', designId);
            const localVarPath = `/api/purchase-orders/{id}/preview-document/{designId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"designId"}}`, encodeURIComponent(String(designId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {UpdatePurchaseOrderData} [data]
         * @param {Array<File>} [files]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePurchaseOrder: async (id, data, files, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updatePurchaseOrder', 'id', id);
            const localVarPath = `/api/purchase-orders/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (data !== undefined) {
                localVarFormParams.append('data', new Blob([JSON.stringify(data)], { type: "application/json", }));
            }
            if (files) {
                files.forEach((element) => {
                    localVarFormParams.append('files', element);
                });
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {UpdatePurchaseOrderStatusData} updatePurchaseOrderStatusData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePurchaseOrderStatus: async (id, updatePurchaseOrderStatusData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updatePurchaseOrderStatus', 'id', id);
            // verify required parameter 'updatePurchaseOrderStatusData' is not null or undefined
            assertParamExists('updatePurchaseOrderStatus', 'updatePurchaseOrderStatusData', updatePurchaseOrderStatusData);
            const localVarPath = `/api/purchase-orders/{id}/status`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(updatePurchaseOrderStatusData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * PurchaseOrdersApi - functional programming interface
 * @export
 */
export const PurchaseOrdersApiFp = function (configuration) {
    const localVarAxiosParamCreator = PurchaseOrdersApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkPurchaseInvoice(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkPurchaseInvoice(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async closePurchaseOrder(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.closePurchaseOrder(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createIncomeLotsForPurchaseOrder(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createIncomeLotsForPurchaseOrder(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {CreatePurchaseOrderData} data
         * @param {Array<File>} [files]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPurchaseOrder(data, files, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPurchaseOrder(data, files, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} purchaseOrderTemplateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPurchaseOrderFromTemplate(purchaseOrderTemplateId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPurchaseOrderFromTemplate(purchaseOrderTemplateId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePurchaseOrder(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePurchaseOrder(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async duplicatePurchaseOrder(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.duplicatePurchaseOrder(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIncomeLotsForPurchaseOrder(id, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIncomeLotsForPurchaseOrder(id, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPurchaseOrder(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPurchaseOrder(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPurchaseOrders(criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPurchaseOrders(criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {CreateIncomeLotFromPackingListData} createIncomeLotFromPackingListData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importPackingList(id, createIncomeLotFromPackingListData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importPackingList(id, createIncomeLotFromPackingListData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {File} file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async preparePackingListForImport(id, file, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.preparePackingListForImport(id, file, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {string} designId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async previewPurchaseOrderDocument(id, designId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.previewPurchaseOrderDocument(id, designId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {UpdatePurchaseOrderData} [data]
         * @param {Array<File>} [files]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePurchaseOrder(id, data, files, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePurchaseOrder(id, data, files, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {UpdatePurchaseOrderStatusData} updatePurchaseOrderStatusData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePurchaseOrderStatus(id, updatePurchaseOrderStatusData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePurchaseOrderStatus(id, updatePurchaseOrderStatusData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * PurchaseOrdersApi - factory interface
 * @export
 */
export const PurchaseOrdersApiFactory = function (configuration, basePath, axios) {
    const localVarFp = PurchaseOrdersApiFp(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkPurchaseInvoice(id, options) {
            return localVarFp.checkPurchaseInvoice(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        closePurchaseOrder(id, options) {
            return localVarFp.closePurchaseOrder(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIncomeLotsForPurchaseOrder(id, options) {
            return localVarFp.createIncomeLotsForPurchaseOrder(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CreatePurchaseOrderData} data
         * @param {Array<File>} [files]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPurchaseOrder(data, files, options) {
            return localVarFp.createPurchaseOrder(data, files, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} purchaseOrderTemplateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPurchaseOrderFromTemplate(purchaseOrderTemplateId, options) {
            return localVarFp.createPurchaseOrderFromTemplate(purchaseOrderTemplateId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePurchaseOrder(id, options) {
            return localVarFp.deletePurchaseOrder(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicatePurchaseOrder(id, options) {
            return localVarFp.duplicatePurchaseOrder(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIncomeLotsForPurchaseOrder(id, page, size, sort, options) {
            return localVarFp.getIncomeLotsForPurchaseOrder(id, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchaseOrder(id, options) {
            return localVarFp.getPurchaseOrder(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchaseOrders(criteria, page, size, sort, options) {
            return localVarFp.getPurchaseOrders(criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {CreateIncomeLotFromPackingListData} createIncomeLotFromPackingListData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importPackingList(id, createIncomeLotFromPackingListData, options) {
            return localVarFp.importPackingList(id, createIncomeLotFromPackingListData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {File} file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        preparePackingListForImport(id, file, options) {
            return localVarFp.preparePackingListForImport(id, file, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {string} designId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewPurchaseOrderDocument(id, designId, options) {
            return localVarFp.previewPurchaseOrderDocument(id, designId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {UpdatePurchaseOrderData} [data]
         * @param {Array<File>} [files]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePurchaseOrder(id, data, files, options) {
            return localVarFp.updatePurchaseOrder(id, data, files, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {UpdatePurchaseOrderStatusData} updatePurchaseOrderStatusData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePurchaseOrderStatus(id, updatePurchaseOrderStatusData, options) {
            return localVarFp.updatePurchaseOrderStatus(id, updatePurchaseOrderStatusData, options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrdersApi
*/
export function checkPurchaseInvoice(id, options) {
    return PurchaseOrdersApiFp().checkPurchaseInvoice(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrdersApi
*/
export function closePurchaseOrder(id, options) {
    return PurchaseOrdersApiFp().closePurchaseOrder(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrdersApi
*/
export function createIncomeLotsForPurchaseOrder(id, options) {
    return PurchaseOrdersApiFp().createIncomeLotsForPurchaseOrder(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {CreatePurchaseOrderData} data
        * @param {Array<File>} [files]
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrdersApi
*/
export function createPurchaseOrder(data, files, options) {
    return PurchaseOrdersApiFp().createPurchaseOrder(data, files, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} purchaseOrderTemplateId
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrdersApi
*/
export function createPurchaseOrderFromTemplate(purchaseOrderTemplateId, options) {
    return PurchaseOrdersApiFp().createPurchaseOrderFromTemplate(purchaseOrderTemplateId, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrdersApi
*/
export function deletePurchaseOrder(id, options) {
    return PurchaseOrdersApiFp().deletePurchaseOrder(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrdersApi
*/
export function duplicatePurchaseOrder(id, options) {
    return PurchaseOrdersApiFp().duplicatePurchaseOrder(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrdersApi
*/
export function getIncomeLotsForPurchaseOrder(id, page, size, sort, options) {
    return PurchaseOrdersApiFp().getIncomeLotsForPurchaseOrder(id, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrdersApi
*/
export function getPurchaseOrder(id, options) {
    return PurchaseOrdersApiFp().getPurchaseOrder(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrdersApi
*/
export function getPurchaseOrders(criteria, page, size, sort, options) {
    return PurchaseOrdersApiFp().getPurchaseOrders(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {CreateIncomeLotFromPackingListData} createIncomeLotFromPackingListData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrdersApi
*/
export function importPackingList(id, createIncomeLotFromPackingListData, options) {
    return PurchaseOrdersApiFp().importPackingList(id, createIncomeLotFromPackingListData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {File} file
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrdersApi
*/
export function preparePackingListForImport(id, file, options) {
    return PurchaseOrdersApiFp().preparePackingListForImport(id, file, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {string} designId
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrdersApi
*/
export function previewPurchaseOrderDocument(id, designId, options) {
    return PurchaseOrdersApiFp().previewPurchaseOrderDocument(id, designId, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {UpdatePurchaseOrderData} [data]
        * @param {Array<File>} [files]
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrdersApi
*/
export function updatePurchaseOrder(id, data, files, options) {
    return PurchaseOrdersApiFp().updatePurchaseOrder(id, data, files, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {UpdatePurchaseOrderStatusData} updatePurchaseOrderStatusData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrdersApi
*/
export function updatePurchaseOrderStatus(id, updatePurchaseOrderStatusData, options) {
    return PurchaseOrdersApiFp().updatePurchaseOrderStatus(id, updatePurchaseOrderStatusData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrdersApi
*/
export function checkPurchaseInvoiceRaw(id, options) {
    return PurchaseOrdersApiFp().checkPurchaseInvoice(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrdersApi
*/
export function closePurchaseOrderRaw(id, options) {
    return PurchaseOrdersApiFp().closePurchaseOrder(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrdersApi
*/
export function createIncomeLotsForPurchaseOrderRaw(id, options) {
    return PurchaseOrdersApiFp().createIncomeLotsForPurchaseOrder(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {CreatePurchaseOrderData} data
        * @param {Array<File>} [files]
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrdersApi
*/
export function createPurchaseOrderRaw(data, files, options) {
    return PurchaseOrdersApiFp().createPurchaseOrder(data, files, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} purchaseOrderTemplateId
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrdersApi
*/
export function createPurchaseOrderFromTemplateRaw(purchaseOrderTemplateId, options) {
    return PurchaseOrdersApiFp().createPurchaseOrderFromTemplate(purchaseOrderTemplateId, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrdersApi
*/
export function deletePurchaseOrderRaw(id, options) {
    return PurchaseOrdersApiFp().deletePurchaseOrder(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrdersApi
*/
export function duplicatePurchaseOrderRaw(id, options) {
    return PurchaseOrdersApiFp().duplicatePurchaseOrder(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrdersApi
*/
export function getIncomeLotsForPurchaseOrderRaw(id, page, size, sort, options) {
    return PurchaseOrdersApiFp().getIncomeLotsForPurchaseOrder(id, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrdersApi
*/
export function getPurchaseOrderRaw(id, options) {
    return PurchaseOrdersApiFp().getPurchaseOrder(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrdersApi
*/
export function getPurchaseOrdersRaw(criteria, page, size, sort, options) {
    return PurchaseOrdersApiFp().getPurchaseOrders(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {CreateIncomeLotFromPackingListData} createIncomeLotFromPackingListData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrdersApi
*/
export function importPackingListRaw(id, createIncomeLotFromPackingListData, options) {
    return PurchaseOrdersApiFp().importPackingList(id, createIncomeLotFromPackingListData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {File} file
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrdersApi
*/
export function preparePackingListForImportRaw(id, file, options) {
    return PurchaseOrdersApiFp().preparePackingListForImport(id, file, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {string} designId
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrdersApi
*/
export function previewPurchaseOrderDocumentRaw(id, designId, options) {
    return PurchaseOrdersApiFp().previewPurchaseOrderDocument(id, designId, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {UpdatePurchaseOrderData} [data]
        * @param {Array<File>} [files]
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrdersApi
*/
export function updatePurchaseOrderRaw(id, data, files, options) {
    return PurchaseOrdersApiFp().updatePurchaseOrder(id, data, files, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {UpdatePurchaseOrderStatusData} updatePurchaseOrderStatusData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof PurchaseOrdersApi
*/
export function updatePurchaseOrderStatusRaw(id, updatePurchaseOrderStatusData, options) {
    return PurchaseOrdersApiFp().updatePurchaseOrderStatus(id, updatePurchaseOrderStatusData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * RelationProductOverrideControllerApi - axios parameter creator
 * @export
 */
export const RelationProductOverrideControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {CreateRelationProductOverrideData} createRelationProductOverrideData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRelationProductOverride: async (createRelationProductOverrideData, options = {}) => {
            // verify required parameter 'createRelationProductOverrideData' is not null or undefined
            assertParamExists('createRelationProductOverride', 'createRelationProductOverrideData', createRelationProductOverrideData);
            const localVarPath = `/api/relation-product-overrides`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createRelationProductOverrideData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRelationProductOverride: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteRelationProductOverride', 'id', id);
            const localVarPath = `/api/relation-product-overrides/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelationProductOverrides: async (id, page, size, sort, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getRelationProductOverrides', 'id', id);
            const localVarPath = `/api/relations/{id}/product-overrides`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {CreateRelationProductOverrideData} createRelationProductOverrideData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRelationProductOverride: async (id, createRelationProductOverrideData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateRelationProductOverride', 'id', id);
            // verify required parameter 'createRelationProductOverrideData' is not null or undefined
            assertParamExists('updateRelationProductOverride', 'createRelationProductOverrideData', createRelationProductOverrideData);
            const localVarPath = `/api/relation-product-overrides/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createRelationProductOverrideData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * RelationProductOverrideControllerApi - functional programming interface
 * @export
 */
export const RelationProductOverrideControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = RelationProductOverrideControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {CreateRelationProductOverrideData} createRelationProductOverrideData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRelationProductOverride(createRelationProductOverrideData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRelationProductOverride(createRelationProductOverrideData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteRelationProductOverride(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteRelationProductOverride(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRelationProductOverrides(id, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRelationProductOverrides(id, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {CreateRelationProductOverrideData} createRelationProductOverrideData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRelationProductOverride(id, createRelationProductOverrideData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRelationProductOverride(id, createRelationProductOverrideData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * RelationProductOverrideControllerApi - factory interface
 * @export
 */
export const RelationProductOverrideControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = RelationProductOverrideControllerApiFp(configuration);
    return {
        /**
         *
         * @param {CreateRelationProductOverrideData} createRelationProductOverrideData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRelationProductOverride(createRelationProductOverrideData, options) {
            return localVarFp.createRelationProductOverride(createRelationProductOverrideData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRelationProductOverride(id, options) {
            return localVarFp.deleteRelationProductOverride(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelationProductOverrides(id, page, size, sort, options) {
            return localVarFp.getRelationProductOverrides(id, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {CreateRelationProductOverrideData} createRelationProductOverrideData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRelationProductOverride(id, createRelationProductOverrideData, options) {
            return localVarFp.updateRelationProductOverride(id, createRelationProductOverrideData, options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
        * @param {CreateRelationProductOverrideData} createRelationProductOverrideData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof RelationProductOverrideControllerApi
*/
export function createRelationProductOverride(createRelationProductOverrideData, options) {
    return RelationProductOverrideControllerApiFp().createRelationProductOverride(createRelationProductOverrideData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof RelationProductOverrideControllerApi
*/
export function deleteRelationProductOverride(id, options) {
    return RelationProductOverrideControllerApiFp().deleteRelationProductOverride(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof RelationProductOverrideControllerApi
*/
export function getRelationProductOverrides(id, page, size, sort, options) {
    return RelationProductOverrideControllerApiFp().getRelationProductOverrides(id, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {CreateRelationProductOverrideData} createRelationProductOverrideData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof RelationProductOverrideControllerApi
*/
export function updateRelationProductOverride(id, createRelationProductOverrideData, options) {
    return RelationProductOverrideControllerApiFp().updateRelationProductOverride(id, createRelationProductOverrideData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {CreateRelationProductOverrideData} createRelationProductOverrideData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof RelationProductOverrideControllerApi
*/
export function createRelationProductOverrideRaw(createRelationProductOverrideData, options) {
    return RelationProductOverrideControllerApiFp().createRelationProductOverride(createRelationProductOverrideData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof RelationProductOverrideControllerApi
*/
export function deleteRelationProductOverrideRaw(id, options) {
    return RelationProductOverrideControllerApiFp().deleteRelationProductOverride(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof RelationProductOverrideControllerApi
*/
export function getRelationProductOverridesRaw(id, page, size, sort, options) {
    return RelationProductOverrideControllerApiFp().getRelationProductOverrides(id, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {CreateRelationProductOverrideData} createRelationProductOverrideData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof RelationProductOverrideControllerApi
*/
export function updateRelationProductOverrideRaw(id, createRelationProductOverrideData, options) {
    return RelationProductOverrideControllerApiFp().updateRelationProductOverride(id, createRelationProductOverrideData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * RelationsApi - axios parameter creator
 * @export
 */
export const RelationsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} relationId
         * @param {string} productId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activePriceListItemByRelationAndProduct: async (relationId, productId, options = {}) => {
            // verify required parameter 'relationId' is not null or undefined
            assertParamExists('activePriceListItemByRelationAndProduct', 'relationId', relationId);
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('activePriceListItemByRelationAndProduct', 'productId', productId);
            const localVarPath = `/api/relations/{relationId}/product/{productId}`
                .replace(`{${"relationId"}}`, encodeURIComponent(String(relationId)))
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {CreateRelationData} createRelationData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRelation: async (createRelationData, options = {}) => {
            // verify required parameter 'createRelationData' is not null or undefined
            assertParamExists('createRelation', 'createRelationData', createRelationData);
            const localVarPath = `/api/relations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createRelationData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRelation: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteRelation', 'id', id);
            const localVarPath = `/api/relations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelation: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getRelation', 'id', id);
            const localVarPath = `/api/relations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelationAddresses: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getRelationAddresses', 'id', id);
            const localVarPath = `/api/relations/{id}/addresses`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelationTransportMethods: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getRelationTransportMethods', 'id', id);
            const localVarPath = `/api/relations/{id}/transport-methods`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelations: async (criteria, page, size, sort, options = {}) => {
            const localVarPath = `/api/relations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {UpdateRelationData} updateRelationData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRelation: async (id, updateRelationData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateRelation', 'id', id);
            // verify required parameter 'updateRelationData' is not null or undefined
            assertParamExists('updateRelation', 'updateRelationData', updateRelationData);
            const localVarPath = `/api/relations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(updateRelationData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * RelationsApi - functional programming interface
 * @export
 */
export const RelationsApiFp = function (configuration) {
    const localVarAxiosParamCreator = RelationsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} relationId
         * @param {string} productId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async activePriceListItemByRelationAndProduct(relationId, productId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.activePriceListItemByRelationAndProduct(relationId, productId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {CreateRelationData} createRelationData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRelation(createRelationData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRelation(createRelationData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteRelation(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteRelation(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRelation(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRelation(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRelationAddresses(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRelationAddresses(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRelationTransportMethods(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRelationTransportMethods(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRelations(criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRelations(criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {UpdateRelationData} updateRelationData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRelation(id, updateRelationData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRelation(id, updateRelationData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * RelationsApi - factory interface
 * @export
 */
export const RelationsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = RelationsApiFp(configuration);
    return {
        /**
         *
         * @param {string} relationId
         * @param {string} productId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activePriceListItemByRelationAndProduct(relationId, productId, options) {
            return localVarFp.activePriceListItemByRelationAndProduct(relationId, productId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CreateRelationData} createRelationData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRelation(createRelationData, options) {
            return localVarFp.createRelation(createRelationData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRelation(id, options) {
            return localVarFp.deleteRelation(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelation(id, options) {
            return localVarFp.getRelation(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelationAddresses(id, options) {
            return localVarFp.getRelationAddresses(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelationTransportMethods(id, options) {
            return localVarFp.getRelationTransportMethods(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelations(criteria, page, size, sort, options) {
            return localVarFp.getRelations(criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {UpdateRelationData} updateRelationData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRelation(id, updateRelationData, options) {
            return localVarFp.updateRelation(id, updateRelationData, options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
        * @param {string} relationId
        * @param {string} productId
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof RelationsApi
*/
export function activePriceListItemByRelationAndProduct(relationId, productId, options) {
    return RelationsApiFp().activePriceListItemByRelationAndProduct(relationId, productId, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {CreateRelationData} createRelationData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof RelationsApi
*/
export function createRelation(createRelationData, options) {
    return RelationsApiFp().createRelation(createRelationData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof RelationsApi
*/
export function deleteRelation(id, options) {
    return RelationsApiFp().deleteRelation(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof RelationsApi
*/
export function getRelation(id, options) {
    return RelationsApiFp().getRelation(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof RelationsApi
*/
export function getRelationAddresses(id, options) {
    return RelationsApiFp().getRelationAddresses(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof RelationsApi
*/
export function getRelationTransportMethods(id, options) {
    return RelationsApiFp().getRelationTransportMethods(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof RelationsApi
*/
export function getRelations(criteria, page, size, sort, options) {
    return RelationsApiFp().getRelations(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {UpdateRelationData} updateRelationData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof RelationsApi
*/
export function updateRelation(id, updateRelationData, options) {
    return RelationsApiFp().updateRelation(id, updateRelationData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} relationId
        * @param {string} productId
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof RelationsApi
*/
export function activePriceListItemByRelationAndProductRaw(relationId, productId, options) {
    return RelationsApiFp().activePriceListItemByRelationAndProduct(relationId, productId, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {CreateRelationData} createRelationData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof RelationsApi
*/
export function createRelationRaw(createRelationData, options) {
    return RelationsApiFp().createRelation(createRelationData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof RelationsApi
*/
export function deleteRelationRaw(id, options) {
    return RelationsApiFp().deleteRelation(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof RelationsApi
*/
export function getRelationRaw(id, options) {
    return RelationsApiFp().getRelation(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof RelationsApi
*/
export function getRelationAddressesRaw(id, options) {
    return RelationsApiFp().getRelationAddresses(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof RelationsApi
*/
export function getRelationTransportMethodsRaw(id, options) {
    return RelationsApiFp().getRelationTransportMethods(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof RelationsApi
*/
export function getRelationsRaw(criteria, page, size, sort, options) {
    return RelationsApiFp().getRelations(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {UpdateRelationData} updateRelationData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof RelationsApi
*/
export function updateRelationRaw(id, updateRelationData, options) {
    return RelationsApiFp().updateRelation(id, updateRelationData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * RemovalApi - axios parameter creator
 * @export
 */
export const RemovalApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} resourceKey
         * @param {IdsToDeleteData} idsToDeleteData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeEntities: async (resourceKey, idsToDeleteData, options = {}) => {
            // verify required parameter 'resourceKey' is not null or undefined
            assertParamExists('removeEntities', 'resourceKey', resourceKey);
            // verify required parameter 'idsToDeleteData' is not null or undefined
            assertParamExists('removeEntities', 'idsToDeleteData', idsToDeleteData);
            const localVarPath = `/api/remove/{resourceKey}`
                .replace(`{${"resourceKey"}}`, encodeURIComponent(String(resourceKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(idsToDeleteData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * RemovalApi - functional programming interface
 * @export
 */
export const RemovalApiFp = function (configuration) {
    const localVarAxiosParamCreator = RemovalApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} resourceKey
         * @param {IdsToDeleteData} idsToDeleteData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeEntities(resourceKey, idsToDeleteData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeEntities(resourceKey, idsToDeleteData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * RemovalApi - factory interface
 * @export
 */
export const RemovalApiFactory = function (configuration, basePath, axios) {
    const localVarFp = RemovalApiFp(configuration);
    return {
        /**
         *
         * @param {string} resourceKey
         * @param {IdsToDeleteData} idsToDeleteData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeEntities(resourceKey, idsToDeleteData, options) {
            return localVarFp.removeEntities(resourceKey, idsToDeleteData, options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
        * @param {string} resourceKey
        * @param {IdsToDeleteData} idsToDeleteData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof RemovalApi
*/
export function removeEntities(resourceKey, idsToDeleteData, options) {
    return RemovalApiFp().removeEntities(resourceKey, idsToDeleteData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} resourceKey
        * @param {IdsToDeleteData} idsToDeleteData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof RemovalApi
*/
export function removeEntitiesRaw(resourceKey, idsToDeleteData, options) {
    return RemovalApiFp().removeEntities(resourceKey, idsToDeleteData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * ReportDesignsApi - axios parameter creator
 * @export
 */
export const ReportDesignsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveReportDesign: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('archiveReportDesign', 'id', id);
            const localVarPath = `/api/report-designs/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {CreateReportDesignData} createReportDesignData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReportDesign: async (createReportDesignData, options = {}) => {
            // verify required parameter 'createReportDesignData' is not null or undefined
            assertParamExists('createReportDesign', 'createReportDesignData', createReportDesignData);
            const localVarPath = `/api/report-designs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createReportDesignData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {'SALES_ORDER_CONFIRMATION_WITHOUT_PRICES' | 'SALES_ORDER_CONFIRMATION' | 'SALES_INVOICE' | 'SALES_PACKING_SLIP' | 'SALES_DELIVERY_RECEIPT_WITHOUT_PRICES' | 'SALES_DELIVERY_RECEIPT' | 'SALES_TRANSPORT_DOCUMENT' | 'SALES_ORDER_PALLET_LABEL' | 'SALES_BOX_LABEL' | 'SALES_WEIGHT_LABEL' | 'SALES_LIST' | 'SALES_OTHER' | 'PRICE_LIST' | 'STOCK_BOX_LABEL' | 'STOCK_DOCUMENT' | 'STOCK_LIST' | 'PURCHASING_ORDER_CONFIRMATION' | 'PURCHASING_INCOMING_LOT_DOCUMENT' | 'PURCHASING_UNLOAD_DOCUMENT' | 'PURCHASING_LIST' | 'PURCHASING_OTHER' | 'PRODUCTION_BOX_LABEL' | 'PRODUCTION_ORDER_CONFIRMATION' | 'PRODUCTION_LIST' | 'PRODUCTION_OTHER'} category
         * @param {string} [resourceId]
         * @param {string} [criteria]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportData: async (category, resourceId, criteria, options = {}) => {
            // verify required parameter 'category' is not null or undefined
            assertParamExists('getReportData', 'category', category);
            const localVarPath = `/api/report-designs/real-data/{category}`
                .replace(`{${"category"}}`, encodeURIComponent(String(category)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (resourceId !== undefined) {
                localVarQueryParameter['resourceId'] = resourceId;
            }
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportDesign: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getReportDesign', 'id', id);
            const localVarPath = `/api/report-designs/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportDesigns: async (criteria, page, size, sort, options = {}) => {
            const localVarPath = `/api/report-designs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {'SALES_ORDER_CONFIRMATION_WITHOUT_PRICES' | 'SALES_ORDER_CONFIRMATION' | 'SALES_INVOICE' | 'SALES_PACKING_SLIP' | 'SALES_DELIVERY_RECEIPT_WITHOUT_PRICES' | 'SALES_DELIVERY_RECEIPT' | 'SALES_TRANSPORT_DOCUMENT' | 'SALES_ORDER_PALLET_LABEL' | 'SALES_BOX_LABEL' | 'SALES_WEIGHT_LABEL' | 'SALES_LIST' | 'SALES_OTHER' | 'PRICE_LIST' | 'STOCK_BOX_LABEL' | 'STOCK_DOCUMENT' | 'STOCK_LIST' | 'PURCHASING_ORDER_CONFIRMATION' | 'PURCHASING_INCOMING_LOT_DOCUMENT' | 'PURCHASING_UNLOAD_DOCUMENT' | 'PURCHASING_LIST' | 'PURCHASING_OTHER' | 'PRODUCTION_BOX_LABEL' | 'PRODUCTION_ORDER_CONFIRMATION' | 'PRODUCTION_LIST' | 'PRODUCTION_OTHER'} category
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportDummyData: async (category, options = {}) => {
            // verify required parameter 'category' is not null or undefined
            assertParamExists('getReportDummyData', 'category', category);
            const localVarPath = `/api/report-designs/dummy-data/{category}`
                .replace(`{${"category"}}`, encodeURIComponent(String(category)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {'SALES_ORDER_CONFIRMATION_WITHOUT_PRICES' | 'SALES_ORDER_CONFIRMATION' | 'SALES_INVOICE' | 'SALES_PACKING_SLIP' | 'SALES_DELIVERY_RECEIPT_WITHOUT_PRICES' | 'SALES_DELIVERY_RECEIPT' | 'SALES_TRANSPORT_DOCUMENT' | 'SALES_ORDER_PALLET_LABEL' | 'SALES_BOX_LABEL' | 'SALES_WEIGHT_LABEL' | 'SALES_LIST' | 'SALES_OTHER' | 'PRICE_LIST' | 'STOCK_BOX_LABEL' | 'STOCK_DOCUMENT' | 'STOCK_LIST' | 'PURCHASING_ORDER_CONFIRMATION' | 'PURCHASING_INCOMING_LOT_DOCUMENT' | 'PURCHASING_UNLOAD_DOCUMENT' | 'PURCHASING_LIST' | 'PURCHASING_OTHER' | 'PRODUCTION_BOX_LABEL' | 'PRODUCTION_ORDER_CONFIRMATION' | 'PRODUCTION_LIST' | 'PRODUCTION_OTHER'} category
         * @param {string} relationId
         * @param {string} ownerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportPreference: async (category, relationId, ownerId, options = {}) => {
            // verify required parameter 'category' is not null or undefined
            assertParamExists('getReportPreference', 'category', category);
            // verify required parameter 'relationId' is not null or undefined
            assertParamExists('getReportPreference', 'relationId', relationId);
            // verify required parameter 'ownerId' is not null or undefined
            assertParamExists('getReportPreference', 'ownerId', ownerId);
            const localVarPath = `/api/report-designs/preference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }
            if (relationId !== undefined) {
                localVarQueryParameter['relationId'] = relationId;
            }
            if (ownerId !== undefined) {
                localVarQueryParameter['ownerId'] = ownerId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} resourceId
         * @param {'SALES_ORDER_CONFIRMATION_WITHOUT_PRICES' | 'SALES_ORDER_CONFIRMATION' | 'SALES_INVOICE' | 'SALES_PACKING_SLIP' | 'SALES_DELIVERY_RECEIPT_WITHOUT_PRICES' | 'SALES_DELIVERY_RECEIPT' | 'SALES_TRANSPORT_DOCUMENT' | 'SALES_ORDER_PALLET_LABEL' | 'SALES_BOX_LABEL' | 'SALES_WEIGHT_LABEL' | 'SALES_LIST' | 'SALES_OTHER' | 'PRICE_LIST' | 'STOCK_BOX_LABEL' | 'STOCK_DOCUMENT' | 'STOCK_LIST' | 'PURCHASING_ORDER_CONFIRMATION' | 'PURCHASING_INCOMING_LOT_DOCUMENT' | 'PURCHASING_UNLOAD_DOCUMENT' | 'PURCHASING_LIST' | 'PURCHASING_OTHER' | 'PRODUCTION_BOX_LABEL' | 'PRODUCTION_ORDER_CONFIRMATION' | 'PRODUCTION_LIST' | 'PRODUCTION_OTHER'} category
         * @param {'CORE' | 'FINANCE' | 'PRODUCTION' | 'PURCHASING' | 'SALES' | 'STOCK' | 'INCOME' | 'OUTCOME'} module
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportPreferenceForResource: async (resourceId, category, module, options = {}) => {
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('getReportPreferenceForResource', 'resourceId', resourceId);
            // verify required parameter 'category' is not null or undefined
            assertParamExists('getReportPreferenceForResource', 'category', category);
            // verify required parameter 'module' is not null or undefined
            assertParamExists('getReportPreferenceForResource', 'module', module);
            const localVarPath = `/api/report-designs/preference/resource`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (resourceId !== undefined) {
                localVarQueryParameter['resourceId'] = resourceId;
            }
            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }
            if (module !== undefined) {
                localVarQueryParameter['module'] = module;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {UpdateReportDesignData} updateReportDesignData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReportDesign: async (id, updateReportDesignData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateReportDesign', 'id', id);
            // verify required parameter 'updateReportDesignData' is not null or undefined
            assertParamExists('updateReportDesign', 'updateReportDesignData', updateReportDesignData);
            const localVarPath = `/api/report-designs/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(updateReportDesignData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ReportDesignsApi - functional programming interface
 * @export
 */
export const ReportDesignsApiFp = function (configuration) {
    const localVarAxiosParamCreator = ReportDesignsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async archiveReportDesign(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.archiveReportDesign(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {CreateReportDesignData} createReportDesignData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createReportDesign(createReportDesignData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createReportDesign(createReportDesignData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {'SALES_ORDER_CONFIRMATION_WITHOUT_PRICES' | 'SALES_ORDER_CONFIRMATION' | 'SALES_INVOICE' | 'SALES_PACKING_SLIP' | 'SALES_DELIVERY_RECEIPT_WITHOUT_PRICES' | 'SALES_DELIVERY_RECEIPT' | 'SALES_TRANSPORT_DOCUMENT' | 'SALES_ORDER_PALLET_LABEL' | 'SALES_BOX_LABEL' | 'SALES_WEIGHT_LABEL' | 'SALES_LIST' | 'SALES_OTHER' | 'PRICE_LIST' | 'STOCK_BOX_LABEL' | 'STOCK_DOCUMENT' | 'STOCK_LIST' | 'PURCHASING_ORDER_CONFIRMATION' | 'PURCHASING_INCOMING_LOT_DOCUMENT' | 'PURCHASING_UNLOAD_DOCUMENT' | 'PURCHASING_LIST' | 'PURCHASING_OTHER' | 'PRODUCTION_BOX_LABEL' | 'PRODUCTION_ORDER_CONFIRMATION' | 'PRODUCTION_LIST' | 'PRODUCTION_OTHER'} category
         * @param {string} [resourceId]
         * @param {string} [criteria]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReportData(category, resourceId, criteria, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReportData(category, resourceId, criteria, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReportDesign(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReportDesign(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReportDesigns(criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReportDesigns(criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {'SALES_ORDER_CONFIRMATION_WITHOUT_PRICES' | 'SALES_ORDER_CONFIRMATION' | 'SALES_INVOICE' | 'SALES_PACKING_SLIP' | 'SALES_DELIVERY_RECEIPT_WITHOUT_PRICES' | 'SALES_DELIVERY_RECEIPT' | 'SALES_TRANSPORT_DOCUMENT' | 'SALES_ORDER_PALLET_LABEL' | 'SALES_BOX_LABEL' | 'SALES_WEIGHT_LABEL' | 'SALES_LIST' | 'SALES_OTHER' | 'PRICE_LIST' | 'STOCK_BOX_LABEL' | 'STOCK_DOCUMENT' | 'STOCK_LIST' | 'PURCHASING_ORDER_CONFIRMATION' | 'PURCHASING_INCOMING_LOT_DOCUMENT' | 'PURCHASING_UNLOAD_DOCUMENT' | 'PURCHASING_LIST' | 'PURCHASING_OTHER' | 'PRODUCTION_BOX_LABEL' | 'PRODUCTION_ORDER_CONFIRMATION' | 'PRODUCTION_LIST' | 'PRODUCTION_OTHER'} category
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReportDummyData(category, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReportDummyData(category, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {'SALES_ORDER_CONFIRMATION_WITHOUT_PRICES' | 'SALES_ORDER_CONFIRMATION' | 'SALES_INVOICE' | 'SALES_PACKING_SLIP' | 'SALES_DELIVERY_RECEIPT_WITHOUT_PRICES' | 'SALES_DELIVERY_RECEIPT' | 'SALES_TRANSPORT_DOCUMENT' | 'SALES_ORDER_PALLET_LABEL' | 'SALES_BOX_LABEL' | 'SALES_WEIGHT_LABEL' | 'SALES_LIST' | 'SALES_OTHER' | 'PRICE_LIST' | 'STOCK_BOX_LABEL' | 'STOCK_DOCUMENT' | 'STOCK_LIST' | 'PURCHASING_ORDER_CONFIRMATION' | 'PURCHASING_INCOMING_LOT_DOCUMENT' | 'PURCHASING_UNLOAD_DOCUMENT' | 'PURCHASING_LIST' | 'PURCHASING_OTHER' | 'PRODUCTION_BOX_LABEL' | 'PRODUCTION_ORDER_CONFIRMATION' | 'PRODUCTION_LIST' | 'PRODUCTION_OTHER'} category
         * @param {string} relationId
         * @param {string} ownerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReportPreference(category, relationId, ownerId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReportPreference(category, relationId, ownerId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} resourceId
         * @param {'SALES_ORDER_CONFIRMATION_WITHOUT_PRICES' | 'SALES_ORDER_CONFIRMATION' | 'SALES_INVOICE' | 'SALES_PACKING_SLIP' | 'SALES_DELIVERY_RECEIPT_WITHOUT_PRICES' | 'SALES_DELIVERY_RECEIPT' | 'SALES_TRANSPORT_DOCUMENT' | 'SALES_ORDER_PALLET_LABEL' | 'SALES_BOX_LABEL' | 'SALES_WEIGHT_LABEL' | 'SALES_LIST' | 'SALES_OTHER' | 'PRICE_LIST' | 'STOCK_BOX_LABEL' | 'STOCK_DOCUMENT' | 'STOCK_LIST' | 'PURCHASING_ORDER_CONFIRMATION' | 'PURCHASING_INCOMING_LOT_DOCUMENT' | 'PURCHASING_UNLOAD_DOCUMENT' | 'PURCHASING_LIST' | 'PURCHASING_OTHER' | 'PRODUCTION_BOX_LABEL' | 'PRODUCTION_ORDER_CONFIRMATION' | 'PRODUCTION_LIST' | 'PRODUCTION_OTHER'} category
         * @param {'CORE' | 'FINANCE' | 'PRODUCTION' | 'PURCHASING' | 'SALES' | 'STOCK' | 'INCOME' | 'OUTCOME'} module
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReportPreferenceForResource(resourceId, category, module, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReportPreferenceForResource(resourceId, category, module, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {UpdateReportDesignData} updateReportDesignData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateReportDesign(id, updateReportDesignData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateReportDesign(id, updateReportDesignData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * ReportDesignsApi - factory interface
 * @export
 */
export const ReportDesignsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ReportDesignsApiFp(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveReportDesign(id, options) {
            return localVarFp.archiveReportDesign(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CreateReportDesignData} createReportDesignData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReportDesign(createReportDesignData, options) {
            return localVarFp.createReportDesign(createReportDesignData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {'SALES_ORDER_CONFIRMATION_WITHOUT_PRICES' | 'SALES_ORDER_CONFIRMATION' | 'SALES_INVOICE' | 'SALES_PACKING_SLIP' | 'SALES_DELIVERY_RECEIPT_WITHOUT_PRICES' | 'SALES_DELIVERY_RECEIPT' | 'SALES_TRANSPORT_DOCUMENT' | 'SALES_ORDER_PALLET_LABEL' | 'SALES_BOX_LABEL' | 'SALES_WEIGHT_LABEL' | 'SALES_LIST' | 'SALES_OTHER' | 'PRICE_LIST' | 'STOCK_BOX_LABEL' | 'STOCK_DOCUMENT' | 'STOCK_LIST' | 'PURCHASING_ORDER_CONFIRMATION' | 'PURCHASING_INCOMING_LOT_DOCUMENT' | 'PURCHASING_UNLOAD_DOCUMENT' | 'PURCHASING_LIST' | 'PURCHASING_OTHER' | 'PRODUCTION_BOX_LABEL' | 'PRODUCTION_ORDER_CONFIRMATION' | 'PRODUCTION_LIST' | 'PRODUCTION_OTHER'} category
         * @param {string} [resourceId]
         * @param {string} [criteria]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportData(category, resourceId, criteria, options) {
            return localVarFp.getReportData(category, resourceId, criteria, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportDesign(id, options) {
            return localVarFp.getReportDesign(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportDesigns(criteria, page, size, sort, options) {
            return localVarFp.getReportDesigns(criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {'SALES_ORDER_CONFIRMATION_WITHOUT_PRICES' | 'SALES_ORDER_CONFIRMATION' | 'SALES_INVOICE' | 'SALES_PACKING_SLIP' | 'SALES_DELIVERY_RECEIPT_WITHOUT_PRICES' | 'SALES_DELIVERY_RECEIPT' | 'SALES_TRANSPORT_DOCUMENT' | 'SALES_ORDER_PALLET_LABEL' | 'SALES_BOX_LABEL' | 'SALES_WEIGHT_LABEL' | 'SALES_LIST' | 'SALES_OTHER' | 'PRICE_LIST' | 'STOCK_BOX_LABEL' | 'STOCK_DOCUMENT' | 'STOCK_LIST' | 'PURCHASING_ORDER_CONFIRMATION' | 'PURCHASING_INCOMING_LOT_DOCUMENT' | 'PURCHASING_UNLOAD_DOCUMENT' | 'PURCHASING_LIST' | 'PURCHASING_OTHER' | 'PRODUCTION_BOX_LABEL' | 'PRODUCTION_ORDER_CONFIRMATION' | 'PRODUCTION_LIST' | 'PRODUCTION_OTHER'} category
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportDummyData(category, options) {
            return localVarFp.getReportDummyData(category, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {'SALES_ORDER_CONFIRMATION_WITHOUT_PRICES' | 'SALES_ORDER_CONFIRMATION' | 'SALES_INVOICE' | 'SALES_PACKING_SLIP' | 'SALES_DELIVERY_RECEIPT_WITHOUT_PRICES' | 'SALES_DELIVERY_RECEIPT' | 'SALES_TRANSPORT_DOCUMENT' | 'SALES_ORDER_PALLET_LABEL' | 'SALES_BOX_LABEL' | 'SALES_WEIGHT_LABEL' | 'SALES_LIST' | 'SALES_OTHER' | 'PRICE_LIST' | 'STOCK_BOX_LABEL' | 'STOCK_DOCUMENT' | 'STOCK_LIST' | 'PURCHASING_ORDER_CONFIRMATION' | 'PURCHASING_INCOMING_LOT_DOCUMENT' | 'PURCHASING_UNLOAD_DOCUMENT' | 'PURCHASING_LIST' | 'PURCHASING_OTHER' | 'PRODUCTION_BOX_LABEL' | 'PRODUCTION_ORDER_CONFIRMATION' | 'PRODUCTION_LIST' | 'PRODUCTION_OTHER'} category
         * @param {string} relationId
         * @param {string} ownerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportPreference(category, relationId, ownerId, options) {
            return localVarFp.getReportPreference(category, relationId, ownerId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} resourceId
         * @param {'SALES_ORDER_CONFIRMATION_WITHOUT_PRICES' | 'SALES_ORDER_CONFIRMATION' | 'SALES_INVOICE' | 'SALES_PACKING_SLIP' | 'SALES_DELIVERY_RECEIPT_WITHOUT_PRICES' | 'SALES_DELIVERY_RECEIPT' | 'SALES_TRANSPORT_DOCUMENT' | 'SALES_ORDER_PALLET_LABEL' | 'SALES_BOX_LABEL' | 'SALES_WEIGHT_LABEL' | 'SALES_LIST' | 'SALES_OTHER' | 'PRICE_LIST' | 'STOCK_BOX_LABEL' | 'STOCK_DOCUMENT' | 'STOCK_LIST' | 'PURCHASING_ORDER_CONFIRMATION' | 'PURCHASING_INCOMING_LOT_DOCUMENT' | 'PURCHASING_UNLOAD_DOCUMENT' | 'PURCHASING_LIST' | 'PURCHASING_OTHER' | 'PRODUCTION_BOX_LABEL' | 'PRODUCTION_ORDER_CONFIRMATION' | 'PRODUCTION_LIST' | 'PRODUCTION_OTHER'} category
         * @param {'CORE' | 'FINANCE' | 'PRODUCTION' | 'PURCHASING' | 'SALES' | 'STOCK' | 'INCOME' | 'OUTCOME'} module
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportPreferenceForResource(resourceId, category, module, options) {
            return localVarFp.getReportPreferenceForResource(resourceId, category, module, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {UpdateReportDesignData} updateReportDesignData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReportDesign(id, updateReportDesignData, options) {
            return localVarFp.updateReportDesign(id, updateReportDesignData, options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ReportDesignsApi
*/
export function archiveReportDesign(id, options) {
    return ReportDesignsApiFp().archiveReportDesign(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {CreateReportDesignData} createReportDesignData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ReportDesignsApi
*/
export function createReportDesign(createReportDesignData, options) {
    return ReportDesignsApiFp().createReportDesign(createReportDesignData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {'SALES_ORDER_CONFIRMATION_WITHOUT_PRICES' | 'SALES_ORDER_CONFIRMATION' | 'SALES_INVOICE' | 'SALES_PACKING_SLIP' | 'SALES_DELIVERY_RECEIPT_WITHOUT_PRICES' | 'SALES_DELIVERY_RECEIPT' | 'SALES_TRANSPORT_DOCUMENT' | 'SALES_ORDER_PALLET_LABEL' | 'SALES_BOX_LABEL' | 'SALES_WEIGHT_LABEL' | 'SALES_LIST' | 'SALES_OTHER' | 'PRICE_LIST' | 'STOCK_BOX_LABEL' | 'STOCK_DOCUMENT' | 'STOCK_LIST' | 'PURCHASING_ORDER_CONFIRMATION' | 'PURCHASING_INCOMING_LOT_DOCUMENT' | 'PURCHASING_UNLOAD_DOCUMENT' | 'PURCHASING_LIST' | 'PURCHASING_OTHER' | 'PRODUCTION_BOX_LABEL' | 'PRODUCTION_ORDER_CONFIRMATION' | 'PRODUCTION_LIST' | 'PRODUCTION_OTHER'} category
        * @param {string} [resourceId]
        * @param {string} [criteria]
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ReportDesignsApi
*/
export function getReportData(category, resourceId, criteria, options) {
    return ReportDesignsApiFp().getReportData(category, resourceId, criteria, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ReportDesignsApi
*/
export function getReportDesign(id, options) {
    return ReportDesignsApiFp().getReportDesign(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ReportDesignsApi
*/
export function getReportDesigns(criteria, page, size, sort, options) {
    return ReportDesignsApiFp().getReportDesigns(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {'SALES_ORDER_CONFIRMATION_WITHOUT_PRICES' | 'SALES_ORDER_CONFIRMATION' | 'SALES_INVOICE' | 'SALES_PACKING_SLIP' | 'SALES_DELIVERY_RECEIPT_WITHOUT_PRICES' | 'SALES_DELIVERY_RECEIPT' | 'SALES_TRANSPORT_DOCUMENT' | 'SALES_ORDER_PALLET_LABEL' | 'SALES_BOX_LABEL' | 'SALES_WEIGHT_LABEL' | 'SALES_LIST' | 'SALES_OTHER' | 'PRICE_LIST' | 'STOCK_BOX_LABEL' | 'STOCK_DOCUMENT' | 'STOCK_LIST' | 'PURCHASING_ORDER_CONFIRMATION' | 'PURCHASING_INCOMING_LOT_DOCUMENT' | 'PURCHASING_UNLOAD_DOCUMENT' | 'PURCHASING_LIST' | 'PURCHASING_OTHER' | 'PRODUCTION_BOX_LABEL' | 'PRODUCTION_ORDER_CONFIRMATION' | 'PRODUCTION_LIST' | 'PRODUCTION_OTHER'} category
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ReportDesignsApi
*/
export function getReportDummyData(category, options) {
    return ReportDesignsApiFp().getReportDummyData(category, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {'SALES_ORDER_CONFIRMATION_WITHOUT_PRICES' | 'SALES_ORDER_CONFIRMATION' | 'SALES_INVOICE' | 'SALES_PACKING_SLIP' | 'SALES_DELIVERY_RECEIPT_WITHOUT_PRICES' | 'SALES_DELIVERY_RECEIPT' | 'SALES_TRANSPORT_DOCUMENT' | 'SALES_ORDER_PALLET_LABEL' | 'SALES_BOX_LABEL' | 'SALES_WEIGHT_LABEL' | 'SALES_LIST' | 'SALES_OTHER' | 'PRICE_LIST' | 'STOCK_BOX_LABEL' | 'STOCK_DOCUMENT' | 'STOCK_LIST' | 'PURCHASING_ORDER_CONFIRMATION' | 'PURCHASING_INCOMING_LOT_DOCUMENT' | 'PURCHASING_UNLOAD_DOCUMENT' | 'PURCHASING_LIST' | 'PURCHASING_OTHER' | 'PRODUCTION_BOX_LABEL' | 'PRODUCTION_ORDER_CONFIRMATION' | 'PRODUCTION_LIST' | 'PRODUCTION_OTHER'} category
        * @param {string} relationId
        * @param {string} ownerId
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ReportDesignsApi
*/
export function getReportPreference(category, relationId, ownerId, options) {
    return ReportDesignsApiFp().getReportPreference(category, relationId, ownerId, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} resourceId
        * @param {'SALES_ORDER_CONFIRMATION_WITHOUT_PRICES' | 'SALES_ORDER_CONFIRMATION' | 'SALES_INVOICE' | 'SALES_PACKING_SLIP' | 'SALES_DELIVERY_RECEIPT_WITHOUT_PRICES' | 'SALES_DELIVERY_RECEIPT' | 'SALES_TRANSPORT_DOCUMENT' | 'SALES_ORDER_PALLET_LABEL' | 'SALES_BOX_LABEL' | 'SALES_WEIGHT_LABEL' | 'SALES_LIST' | 'SALES_OTHER' | 'PRICE_LIST' | 'STOCK_BOX_LABEL' | 'STOCK_DOCUMENT' | 'STOCK_LIST' | 'PURCHASING_ORDER_CONFIRMATION' | 'PURCHASING_INCOMING_LOT_DOCUMENT' | 'PURCHASING_UNLOAD_DOCUMENT' | 'PURCHASING_LIST' | 'PURCHASING_OTHER' | 'PRODUCTION_BOX_LABEL' | 'PRODUCTION_ORDER_CONFIRMATION' | 'PRODUCTION_LIST' | 'PRODUCTION_OTHER'} category
        * @param {'CORE' | 'FINANCE' | 'PRODUCTION' | 'PURCHASING' | 'SALES' | 'STOCK' | 'INCOME' | 'OUTCOME'} module
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ReportDesignsApi
*/
export function getReportPreferenceForResource(resourceId, category, module, options) {
    return ReportDesignsApiFp().getReportPreferenceForResource(resourceId, category, module, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {UpdateReportDesignData} updateReportDesignData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ReportDesignsApi
*/
export function updateReportDesign(id, updateReportDesignData, options) {
    return ReportDesignsApiFp().updateReportDesign(id, updateReportDesignData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ReportDesignsApi
*/
export function archiveReportDesignRaw(id, options) {
    return ReportDesignsApiFp().archiveReportDesign(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {CreateReportDesignData} createReportDesignData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ReportDesignsApi
*/
export function createReportDesignRaw(createReportDesignData, options) {
    return ReportDesignsApiFp().createReportDesign(createReportDesignData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {'SALES_ORDER_CONFIRMATION_WITHOUT_PRICES' | 'SALES_ORDER_CONFIRMATION' | 'SALES_INVOICE' | 'SALES_PACKING_SLIP' | 'SALES_DELIVERY_RECEIPT_WITHOUT_PRICES' | 'SALES_DELIVERY_RECEIPT' | 'SALES_TRANSPORT_DOCUMENT' | 'SALES_ORDER_PALLET_LABEL' | 'SALES_BOX_LABEL' | 'SALES_WEIGHT_LABEL' | 'SALES_LIST' | 'SALES_OTHER' | 'PRICE_LIST' | 'STOCK_BOX_LABEL' | 'STOCK_DOCUMENT' | 'STOCK_LIST' | 'PURCHASING_ORDER_CONFIRMATION' | 'PURCHASING_INCOMING_LOT_DOCUMENT' | 'PURCHASING_UNLOAD_DOCUMENT' | 'PURCHASING_LIST' | 'PURCHASING_OTHER' | 'PRODUCTION_BOX_LABEL' | 'PRODUCTION_ORDER_CONFIRMATION' | 'PRODUCTION_LIST' | 'PRODUCTION_OTHER'} category
        * @param {string} [resourceId]
        * @param {string} [criteria]
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ReportDesignsApi
*/
export function getReportDataRaw(category, resourceId, criteria, options) {
    return ReportDesignsApiFp().getReportData(category, resourceId, criteria, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ReportDesignsApi
*/
export function getReportDesignRaw(id, options) {
    return ReportDesignsApiFp().getReportDesign(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ReportDesignsApi
*/
export function getReportDesignsRaw(criteria, page, size, sort, options) {
    return ReportDesignsApiFp().getReportDesigns(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {'SALES_ORDER_CONFIRMATION_WITHOUT_PRICES' | 'SALES_ORDER_CONFIRMATION' | 'SALES_INVOICE' | 'SALES_PACKING_SLIP' | 'SALES_DELIVERY_RECEIPT_WITHOUT_PRICES' | 'SALES_DELIVERY_RECEIPT' | 'SALES_TRANSPORT_DOCUMENT' | 'SALES_ORDER_PALLET_LABEL' | 'SALES_BOX_LABEL' | 'SALES_WEIGHT_LABEL' | 'SALES_LIST' | 'SALES_OTHER' | 'PRICE_LIST' | 'STOCK_BOX_LABEL' | 'STOCK_DOCUMENT' | 'STOCK_LIST' | 'PURCHASING_ORDER_CONFIRMATION' | 'PURCHASING_INCOMING_LOT_DOCUMENT' | 'PURCHASING_UNLOAD_DOCUMENT' | 'PURCHASING_LIST' | 'PURCHASING_OTHER' | 'PRODUCTION_BOX_LABEL' | 'PRODUCTION_ORDER_CONFIRMATION' | 'PRODUCTION_LIST' | 'PRODUCTION_OTHER'} category
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ReportDesignsApi
*/
export function getReportDummyDataRaw(category, options) {
    return ReportDesignsApiFp().getReportDummyData(category, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {'SALES_ORDER_CONFIRMATION_WITHOUT_PRICES' | 'SALES_ORDER_CONFIRMATION' | 'SALES_INVOICE' | 'SALES_PACKING_SLIP' | 'SALES_DELIVERY_RECEIPT_WITHOUT_PRICES' | 'SALES_DELIVERY_RECEIPT' | 'SALES_TRANSPORT_DOCUMENT' | 'SALES_ORDER_PALLET_LABEL' | 'SALES_BOX_LABEL' | 'SALES_WEIGHT_LABEL' | 'SALES_LIST' | 'SALES_OTHER' | 'PRICE_LIST' | 'STOCK_BOX_LABEL' | 'STOCK_DOCUMENT' | 'STOCK_LIST' | 'PURCHASING_ORDER_CONFIRMATION' | 'PURCHASING_INCOMING_LOT_DOCUMENT' | 'PURCHASING_UNLOAD_DOCUMENT' | 'PURCHASING_LIST' | 'PURCHASING_OTHER' | 'PRODUCTION_BOX_LABEL' | 'PRODUCTION_ORDER_CONFIRMATION' | 'PRODUCTION_LIST' | 'PRODUCTION_OTHER'} category
        * @param {string} relationId
        * @param {string} ownerId
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ReportDesignsApi
*/
export function getReportPreferenceRaw(category, relationId, ownerId, options) {
    return ReportDesignsApiFp().getReportPreference(category, relationId, ownerId, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} resourceId
        * @param {'SALES_ORDER_CONFIRMATION_WITHOUT_PRICES' | 'SALES_ORDER_CONFIRMATION' | 'SALES_INVOICE' | 'SALES_PACKING_SLIP' | 'SALES_DELIVERY_RECEIPT_WITHOUT_PRICES' | 'SALES_DELIVERY_RECEIPT' | 'SALES_TRANSPORT_DOCUMENT' | 'SALES_ORDER_PALLET_LABEL' | 'SALES_BOX_LABEL' | 'SALES_WEIGHT_LABEL' | 'SALES_LIST' | 'SALES_OTHER' | 'PRICE_LIST' | 'STOCK_BOX_LABEL' | 'STOCK_DOCUMENT' | 'STOCK_LIST' | 'PURCHASING_ORDER_CONFIRMATION' | 'PURCHASING_INCOMING_LOT_DOCUMENT' | 'PURCHASING_UNLOAD_DOCUMENT' | 'PURCHASING_LIST' | 'PURCHASING_OTHER' | 'PRODUCTION_BOX_LABEL' | 'PRODUCTION_ORDER_CONFIRMATION' | 'PRODUCTION_LIST' | 'PRODUCTION_OTHER'} category
        * @param {'CORE' | 'FINANCE' | 'PRODUCTION' | 'PURCHASING' | 'SALES' | 'STOCK' | 'INCOME' | 'OUTCOME'} module
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ReportDesignsApi
*/
export function getReportPreferenceForResourceRaw(resourceId, category, module, options) {
    return ReportDesignsApiFp().getReportPreferenceForResource(resourceId, category, module, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {UpdateReportDesignData} updateReportDesignData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof ReportDesignsApi
*/
export function updateReportDesignRaw(id, updateReportDesignData, options) {
    return ReportDesignsApiFp().updateReportDesign(id, updateReportDesignData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * RolesApi - axios parameter creator
 * @export
 */
export const RolesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveRole: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('archiveRole', 'id', id);
            const localVarPath = `/api/roles/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveRole1: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('archiveRole1', 'id', id);
            const localVarPath = `/api/reference/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copyRole: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('copyRole', 'id', id);
            const localVarPath = `/api/roles/{id}/copy`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copyRole1: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('copyRole1', 'id', id);
            const localVarPath = `/api/reference/{id}/copy`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {CreateRoleData} createRoleData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRole: async (createRoleData, options = {}) => {
            // verify required parameter 'createRoleData' is not null or undefined
            assertParamExists('createRole', 'createRoleData', createRoleData);
            const localVarPath = `/api/roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createRoleData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {CreateRoleData} createRoleData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRole1: async (createRoleData, options = {}) => {
            // verify required parameter 'createRoleData' is not null or undefined
            assertParamExists('createRole1', 'createRoleData', createRoleData);
            const localVarPath = `/api/reference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createRoleData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPrivileges: async (options = {}) => {
            const localVarPath = `/api/roles/privileges`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPrivileges1: async (options = {}) => {
            const localVarPath = `/api/reference/privileges`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} resource
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReference: async (resource, id, options = {}) => {
            // verify required parameter 'resource' is not null or undefined
            assertParamExists('getReference', 'resource', resource);
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getReference', 'id', id);
            const localVarPath = `/api/reference/{resource}/{id}`
                .replace(`{${"resource"}}`, encodeURIComponent(String(resource)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRole: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getRole', 'id', id);
            const localVarPath = `/api/roles/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRole1: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getRole1', 'id', id);
            const localVarPath = `/api/reference/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoles: async (criteria, page, size, sort, options = {}) => {
            const localVarPath = `/api/roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {UpdateRoleData} updateRoleData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRole: async (id, updateRoleData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateRole', 'id', id);
            // verify required parameter 'updateRoleData' is not null or undefined
            assertParamExists('updateRole', 'updateRoleData', updateRoleData);
            const localVarPath = `/api/roles/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(updateRoleData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {UpdateRoleData} updateRoleData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRole1: async (id, updateRoleData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateRole1', 'id', id);
            // verify required parameter 'updateRoleData' is not null or undefined
            assertParamExists('updateRole1', 'updateRoleData', updateRoleData);
            const localVarPath = `/api/reference/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(updateRoleData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * RolesApi - functional programming interface
 * @export
 */
export const RolesApiFp = function (configuration) {
    const localVarAxiosParamCreator = RolesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async archiveRole(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.archiveRole(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async archiveRole1(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.archiveRole1(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async copyRole(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.copyRole(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async copyRole1(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.copyRole1(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {CreateRoleData} createRoleData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRole(createRoleData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRole(createRoleData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {CreateRoleData} createRoleData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRole1(createRoleData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRole1(createRoleData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllPrivileges(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllPrivileges(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllPrivileges1(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllPrivileges1(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} resource
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReference(resource, id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReference(resource, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRole(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRole(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRole1(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRole1(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRoles(criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRoles(criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {UpdateRoleData} updateRoleData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRole(id, updateRoleData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRole(id, updateRoleData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {UpdateRoleData} updateRoleData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRole1(id, updateRoleData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRole1(id, updateRoleData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * RolesApi - factory interface
 * @export
 */
export const RolesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = RolesApiFp(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveRole(id, options) {
            return localVarFp.archiveRole(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveRole1(id, options) {
            return localVarFp.archiveRole1(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copyRole(id, options) {
            return localVarFp.copyRole(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copyRole1(id, options) {
            return localVarFp.copyRole1(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CreateRoleData} createRoleData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRole(createRoleData, options) {
            return localVarFp.createRole(createRoleData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CreateRoleData} createRoleData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRole1(createRoleData, options) {
            return localVarFp.createRole1(createRoleData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPrivileges(options) {
            return localVarFp.getAllPrivileges(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPrivileges1(options) {
            return localVarFp.getAllPrivileges1(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} resource
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReference(resource, id, options) {
            return localVarFp.getReference(resource, id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRole(id, options) {
            return localVarFp.getRole(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRole1(id, options) {
            return localVarFp.getRole1(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoles(criteria, page, size, sort, options) {
            return localVarFp.getRoles(criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {UpdateRoleData} updateRoleData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRole(id, updateRoleData, options) {
            return localVarFp.updateRole(id, updateRoleData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {UpdateRoleData} updateRoleData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRole1(id, updateRoleData, options) {
            return localVarFp.updateRole1(id, updateRoleData, options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof RolesApi
*/
export function archiveRole(id, options) {
    return RolesApiFp().archiveRole(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof RolesApi
*/
export function archiveRole1(id, options) {
    return RolesApiFp().archiveRole1(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof RolesApi
*/
export function copyRole(id, options) {
    return RolesApiFp().copyRole(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof RolesApi
*/
export function copyRole1(id, options) {
    return RolesApiFp().copyRole1(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {CreateRoleData} createRoleData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof RolesApi
*/
export function createRole(createRoleData, options) {
    return RolesApiFp().createRole(createRoleData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {CreateRoleData} createRoleData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof RolesApi
*/
export function createRole1(createRoleData, options) {
    return RolesApiFp().createRole1(createRoleData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof RolesApi
*/
export function getAllPrivileges(options) {
    return RolesApiFp().getAllPrivileges(options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof RolesApi
*/
export function getAllPrivileges1(options) {
    return RolesApiFp().getAllPrivileges1(options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} resource
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof RolesApi
*/
export function getReference(resource, id, options) {
    return RolesApiFp().getReference(resource, id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof RolesApi
*/
export function getRole(id, options) {
    return RolesApiFp().getRole(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof RolesApi
*/
export function getRole1(id, options) {
    return RolesApiFp().getRole1(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof RolesApi
*/
export function getRoles(criteria, page, size, sort, options) {
    return RolesApiFp().getRoles(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {UpdateRoleData} updateRoleData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof RolesApi
*/
export function updateRole(id, updateRoleData, options) {
    return RolesApiFp().updateRole(id, updateRoleData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {UpdateRoleData} updateRoleData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof RolesApi
*/
export function updateRole1(id, updateRoleData, options) {
    return RolesApiFp().updateRole1(id, updateRoleData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof RolesApi
*/
export function archiveRoleRaw(id, options) {
    return RolesApiFp().archiveRole(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof RolesApi
*/
export function archiveRole1Raw(id, options) {
    return RolesApiFp().archiveRole1(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof RolesApi
*/
export function copyRoleRaw(id, options) {
    return RolesApiFp().copyRole(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof RolesApi
*/
export function copyRole1Raw(id, options) {
    return RolesApiFp().copyRole1(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {CreateRoleData} createRoleData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof RolesApi
*/
export function createRoleRaw(createRoleData, options) {
    return RolesApiFp().createRole(createRoleData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {CreateRoleData} createRoleData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof RolesApi
*/
export function createRole1Raw(createRoleData, options) {
    return RolesApiFp().createRole1(createRoleData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof RolesApi
*/
export function getAllPrivilegesRaw(options) {
    return RolesApiFp().getAllPrivileges(options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof RolesApi
*/
export function getAllPrivileges1Raw(options) {
    return RolesApiFp().getAllPrivileges1(options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} resource
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof RolesApi
*/
export function getReferenceRaw(resource, id, options) {
    return RolesApiFp().getReference(resource, id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof RolesApi
*/
export function getRoleRaw(id, options) {
    return RolesApiFp().getRole(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof RolesApi
*/
export function getRole1Raw(id, options) {
    return RolesApiFp().getRole1(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof RolesApi
*/
export function getRolesRaw(criteria, page, size, sort, options) {
    return RolesApiFp().getRoles(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {UpdateRoleData} updateRoleData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof RolesApi
*/
export function updateRoleRaw(id, updateRoleData, options) {
    return RolesApiFp().updateRole(id, updateRoleData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {UpdateRoleData} updateRoleData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof RolesApi
*/
export function updateRole1Raw(id, updateRoleData, options) {
    return RolesApiFp().updateRole1(id, updateRoleData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * RqueueRestControllerApi - axios parameter creator
 * @export
 */
export const RqueueRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {'DAILY' | 'WEEKLY' | 'MONTHLY'} arg0
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aggregateDataCounter: async (arg0, options = {}) => {
            // verify required parameter 'arg0' is not null or undefined
            assertParamExists('aggregateDataCounter', 'arg0', arg0);
            const localVarPath = `/rqueue/api/v1/aggregate-data-selector`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (arg0 !== undefined) {
                localVarQueryParameter['arg0'] = arg0;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {MessageMoveRequest} messageMoveRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dataType: async (messageMoveRequest, options = {}) => {
            // verify required parameter 'messageMoveRequest' is not null or undefined
            assertParamExists('dataType', 'messageMoveRequest', messageMoveRequest);
            const localVarPath = `/rqueue/api/v1/move-data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(messageMoveRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {DataTypeRequest} dataTypeRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dataType1: async (dataTypeRequest, options = {}) => {
            // verify required parameter 'dataTypeRequest' is not null or undefined
            assertParamExists('dataType1', 'dataTypeRequest', dataTypeRequest);
            const localVarPath = `/rqueue/api/v1/data-type`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(dataTypeRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {DataDeleteRequest} dataDeleteRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAll: async (dataDeleteRequest, options = {}) => {
            // verify required parameter 'dataDeleteRequest' is not null or undefined
            assertParamExists('deleteAll', 'dataDeleteRequest', dataDeleteRequest);
            const localVarPath = `/rqueue/api/v1/delete-queue-part`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(dataDeleteRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {MessageDeleteRequest} messageDeleteRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMessage: async (messageDeleteRequest, options = {}) => {
            // verify required parameter 'messageDeleteRequest' is not null or undefined
            assertParamExists('deleteMessage', 'messageDeleteRequest', messageDeleteRequest);
            const localVarPath = `/rqueue/api/v1/delete-message`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(messageDeleteRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {DataTypeRequest} dataTypeRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteQueue: async (dataTypeRequest, options = {}) => {
            // verify required parameter 'dataTypeRequest' is not null or undefined
            assertParamExists('deleteQueue', 'dataTypeRequest', dataTypeRequest);
            const localVarPath = `/rqueue/api/v1/delete-queue`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(dataTypeRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {QueueExploreRequest} queueExploreRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exploreQueue: async (queueExploreRequest, options = {}) => {
            // verify required parameter 'queueExploreRequest' is not null or undefined
            assertParamExists('exploreQueue', 'queueExploreRequest', queueExploreRequest);
            const localVarPath = `/rqueue/api/v1/queue-data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(queueExploreRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ChartDataRequest} chartDataRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardData: async (chartDataRequest, options = {}) => {
            // verify required parameter 'chartDataRequest' is not null or undefined
            assertParamExists('getDashboardData', 'chartDataRequest', chartDataRequest);
            const localVarPath = `/rqueue/api/v1/chart`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(chartDataRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} messageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobs: async (messageId, options = {}) => {
            // verify required parameter 'messageId' is not null or undefined
            assertParamExists('getJobs', 'messageId', messageId);
            const localVarPath = `/rqueue/api/v1/jobs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (messageId !== undefined) {
                localVarQueryParameter['message-id'] = messageId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {PauseUnpauseQueueRequest} pauseUnpauseQueueRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pauseUnpauseQueue: async (pauseUnpauseQueueRequest, options = {}) => {
            // verify required parameter 'pauseUnpauseQueueRequest' is not null or undefined
            assertParamExists('pauseUnpauseQueue', 'pauseUnpauseQueueRequest', pauseUnpauseQueueRequest);
            const localVarPath = `/rqueue/api/v1/pause-unpause-queue`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(pauseUnpauseQueueRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {DateViewRequest} dateViewRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewData: async (dateViewRequest, options = {}) => {
            // verify required parameter 'dateViewRequest' is not null or undefined
            assertParamExists('viewData', 'dateViewRequest', dateViewRequest);
            const localVarPath = `/rqueue/api/v1/view-data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(dateViewRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * RqueueRestControllerApi - functional programming interface
 * @export
 */
export const RqueueRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = RqueueRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {'DAILY' | 'WEEKLY' | 'MONTHLY'} arg0
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async aggregateDataCounter(arg0, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.aggregateDataCounter(arg0, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {MessageMoveRequest} messageMoveRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dataType(messageMoveRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dataType(messageMoveRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {DataTypeRequest} dataTypeRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dataType1(dataTypeRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dataType1(dataTypeRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {DataDeleteRequest} dataDeleteRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAll(dataDeleteRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAll(dataDeleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {MessageDeleteRequest} messageDeleteRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteMessage(messageDeleteRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteMessage(messageDeleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {DataTypeRequest} dataTypeRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteQueue(dataTypeRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteQueue(dataTypeRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {QueueExploreRequest} queueExploreRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exploreQueue(queueExploreRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exploreQueue(queueExploreRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {ChartDataRequest} chartDataRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDashboardData(chartDataRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDashboardData(chartDataRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} messageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getJobs(messageId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getJobs(messageId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {PauseUnpauseQueueRequest} pauseUnpauseQueueRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pauseUnpauseQueue(pauseUnpauseQueueRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pauseUnpauseQueue(pauseUnpauseQueueRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {DateViewRequest} dateViewRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async viewData(dateViewRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.viewData(dateViewRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * RqueueRestControllerApi - factory interface
 * @export
 */
export const RqueueRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = RqueueRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {'DAILY' | 'WEEKLY' | 'MONTHLY'} arg0
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aggregateDataCounter(arg0, options) {
            return localVarFp.aggregateDataCounter(arg0, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {MessageMoveRequest} messageMoveRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dataType(messageMoveRequest, options) {
            return localVarFp.dataType(messageMoveRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DataTypeRequest} dataTypeRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dataType1(dataTypeRequest, options) {
            return localVarFp.dataType1(dataTypeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DataDeleteRequest} dataDeleteRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAll(dataDeleteRequest, options) {
            return localVarFp.deleteAll(dataDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {MessageDeleteRequest} messageDeleteRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMessage(messageDeleteRequest, options) {
            return localVarFp.deleteMessage(messageDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DataTypeRequest} dataTypeRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteQueue(dataTypeRequest, options) {
            return localVarFp.deleteQueue(dataTypeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {QueueExploreRequest} queueExploreRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exploreQueue(queueExploreRequest, options) {
            return localVarFp.exploreQueue(queueExploreRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ChartDataRequest} chartDataRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardData(chartDataRequest, options) {
            return localVarFp.getDashboardData(chartDataRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} messageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobs(messageId, options) {
            return localVarFp.getJobs(messageId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PauseUnpauseQueueRequest} pauseUnpauseQueueRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pauseUnpauseQueue(pauseUnpauseQueueRequest, options) {
            return localVarFp.pauseUnpauseQueue(pauseUnpauseQueueRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DateViewRequest} dateViewRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewData(dateViewRequest, options) {
            return localVarFp.viewData(dateViewRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
        * @param {'DAILY' | 'WEEKLY' | 'MONTHLY'} arg0
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof RqueueRestControllerApi
*/
export function aggregateDataCounter(arg0, options) {
    return RqueueRestControllerApiFp().aggregateDataCounter(arg0, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {MessageMoveRequest} messageMoveRequest
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof RqueueRestControllerApi
*/
export function dataType(messageMoveRequest, options) {
    return RqueueRestControllerApiFp().dataType(messageMoveRequest, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {DataTypeRequest} dataTypeRequest
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof RqueueRestControllerApi
*/
export function dataType1(dataTypeRequest, options) {
    return RqueueRestControllerApiFp().dataType1(dataTypeRequest, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {DataDeleteRequest} dataDeleteRequest
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof RqueueRestControllerApi
*/
export function deleteAll(dataDeleteRequest, options) {
    return RqueueRestControllerApiFp().deleteAll(dataDeleteRequest, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {MessageDeleteRequest} messageDeleteRequest
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof RqueueRestControllerApi
*/
export function deleteMessage(messageDeleteRequest, options) {
    return RqueueRestControllerApiFp().deleteMessage(messageDeleteRequest, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {DataTypeRequest} dataTypeRequest
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof RqueueRestControllerApi
*/
export function deleteQueue(dataTypeRequest, options) {
    return RqueueRestControllerApiFp().deleteQueue(dataTypeRequest, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {QueueExploreRequest} queueExploreRequest
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof RqueueRestControllerApi
*/
export function exploreQueue(queueExploreRequest, options) {
    return RqueueRestControllerApiFp().exploreQueue(queueExploreRequest, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {ChartDataRequest} chartDataRequest
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof RqueueRestControllerApi
*/
export function getDashboardData(chartDataRequest, options) {
    return RqueueRestControllerApiFp().getDashboardData(chartDataRequest, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} messageId
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof RqueueRestControllerApi
*/
export function getJobs(messageId, options) {
    return RqueueRestControllerApiFp().getJobs(messageId, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {PauseUnpauseQueueRequest} pauseUnpauseQueueRequest
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof RqueueRestControllerApi
*/
export function pauseUnpauseQueue(pauseUnpauseQueueRequest, options) {
    return RqueueRestControllerApiFp().pauseUnpauseQueue(pauseUnpauseQueueRequest, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {DateViewRequest} dateViewRequest
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof RqueueRestControllerApi
*/
export function viewData(dateViewRequest, options) {
    return RqueueRestControllerApiFp().viewData(dateViewRequest, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {'DAILY' | 'WEEKLY' | 'MONTHLY'} arg0
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof RqueueRestControllerApi
*/
export function aggregateDataCounterRaw(arg0, options) {
    return RqueueRestControllerApiFp().aggregateDataCounter(arg0, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {MessageMoveRequest} messageMoveRequest
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof RqueueRestControllerApi
*/
export function dataTypeRaw(messageMoveRequest, options) {
    return RqueueRestControllerApiFp().dataType(messageMoveRequest, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {DataTypeRequest} dataTypeRequest
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof RqueueRestControllerApi
*/
export function dataType1Raw(dataTypeRequest, options) {
    return RqueueRestControllerApiFp().dataType1(dataTypeRequest, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {DataDeleteRequest} dataDeleteRequest
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof RqueueRestControllerApi
*/
export function deleteAllRaw(dataDeleteRequest, options) {
    return RqueueRestControllerApiFp().deleteAll(dataDeleteRequest, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {MessageDeleteRequest} messageDeleteRequest
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof RqueueRestControllerApi
*/
export function deleteMessageRaw(messageDeleteRequest, options) {
    return RqueueRestControllerApiFp().deleteMessage(messageDeleteRequest, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {DataTypeRequest} dataTypeRequest
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof RqueueRestControllerApi
*/
export function deleteQueueRaw(dataTypeRequest, options) {
    return RqueueRestControllerApiFp().deleteQueue(dataTypeRequest, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {QueueExploreRequest} queueExploreRequest
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof RqueueRestControllerApi
*/
export function exploreQueueRaw(queueExploreRequest, options) {
    return RqueueRestControllerApiFp().exploreQueue(queueExploreRequest, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {ChartDataRequest} chartDataRequest
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof RqueueRestControllerApi
*/
export function getDashboardDataRaw(chartDataRequest, options) {
    return RqueueRestControllerApiFp().getDashboardData(chartDataRequest, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} messageId
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof RqueueRestControllerApi
*/
export function getJobsRaw(messageId, options) {
    return RqueueRestControllerApiFp().getJobs(messageId, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {PauseUnpauseQueueRequest} pauseUnpauseQueueRequest
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof RqueueRestControllerApi
*/
export function pauseUnpauseQueueRaw(pauseUnpauseQueueRequest, options) {
    return RqueueRestControllerApiFp().pauseUnpauseQueue(pauseUnpauseQueueRequest, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {DateViewRequest} dateViewRequest
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof RqueueRestControllerApi
*/
export function viewDataRaw(dateViewRequest, options) {
    return RqueueRestControllerApiFp().viewData(dateViewRequest, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * SalesLabelTemplatePreferencesApi - axios parameter creator
 * @export
 */
export const SalesLabelTemplatePreferencesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {CreateSalesLabelTemplatePreferenceData} createSalesLabelTemplatePreferenceData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSalesLabelTemplatePreference: async (createSalesLabelTemplatePreferenceData, options = {}) => {
            // verify required parameter 'createSalesLabelTemplatePreferenceData' is not null or undefined
            assertParamExists('createSalesLabelTemplatePreference', 'createSalesLabelTemplatePreferenceData', createSalesLabelTemplatePreferenceData);
            const localVarPath = `/api/sales-label-template-preferences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createSalesLabelTemplatePreferenceData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSalesLabelTemplatePreference: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteSalesLabelTemplatePreference', 'id', id);
            const localVarPath = `/api/sales-label-template-preferences/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalesLabelTemplatePreference: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSalesLabelTemplatePreference', 'id', id);
            const localVarPath = `/api/sales-label-template-preferences/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalesLabelTemplatePreferenceBySalesOrderRow: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSalesLabelTemplatePreferenceBySalesOrderRow', 'id', id);
            const localVarPath = `/api/sales-label-template-preferences/sales-order-row/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalesLabelTemplatePreferences: async (criteria, page, size, sort, options = {}) => {
            const localVarPath = `/api/sales-label-template-preferences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {UpdateSalesLabelTemplatePreferenceData} updateSalesLabelTemplatePreferenceData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSalesLabelTemplatePreference: async (id, updateSalesLabelTemplatePreferenceData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateSalesLabelTemplatePreference', 'id', id);
            // verify required parameter 'updateSalesLabelTemplatePreferenceData' is not null or undefined
            assertParamExists('updateSalesLabelTemplatePreference', 'updateSalesLabelTemplatePreferenceData', updateSalesLabelTemplatePreferenceData);
            const localVarPath = `/api/sales-label-template-preferences/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(updateSalesLabelTemplatePreferenceData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * SalesLabelTemplatePreferencesApi - functional programming interface
 * @export
 */
export const SalesLabelTemplatePreferencesApiFp = function (configuration) {
    const localVarAxiosParamCreator = SalesLabelTemplatePreferencesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {CreateSalesLabelTemplatePreferenceData} createSalesLabelTemplatePreferenceData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSalesLabelTemplatePreference(createSalesLabelTemplatePreferenceData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSalesLabelTemplatePreference(createSalesLabelTemplatePreferenceData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSalesLabelTemplatePreference(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSalesLabelTemplatePreference(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSalesLabelTemplatePreference(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSalesLabelTemplatePreference(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSalesLabelTemplatePreferenceBySalesOrderRow(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSalesLabelTemplatePreferenceBySalesOrderRow(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSalesLabelTemplatePreferences(criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSalesLabelTemplatePreferences(criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {UpdateSalesLabelTemplatePreferenceData} updateSalesLabelTemplatePreferenceData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSalesLabelTemplatePreference(id, updateSalesLabelTemplatePreferenceData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSalesLabelTemplatePreference(id, updateSalesLabelTemplatePreferenceData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * SalesLabelTemplatePreferencesApi - factory interface
 * @export
 */
export const SalesLabelTemplatePreferencesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = SalesLabelTemplatePreferencesApiFp(configuration);
    return {
        /**
         *
         * @param {CreateSalesLabelTemplatePreferenceData} createSalesLabelTemplatePreferenceData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSalesLabelTemplatePreference(createSalesLabelTemplatePreferenceData, options) {
            return localVarFp.createSalesLabelTemplatePreference(createSalesLabelTemplatePreferenceData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSalesLabelTemplatePreference(id, options) {
            return localVarFp.deleteSalesLabelTemplatePreference(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalesLabelTemplatePreference(id, options) {
            return localVarFp.getSalesLabelTemplatePreference(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalesLabelTemplatePreferenceBySalesOrderRow(id, options) {
            return localVarFp.getSalesLabelTemplatePreferenceBySalesOrderRow(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalesLabelTemplatePreferences(criteria, page, size, sort, options) {
            return localVarFp.getSalesLabelTemplatePreferences(criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {UpdateSalesLabelTemplatePreferenceData} updateSalesLabelTemplatePreferenceData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSalesLabelTemplatePreference(id, updateSalesLabelTemplatePreferenceData, options) {
            return localVarFp.updateSalesLabelTemplatePreference(id, updateSalesLabelTemplatePreferenceData, options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
        * @param {CreateSalesLabelTemplatePreferenceData} createSalesLabelTemplatePreferenceData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesLabelTemplatePreferencesApi
*/
export function createSalesLabelTemplatePreference(createSalesLabelTemplatePreferenceData, options) {
    return SalesLabelTemplatePreferencesApiFp().createSalesLabelTemplatePreference(createSalesLabelTemplatePreferenceData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesLabelTemplatePreferencesApi
*/
export function deleteSalesLabelTemplatePreference(id, options) {
    return SalesLabelTemplatePreferencesApiFp().deleteSalesLabelTemplatePreference(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesLabelTemplatePreferencesApi
*/
export function getSalesLabelTemplatePreference(id, options) {
    return SalesLabelTemplatePreferencesApiFp().getSalesLabelTemplatePreference(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesLabelTemplatePreferencesApi
*/
export function getSalesLabelTemplatePreferenceBySalesOrderRow(id, options) {
    return SalesLabelTemplatePreferencesApiFp().getSalesLabelTemplatePreferenceBySalesOrderRow(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesLabelTemplatePreferencesApi
*/
export function getSalesLabelTemplatePreferences(criteria, page, size, sort, options) {
    return SalesLabelTemplatePreferencesApiFp().getSalesLabelTemplatePreferences(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {UpdateSalesLabelTemplatePreferenceData} updateSalesLabelTemplatePreferenceData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesLabelTemplatePreferencesApi
*/
export function updateSalesLabelTemplatePreference(id, updateSalesLabelTemplatePreferenceData, options) {
    return SalesLabelTemplatePreferencesApiFp().updateSalesLabelTemplatePreference(id, updateSalesLabelTemplatePreferenceData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {CreateSalesLabelTemplatePreferenceData} createSalesLabelTemplatePreferenceData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesLabelTemplatePreferencesApi
*/
export function createSalesLabelTemplatePreferenceRaw(createSalesLabelTemplatePreferenceData, options) {
    return SalesLabelTemplatePreferencesApiFp().createSalesLabelTemplatePreference(createSalesLabelTemplatePreferenceData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesLabelTemplatePreferencesApi
*/
export function deleteSalesLabelTemplatePreferenceRaw(id, options) {
    return SalesLabelTemplatePreferencesApiFp().deleteSalesLabelTemplatePreference(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesLabelTemplatePreferencesApi
*/
export function getSalesLabelTemplatePreferenceRaw(id, options) {
    return SalesLabelTemplatePreferencesApiFp().getSalesLabelTemplatePreference(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesLabelTemplatePreferencesApi
*/
export function getSalesLabelTemplatePreferenceBySalesOrderRowRaw(id, options) {
    return SalesLabelTemplatePreferencesApiFp().getSalesLabelTemplatePreferenceBySalesOrderRow(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesLabelTemplatePreferencesApi
*/
export function getSalesLabelTemplatePreferencesRaw(criteria, page, size, sort, options) {
    return SalesLabelTemplatePreferencesApiFp().getSalesLabelTemplatePreferences(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {UpdateSalesLabelTemplatePreferenceData} updateSalesLabelTemplatePreferenceData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesLabelTemplatePreferencesApi
*/
export function updateSalesLabelTemplatePreferenceRaw(id, updateSalesLabelTemplatePreferenceData, options) {
    return SalesLabelTemplatePreferencesApiFp().updateSalesLabelTemplatePreference(id, updateSalesLabelTemplatePreferenceData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * SalesOrderRowReservationForProductionStepApi - axios parameter creator
 * @export
 */
export const SalesOrderRowReservationForProductionStepApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} id
         * @param {CreateResultLotForProductionStepData} createResultLotForProductionStepData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createResultLotForProductionStepWithReservation: async (id, createResultLotForProductionStepData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createResultLotForProductionStepWithReservation', 'id', id);
            // verify required parameter 'createResultLotForProductionStepData' is not null or undefined
            assertParamExists('createResultLotForProductionStepWithReservation', 'createResultLotForProductionStepData', createResultLotForProductionStepData);
            const localVarPath = `/api/sales-order-row-reservation-for-production-step/{id}/create-result-lot`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createResultLotForProductionStepData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResultLotsFromSalesOrderRowReservationForProductionStep: async (id, criteria, page, size, sort, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getResultLotsFromSalesOrderRowReservationForProductionStep', 'id', id);
            const localVarPath = `/api/sales-order-row-reservation-for-production-step/{id}/results`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalesOrderRowReservationForProductionSteps: async (criteria, page, size, sort, options = {}) => {
            const localVarPath = `/api/sales-order-row-reservation-for-production-step`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<UpdateOrderOfSalesOrderRowReservationForProductionStepsData>} updateOrderOfSalesOrderRowReservationForProductionStepsData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateResultLotForProductionStepWithReservationsOrder: async (updateOrderOfSalesOrderRowReservationForProductionStepsData, options = {}) => {
            // verify required parameter 'updateOrderOfSalesOrderRowReservationForProductionStepsData' is not null or undefined
            assertParamExists('updateResultLotForProductionStepWithReservationsOrder', 'updateOrderOfSalesOrderRowReservationForProductionStepsData', updateOrderOfSalesOrderRowReservationForProductionStepsData);
            const localVarPath = `/api/sales-order-row-reservation-for-production-step/update-order`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(updateOrderOfSalesOrderRowReservationForProductionStepsData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * SalesOrderRowReservationForProductionStepApi - functional programming interface
 * @export
 */
export const SalesOrderRowReservationForProductionStepApiFp = function (configuration) {
    const localVarAxiosParamCreator = SalesOrderRowReservationForProductionStepApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {CreateResultLotForProductionStepData} createResultLotForProductionStepData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createResultLotForProductionStepWithReservation(id, createResultLotForProductionStepData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createResultLotForProductionStepWithReservation(id, createResultLotForProductionStepData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getResultLotsFromSalesOrderRowReservationForProductionStep(id, criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getResultLotsFromSalesOrderRowReservationForProductionStep(id, criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSalesOrderRowReservationForProductionSteps(criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSalesOrderRowReservationForProductionSteps(criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {Array<UpdateOrderOfSalesOrderRowReservationForProductionStepsData>} updateOrderOfSalesOrderRowReservationForProductionStepsData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateResultLotForProductionStepWithReservationsOrder(updateOrderOfSalesOrderRowReservationForProductionStepsData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateResultLotForProductionStepWithReservationsOrder(updateOrderOfSalesOrderRowReservationForProductionStepsData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * SalesOrderRowReservationForProductionStepApi - factory interface
 * @export
 */
export const SalesOrderRowReservationForProductionStepApiFactory = function (configuration, basePath, axios) {
    const localVarFp = SalesOrderRowReservationForProductionStepApiFp(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {CreateResultLotForProductionStepData} createResultLotForProductionStepData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createResultLotForProductionStepWithReservation(id, createResultLotForProductionStepData, options) {
            return localVarFp.createResultLotForProductionStepWithReservation(id, createResultLotForProductionStepData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResultLotsFromSalesOrderRowReservationForProductionStep(id, criteria, page, size, sort, options) {
            return localVarFp.getResultLotsFromSalesOrderRowReservationForProductionStep(id, criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalesOrderRowReservationForProductionSteps(criteria, page, size, sort, options) {
            return localVarFp.getSalesOrderRowReservationForProductionSteps(criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<UpdateOrderOfSalesOrderRowReservationForProductionStepsData>} updateOrderOfSalesOrderRowReservationForProductionStepsData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateResultLotForProductionStepWithReservationsOrder(updateOrderOfSalesOrderRowReservationForProductionStepsData, options) {
            return localVarFp.updateResultLotForProductionStepWithReservationsOrder(updateOrderOfSalesOrderRowReservationForProductionStepsData, options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
        * @param {string} id
        * @param {CreateResultLotForProductionStepData} createResultLotForProductionStepData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrderRowReservationForProductionStepApi
*/
export function createResultLotForProductionStepWithReservation(id, createResultLotForProductionStepData, options) {
    return SalesOrderRowReservationForProductionStepApiFp().createResultLotForProductionStepWithReservation(id, createResultLotForProductionStepData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrderRowReservationForProductionStepApi
*/
export function getResultLotsFromSalesOrderRowReservationForProductionStep(id, criteria, page, size, sort, options) {
    return SalesOrderRowReservationForProductionStepApiFp().getResultLotsFromSalesOrderRowReservationForProductionStep(id, criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrderRowReservationForProductionStepApi
*/
export function getSalesOrderRowReservationForProductionSteps(criteria, page, size, sort, options) {
    return SalesOrderRowReservationForProductionStepApiFp().getSalesOrderRowReservationForProductionSteps(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {Array<UpdateOrderOfSalesOrderRowReservationForProductionStepsData>} updateOrderOfSalesOrderRowReservationForProductionStepsData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrderRowReservationForProductionStepApi
*/
export function updateResultLotForProductionStepWithReservationsOrder(updateOrderOfSalesOrderRowReservationForProductionStepsData, options) {
    return SalesOrderRowReservationForProductionStepApiFp().updateResultLotForProductionStepWithReservationsOrder(updateOrderOfSalesOrderRowReservationForProductionStepsData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {CreateResultLotForProductionStepData} createResultLotForProductionStepData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrderRowReservationForProductionStepApi
*/
export function createResultLotForProductionStepWithReservationRaw(id, createResultLotForProductionStepData, options) {
    return SalesOrderRowReservationForProductionStepApiFp().createResultLotForProductionStepWithReservation(id, createResultLotForProductionStepData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrderRowReservationForProductionStepApi
*/
export function getResultLotsFromSalesOrderRowReservationForProductionStepRaw(id, criteria, page, size, sort, options) {
    return SalesOrderRowReservationForProductionStepApiFp().getResultLotsFromSalesOrderRowReservationForProductionStep(id, criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrderRowReservationForProductionStepApi
*/
export function getSalesOrderRowReservationForProductionStepsRaw(criteria, page, size, sort, options) {
    return SalesOrderRowReservationForProductionStepApiFp().getSalesOrderRowReservationForProductionSteps(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {Array<UpdateOrderOfSalesOrderRowReservationForProductionStepsData>} updateOrderOfSalesOrderRowReservationForProductionStepsData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrderRowReservationForProductionStepApi
*/
export function updateResultLotForProductionStepWithReservationsOrderRaw(updateOrderOfSalesOrderRowReservationForProductionStepsData, options) {
    return SalesOrderRowReservationForProductionStepApiFp().updateResultLotForProductionStepWithReservationsOrder(updateOrderOfSalesOrderRowReservationForProductionStepsData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * SalesOrderRowTemplatesApi - axios parameter creator
 * @export
 */
export const SalesOrderRowTemplatesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} id
         * @param {CreateSalesOrderRowTemplateData} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSalesOrderRowTemplate: async (id, data, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createSalesOrderRowTemplate', 'id', id);
            // verify required parameter 'data' is not null or undefined
            assertParamExists('createSalesOrderRowTemplate', 'data', data);
            const localVarPath = `/api/sales-order-template/{id}/rows`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (data !== undefined) {
                localVarFormParams.append('data', new Blob([JSON.stringify(data)], { type: "application/json", }));
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSalesOrderRowTemplate: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteSalesOrderRowTemplate', 'id', id);
            const localVarPath = `/api/sales-order-row-templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRowsForSalesOrderTemplate: async (id, criteria, page, size, sort, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getRowsForSalesOrderTemplate', 'id', id);
            const localVarPath = `/api/sales-order-template/{id}/rows`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalesOrderRowTemplate: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSalesOrderRowTemplate', 'id', id);
            const localVarPath = `/api/sales-order-row-templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalesOrderRowTemplates: async (criteria, page, size, sort, options = {}) => {
            const localVarPath = `/api/sales-order-row-templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {UpdateSalesOrderRowTemplateData} updateSalesOrderRowTemplateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSalesOrderRowTemplate: async (id, updateSalesOrderRowTemplateData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateSalesOrderRowTemplate', 'id', id);
            // verify required parameter 'updateSalesOrderRowTemplateData' is not null or undefined
            assertParamExists('updateSalesOrderRowTemplate', 'updateSalesOrderRowTemplateData', updateSalesOrderRowTemplateData);
            const localVarPath = `/api/sales-order-row-templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(updateSalesOrderRowTemplateData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * SalesOrderRowTemplatesApi - functional programming interface
 * @export
 */
export const SalesOrderRowTemplatesApiFp = function (configuration) {
    const localVarAxiosParamCreator = SalesOrderRowTemplatesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {CreateSalesOrderRowTemplateData} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSalesOrderRowTemplate(id, data, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSalesOrderRowTemplate(id, data, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSalesOrderRowTemplate(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSalesOrderRowTemplate(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRowsForSalesOrderTemplate(id, criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRowsForSalesOrderTemplate(id, criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSalesOrderRowTemplate(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSalesOrderRowTemplate(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSalesOrderRowTemplates(criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSalesOrderRowTemplates(criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {UpdateSalesOrderRowTemplateData} updateSalesOrderRowTemplateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSalesOrderRowTemplate(id, updateSalesOrderRowTemplateData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSalesOrderRowTemplate(id, updateSalesOrderRowTemplateData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * SalesOrderRowTemplatesApi - factory interface
 * @export
 */
export const SalesOrderRowTemplatesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = SalesOrderRowTemplatesApiFp(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {CreateSalesOrderRowTemplateData} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSalesOrderRowTemplate(id, data, options) {
            return localVarFp.createSalesOrderRowTemplate(id, data, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSalesOrderRowTemplate(id, options) {
            return localVarFp.deleteSalesOrderRowTemplate(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRowsForSalesOrderTemplate(id, criteria, page, size, sort, options) {
            return localVarFp.getRowsForSalesOrderTemplate(id, criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalesOrderRowTemplate(id, options) {
            return localVarFp.getSalesOrderRowTemplate(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalesOrderRowTemplates(criteria, page, size, sort, options) {
            return localVarFp.getSalesOrderRowTemplates(criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {UpdateSalesOrderRowTemplateData} updateSalesOrderRowTemplateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSalesOrderRowTemplate(id, updateSalesOrderRowTemplateData, options) {
            return localVarFp.updateSalesOrderRowTemplate(id, updateSalesOrderRowTemplateData, options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
        * @param {string} id
        * @param {CreateSalesOrderRowTemplateData} data
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrderRowTemplatesApi
*/
export function createSalesOrderRowTemplate(id, data, options) {
    return SalesOrderRowTemplatesApiFp().createSalesOrderRowTemplate(id, data, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrderRowTemplatesApi
*/
export function deleteSalesOrderRowTemplate(id, options) {
    return SalesOrderRowTemplatesApiFp().deleteSalesOrderRowTemplate(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrderRowTemplatesApi
*/
export function getRowsForSalesOrderTemplate(id, criteria, page, size, sort, options) {
    return SalesOrderRowTemplatesApiFp().getRowsForSalesOrderTemplate(id, criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrderRowTemplatesApi
*/
export function getSalesOrderRowTemplate(id, options) {
    return SalesOrderRowTemplatesApiFp().getSalesOrderRowTemplate(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrderRowTemplatesApi
*/
export function getSalesOrderRowTemplates(criteria, page, size, sort, options) {
    return SalesOrderRowTemplatesApiFp().getSalesOrderRowTemplates(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {UpdateSalesOrderRowTemplateData} updateSalesOrderRowTemplateData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrderRowTemplatesApi
*/
export function updateSalesOrderRowTemplate(id, updateSalesOrderRowTemplateData, options) {
    return SalesOrderRowTemplatesApiFp().updateSalesOrderRowTemplate(id, updateSalesOrderRowTemplateData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {CreateSalesOrderRowTemplateData} data
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrderRowTemplatesApi
*/
export function createSalesOrderRowTemplateRaw(id, data, options) {
    return SalesOrderRowTemplatesApiFp().createSalesOrderRowTemplate(id, data, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrderRowTemplatesApi
*/
export function deleteSalesOrderRowTemplateRaw(id, options) {
    return SalesOrderRowTemplatesApiFp().deleteSalesOrderRowTemplate(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrderRowTemplatesApi
*/
export function getRowsForSalesOrderTemplateRaw(id, criteria, page, size, sort, options) {
    return SalesOrderRowTemplatesApiFp().getRowsForSalesOrderTemplate(id, criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrderRowTemplatesApi
*/
export function getSalesOrderRowTemplateRaw(id, options) {
    return SalesOrderRowTemplatesApiFp().getSalesOrderRowTemplate(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrderRowTemplatesApi
*/
export function getSalesOrderRowTemplatesRaw(criteria, page, size, sort, options) {
    return SalesOrderRowTemplatesApiFp().getSalesOrderRowTemplates(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {UpdateSalesOrderRowTemplateData} updateSalesOrderRowTemplateData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrderRowTemplatesApi
*/
export function updateSalesOrderRowTemplateRaw(id, updateSalesOrderRowTemplateData, options) {
    return SalesOrderRowTemplatesApiFp().updateSalesOrderRowTemplate(id, updateSalesOrderRowTemplateData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * SalesOrderRowWeightsApi - axios parameter creator
 * @export
 */
export const SalesOrderRowWeightsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} lotNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalesOrderRowWeightByLotNumber: async (lotNumber, options = {}) => {
            // verify required parameter 'lotNumber' is not null or undefined
            assertParamExists('getSalesOrderRowWeightByLotNumber', 'lotNumber', lotNumber);
            const localVarPath = `/api/sales-order-row-weights/lot-number/{lotNumber}`
                .replace(`{${"lotNumber"}}`, encodeURIComponent(String(lotNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalesOrderRowWeightBySalesOrder: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSalesOrderRowWeightBySalesOrder', 'id', id);
            const localVarPath = `/api/sales-order-row-weights/sales-order/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalesOrderRowWeights: async (criteria, page, size, sort, options = {}) => {
            const localVarPath = `/api/sales-order-row-weights`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * SalesOrderRowWeightsApi - functional programming interface
 * @export
 */
export const SalesOrderRowWeightsApiFp = function (configuration) {
    const localVarAxiosParamCreator = SalesOrderRowWeightsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} lotNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSalesOrderRowWeightByLotNumber(lotNumber, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSalesOrderRowWeightByLotNumber(lotNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSalesOrderRowWeightBySalesOrder(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSalesOrderRowWeightBySalesOrder(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSalesOrderRowWeights(criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSalesOrderRowWeights(criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * SalesOrderRowWeightsApi - factory interface
 * @export
 */
export const SalesOrderRowWeightsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = SalesOrderRowWeightsApiFp(configuration);
    return {
        /**
         *
         * @param {string} lotNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalesOrderRowWeightByLotNumber(lotNumber, options) {
            return localVarFp.getSalesOrderRowWeightByLotNumber(lotNumber, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalesOrderRowWeightBySalesOrder(id, options) {
            return localVarFp.getSalesOrderRowWeightBySalesOrder(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalesOrderRowWeights(criteria, page, size, sort, options) {
            return localVarFp.getSalesOrderRowWeights(criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
        * @param {string} lotNumber
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrderRowWeightsApi
*/
export function getSalesOrderRowWeightByLotNumber(lotNumber, options) {
    return SalesOrderRowWeightsApiFp().getSalesOrderRowWeightByLotNumber(lotNumber, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrderRowWeightsApi
*/
export function getSalesOrderRowWeightBySalesOrder(id, options) {
    return SalesOrderRowWeightsApiFp().getSalesOrderRowWeightBySalesOrder(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrderRowWeightsApi
*/
export function getSalesOrderRowWeights(criteria, page, size, sort, options) {
    return SalesOrderRowWeightsApiFp().getSalesOrderRowWeights(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} lotNumber
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrderRowWeightsApi
*/
export function getSalesOrderRowWeightByLotNumberRaw(lotNumber, options) {
    return SalesOrderRowWeightsApiFp().getSalesOrderRowWeightByLotNumber(lotNumber, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrderRowWeightsApi
*/
export function getSalesOrderRowWeightBySalesOrderRaw(id, options) {
    return SalesOrderRowWeightsApiFp().getSalesOrderRowWeightBySalesOrder(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrderRowWeightsApi
*/
export function getSalesOrderRowWeightsRaw(criteria, page, size, sort, options) {
    return SalesOrderRowWeightsApiFp().getSalesOrderRowWeights(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * SalesOrderRowsApi - axios parameter creator
 * @export
 */
export const SalesOrderRowsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} id
         * @param {CloseSalesOrderRowData} closeSalesOrderRowData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        closeSalesOrderRow: async (id, closeSalesOrderRowData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('closeSalesOrderRow', 'id', id);
            // verify required parameter 'closeSalesOrderRowData' is not null or undefined
            assertParamExists('closeSalesOrderRow', 'closeSalesOrderRowData', closeSalesOrderRowData);
            const localVarPath = `/api/sales-order-rows/close/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(closeSalesOrderRowData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {Array<ConnectWeightsToLotsData>} connectWeightsToLotsData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectLotWeightsToSalesOrderRow: async (id, connectWeightsToLotsData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('connectLotWeightsToSalesOrderRow', 'id', id);
            // verify required parameter 'connectWeightsToLotsData' is not null or undefined
            assertParamExists('connectLotWeightsToSalesOrderRow', 'connectWeightsToLotsData', connectWeightsToLotsData);
            const localVarPath = `/api/sales-order-row/{id}/connect-weights-to-lot`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(connectWeightsToLotsData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {CreateOutcomeLotData} createOutcomeLotData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOutcomeLot: async (id, createOutcomeLotData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createOutcomeLot', 'id', id);
            // verify required parameter 'createOutcomeLotData' is not null or undefined
            assertParamExists('createOutcomeLot', 'createOutcomeLotData', createOutcomeLotData);
            const localVarPath = `/api/sales-order-row/{id}/outcome-lots`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createOutcomeLotData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOutcomeLotForOrderRowBasedOnReservation: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createOutcomeLotForOrderRowBasedOnReservation', 'id', id);
            const localVarPath = `/api/sales-order-row/{id}/outcome-lots-based-on-reservation`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {CreateSalesOrderRowData} data
         * @param {Array<File>} [files]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSalesOrderRow: async (id, data, files, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createSalesOrderRow', 'id', id);
            // verify required parameter 'data' is not null or undefined
            assertParamExists('createSalesOrderRow', 'data', data);
            const localVarPath = `/api/sales-order/{id}/rows`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (data !== undefined) {
                localVarFormParams.append('data', new Blob([JSON.stringify(data)], { type: "application/json", }));
            }
            if (files) {
                files.forEach((element) => {
                    localVarFormParams.append('files', element);
                });
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} salesOrderRowId
         * @param {string} outcomeLotId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOutcomeLot1: async (salesOrderRowId, outcomeLotId, options = {}) => {
            // verify required parameter 'salesOrderRowId' is not null or undefined
            assertParamExists('deleteOutcomeLot1', 'salesOrderRowId', salesOrderRowId);
            // verify required parameter 'outcomeLotId' is not null or undefined
            assertParamExists('deleteOutcomeLot1', 'outcomeLotId', outcomeLotId);
            const localVarPath = `/api/sales-order-row/{salesOrderRowId}/outcome-lots/{outcomeLotId}`
                .replace(`{${"salesOrderRowId"}}`, encodeURIComponent(String(salesOrderRowId)))
                .replace(`{${"outcomeLotId"}}`, encodeURIComponent(String(outcomeLotId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSalesOrderRow: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteSalesOrderRow', 'id', id);
            const localVarPath = `/api/sales-order-rows/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSalesOrderRow1: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteSalesOrderRow1', 'id', id);
            const localVarPath = `/api/sales-order-template/{orderId}/rows/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSalesOrderRow2: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteSalesOrderRow2', 'id', id);
            const localVarPath = `/api/sales-order/{orderId}/rows/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSalesOrderRow3: async (options = {}) => {
            const localVarPath = `/api/sales-order-template/{orderId}`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [criteria]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOutcomeLotTotalsForSalesOrderRow: async (criteria, options = {}) => {
            const localVarPath = `/api/sales-order-row/{id}/outcome-lot-totals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOutcomeLotsForSalesOrderRow: async (id, criteria, page, size, sort, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getOutcomeLotsForSalesOrderRow', 'id', id);
            const localVarPath = `/api/sales-order-row/{id}/outcome-lots`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [criteria]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecentSalesPrices: async (criteria, options = {}) => {
            const localVarPath = `/api/recent-sales-prices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReservationsForSalesOrderRow: async (id, criteria, page, size, sort, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getReservationsForSalesOrderRow', 'id', id);
            const localVarPath = `/api/sales-order-row/{id}/reservations`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRowsForSalesOrder: async (id, criteria, page, size, sort, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getRowsForSalesOrder', 'id', id);
            const localVarPath = `/api/sales-order/{id}/rows`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalesOrderRow: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSalesOrderRow', 'id', id);
            const localVarPath = `/api/sales-order-rows/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [criteria]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalesOrderRowTotals: async (criteria, options = {}) => {
            const localVarPath = `/api/sales-order-rows/totals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalesOrderRows: async (criteria, page, size, sort, options = {}) => {
            const localVarPath = `/api/sales-order-rows`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {PreviewSalesOrderRowPrintJobData} previewSalesOrderRowPrintJobData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewPrintJob: async (previewSalesOrderRowPrintJobData, options = {}) => {
            // verify required parameter 'previewSalesOrderRowPrintJobData' is not null or undefined
            assertParamExists('previewPrintJob', 'previewSalesOrderRowPrintJobData', previewSalesOrderRowPrintJobData);
            const localVarPath = `/api/preview-print-label`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(previewSalesOrderRowPrintJobData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {PrintSalesOrderRowLabelData} printSalesOrderRowLabelData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        printSalesOrderRowLabel: async (id, printSalesOrderRowLabelData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('printSalesOrderRowLabel', 'id', id);
            // verify required parameter 'printSalesOrderRowLabelData' is not null or undefined
            assertParamExists('printSalesOrderRowLabel', 'printSalesOrderRowLabelData', printSalesOrderRowLabelData);
            const localVarPath = `/api/sales-order-rows/{id}/print-label`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(printSalesOrderRowLabelData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {UpdateSalesOrderRowData} data
         * @param {Array<File>} [files]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSalesOrderRow: async (id, data, files, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateSalesOrderRow', 'id', id);
            // verify required parameter 'data' is not null or undefined
            assertParamExists('updateSalesOrderRow', 'data', data);
            const localVarPath = `/api/sales-order-rows/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (data !== undefined) {
                localVarFormParams.append('data', new Blob([JSON.stringify(data)], { type: "application/json", }));
            }
            if (files) {
                files.forEach((element) => {
                    localVarFormParams.append('files', element);
                });
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {UpdateSalesOrderRowStatusData} updateSalesOrderRowStatusData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSalesOrderRowStatus: async (id, updateSalesOrderRowStatusData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateSalesOrderRowStatus', 'id', id);
            // verify required parameter 'updateSalesOrderRowStatusData' is not null or undefined
            assertParamExists('updateSalesOrderRowStatus', 'updateSalesOrderRowStatusData', updateSalesOrderRowStatusData);
            const localVarPath = `/api/sales-order-rows/{id}/status`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(updateSalesOrderRowStatusData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * SalesOrderRowsApi - functional programming interface
 * @export
 */
export const SalesOrderRowsApiFp = function (configuration) {
    const localVarAxiosParamCreator = SalesOrderRowsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {CloseSalesOrderRowData} closeSalesOrderRowData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async closeSalesOrderRow(id, closeSalesOrderRowData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.closeSalesOrderRow(id, closeSalesOrderRowData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {Array<ConnectWeightsToLotsData>} connectWeightsToLotsData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async connectLotWeightsToSalesOrderRow(id, connectWeightsToLotsData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.connectLotWeightsToSalesOrderRow(id, connectWeightsToLotsData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {CreateOutcomeLotData} createOutcomeLotData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOutcomeLot(id, createOutcomeLotData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOutcomeLot(id, createOutcomeLotData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOutcomeLotForOrderRowBasedOnReservation(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOutcomeLotForOrderRowBasedOnReservation(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {CreateSalesOrderRowData} data
         * @param {Array<File>} [files]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSalesOrderRow(id, data, files, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSalesOrderRow(id, data, files, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} salesOrderRowId
         * @param {string} outcomeLotId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOutcomeLot1(salesOrderRowId, outcomeLotId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOutcomeLot1(salesOrderRowId, outcomeLotId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSalesOrderRow(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSalesOrderRow(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSalesOrderRow1(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSalesOrderRow1(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSalesOrderRow2(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSalesOrderRow2(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSalesOrderRow3(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSalesOrderRow3(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} [criteria]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOutcomeLotTotalsForSalesOrderRow(criteria, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOutcomeLotTotalsForSalesOrderRow(criteria, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOutcomeLotsForSalesOrderRow(id, criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOutcomeLotsForSalesOrderRow(id, criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} [criteria]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRecentSalesPrices(criteria, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRecentSalesPrices(criteria, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReservationsForSalesOrderRow(id, criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReservationsForSalesOrderRow(id, criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRowsForSalesOrder(id, criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRowsForSalesOrder(id, criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSalesOrderRow(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSalesOrderRow(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} [criteria]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSalesOrderRowTotals(criteria, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSalesOrderRowTotals(criteria, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSalesOrderRows(criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSalesOrderRows(criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {PreviewSalesOrderRowPrintJobData} previewSalesOrderRowPrintJobData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async previewPrintJob(previewSalesOrderRowPrintJobData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.previewPrintJob(previewSalesOrderRowPrintJobData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {PrintSalesOrderRowLabelData} printSalesOrderRowLabelData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async printSalesOrderRowLabel(id, printSalesOrderRowLabelData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.printSalesOrderRowLabel(id, printSalesOrderRowLabelData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {UpdateSalesOrderRowData} data
         * @param {Array<File>} [files]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSalesOrderRow(id, data, files, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSalesOrderRow(id, data, files, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {UpdateSalesOrderRowStatusData} updateSalesOrderRowStatusData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSalesOrderRowStatus(id, updateSalesOrderRowStatusData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSalesOrderRowStatus(id, updateSalesOrderRowStatusData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * SalesOrderRowsApi - factory interface
 * @export
 */
export const SalesOrderRowsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = SalesOrderRowsApiFp(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {CloseSalesOrderRowData} closeSalesOrderRowData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        closeSalesOrderRow(id, closeSalesOrderRowData, options) {
            return localVarFp.closeSalesOrderRow(id, closeSalesOrderRowData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {Array<ConnectWeightsToLotsData>} connectWeightsToLotsData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectLotWeightsToSalesOrderRow(id, connectWeightsToLotsData, options) {
            return localVarFp.connectLotWeightsToSalesOrderRow(id, connectWeightsToLotsData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {CreateOutcomeLotData} createOutcomeLotData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOutcomeLot(id, createOutcomeLotData, options) {
            return localVarFp.createOutcomeLot(id, createOutcomeLotData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOutcomeLotForOrderRowBasedOnReservation(id, options) {
            return localVarFp.createOutcomeLotForOrderRowBasedOnReservation(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {CreateSalesOrderRowData} data
         * @param {Array<File>} [files]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSalesOrderRow(id, data, files, options) {
            return localVarFp.createSalesOrderRow(id, data, files, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} salesOrderRowId
         * @param {string} outcomeLotId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOutcomeLot1(salesOrderRowId, outcomeLotId, options) {
            return localVarFp.deleteOutcomeLot1(salesOrderRowId, outcomeLotId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSalesOrderRow(id, options) {
            return localVarFp.deleteSalesOrderRow(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSalesOrderRow1(id, options) {
            return localVarFp.deleteSalesOrderRow1(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSalesOrderRow2(id, options) {
            return localVarFp.deleteSalesOrderRow2(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSalesOrderRow3(options) {
            return localVarFp.deleteSalesOrderRow3(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [criteria]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOutcomeLotTotalsForSalesOrderRow(criteria, options) {
            return localVarFp.getOutcomeLotTotalsForSalesOrderRow(criteria, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOutcomeLotsForSalesOrderRow(id, criteria, page, size, sort, options) {
            return localVarFp.getOutcomeLotsForSalesOrderRow(id, criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [criteria]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecentSalesPrices(criteria, options) {
            return localVarFp.getRecentSalesPrices(criteria, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReservationsForSalesOrderRow(id, criteria, page, size, sort, options) {
            return localVarFp.getReservationsForSalesOrderRow(id, criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRowsForSalesOrder(id, criteria, page, size, sort, options) {
            return localVarFp.getRowsForSalesOrder(id, criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalesOrderRow(id, options) {
            return localVarFp.getSalesOrderRow(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [criteria]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalesOrderRowTotals(criteria, options) {
            return localVarFp.getSalesOrderRowTotals(criteria, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalesOrderRows(criteria, page, size, sort, options) {
            return localVarFp.getSalesOrderRows(criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PreviewSalesOrderRowPrintJobData} previewSalesOrderRowPrintJobData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewPrintJob(previewSalesOrderRowPrintJobData, options) {
            return localVarFp.previewPrintJob(previewSalesOrderRowPrintJobData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {PrintSalesOrderRowLabelData} printSalesOrderRowLabelData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        printSalesOrderRowLabel(id, printSalesOrderRowLabelData, options) {
            return localVarFp.printSalesOrderRowLabel(id, printSalesOrderRowLabelData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {UpdateSalesOrderRowData} data
         * @param {Array<File>} [files]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSalesOrderRow(id, data, files, options) {
            return localVarFp.updateSalesOrderRow(id, data, files, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {UpdateSalesOrderRowStatusData} updateSalesOrderRowStatusData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSalesOrderRowStatus(id, updateSalesOrderRowStatusData, options) {
            return localVarFp.updateSalesOrderRowStatus(id, updateSalesOrderRowStatusData, options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
        * @param {string} id
        * @param {CloseSalesOrderRowData} closeSalesOrderRowData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrderRowsApi
*/
export function closeSalesOrderRow(id, closeSalesOrderRowData, options) {
    return SalesOrderRowsApiFp().closeSalesOrderRow(id, closeSalesOrderRowData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {Array<ConnectWeightsToLotsData>} connectWeightsToLotsData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrderRowsApi
*/
export function connectLotWeightsToSalesOrderRow(id, connectWeightsToLotsData, options) {
    return SalesOrderRowsApiFp().connectLotWeightsToSalesOrderRow(id, connectWeightsToLotsData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {CreateOutcomeLotData} createOutcomeLotData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrderRowsApi
*/
export function createOutcomeLot(id, createOutcomeLotData, options) {
    return SalesOrderRowsApiFp().createOutcomeLot(id, createOutcomeLotData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrderRowsApi
*/
export function createOutcomeLotForOrderRowBasedOnReservation(id, options) {
    return SalesOrderRowsApiFp().createOutcomeLotForOrderRowBasedOnReservation(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {CreateSalesOrderRowData} data
        * @param {Array<File>} [files]
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrderRowsApi
*/
export function createSalesOrderRow(id, data, files, options) {
    return SalesOrderRowsApiFp().createSalesOrderRow(id, data, files, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} salesOrderRowId
        * @param {string} outcomeLotId
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrderRowsApi
*/
export function deleteOutcomeLot1(salesOrderRowId, outcomeLotId, options) {
    return SalesOrderRowsApiFp().deleteOutcomeLot1(salesOrderRowId, outcomeLotId, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrderRowsApi
*/
export function deleteSalesOrderRow(id, options) {
    return SalesOrderRowsApiFp().deleteSalesOrderRow(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrderRowsApi
*/
export function deleteSalesOrderRow1(id, options) {
    return SalesOrderRowsApiFp().deleteSalesOrderRow1(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrderRowsApi
*/
export function deleteSalesOrderRow2(id, options) {
    return SalesOrderRowsApiFp().deleteSalesOrderRow2(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrderRowsApi
*/
export function deleteSalesOrderRow3(options) {
    return SalesOrderRowsApiFp().deleteSalesOrderRow3(options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} [criteria]
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrderRowsApi
*/
export function getOutcomeLotTotalsForSalesOrderRow(criteria, options) {
    return SalesOrderRowsApiFp().getOutcomeLotTotalsForSalesOrderRow(criteria, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrderRowsApi
*/
export function getOutcomeLotsForSalesOrderRow(id, criteria, page, size, sort, options) {
    return SalesOrderRowsApiFp().getOutcomeLotsForSalesOrderRow(id, criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} [criteria]
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrderRowsApi
*/
export function getRecentSalesPrices(criteria, options) {
    return SalesOrderRowsApiFp().getRecentSalesPrices(criteria, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrderRowsApi
*/
export function getReservationsForSalesOrderRow(id, criteria, page, size, sort, options) {
    return SalesOrderRowsApiFp().getReservationsForSalesOrderRow(id, criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrderRowsApi
*/
export function getRowsForSalesOrder(id, criteria, page, size, sort, options) {
    return SalesOrderRowsApiFp().getRowsForSalesOrder(id, criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrderRowsApi
*/
export function getSalesOrderRow(id, options) {
    return SalesOrderRowsApiFp().getSalesOrderRow(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} [criteria]
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrderRowsApi
*/
export function getSalesOrderRowTotals(criteria, options) {
    return SalesOrderRowsApiFp().getSalesOrderRowTotals(criteria, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrderRowsApi
*/
export function getSalesOrderRows(criteria, page, size, sort, options) {
    return SalesOrderRowsApiFp().getSalesOrderRows(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {PreviewSalesOrderRowPrintJobData} previewSalesOrderRowPrintJobData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrderRowsApi
*/
export function previewPrintJob(previewSalesOrderRowPrintJobData, options) {
    return SalesOrderRowsApiFp().previewPrintJob(previewSalesOrderRowPrintJobData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {PrintSalesOrderRowLabelData} printSalesOrderRowLabelData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrderRowsApi
*/
export function printSalesOrderRowLabel(id, printSalesOrderRowLabelData, options) {
    return SalesOrderRowsApiFp().printSalesOrderRowLabel(id, printSalesOrderRowLabelData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {UpdateSalesOrderRowData} data
        * @param {Array<File>} [files]
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrderRowsApi
*/
export function updateSalesOrderRow(id, data, files, options) {
    return SalesOrderRowsApiFp().updateSalesOrderRow(id, data, files, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {UpdateSalesOrderRowStatusData} updateSalesOrderRowStatusData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrderRowsApi
*/
export function updateSalesOrderRowStatus(id, updateSalesOrderRowStatusData, options) {
    return SalesOrderRowsApiFp().updateSalesOrderRowStatus(id, updateSalesOrderRowStatusData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {CloseSalesOrderRowData} closeSalesOrderRowData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrderRowsApi
*/
export function closeSalesOrderRowRaw(id, closeSalesOrderRowData, options) {
    return SalesOrderRowsApiFp().closeSalesOrderRow(id, closeSalesOrderRowData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {Array<ConnectWeightsToLotsData>} connectWeightsToLotsData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrderRowsApi
*/
export function connectLotWeightsToSalesOrderRowRaw(id, connectWeightsToLotsData, options) {
    return SalesOrderRowsApiFp().connectLotWeightsToSalesOrderRow(id, connectWeightsToLotsData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {CreateOutcomeLotData} createOutcomeLotData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrderRowsApi
*/
export function createOutcomeLotRaw(id, createOutcomeLotData, options) {
    return SalesOrderRowsApiFp().createOutcomeLot(id, createOutcomeLotData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrderRowsApi
*/
export function createOutcomeLotForOrderRowBasedOnReservationRaw(id, options) {
    return SalesOrderRowsApiFp().createOutcomeLotForOrderRowBasedOnReservation(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {CreateSalesOrderRowData} data
        * @param {Array<File>} [files]
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrderRowsApi
*/
export function createSalesOrderRowRaw(id, data, files, options) {
    return SalesOrderRowsApiFp().createSalesOrderRow(id, data, files, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} salesOrderRowId
        * @param {string} outcomeLotId
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrderRowsApi
*/
export function deleteOutcomeLot1Raw(salesOrderRowId, outcomeLotId, options) {
    return SalesOrderRowsApiFp().deleteOutcomeLot1(salesOrderRowId, outcomeLotId, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrderRowsApi
*/
export function deleteSalesOrderRowRaw(id, options) {
    return SalesOrderRowsApiFp().deleteSalesOrderRow(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrderRowsApi
*/
export function deleteSalesOrderRow1Raw(id, options) {
    return SalesOrderRowsApiFp().deleteSalesOrderRow1(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrderRowsApi
*/
export function deleteSalesOrderRow2Raw(id, options) {
    return SalesOrderRowsApiFp().deleteSalesOrderRow2(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrderRowsApi
*/
export function deleteSalesOrderRow3Raw(options) {
    return SalesOrderRowsApiFp().deleteSalesOrderRow3(options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} [criteria]
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrderRowsApi
*/
export function getOutcomeLotTotalsForSalesOrderRowRaw(criteria, options) {
    return SalesOrderRowsApiFp().getOutcomeLotTotalsForSalesOrderRow(criteria, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrderRowsApi
*/
export function getOutcomeLotsForSalesOrderRowRaw(id, criteria, page, size, sort, options) {
    return SalesOrderRowsApiFp().getOutcomeLotsForSalesOrderRow(id, criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} [criteria]
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrderRowsApi
*/
export function getRecentSalesPricesRaw(criteria, options) {
    return SalesOrderRowsApiFp().getRecentSalesPrices(criteria, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrderRowsApi
*/
export function getReservationsForSalesOrderRowRaw(id, criteria, page, size, sort, options) {
    return SalesOrderRowsApiFp().getReservationsForSalesOrderRow(id, criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrderRowsApi
*/
export function getRowsForSalesOrderRaw(id, criteria, page, size, sort, options) {
    return SalesOrderRowsApiFp().getRowsForSalesOrder(id, criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrderRowsApi
*/
export function getSalesOrderRowRaw(id, options) {
    return SalesOrderRowsApiFp().getSalesOrderRow(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} [criteria]
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrderRowsApi
*/
export function getSalesOrderRowTotalsRaw(criteria, options) {
    return SalesOrderRowsApiFp().getSalesOrderRowTotals(criteria, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrderRowsApi
*/
export function getSalesOrderRowsRaw(criteria, page, size, sort, options) {
    return SalesOrderRowsApiFp().getSalesOrderRows(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {PreviewSalesOrderRowPrintJobData} previewSalesOrderRowPrintJobData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrderRowsApi
*/
export function previewPrintJobRaw(previewSalesOrderRowPrintJobData, options) {
    return SalesOrderRowsApiFp().previewPrintJob(previewSalesOrderRowPrintJobData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {PrintSalesOrderRowLabelData} printSalesOrderRowLabelData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrderRowsApi
*/
export function printSalesOrderRowLabelRaw(id, printSalesOrderRowLabelData, options) {
    return SalesOrderRowsApiFp().printSalesOrderRowLabel(id, printSalesOrderRowLabelData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {UpdateSalesOrderRowData} data
        * @param {Array<File>} [files]
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrderRowsApi
*/
export function updateSalesOrderRowRaw(id, data, files, options) {
    return SalesOrderRowsApiFp().updateSalesOrderRow(id, data, files, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {UpdateSalesOrderRowStatusData} updateSalesOrderRowStatusData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrderRowsApi
*/
export function updateSalesOrderRowStatusRaw(id, updateSalesOrderRowStatusData, options) {
    return SalesOrderRowsApiFp().updateSalesOrderRowStatus(id, updateSalesOrderRowStatusData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * SalesOrderRowsPrintJobsApi - axios parameter creator
 * @export
 */
export const SalesOrderRowsPrintJobsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalesOrderRowLabelPrintJobs: async (criteria, page, size, sort, options = {}) => {
            const localVarPath = `/api/sales-order-row-label-print-jobs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * SalesOrderRowsPrintJobsApi - functional programming interface
 * @export
 */
export const SalesOrderRowsPrintJobsApiFp = function (configuration) {
    const localVarAxiosParamCreator = SalesOrderRowsPrintJobsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSalesOrderRowLabelPrintJobs(criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSalesOrderRowLabelPrintJobs(criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * SalesOrderRowsPrintJobsApi - factory interface
 * @export
 */
export const SalesOrderRowsPrintJobsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = SalesOrderRowsPrintJobsApiFp(configuration);
    return {
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalesOrderRowLabelPrintJobs(criteria, page, size, sort, options) {
            return localVarFp.getSalesOrderRowLabelPrintJobs(criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrderRowsPrintJobsApi
*/
export function getSalesOrderRowLabelPrintJobs(criteria, page, size, sort, options) {
    return SalesOrderRowsPrintJobsApiFp().getSalesOrderRowLabelPrintJobs(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrderRowsPrintJobsApi
*/
export function getSalesOrderRowLabelPrintJobsRaw(criteria, page, size, sort, options) {
    return SalesOrderRowsPrintJobsApiFp().getSalesOrderRowLabelPrintJobs(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * SalesOrderTemplatesApi - axios parameter creator
 * @export
 */
export const SalesOrderTemplatesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {CreateSalesOrderTemplateData} createSalesOrderTemplateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSalesOrderTemplate: async (createSalesOrderTemplateData, options = {}) => {
            // verify required parameter 'createSalesOrderTemplateData' is not null or undefined
            assertParamExists('createSalesOrderTemplate', 'createSalesOrderTemplateData', createSalesOrderTemplateData);
            const localVarPath = `/api/sales-order-templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createSalesOrderTemplateData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} salesOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSalesOrderTemplateFromOrder: async (salesOrderId, options = {}) => {
            // verify required parameter 'salesOrderId' is not null or undefined
            assertParamExists('createSalesOrderTemplateFromOrder', 'salesOrderId', salesOrderId);
            const localVarPath = `/api/sales-order-template-from-order/{salesOrderId}`
                .replace(`{${"salesOrderId"}}`, encodeURIComponent(String(salesOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSalesOrderTemplate: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteSalesOrderTemplate', 'id', id);
            const localVarPath = `/api/sales-order-templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicateSalesOrderTemplate: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('duplicateSalesOrderTemplate', 'id', id);
            const localVarPath = `/api/sales-order-templates/{id}/duplicate`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalesOrderTemplate: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSalesOrderTemplate', 'id', id);
            const localVarPath = `/api/sales-order-templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalesOrderTemplates: async (criteria, page, size, sort, options = {}) => {
            const localVarPath = `/api/sales-order-templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {UpdateSalesOrderTemplateData} updateSalesOrderTemplateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSalesOrderTemplate: async (id, updateSalesOrderTemplateData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateSalesOrderTemplate', 'id', id);
            // verify required parameter 'updateSalesOrderTemplateData' is not null or undefined
            assertParamExists('updateSalesOrderTemplate', 'updateSalesOrderTemplateData', updateSalesOrderTemplateData);
            const localVarPath = `/api/sales-order-templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(updateSalesOrderTemplateData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * SalesOrderTemplatesApi - functional programming interface
 * @export
 */
export const SalesOrderTemplatesApiFp = function (configuration) {
    const localVarAxiosParamCreator = SalesOrderTemplatesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {CreateSalesOrderTemplateData} createSalesOrderTemplateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSalesOrderTemplate(createSalesOrderTemplateData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSalesOrderTemplate(createSalesOrderTemplateData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} salesOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSalesOrderTemplateFromOrder(salesOrderId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSalesOrderTemplateFromOrder(salesOrderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSalesOrderTemplate(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSalesOrderTemplate(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async duplicateSalesOrderTemplate(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.duplicateSalesOrderTemplate(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSalesOrderTemplate(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSalesOrderTemplate(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSalesOrderTemplates(criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSalesOrderTemplates(criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {UpdateSalesOrderTemplateData} updateSalesOrderTemplateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSalesOrderTemplate(id, updateSalesOrderTemplateData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSalesOrderTemplate(id, updateSalesOrderTemplateData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * SalesOrderTemplatesApi - factory interface
 * @export
 */
export const SalesOrderTemplatesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = SalesOrderTemplatesApiFp(configuration);
    return {
        /**
         *
         * @param {CreateSalesOrderTemplateData} createSalesOrderTemplateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSalesOrderTemplate(createSalesOrderTemplateData, options) {
            return localVarFp.createSalesOrderTemplate(createSalesOrderTemplateData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} salesOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSalesOrderTemplateFromOrder(salesOrderId, options) {
            return localVarFp.createSalesOrderTemplateFromOrder(salesOrderId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSalesOrderTemplate(id, options) {
            return localVarFp.deleteSalesOrderTemplate(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicateSalesOrderTemplate(id, options) {
            return localVarFp.duplicateSalesOrderTemplate(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalesOrderTemplate(id, options) {
            return localVarFp.getSalesOrderTemplate(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalesOrderTemplates(criteria, page, size, sort, options) {
            return localVarFp.getSalesOrderTemplates(criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {UpdateSalesOrderTemplateData} updateSalesOrderTemplateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSalesOrderTemplate(id, updateSalesOrderTemplateData, options) {
            return localVarFp.updateSalesOrderTemplate(id, updateSalesOrderTemplateData, options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
        * @param {CreateSalesOrderTemplateData} createSalesOrderTemplateData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrderTemplatesApi
*/
export function createSalesOrderTemplate(createSalesOrderTemplateData, options) {
    return SalesOrderTemplatesApiFp().createSalesOrderTemplate(createSalesOrderTemplateData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} salesOrderId
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrderTemplatesApi
*/
export function createSalesOrderTemplateFromOrder(salesOrderId, options) {
    return SalesOrderTemplatesApiFp().createSalesOrderTemplateFromOrder(salesOrderId, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrderTemplatesApi
*/
export function deleteSalesOrderTemplate(id, options) {
    return SalesOrderTemplatesApiFp().deleteSalesOrderTemplate(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrderTemplatesApi
*/
export function duplicateSalesOrderTemplate(id, options) {
    return SalesOrderTemplatesApiFp().duplicateSalesOrderTemplate(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrderTemplatesApi
*/
export function getSalesOrderTemplate(id, options) {
    return SalesOrderTemplatesApiFp().getSalesOrderTemplate(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrderTemplatesApi
*/
export function getSalesOrderTemplates(criteria, page, size, sort, options) {
    return SalesOrderTemplatesApiFp().getSalesOrderTemplates(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {UpdateSalesOrderTemplateData} updateSalesOrderTemplateData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrderTemplatesApi
*/
export function updateSalesOrderTemplate(id, updateSalesOrderTemplateData, options) {
    return SalesOrderTemplatesApiFp().updateSalesOrderTemplate(id, updateSalesOrderTemplateData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {CreateSalesOrderTemplateData} createSalesOrderTemplateData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrderTemplatesApi
*/
export function createSalesOrderTemplateRaw(createSalesOrderTemplateData, options) {
    return SalesOrderTemplatesApiFp().createSalesOrderTemplate(createSalesOrderTemplateData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} salesOrderId
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrderTemplatesApi
*/
export function createSalesOrderTemplateFromOrderRaw(salesOrderId, options) {
    return SalesOrderTemplatesApiFp().createSalesOrderTemplateFromOrder(salesOrderId, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrderTemplatesApi
*/
export function deleteSalesOrderTemplateRaw(id, options) {
    return SalesOrderTemplatesApiFp().deleteSalesOrderTemplate(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrderTemplatesApi
*/
export function duplicateSalesOrderTemplateRaw(id, options) {
    return SalesOrderTemplatesApiFp().duplicateSalesOrderTemplate(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrderTemplatesApi
*/
export function getSalesOrderTemplateRaw(id, options) {
    return SalesOrderTemplatesApiFp().getSalesOrderTemplate(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrderTemplatesApi
*/
export function getSalesOrderTemplatesRaw(criteria, page, size, sort, options) {
    return SalesOrderTemplatesApiFp().getSalesOrderTemplates(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {UpdateSalesOrderTemplateData} updateSalesOrderTemplateData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrderTemplatesApi
*/
export function updateSalesOrderTemplateRaw(id, updateSalesOrderTemplateData, options) {
    return SalesOrderTemplatesApiFp().updateSalesOrderTemplate(id, updateSalesOrderTemplateData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * SalesOrdersApi - axios parameter creator
 * @export
 */
export const SalesOrdersApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {BulkPrintSalesOrdersLabelData} bulkPrintSalesOrdersLabelData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkPrintSalesOrderLabels: async (bulkPrintSalesOrdersLabelData, options = {}) => {
            // verify required parameter 'bulkPrintSalesOrdersLabelData' is not null or undefined
            assertParamExists('bulkPrintSalesOrderLabels', 'bulkPrintSalesOrdersLabelData', bulkPrintSalesOrdersLabelData);
            const localVarPath = `/api/sales-orders/bulk-print-labels`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(bulkPrintSalesOrdersLabelData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {CloseSalesOrderData} closeSalesOrderData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        closeSalesOrder: async (id, closeSalesOrderData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('closeSalesOrder', 'id', id);
            // verify required parameter 'closeSalesOrderData' is not null or undefined
            assertParamExists('closeSalesOrder', 'closeSalesOrderData', closeSalesOrderData);
            const localVarPath = `/api/sales-orders/close/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(closeSalesOrderData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {CreateOutcomeForSalesOrdersData} createOutcomeForSalesOrdersData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOutcomeForOrders: async (createOutcomeForSalesOrdersData, options = {}) => {
            // verify required parameter 'createOutcomeForSalesOrdersData' is not null or undefined
            assertParamExists('createOutcomeForOrders', 'createOutcomeForSalesOrdersData', createOutcomeForSalesOrdersData);
            const localVarPath = `/api/sales-orders/create-outcome`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createOutcomeForSalesOrdersData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOutcomeLotForOrderBasedOnReservation: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createOutcomeLotForOrderBasedOnReservation', 'id', id);
            const localVarPath = `/api/sales-order/{id}/outcome-lots-based-on-reservation`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {CreateSalesOrderData} data
         * @param {Array<File>} [files]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSalesOrder: async (data, files, options = {}) => {
            // verify required parameter 'data' is not null or undefined
            assertParamExists('createSalesOrder', 'data', data);
            const localVarPath = `/api/sales-orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (data !== undefined) {
                localVarFormParams.append('data', new Blob([JSON.stringify(data)], { type: "application/json", }));
            }
            if (files) {
                files.forEach((element) => {
                    localVarFormParams.append('files', element);
                });
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} salesOrderTemplateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSalesOrderFromTemplate: async (salesOrderTemplateId, options = {}) => {
            // verify required parameter 'salesOrderTemplateId' is not null or undefined
            assertParamExists('createSalesOrderFromTemplate', 'salesOrderTemplateId', salesOrderTemplateId);
            const localVarPath = `/api/sales-order-from-template/{salesOrderTemplateId}`
                .replace(`{${"salesOrderTemplateId"}}`, encodeURIComponent(String(salesOrderTemplateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSalesOrder: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteSalesOrder', 'id', id);
            const localVarPath = `/api/sales-orders/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicateSalesOrder: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('duplicateSalesOrder', 'id', id);
            const localVarPath = `/api/sales-orders/{id}/duplicate`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalesOrder: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSalesOrder', 'id', id);
            const localVarPath = `/api/sales-orders/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalesOrderFiles: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSalesOrderFiles', 'id', id);
            const localVarPath = `/api/sales-orders/{id}/files`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalesOrders: async (criteria, page, size, sort, options = {}) => {
            const localVarPath = `/api/sales-orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {string} designId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewSalesOrderDocument: async (id, designId, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('previewSalesOrderDocument', 'id', id);
            // verify required parameter 'designId' is not null or undefined
            assertParamExists('previewSalesOrderDocument', 'designId', designId);
            const localVarPath = `/api/sales-orders/{id}/preview-document/{designId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"designId"}}`, encodeURIComponent(String(designId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {PrintSalesOrdersByCriteriaData} printSalesOrdersByCriteriaData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        printSalesOrderDocuments: async (printSalesOrdersByCriteriaData, options = {}) => {
            // verify required parameter 'printSalesOrdersByCriteriaData' is not null or undefined
            assertParamExists('printSalesOrderDocuments', 'printSalesOrdersByCriteriaData', printSalesOrdersByCriteriaData);
            const localVarPath = `/api/sales-orders/print-criteria`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(printSalesOrdersByCriteriaData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {UpdateSalesOrderData} data
         * @param {Array<File>} [files]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSalesOrder: async (id, data, files, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateSalesOrder', 'id', id);
            // verify required parameter 'data' is not null or undefined
            assertParamExists('updateSalesOrder', 'data', data);
            const localVarPath = `/api/sales-orders/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (data !== undefined) {
                localVarFormParams.append('data', new Blob([JSON.stringify(data)], { type: "application/json", }));
            }
            if (files) {
                files.forEach((element) => {
                    localVarFormParams.append('files', element);
                });
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {UpdateSalesOrderStatusData} updateSalesOrderStatusData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSalesOrderStatus: async (id, updateSalesOrderStatusData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateSalesOrderStatus', 'id', id);
            // verify required parameter 'updateSalesOrderStatusData' is not null or undefined
            assertParamExists('updateSalesOrderStatus', 'updateSalesOrderStatusData', updateSalesOrderStatusData);
            const localVarPath = `/api/sales-orders/{id}/status`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(updateSalesOrderStatusData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * SalesOrdersApi - functional programming interface
 * @export
 */
export const SalesOrdersApiFp = function (configuration) {
    const localVarAxiosParamCreator = SalesOrdersApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {BulkPrintSalesOrdersLabelData} bulkPrintSalesOrdersLabelData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkPrintSalesOrderLabels(bulkPrintSalesOrdersLabelData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkPrintSalesOrderLabels(bulkPrintSalesOrdersLabelData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {CloseSalesOrderData} closeSalesOrderData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async closeSalesOrder(id, closeSalesOrderData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.closeSalesOrder(id, closeSalesOrderData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {CreateOutcomeForSalesOrdersData} createOutcomeForSalesOrdersData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOutcomeForOrders(createOutcomeForSalesOrdersData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOutcomeForOrders(createOutcomeForSalesOrdersData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOutcomeLotForOrderBasedOnReservation(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOutcomeLotForOrderBasedOnReservation(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {CreateSalesOrderData} data
         * @param {Array<File>} [files]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSalesOrder(data, files, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSalesOrder(data, files, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} salesOrderTemplateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSalesOrderFromTemplate(salesOrderTemplateId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSalesOrderFromTemplate(salesOrderTemplateId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSalesOrder(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSalesOrder(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async duplicateSalesOrder(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.duplicateSalesOrder(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSalesOrder(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSalesOrder(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSalesOrderFiles(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSalesOrderFiles(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSalesOrders(criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSalesOrders(criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {string} designId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async previewSalesOrderDocument(id, designId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.previewSalesOrderDocument(id, designId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {PrintSalesOrdersByCriteriaData} printSalesOrdersByCriteriaData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async printSalesOrderDocuments(printSalesOrdersByCriteriaData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.printSalesOrderDocuments(printSalesOrdersByCriteriaData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {UpdateSalesOrderData} data
         * @param {Array<File>} [files]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSalesOrder(id, data, files, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSalesOrder(id, data, files, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {UpdateSalesOrderStatusData} updateSalesOrderStatusData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSalesOrderStatus(id, updateSalesOrderStatusData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSalesOrderStatus(id, updateSalesOrderStatusData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * SalesOrdersApi - factory interface
 * @export
 */
export const SalesOrdersApiFactory = function (configuration, basePath, axios) {
    const localVarFp = SalesOrdersApiFp(configuration);
    return {
        /**
         *
         * @param {BulkPrintSalesOrdersLabelData} bulkPrintSalesOrdersLabelData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkPrintSalesOrderLabels(bulkPrintSalesOrdersLabelData, options) {
            return localVarFp.bulkPrintSalesOrderLabels(bulkPrintSalesOrdersLabelData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {CloseSalesOrderData} closeSalesOrderData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        closeSalesOrder(id, closeSalesOrderData, options) {
            return localVarFp.closeSalesOrder(id, closeSalesOrderData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CreateOutcomeForSalesOrdersData} createOutcomeForSalesOrdersData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOutcomeForOrders(createOutcomeForSalesOrdersData, options) {
            return localVarFp.createOutcomeForOrders(createOutcomeForSalesOrdersData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOutcomeLotForOrderBasedOnReservation(id, options) {
            return localVarFp.createOutcomeLotForOrderBasedOnReservation(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CreateSalesOrderData} data
         * @param {Array<File>} [files]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSalesOrder(data, files, options) {
            return localVarFp.createSalesOrder(data, files, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} salesOrderTemplateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSalesOrderFromTemplate(salesOrderTemplateId, options) {
            return localVarFp.createSalesOrderFromTemplate(salesOrderTemplateId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSalesOrder(id, options) {
            return localVarFp.deleteSalesOrder(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicateSalesOrder(id, options) {
            return localVarFp.duplicateSalesOrder(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalesOrder(id, options) {
            return localVarFp.getSalesOrder(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalesOrderFiles(id, options) {
            return localVarFp.getSalesOrderFiles(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalesOrders(criteria, page, size, sort, options) {
            return localVarFp.getSalesOrders(criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {string} designId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewSalesOrderDocument(id, designId, options) {
            return localVarFp.previewSalesOrderDocument(id, designId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PrintSalesOrdersByCriteriaData} printSalesOrdersByCriteriaData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        printSalesOrderDocuments(printSalesOrdersByCriteriaData, options) {
            return localVarFp.printSalesOrderDocuments(printSalesOrdersByCriteriaData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {UpdateSalesOrderData} data
         * @param {Array<File>} [files]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSalesOrder(id, data, files, options) {
            return localVarFp.updateSalesOrder(id, data, files, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {UpdateSalesOrderStatusData} updateSalesOrderStatusData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSalesOrderStatus(id, updateSalesOrderStatusData, options) {
            return localVarFp.updateSalesOrderStatus(id, updateSalesOrderStatusData, options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
        * @param {BulkPrintSalesOrdersLabelData} bulkPrintSalesOrdersLabelData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrdersApi
*/
export function bulkPrintSalesOrderLabels(bulkPrintSalesOrdersLabelData, options) {
    return SalesOrdersApiFp().bulkPrintSalesOrderLabels(bulkPrintSalesOrdersLabelData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {CloseSalesOrderData} closeSalesOrderData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrdersApi
*/
export function closeSalesOrder(id, closeSalesOrderData, options) {
    return SalesOrdersApiFp().closeSalesOrder(id, closeSalesOrderData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {CreateOutcomeForSalesOrdersData} createOutcomeForSalesOrdersData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrdersApi
*/
export function createOutcomeForOrders(createOutcomeForSalesOrdersData, options) {
    return SalesOrdersApiFp().createOutcomeForOrders(createOutcomeForSalesOrdersData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrdersApi
*/
export function createOutcomeLotForOrderBasedOnReservation(id, options) {
    return SalesOrdersApiFp().createOutcomeLotForOrderBasedOnReservation(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {CreateSalesOrderData} data
        * @param {Array<File>} [files]
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrdersApi
*/
export function createSalesOrder(data, files, options) {
    return SalesOrdersApiFp().createSalesOrder(data, files, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} salesOrderTemplateId
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrdersApi
*/
export function createSalesOrderFromTemplate(salesOrderTemplateId, options) {
    return SalesOrdersApiFp().createSalesOrderFromTemplate(salesOrderTemplateId, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrdersApi
*/
export function deleteSalesOrder(id, options) {
    return SalesOrdersApiFp().deleteSalesOrder(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrdersApi
*/
export function duplicateSalesOrder(id, options) {
    return SalesOrdersApiFp().duplicateSalesOrder(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrdersApi
*/
export function getSalesOrder(id, options) {
    return SalesOrdersApiFp().getSalesOrder(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrdersApi
*/
export function getSalesOrderFiles(id, options) {
    return SalesOrdersApiFp().getSalesOrderFiles(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrdersApi
*/
export function getSalesOrders(criteria, page, size, sort, options) {
    return SalesOrdersApiFp().getSalesOrders(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {string} designId
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrdersApi
*/
export function previewSalesOrderDocument(id, designId, options) {
    return SalesOrdersApiFp().previewSalesOrderDocument(id, designId, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {PrintSalesOrdersByCriteriaData} printSalesOrdersByCriteriaData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrdersApi
*/
export function printSalesOrderDocuments(printSalesOrdersByCriteriaData, options) {
    return SalesOrdersApiFp().printSalesOrderDocuments(printSalesOrdersByCriteriaData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {UpdateSalesOrderData} data
        * @param {Array<File>} [files]
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrdersApi
*/
export function updateSalesOrder(id, data, files, options) {
    return SalesOrdersApiFp().updateSalesOrder(id, data, files, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {UpdateSalesOrderStatusData} updateSalesOrderStatusData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrdersApi
*/
export function updateSalesOrderStatus(id, updateSalesOrderStatusData, options) {
    return SalesOrdersApiFp().updateSalesOrderStatus(id, updateSalesOrderStatusData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {BulkPrintSalesOrdersLabelData} bulkPrintSalesOrdersLabelData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrdersApi
*/
export function bulkPrintSalesOrderLabelsRaw(bulkPrintSalesOrdersLabelData, options) {
    return SalesOrdersApiFp().bulkPrintSalesOrderLabels(bulkPrintSalesOrdersLabelData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {CloseSalesOrderData} closeSalesOrderData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrdersApi
*/
export function closeSalesOrderRaw(id, closeSalesOrderData, options) {
    return SalesOrdersApiFp().closeSalesOrder(id, closeSalesOrderData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {CreateOutcomeForSalesOrdersData} createOutcomeForSalesOrdersData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrdersApi
*/
export function createOutcomeForOrdersRaw(createOutcomeForSalesOrdersData, options) {
    return SalesOrdersApiFp().createOutcomeForOrders(createOutcomeForSalesOrdersData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrdersApi
*/
export function createOutcomeLotForOrderBasedOnReservationRaw(id, options) {
    return SalesOrdersApiFp().createOutcomeLotForOrderBasedOnReservation(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {CreateSalesOrderData} data
        * @param {Array<File>} [files]
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrdersApi
*/
export function createSalesOrderRaw(data, files, options) {
    return SalesOrdersApiFp().createSalesOrder(data, files, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} salesOrderTemplateId
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrdersApi
*/
export function createSalesOrderFromTemplateRaw(salesOrderTemplateId, options) {
    return SalesOrdersApiFp().createSalesOrderFromTemplate(salesOrderTemplateId, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrdersApi
*/
export function deleteSalesOrderRaw(id, options) {
    return SalesOrdersApiFp().deleteSalesOrder(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrdersApi
*/
export function duplicateSalesOrderRaw(id, options) {
    return SalesOrdersApiFp().duplicateSalesOrder(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrdersApi
*/
export function getSalesOrderRaw(id, options) {
    return SalesOrdersApiFp().getSalesOrder(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrdersApi
*/
export function getSalesOrderFilesRaw(id, options) {
    return SalesOrdersApiFp().getSalesOrderFiles(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrdersApi
*/
export function getSalesOrdersRaw(criteria, page, size, sort, options) {
    return SalesOrdersApiFp().getSalesOrders(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {string} designId
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrdersApi
*/
export function previewSalesOrderDocumentRaw(id, designId, options) {
    return SalesOrdersApiFp().previewSalesOrderDocument(id, designId, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {PrintSalesOrdersByCriteriaData} printSalesOrdersByCriteriaData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrdersApi
*/
export function printSalesOrderDocumentsRaw(printSalesOrdersByCriteriaData, options) {
    return SalesOrdersApiFp().printSalesOrderDocuments(printSalesOrdersByCriteriaData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {UpdateSalesOrderData} data
        * @param {Array<File>} [files]
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrdersApi
*/
export function updateSalesOrderRaw(id, data, files, options) {
    return SalesOrdersApiFp().updateSalesOrder(id, data, files, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {UpdateSalesOrderStatusData} updateSalesOrderStatusData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SalesOrdersApi
*/
export function updateSalesOrderStatusRaw(id, updateSalesOrderStatusData, options) {
    return SalesOrdersApiFp().updateSalesOrderStatus(id, updateSalesOrderStatusData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * SecurityApi - axios parameter creator
 * @export
 */
export const SecurityApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {PasswordValidationData} passwordValidationData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableMfa: async (passwordValidationData, options = {}) => {
            // verify required parameter 'passwordValidationData' is not null or undefined
            assertParamExists('disableMfa', 'passwordValidationData', passwordValidationData);
            const localVarPath = `/api/security/disable-mfa`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(passwordValidationData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMfaStatus: async (options = {}) => {
            const localVarPath = `/api/security/mfa-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {RequestTokenData} requestTokenData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login: async (requestTokenData, options = {}) => {
            // verify required parameter 'requestTokenData' is not null or undefined
            assertParamExists('login', 'requestTokenData', requestTokenData);
            const localVarPath = `/api/security/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(requestTokenData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout: async (options = {}) => {
            const localVarPath = `/api/security/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {PasswordValidationData} passwordValidationData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestMfaSetup: async (passwordValidationData, options = {}) => {
            // verify required parameter 'passwordValidationData' is not null or undefined
            assertParamExists('requestMfaSetup', 'passwordValidationData', passwordValidationData);
            const localVarPath = `/api/security/request-mfa-otp-setup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(passwordValidationData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {SetupMultiFactorAuthenticationData} setupMultiFactorAuthenticationData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitMfaSetup: async (setupMultiFactorAuthenticationData, options = {}) => {
            // verify required parameter 'setupMultiFactorAuthenticationData' is not null or undefined
            assertParamExists('submitMfaSetup', 'setupMultiFactorAuthenticationData', setupMultiFactorAuthenticationData);
            const localVarPath = `/api/security/mfa-otp-setup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(setupMultiFactorAuthenticationData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {PasswordValidationData} passwordValidationData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validatePassword: async (passwordValidationData, options = {}) => {
            // verify required parameter 'passwordValidationData' is not null or undefined
            assertParamExists('validatePassword', 'passwordValidationData', passwordValidationData);
            const localVarPath = `/api/security/validate-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(passwordValidationData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * SecurityApi - functional programming interface
 * @export
 */
export const SecurityApiFp = function (configuration) {
    const localVarAxiosParamCreator = SecurityApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {PasswordValidationData} passwordValidationData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async disableMfa(passwordValidationData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.disableMfa(passwordValidationData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMfaStatus(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMfaStatus(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {RequestTokenData} requestTokenData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async login(requestTokenData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.login(requestTokenData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async logout(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.logout(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {PasswordValidationData} passwordValidationData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestMfaSetup(passwordValidationData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestMfaSetup(passwordValidationData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {SetupMultiFactorAuthenticationData} setupMultiFactorAuthenticationData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submitMfaSetup(setupMultiFactorAuthenticationData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submitMfaSetup(setupMultiFactorAuthenticationData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {PasswordValidationData} passwordValidationData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validatePassword(passwordValidationData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validatePassword(passwordValidationData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * SecurityApi - factory interface
 * @export
 */
export const SecurityApiFactory = function (configuration, basePath, axios) {
    const localVarFp = SecurityApiFp(configuration);
    return {
        /**
         *
         * @param {PasswordValidationData} passwordValidationData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableMfa(passwordValidationData, options) {
            return localVarFp.disableMfa(passwordValidationData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMfaStatus(options) {
            return localVarFp.getMfaStatus(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {RequestTokenData} requestTokenData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login(requestTokenData, options) {
            return localVarFp.login(requestTokenData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout(options) {
            return localVarFp.logout(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PasswordValidationData} passwordValidationData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestMfaSetup(passwordValidationData, options) {
            return localVarFp.requestMfaSetup(passwordValidationData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SetupMultiFactorAuthenticationData} setupMultiFactorAuthenticationData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitMfaSetup(setupMultiFactorAuthenticationData, options) {
            return localVarFp.submitMfaSetup(setupMultiFactorAuthenticationData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PasswordValidationData} passwordValidationData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validatePassword(passwordValidationData, options) {
            return localVarFp.validatePassword(passwordValidationData, options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
        * @param {PasswordValidationData} passwordValidationData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SecurityApi
*/
export function disableMfa(passwordValidationData, options) {
    return SecurityApiFp().disableMfa(passwordValidationData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SecurityApi
*/
export function getMfaStatus(options) {
    return SecurityApiFp().getMfaStatus(options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {RequestTokenData} requestTokenData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SecurityApi
*/
export function login(requestTokenData, options) {
    return SecurityApiFp().login(requestTokenData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SecurityApi
*/
export function logout(options) {
    return SecurityApiFp().logout(options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {PasswordValidationData} passwordValidationData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SecurityApi
*/
export function requestMfaSetup(passwordValidationData, options) {
    return SecurityApiFp().requestMfaSetup(passwordValidationData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {SetupMultiFactorAuthenticationData} setupMultiFactorAuthenticationData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SecurityApi
*/
export function submitMfaSetup(setupMultiFactorAuthenticationData, options) {
    return SecurityApiFp().submitMfaSetup(setupMultiFactorAuthenticationData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {PasswordValidationData} passwordValidationData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SecurityApi
*/
export function validatePassword(passwordValidationData, options) {
    return SecurityApiFp().validatePassword(passwordValidationData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {PasswordValidationData} passwordValidationData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SecurityApi
*/
export function disableMfaRaw(passwordValidationData, options) {
    return SecurityApiFp().disableMfa(passwordValidationData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SecurityApi
*/
export function getMfaStatusRaw(options) {
    return SecurityApiFp().getMfaStatus(options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {RequestTokenData} requestTokenData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SecurityApi
*/
export function loginRaw(requestTokenData, options) {
    return SecurityApiFp().login(requestTokenData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SecurityApi
*/
export function logoutRaw(options) {
    return SecurityApiFp().logout(options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {PasswordValidationData} passwordValidationData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SecurityApi
*/
export function requestMfaSetupRaw(passwordValidationData, options) {
    return SecurityApiFp().requestMfaSetup(passwordValidationData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {SetupMultiFactorAuthenticationData} setupMultiFactorAuthenticationData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SecurityApi
*/
export function submitMfaSetupRaw(setupMultiFactorAuthenticationData, options) {
    return SecurityApiFp().submitMfaSetup(setupMultiFactorAuthenticationData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {PasswordValidationData} passwordValidationData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SecurityApi
*/
export function validatePasswordRaw(passwordValidationData, options) {
    return SecurityApiFp().validatePassword(passwordValidationData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * SerialPortScalesApi - axios parameter creator
 * @export
 */
export const SerialPortScalesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {CreateOrUpdateSerialPortScaleData} createOrUpdateSerialPortScaleData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSerialPortScale: async (createOrUpdateSerialPortScaleData, options = {}) => {
            // verify required parameter 'createOrUpdateSerialPortScaleData' is not null or undefined
            assertParamExists('createSerialPortScale', 'createOrUpdateSerialPortScaleData', createOrUpdateSerialPortScaleData);
            const localVarPath = `/api/serial-port-scales`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createOrUpdateSerialPortScaleData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSerialPortScale: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteSerialPortScale', 'id', id);
            const localVarPath = `/api/serial-port-scales/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSerialPortScale: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSerialPortScale', 'id', id);
            const localVarPath = `/api/serial-port-scales/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSerialPortScales: async (criteria, page, size, sort, options = {}) => {
            const localVarPath = `/api/serial-port-scales`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {CreateOrUpdateSerialPortScaleData} createOrUpdateSerialPortScaleData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSerialPortScale: async (id, createOrUpdateSerialPortScaleData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateSerialPortScale', 'id', id);
            // verify required parameter 'createOrUpdateSerialPortScaleData' is not null or undefined
            assertParamExists('updateSerialPortScale', 'createOrUpdateSerialPortScaleData', createOrUpdateSerialPortScaleData);
            const localVarPath = `/api/serial-port-scales/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createOrUpdateSerialPortScaleData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * SerialPortScalesApi - functional programming interface
 * @export
 */
export const SerialPortScalesApiFp = function (configuration) {
    const localVarAxiosParamCreator = SerialPortScalesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {CreateOrUpdateSerialPortScaleData} createOrUpdateSerialPortScaleData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSerialPortScale(createOrUpdateSerialPortScaleData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSerialPortScale(createOrUpdateSerialPortScaleData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSerialPortScale(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSerialPortScale(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSerialPortScale(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSerialPortScale(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSerialPortScales(criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSerialPortScales(criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {CreateOrUpdateSerialPortScaleData} createOrUpdateSerialPortScaleData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSerialPortScale(id, createOrUpdateSerialPortScaleData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSerialPortScale(id, createOrUpdateSerialPortScaleData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * SerialPortScalesApi - factory interface
 * @export
 */
export const SerialPortScalesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = SerialPortScalesApiFp(configuration);
    return {
        /**
         *
         * @param {CreateOrUpdateSerialPortScaleData} createOrUpdateSerialPortScaleData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSerialPortScale(createOrUpdateSerialPortScaleData, options) {
            return localVarFp.createSerialPortScale(createOrUpdateSerialPortScaleData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSerialPortScale(id, options) {
            return localVarFp.deleteSerialPortScale(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSerialPortScale(id, options) {
            return localVarFp.getSerialPortScale(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSerialPortScales(criteria, page, size, sort, options) {
            return localVarFp.getSerialPortScales(criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {CreateOrUpdateSerialPortScaleData} createOrUpdateSerialPortScaleData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSerialPortScale(id, createOrUpdateSerialPortScaleData, options) {
            return localVarFp.updateSerialPortScale(id, createOrUpdateSerialPortScaleData, options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
        * @param {CreateOrUpdateSerialPortScaleData} createOrUpdateSerialPortScaleData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SerialPortScalesApi
*/
export function createSerialPortScale(createOrUpdateSerialPortScaleData, options) {
    return SerialPortScalesApiFp().createSerialPortScale(createOrUpdateSerialPortScaleData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SerialPortScalesApi
*/
export function deleteSerialPortScale(id, options) {
    return SerialPortScalesApiFp().deleteSerialPortScale(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SerialPortScalesApi
*/
export function getSerialPortScale(id, options) {
    return SerialPortScalesApiFp().getSerialPortScale(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SerialPortScalesApi
*/
export function getSerialPortScales(criteria, page, size, sort, options) {
    return SerialPortScalesApiFp().getSerialPortScales(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {CreateOrUpdateSerialPortScaleData} createOrUpdateSerialPortScaleData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SerialPortScalesApi
*/
export function updateSerialPortScale(id, createOrUpdateSerialPortScaleData, options) {
    return SerialPortScalesApiFp().updateSerialPortScale(id, createOrUpdateSerialPortScaleData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {CreateOrUpdateSerialPortScaleData} createOrUpdateSerialPortScaleData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SerialPortScalesApi
*/
export function createSerialPortScaleRaw(createOrUpdateSerialPortScaleData, options) {
    return SerialPortScalesApiFp().createSerialPortScale(createOrUpdateSerialPortScaleData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SerialPortScalesApi
*/
export function deleteSerialPortScaleRaw(id, options) {
    return SerialPortScalesApiFp().deleteSerialPortScale(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SerialPortScalesApi
*/
export function getSerialPortScaleRaw(id, options) {
    return SerialPortScalesApiFp().getSerialPortScale(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SerialPortScalesApi
*/
export function getSerialPortScalesRaw(criteria, page, size, sort, options) {
    return SerialPortScalesApiFp().getSerialPortScales(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {CreateOrUpdateSerialPortScaleData} createOrUpdateSerialPortScaleData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SerialPortScalesApi
*/
export function updateSerialPortScaleRaw(id, createOrUpdateSerialPortScaleData, options) {
    return SerialPortScalesApiFp().updateSerialPortScale(id, createOrUpdateSerialPortScaleData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * SerialPortScannersApi - axios parameter creator
 * @export
 */
export const SerialPortScannersApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {CreateOrUpdateSerialPortScannerData} createOrUpdateSerialPortScannerData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSerialPortScanner: async (createOrUpdateSerialPortScannerData, options = {}) => {
            // verify required parameter 'createOrUpdateSerialPortScannerData' is not null or undefined
            assertParamExists('createSerialPortScanner', 'createOrUpdateSerialPortScannerData', createOrUpdateSerialPortScannerData);
            const localVarPath = `/api/serial-port-scanners`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createOrUpdateSerialPortScannerData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSerialPortScanner: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteSerialPortScanner', 'id', id);
            const localVarPath = `/api/serial-port-scanners/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSerialPortScanner: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSerialPortScanner', 'id', id);
            const localVarPath = `/api/serial-port-scanners/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSerialPortScanners: async (criteria, page, size, sort, options = {}) => {
            const localVarPath = `/api/serial-port-scanners`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {CreateOrUpdateSerialPortScannerData} createOrUpdateSerialPortScannerData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSerialPortScanner: async (id, createOrUpdateSerialPortScannerData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateSerialPortScanner', 'id', id);
            // verify required parameter 'createOrUpdateSerialPortScannerData' is not null or undefined
            assertParamExists('updateSerialPortScanner', 'createOrUpdateSerialPortScannerData', createOrUpdateSerialPortScannerData);
            const localVarPath = `/api/serial-port-scanners/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createOrUpdateSerialPortScannerData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * SerialPortScannersApi - functional programming interface
 * @export
 */
export const SerialPortScannersApiFp = function (configuration) {
    const localVarAxiosParamCreator = SerialPortScannersApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {CreateOrUpdateSerialPortScannerData} createOrUpdateSerialPortScannerData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSerialPortScanner(createOrUpdateSerialPortScannerData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSerialPortScanner(createOrUpdateSerialPortScannerData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSerialPortScanner(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSerialPortScanner(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSerialPortScanner(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSerialPortScanner(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSerialPortScanners(criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSerialPortScanners(criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {CreateOrUpdateSerialPortScannerData} createOrUpdateSerialPortScannerData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSerialPortScanner(id, createOrUpdateSerialPortScannerData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSerialPortScanner(id, createOrUpdateSerialPortScannerData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * SerialPortScannersApi - factory interface
 * @export
 */
export const SerialPortScannersApiFactory = function (configuration, basePath, axios) {
    const localVarFp = SerialPortScannersApiFp(configuration);
    return {
        /**
         *
         * @param {CreateOrUpdateSerialPortScannerData} createOrUpdateSerialPortScannerData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSerialPortScanner(createOrUpdateSerialPortScannerData, options) {
            return localVarFp.createSerialPortScanner(createOrUpdateSerialPortScannerData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSerialPortScanner(id, options) {
            return localVarFp.deleteSerialPortScanner(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSerialPortScanner(id, options) {
            return localVarFp.getSerialPortScanner(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSerialPortScanners(criteria, page, size, sort, options) {
            return localVarFp.getSerialPortScanners(criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {CreateOrUpdateSerialPortScannerData} createOrUpdateSerialPortScannerData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSerialPortScanner(id, createOrUpdateSerialPortScannerData, options) {
            return localVarFp.updateSerialPortScanner(id, createOrUpdateSerialPortScannerData, options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
        * @param {CreateOrUpdateSerialPortScannerData} createOrUpdateSerialPortScannerData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SerialPortScannersApi
*/
export function createSerialPortScanner(createOrUpdateSerialPortScannerData, options) {
    return SerialPortScannersApiFp().createSerialPortScanner(createOrUpdateSerialPortScannerData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SerialPortScannersApi
*/
export function deleteSerialPortScanner(id, options) {
    return SerialPortScannersApiFp().deleteSerialPortScanner(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SerialPortScannersApi
*/
export function getSerialPortScanner(id, options) {
    return SerialPortScannersApiFp().getSerialPortScanner(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SerialPortScannersApi
*/
export function getSerialPortScanners(criteria, page, size, sort, options) {
    return SerialPortScannersApiFp().getSerialPortScanners(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {CreateOrUpdateSerialPortScannerData} createOrUpdateSerialPortScannerData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SerialPortScannersApi
*/
export function updateSerialPortScanner(id, createOrUpdateSerialPortScannerData, options) {
    return SerialPortScannersApiFp().updateSerialPortScanner(id, createOrUpdateSerialPortScannerData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {CreateOrUpdateSerialPortScannerData} createOrUpdateSerialPortScannerData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SerialPortScannersApi
*/
export function createSerialPortScannerRaw(createOrUpdateSerialPortScannerData, options) {
    return SerialPortScannersApiFp().createSerialPortScanner(createOrUpdateSerialPortScannerData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SerialPortScannersApi
*/
export function deleteSerialPortScannerRaw(id, options) {
    return SerialPortScannersApiFp().deleteSerialPortScanner(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SerialPortScannersApi
*/
export function getSerialPortScannerRaw(id, options) {
    return SerialPortScannersApiFp().getSerialPortScanner(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SerialPortScannersApi
*/
export function getSerialPortScannersRaw(criteria, page, size, sort, options) {
    return SerialPortScannersApiFp().getSerialPortScanners(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {CreateOrUpdateSerialPortScannerData} createOrUpdateSerialPortScannerData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SerialPortScannersApi
*/
export function updateSerialPortScannerRaw(id, createOrUpdateSerialPortScannerData, options) {
    return SerialPortScannersApiFp().updateSerialPortScanner(id, createOrUpdateSerialPortScannerData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * SpeciesApi - axios parameter creator
 * @export
 */
export const SpeciesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveSingleSpecies: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('archiveSingleSpecies', 'id', id);
            const localVarPath = `/api/species/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {CreateSpeciesData} createSpeciesData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSpecies: async (createSpeciesData, options = {}) => {
            // verify required parameter 'createSpeciesData' is not null or undefined
            assertParamExists('createSpecies', 'createSpeciesData', createSpeciesData);
            const localVarPath = `/api/species`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createSpeciesData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSingleSpecies: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSingleSpecies', 'id', id);
            const localVarPath = `/api/species/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSpecies: async (criteria, page, size, sort, options = {}) => {
            const localVarPath = `/api/species`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {UpdateSpeciesData} updateSpeciesData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSpecies: async (id, updateSpeciesData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateSpecies', 'id', id);
            // verify required parameter 'updateSpeciesData' is not null or undefined
            assertParamExists('updateSpecies', 'updateSpeciesData', updateSpeciesData);
            const localVarPath = `/api/species/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(updateSpeciesData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * SpeciesApi - functional programming interface
 * @export
 */
export const SpeciesApiFp = function (configuration) {
    const localVarAxiosParamCreator = SpeciesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async archiveSingleSpecies(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.archiveSingleSpecies(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {CreateSpeciesData} createSpeciesData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSpecies(createSpeciesData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSpecies(createSpeciesData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSingleSpecies(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSingleSpecies(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSpecies(criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSpecies(criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {UpdateSpeciesData} updateSpeciesData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSpecies(id, updateSpeciesData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSpecies(id, updateSpeciesData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * SpeciesApi - factory interface
 * @export
 */
export const SpeciesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = SpeciesApiFp(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveSingleSpecies(id, options) {
            return localVarFp.archiveSingleSpecies(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CreateSpeciesData} createSpeciesData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSpecies(createSpeciesData, options) {
            return localVarFp.createSpecies(createSpeciesData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSingleSpecies(id, options) {
            return localVarFp.getSingleSpecies(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSpecies(criteria, page, size, sort, options) {
            return localVarFp.getSpecies(criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {UpdateSpeciesData} updateSpeciesData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSpecies(id, updateSpeciesData, options) {
            return localVarFp.updateSpecies(id, updateSpeciesData, options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SpeciesApi
*/
export function archiveSingleSpecies(id, options) {
    return SpeciesApiFp().archiveSingleSpecies(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {CreateSpeciesData} createSpeciesData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SpeciesApi
*/
export function createSpecies(createSpeciesData, options) {
    return SpeciesApiFp().createSpecies(createSpeciesData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SpeciesApi
*/
export function getSingleSpecies(id, options) {
    return SpeciesApiFp().getSingleSpecies(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SpeciesApi
*/
export function getSpecies(criteria, page, size, sort, options) {
    return SpeciesApiFp().getSpecies(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {UpdateSpeciesData} updateSpeciesData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SpeciesApi
*/
export function updateSpecies(id, updateSpeciesData, options) {
    return SpeciesApiFp().updateSpecies(id, updateSpeciesData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SpeciesApi
*/
export function archiveSingleSpeciesRaw(id, options) {
    return SpeciesApiFp().archiveSingleSpecies(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {CreateSpeciesData} createSpeciesData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SpeciesApi
*/
export function createSpeciesRaw(createSpeciesData, options) {
    return SpeciesApiFp().createSpecies(createSpeciesData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SpeciesApi
*/
export function getSingleSpeciesRaw(id, options) {
    return SpeciesApiFp().getSingleSpecies(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SpeciesApi
*/
export function getSpeciesRaw(criteria, page, size, sort, options) {
    return SpeciesApiFp().getSpecies(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {UpdateSpeciesData} updateSpeciesData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SpeciesApi
*/
export function updateSpeciesRaw(id, updateSpeciesData, options) {
    return SpeciesApiFp().updateSpecies(id, updateSpeciesData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * StockStorageSnapshotsApi - axios parameter creator
 * @export
 */
export const StockStorageSnapshotsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {GenerateStockStorageInvoiceData} generateStockStorageInvoiceData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStockStorageInvoice: async (generateStockStorageInvoiceData, options = {}) => {
            // verify required parameter 'generateStockStorageInvoiceData' is not null or undefined
            assertParamExists('createStockStorageInvoice', 'generateStockStorageInvoiceData', generateStockStorageInvoiceData);
            const localVarPath = `/api/stock-storage-snapshots/create-invoice`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(generateStockStorageInvoiceData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStockStorageSnapshotTotals: async (criteria, page, size, sort, options = {}) => {
            const localVarPath = `/api/stock-storage-snapshots/totals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStockStorageSnapshots: async (criteria, page, size, sort, options = {}) => {
            const localVarPath = `/api/stock-storage-snapshots`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerSnapshot: async (options = {}) => {
            const localVarPath = `/dev/stock-storage-snapshots/create-snapshot`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * StockStorageSnapshotsApi - functional programming interface
 * @export
 */
export const StockStorageSnapshotsApiFp = function (configuration) {
    const localVarAxiosParamCreator = StockStorageSnapshotsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {GenerateStockStorageInvoiceData} generateStockStorageInvoiceData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createStockStorageInvoice(generateStockStorageInvoiceData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createStockStorageInvoice(generateStockStorageInvoiceData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStockStorageSnapshotTotals(criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStockStorageSnapshotTotals(criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStockStorageSnapshots(criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStockStorageSnapshots(criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async triggerSnapshot(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.triggerSnapshot(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * StockStorageSnapshotsApi - factory interface
 * @export
 */
export const StockStorageSnapshotsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = StockStorageSnapshotsApiFp(configuration);
    return {
        /**
         *
         * @param {GenerateStockStorageInvoiceData} generateStockStorageInvoiceData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStockStorageInvoice(generateStockStorageInvoiceData, options) {
            return localVarFp.createStockStorageInvoice(generateStockStorageInvoiceData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStockStorageSnapshotTotals(criteria, page, size, sort, options) {
            return localVarFp.getStockStorageSnapshotTotals(criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStockStorageSnapshots(criteria, page, size, sort, options) {
            return localVarFp.getStockStorageSnapshots(criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerSnapshot(options) {
            return localVarFp.triggerSnapshot(options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
        * @param {GenerateStockStorageInvoiceData} generateStockStorageInvoiceData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof StockStorageSnapshotsApi
*/
export function createStockStorageInvoice(generateStockStorageInvoiceData, options) {
    return StockStorageSnapshotsApiFp().createStockStorageInvoice(generateStockStorageInvoiceData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof StockStorageSnapshotsApi
*/
export function getStockStorageSnapshotTotals(criteria, page, size, sort, options) {
    return StockStorageSnapshotsApiFp().getStockStorageSnapshotTotals(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof StockStorageSnapshotsApi
*/
export function getStockStorageSnapshots(criteria, page, size, sort, options) {
    return StockStorageSnapshotsApiFp().getStockStorageSnapshots(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof StockStorageSnapshotsApi
*/
export function triggerSnapshot(options) {
    return StockStorageSnapshotsApiFp().triggerSnapshot(options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {GenerateStockStorageInvoiceData} generateStockStorageInvoiceData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof StockStorageSnapshotsApi
*/
export function createStockStorageInvoiceRaw(generateStockStorageInvoiceData, options) {
    return StockStorageSnapshotsApiFp().createStockStorageInvoice(generateStockStorageInvoiceData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof StockStorageSnapshotsApi
*/
export function getStockStorageSnapshotTotalsRaw(criteria, page, size, sort, options) {
    return StockStorageSnapshotsApiFp().getStockStorageSnapshotTotals(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof StockStorageSnapshotsApi
*/
export function getStockStorageSnapshotsRaw(criteria, page, size, sort, options) {
    return StockStorageSnapshotsApiFp().getStockStorageSnapshots(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof StockStorageSnapshotsApi
*/
export function triggerSnapshotRaw(options) {
    return StockStorageSnapshotsApiFp().triggerSnapshot(options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * SyncOrdersControllerApi - axios parameter creator
 * @export
 */
export const SyncOrdersControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncInvoices: async (options = {}) => {
            const localVarPath = `/api/account-view/sync-invoices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncOpenItems: async (options = {}) => {
            const localVarPath = `/api/account-view/open-items`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncProductionOrders: async (options = {}) => {
            const localVarPath = `/api/account-view/sync-production-orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPurchaseOrders: async (options = {}) => {
            const localVarPath = `/api/account-view/sync-purchase-orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * SyncOrdersControllerApi - functional programming interface
 * @export
 */
export const SyncOrdersControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = SyncOrdersControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncInvoices(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncInvoices(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncOpenItems(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncOpenItems(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncProductionOrders(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncProductionOrders(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncPurchaseOrders(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncPurchaseOrders(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * SyncOrdersControllerApi - factory interface
 * @export
 */
export const SyncOrdersControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = SyncOrdersControllerApiFp(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncInvoices(options) {
            return localVarFp.syncInvoices(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncOpenItems(options) {
            return localVarFp.syncOpenItems(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncProductionOrders(options) {
            return localVarFp.syncProductionOrders(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPurchaseOrders(options) {
            return localVarFp.syncPurchaseOrders(options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SyncOrdersControllerApi
*/
export function syncInvoices(options) {
    return SyncOrdersControllerApiFp().syncInvoices(options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SyncOrdersControllerApi
*/
export function syncOpenItems(options) {
    return SyncOrdersControllerApiFp().syncOpenItems(options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SyncOrdersControllerApi
*/
export function syncProductionOrders(options) {
    return SyncOrdersControllerApiFp().syncProductionOrders(options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SyncOrdersControllerApi
*/
export function syncPurchaseOrders(options) {
    return SyncOrdersControllerApiFp().syncPurchaseOrders(options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SyncOrdersControllerApi
*/
export function syncInvoicesRaw(options) {
    return SyncOrdersControllerApiFp().syncInvoices(options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SyncOrdersControllerApi
*/
export function syncOpenItemsRaw(options) {
    return SyncOrdersControllerApiFp().syncOpenItems(options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SyncOrdersControllerApi
*/
export function syncProductionOrdersRaw(options) {
    return SyncOrdersControllerApiFp().syncProductionOrders(options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof SyncOrdersControllerApi
*/
export function syncPurchaseOrdersRaw(options) {
    return SyncOrdersControllerApiFp().syncPurchaseOrders(options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * TagOptionsApi - axios parameter creator
 * @export
 */
export const TagOptionsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTagOption: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTagOption', 'id', id);
            const localVarPath = `/api/tag-options/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTagOptions: async (criteria, page, size, sort, options = {}) => {
            const localVarPath = `/api/tag-options`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * TagOptionsApi - functional programming interface
 * @export
 */
export const TagOptionsApiFp = function (configuration) {
    const localVarAxiosParamCreator = TagOptionsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTagOption(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTagOption(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTagOptions(criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTagOptions(criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * TagOptionsApi - factory interface
 * @export
 */
export const TagOptionsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = TagOptionsApiFp(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTagOption(id, options) {
            return localVarFp.getTagOption(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTagOptions(criteria, page, size, sort, options) {
            return localVarFp.getTagOptions(criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof TagOptionsApi
*/
export function getTagOption(id, options) {
    return TagOptionsApiFp().getTagOption(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof TagOptionsApi
*/
export function getTagOptions(criteria, page, size, sort, options) {
    return TagOptionsApiFp().getTagOptions(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof TagOptionsApi
*/
export function getTagOptionRaw(id, options) {
    return TagOptionsApiFp().getTagOption(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof TagOptionsApi
*/
export function getTagOptionsRaw(criteria, page, size, sort, options) {
    return TagOptionsApiFp().getTagOptions(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * TagsApi - axios parameter creator
 * @export
 */
export const TagsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveTag: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('archiveTag', 'id', id);
            const localVarPath = `/api/tags/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {CreateTagData} createTagData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTag: async (createTagData, options = {}) => {
            // verify required parameter 'createTagData' is not null or undefined
            assertParamExists('createTag', 'createTagData', createTagData);
            const localVarPath = `/api/tags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createTagData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTag: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTag', 'id', id);
            const localVarPath = `/api/tags/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTags: async (criteria, page, size, sort, options = {}) => {
            const localVarPath = `/api/tags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {'CORE' | 'FINANCE' | 'PRODUCTION' | 'PURCHASING' | 'SALES' | 'STOCK' | 'INCOME' | 'OUTCOME'} module
         * @param {string} productCategoryId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTagsPerModuleAndProductCategory: async (module, productCategoryId, options = {}) => {
            // verify required parameter 'module' is not null or undefined
            assertParamExists('getTagsPerModuleAndProductCategory', 'module', module);
            // verify required parameter 'productCategoryId' is not null or undefined
            assertParamExists('getTagsPerModuleAndProductCategory', 'productCategoryId', productCategoryId);
            const localVarPath = `/api/tags/cost-type/{module}/product-category/{productCategoryId}`
                .replace(`{${"module"}}`, encodeURIComponent(String(module)))
                .replace(`{${"productCategoryId"}}`, encodeURIComponent(String(productCategoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {UpdateTagData} updateTagData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTag: async (id, updateTagData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateTag', 'id', id);
            // verify required parameter 'updateTagData' is not null or undefined
            assertParamExists('updateTag', 'updateTagData', updateTagData);
            const localVarPath = `/api/tags/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(updateTagData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * TagsApi - functional programming interface
 * @export
 */
export const TagsApiFp = function (configuration) {
    const localVarAxiosParamCreator = TagsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async archiveTag(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.archiveTag(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {CreateTagData} createTagData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTag(createTagData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTag(createTagData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTag(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTag(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTags(criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTags(criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {'CORE' | 'FINANCE' | 'PRODUCTION' | 'PURCHASING' | 'SALES' | 'STOCK' | 'INCOME' | 'OUTCOME'} module
         * @param {string} productCategoryId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTagsPerModuleAndProductCategory(module, productCategoryId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTagsPerModuleAndProductCategory(module, productCategoryId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {UpdateTagData} updateTagData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTag(id, updateTagData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTag(id, updateTagData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * TagsApi - factory interface
 * @export
 */
export const TagsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = TagsApiFp(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveTag(id, options) {
            return localVarFp.archiveTag(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CreateTagData} createTagData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTag(createTagData, options) {
            return localVarFp.createTag(createTagData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTag(id, options) {
            return localVarFp.getTag(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTags(criteria, page, size, sort, options) {
            return localVarFp.getTags(criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {'CORE' | 'FINANCE' | 'PRODUCTION' | 'PURCHASING' | 'SALES' | 'STOCK' | 'INCOME' | 'OUTCOME'} module
         * @param {string} productCategoryId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTagsPerModuleAndProductCategory(module, productCategoryId, options) {
            return localVarFp.getTagsPerModuleAndProductCategory(module, productCategoryId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {UpdateTagData} updateTagData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTag(id, updateTagData, options) {
            return localVarFp.updateTag(id, updateTagData, options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof TagsApi
*/
export function archiveTag(id, options) {
    return TagsApiFp().archiveTag(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {CreateTagData} createTagData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof TagsApi
*/
export function createTag(createTagData, options) {
    return TagsApiFp().createTag(createTagData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof TagsApi
*/
export function getTag(id, options) {
    return TagsApiFp().getTag(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof TagsApi
*/
export function getTags(criteria, page, size, sort, options) {
    return TagsApiFp().getTags(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {'CORE' | 'FINANCE' | 'PRODUCTION' | 'PURCHASING' | 'SALES' | 'STOCK' | 'INCOME' | 'OUTCOME'} module
        * @param {string} productCategoryId
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof TagsApi
*/
export function getTagsPerModuleAndProductCategory(module, productCategoryId, options) {
    return TagsApiFp().getTagsPerModuleAndProductCategory(module, productCategoryId, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {UpdateTagData} updateTagData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof TagsApi
*/
export function updateTag(id, updateTagData, options) {
    return TagsApiFp().updateTag(id, updateTagData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof TagsApi
*/
export function archiveTagRaw(id, options) {
    return TagsApiFp().archiveTag(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {CreateTagData} createTagData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof TagsApi
*/
export function createTagRaw(createTagData, options) {
    return TagsApiFp().createTag(createTagData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof TagsApi
*/
export function getTagRaw(id, options) {
    return TagsApiFp().getTag(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof TagsApi
*/
export function getTagsRaw(criteria, page, size, sort, options) {
    return TagsApiFp().getTags(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {'CORE' | 'FINANCE' | 'PRODUCTION' | 'PURCHASING' | 'SALES' | 'STOCK' | 'INCOME' | 'OUTCOME'} module
        * @param {string} productCategoryId
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof TagsApi
*/
export function getTagsPerModuleAndProductCategoryRaw(module, productCategoryId, options) {
    return TagsApiFp().getTagsPerModuleAndProductCategory(module, productCategoryId, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {UpdateTagData} updateTagData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof TagsApi
*/
export function updateTagRaw(id, updateTagData, options) {
    return TagsApiFp().updateTag(id, updateTagData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * TransportMethodsApi - axios parameter creator
 * @export
 */
export const TransportMethodsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveTransportMethod: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('archiveTransportMethod', 'id', id);
            const localVarPath = `/api/transport-methods/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {CreateTransportMethodData} createTransportMethodData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTransportMethod: async (createTransportMethodData, options = {}) => {
            // verify required parameter 'createTransportMethodData' is not null or undefined
            assertParamExists('createTransportMethod', 'createTransportMethodData', createTransportMethodData);
            const localVarPath = `/api/transport-methods`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createTransportMethodData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransportMethod: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTransportMethod', 'id', id);
            const localVarPath = `/api/transport-methods/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransportMethods: async (criteria, page, size, sort, options = {}) => {
            const localVarPath = `/api/transport-methods`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {UpdateTransportMethodData} updateTransportMethodData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTransportMethod: async (id, updateTransportMethodData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateTransportMethod', 'id', id);
            // verify required parameter 'updateTransportMethodData' is not null or undefined
            assertParamExists('updateTransportMethod', 'updateTransportMethodData', updateTransportMethodData);
            const localVarPath = `/api/transport-methods/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(updateTransportMethodData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * TransportMethodsApi - functional programming interface
 * @export
 */
export const TransportMethodsApiFp = function (configuration) {
    const localVarAxiosParamCreator = TransportMethodsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async archiveTransportMethod(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.archiveTransportMethod(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {CreateTransportMethodData} createTransportMethodData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTransportMethod(createTransportMethodData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTransportMethod(createTransportMethodData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTransportMethod(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTransportMethod(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTransportMethods(criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTransportMethods(criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {UpdateTransportMethodData} updateTransportMethodData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTransportMethod(id, updateTransportMethodData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTransportMethod(id, updateTransportMethodData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * TransportMethodsApi - factory interface
 * @export
 */
export const TransportMethodsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = TransportMethodsApiFp(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveTransportMethod(id, options) {
            return localVarFp.archiveTransportMethod(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CreateTransportMethodData} createTransportMethodData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTransportMethod(createTransportMethodData, options) {
            return localVarFp.createTransportMethod(createTransportMethodData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransportMethod(id, options) {
            return localVarFp.getTransportMethod(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransportMethods(criteria, page, size, sort, options) {
            return localVarFp.getTransportMethods(criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {UpdateTransportMethodData} updateTransportMethodData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTransportMethod(id, updateTransportMethodData, options) {
            return localVarFp.updateTransportMethod(id, updateTransportMethodData, options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof TransportMethodsApi
*/
export function archiveTransportMethod(id, options) {
    return TransportMethodsApiFp().archiveTransportMethod(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {CreateTransportMethodData} createTransportMethodData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof TransportMethodsApi
*/
export function createTransportMethod(createTransportMethodData, options) {
    return TransportMethodsApiFp().createTransportMethod(createTransportMethodData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof TransportMethodsApi
*/
export function getTransportMethod(id, options) {
    return TransportMethodsApiFp().getTransportMethod(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof TransportMethodsApi
*/
export function getTransportMethods(criteria, page, size, sort, options) {
    return TransportMethodsApiFp().getTransportMethods(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {UpdateTransportMethodData} updateTransportMethodData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof TransportMethodsApi
*/
export function updateTransportMethod(id, updateTransportMethodData, options) {
    return TransportMethodsApiFp().updateTransportMethod(id, updateTransportMethodData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof TransportMethodsApi
*/
export function archiveTransportMethodRaw(id, options) {
    return TransportMethodsApiFp().archiveTransportMethod(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {CreateTransportMethodData} createTransportMethodData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof TransportMethodsApi
*/
export function createTransportMethodRaw(createTransportMethodData, options) {
    return TransportMethodsApiFp().createTransportMethod(createTransportMethodData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof TransportMethodsApi
*/
export function getTransportMethodRaw(id, options) {
    return TransportMethodsApiFp().getTransportMethod(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof TransportMethodsApi
*/
export function getTransportMethodsRaw(criteria, page, size, sort, options) {
    return TransportMethodsApiFp().getTransportMethods(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {UpdateTransportMethodData} updateTransportMethodData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof TransportMethodsApi
*/
export function updateTransportMethodRaw(id, updateTransportMethodData, options) {
    return TransportMethodsApiFp().updateTransportMethod(id, updateTransportMethodData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * UserNotificationsApi - axios parameter creator
 * @export
 */
export const UserNotificationsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotifications: async (options = {}) => {
            const localVarPath = `/api/notifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markAllNotificationsAsRead: async (options = {}) => {
            const localVarPath = `/api/notifications/read-all-notifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markNotificationAsRead: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('markNotificationAsRead', 'id', id);
            const localVarPath = `/api/notifications/{id}/mark-as-read`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markNotificationAsUnread: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('markNotificationAsUnread', 'id', id);
            const localVarPath = `/api/notifications/{id}/mark-as-unread`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {CreateNotificationData} createNotificationData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notifyActiveUser: async (createNotificationData, options = {}) => {
            // verify required parameter 'createNotificationData' is not null or undefined
            assertParamExists('notifyActiveUser', 'createNotificationData', createNotificationData);
            const localVarPath = `/api/notifications/notify-active-user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createNotificationData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} userId
         * @param {CreateNotificationData} createNotificationData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notifyUser: async (userId, createNotificationData, options = {}) => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('notifyUser', 'userId', userId);
            // verify required parameter 'createNotificationData' is not null or undefined
            assertParamExists('notifyUser', 'createNotificationData', createNotificationData);
            const localVarPath = `/api/notifications/notify-user/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createNotificationData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * UserNotificationsApi - functional programming interface
 * @export
 */
export const UserNotificationsApiFp = function (configuration) {
    const localVarAxiosParamCreator = UserNotificationsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNotifications(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNotifications(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markAllNotificationsAsRead(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markAllNotificationsAsRead(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markNotificationAsRead(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markNotificationAsRead(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markNotificationAsUnread(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markNotificationAsUnread(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {CreateNotificationData} createNotificationData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notifyActiveUser(createNotificationData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notifyActiveUser(createNotificationData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} userId
         * @param {CreateNotificationData} createNotificationData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notifyUser(userId, createNotificationData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notifyUser(userId, createNotificationData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * UserNotificationsApi - factory interface
 * @export
 */
export const UserNotificationsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = UserNotificationsApiFp(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotifications(options) {
            return localVarFp.getNotifications(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markAllNotificationsAsRead(options) {
            return localVarFp.markAllNotificationsAsRead(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markNotificationAsRead(id, options) {
            return localVarFp.markNotificationAsRead(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markNotificationAsUnread(id, options) {
            return localVarFp.markNotificationAsUnread(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CreateNotificationData} createNotificationData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notifyActiveUser(createNotificationData, options) {
            return localVarFp.notifyActiveUser(createNotificationData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} userId
         * @param {CreateNotificationData} createNotificationData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notifyUser(userId, createNotificationData, options) {
            return localVarFp.notifyUser(userId, createNotificationData, options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof UserNotificationsApi
*/
export function getNotifications(options) {
    return UserNotificationsApiFp().getNotifications(options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof UserNotificationsApi
*/
export function markAllNotificationsAsRead(options) {
    return UserNotificationsApiFp().markAllNotificationsAsRead(options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof UserNotificationsApi
*/
export function markNotificationAsRead(id, options) {
    return UserNotificationsApiFp().markNotificationAsRead(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof UserNotificationsApi
*/
export function markNotificationAsUnread(id, options) {
    return UserNotificationsApiFp().markNotificationAsUnread(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {CreateNotificationData} createNotificationData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof UserNotificationsApi
*/
export function notifyActiveUser(createNotificationData, options) {
    return UserNotificationsApiFp().notifyActiveUser(createNotificationData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} userId
        * @param {CreateNotificationData} createNotificationData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof UserNotificationsApi
*/
export function notifyUser(userId, createNotificationData, options) {
    return UserNotificationsApiFp().notifyUser(userId, createNotificationData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof UserNotificationsApi
*/
export function getNotificationsRaw(options) {
    return UserNotificationsApiFp().getNotifications(options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof UserNotificationsApi
*/
export function markAllNotificationsAsReadRaw(options) {
    return UserNotificationsApiFp().markAllNotificationsAsRead(options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof UserNotificationsApi
*/
export function markNotificationAsReadRaw(id, options) {
    return UserNotificationsApiFp().markNotificationAsRead(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof UserNotificationsApi
*/
export function markNotificationAsUnreadRaw(id, options) {
    return UserNotificationsApiFp().markNotificationAsUnread(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {CreateNotificationData} createNotificationData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof UserNotificationsApi
*/
export function notifyActiveUserRaw(createNotificationData, options) {
    return UserNotificationsApiFp().notifyActiveUser(createNotificationData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} userId
        * @param {CreateNotificationData} createNotificationData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof UserNotificationsApi
*/
export function notifyUserRaw(userId, createNotificationData, options) {
    return UserNotificationsApiFp().notifyUser(userId, createNotificationData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * UsersApi - axios parameter creator
 * @export
 */
export const UsersApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveUser: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('archiveUser', 'id', id);
            const localVarPath = `/api/users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {CreateUserData} createUserData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser: async (createUserData, options = {}) => {
            // verify required parameter 'createUserData' is not null or undefined
            assertParamExists('createUser', 'createUserData', createUserData);
            const localVarPath = `/api/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createUserData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUser: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getUser', 'id', id);
            const localVarPath = `/api/users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsers: async (criteria, page, size, sort, options = {}) => {
            const localVarPath = `/api/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {UpdateUserData} updateUserData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser: async (id, updateUserData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateUser', 'id', id);
            // verify required parameter 'updateUserData' is not null or undefined
            assertParamExists('updateUser', 'updateUserData', updateUserData);
            const localVarPath = `/api/users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {Dashboard} dashboard
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserDashboardData: async (id, dashboard, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateUserDashboardData', 'id', id);
            // verify required parameter 'dashboard' is not null or undefined
            assertParamExists('updateUserDashboardData', 'dashboard', dashboard);
            const localVarPath = `/api/users/{id}/update-dashboard`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(dashboard, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * UsersApi - functional programming interface
 * @export
 */
export const UsersApiFp = function (configuration) {
    const localVarAxiosParamCreator = UsersApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async archiveUser(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.archiveUser(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {CreateUserData} createUserData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createUser(createUserData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createUser(createUserData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUser(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUser(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsers(criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsers(criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {UpdateUserData} updateUserData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUser(id, updateUserData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUser(id, updateUserData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {Dashboard} dashboard
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserDashboardData(id, dashboard, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserDashboardData(id, dashboard, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * UsersApi - factory interface
 * @export
 */
export const UsersApiFactory = function (configuration, basePath, axios) {
    const localVarFp = UsersApiFp(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveUser(id, options) {
            return localVarFp.archiveUser(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CreateUserData} createUserData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser(createUserData, options) {
            return localVarFp.createUser(createUserData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUser(id, options) {
            return localVarFp.getUser(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsers(criteria, page, size, sort, options) {
            return localVarFp.getUsers(criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {UpdateUserData} updateUserData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser(id, updateUserData, options) {
            return localVarFp.updateUser(id, updateUserData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {Dashboard} dashboard
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserDashboardData(id, dashboard, options) {
            return localVarFp.updateUserDashboardData(id, dashboard, options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof UsersApi
*/
export function archiveUser(id, options) {
    return UsersApiFp().archiveUser(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {CreateUserData} createUserData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof UsersApi
*/
export function createUser(createUserData, options) {
    return UsersApiFp().createUser(createUserData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof UsersApi
*/
export function getUser(id, options) {
    return UsersApiFp().getUser(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof UsersApi
*/
export function getUsers(criteria, page, size, sort, options) {
    return UsersApiFp().getUsers(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {UpdateUserData} updateUserData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof UsersApi
*/
export function updateUser(id, updateUserData, options) {
    return UsersApiFp().updateUser(id, updateUserData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {Dashboard} dashboard
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof UsersApi
*/
export function updateUserDashboardData(id, dashboard, options) {
    return UsersApiFp().updateUserDashboardData(id, dashboard, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof UsersApi
*/
export function archiveUserRaw(id, options) {
    return UsersApiFp().archiveUser(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {CreateUserData} createUserData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof UsersApi
*/
export function createUserRaw(createUserData, options) {
    return UsersApiFp().createUser(createUserData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof UsersApi
*/
export function getUserRaw(id, options) {
    return UsersApiFp().getUser(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof UsersApi
*/
export function getUsersRaw(criteria, page, size, sort, options) {
    return UsersApiFp().getUsers(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {UpdateUserData} updateUserData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof UsersApi
*/
export function updateUserRaw(id, updateUserData, options) {
    return UsersApiFp().updateUser(id, updateUserData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {Dashboard} dashboard
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof UsersApi
*/
export function updateUserDashboardDataRaw(id, dashboard, options) {
    return UsersApiFp().updateUserDashboardData(id, dashboard, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * VatRatesApi - axios parameter creator
 * @export
 */
export const VatRatesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveVatRate: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('archiveVatRate', 'id', id);
            const localVarPath = `/api/vat-rates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {CreateVatRateData} createVatRateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVatRate: async (createVatRateData, options = {}) => {
            // verify required parameter 'createVatRateData' is not null or undefined
            assertParamExists('createVatRate', 'createVatRateData', createVatRateData);
            const localVarPath = `/api/vat-rates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createVatRateData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVatRate: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getVatRate', 'id', id);
            const localVarPath = `/api/vat-rates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} relationId
         * @param {string} productId
         * @param {'PURCHASE' | 'SALES' | 'PRODUCTION'} useType
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVatRateForRelationAndProduct: async (relationId, productId, useType, criteria, page, size, sort, options = {}) => {
            // verify required parameter 'relationId' is not null or undefined
            assertParamExists('getVatRateForRelationAndProduct', 'relationId', relationId);
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('getVatRateForRelationAndProduct', 'productId', productId);
            // verify required parameter 'useType' is not null or undefined
            assertParamExists('getVatRateForRelationAndProduct', 'useType', useType);
            const localVarPath = `/api/vat-rates/relation/{relationId}/product/{productId}/use-type/{useType}`
                .replace(`{${"relationId"}}`, encodeURIComponent(String(relationId)))
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)))
                .replace(`{${"useType"}}`, encodeURIComponent(String(useType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVatRates: async (criteria, page, size, sort, options = {}) => {
            const localVarPath = `/api/vat-rates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {UpdateVatRateData} updateVatRateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVatRate: async (id, updateVatRateData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateVatRate', 'id', id);
            // verify required parameter 'updateVatRateData' is not null or undefined
            assertParamExists('updateVatRate', 'updateVatRateData', updateVatRateData);
            const localVarPath = `/api/vat-rates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(updateVatRateData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * VatRatesApi - functional programming interface
 * @export
 */
export const VatRatesApiFp = function (configuration) {
    const localVarAxiosParamCreator = VatRatesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async archiveVatRate(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.archiveVatRate(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {CreateVatRateData} createVatRateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createVatRate(createVatRateData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createVatRate(createVatRateData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVatRate(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVatRate(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} relationId
         * @param {string} productId
         * @param {'PURCHASE' | 'SALES' | 'PRODUCTION'} useType
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVatRateForRelationAndProduct(relationId, productId, useType, criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVatRateForRelationAndProduct(relationId, productId, useType, criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVatRates(criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVatRates(criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {UpdateVatRateData} updateVatRateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateVatRate(id, updateVatRateData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateVatRate(id, updateVatRateData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * VatRatesApi - factory interface
 * @export
 */
export const VatRatesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = VatRatesApiFp(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveVatRate(id, options) {
            return localVarFp.archiveVatRate(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CreateVatRateData} createVatRateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVatRate(createVatRateData, options) {
            return localVarFp.createVatRate(createVatRateData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVatRate(id, options) {
            return localVarFp.getVatRate(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} relationId
         * @param {string} productId
         * @param {'PURCHASE' | 'SALES' | 'PRODUCTION'} useType
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVatRateForRelationAndProduct(relationId, productId, useType, criteria, page, size, sort, options) {
            return localVarFp.getVatRateForRelationAndProduct(relationId, productId, useType, criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVatRates(criteria, page, size, sort, options) {
            return localVarFp.getVatRates(criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {UpdateVatRateData} updateVatRateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVatRate(id, updateVatRateData, options) {
            return localVarFp.updateVatRate(id, updateVatRateData, options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof VatRatesApi
*/
export function archiveVatRate(id, options) {
    return VatRatesApiFp().archiveVatRate(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {CreateVatRateData} createVatRateData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof VatRatesApi
*/
export function createVatRate(createVatRateData, options) {
    return VatRatesApiFp().createVatRate(createVatRateData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof VatRatesApi
*/
export function getVatRate(id, options) {
    return VatRatesApiFp().getVatRate(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} relationId
        * @param {string} productId
        * @param {'PURCHASE' | 'SALES' | 'PRODUCTION'} useType
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof VatRatesApi
*/
export function getVatRateForRelationAndProduct(relationId, productId, useType, criteria, page, size, sort, options) {
    return VatRatesApiFp().getVatRateForRelationAndProduct(relationId, productId, useType, criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof VatRatesApi
*/
export function getVatRates(criteria, page, size, sort, options) {
    return VatRatesApiFp().getVatRates(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {UpdateVatRateData} updateVatRateData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof VatRatesApi
*/
export function updateVatRate(id, updateVatRateData, options) {
    return VatRatesApiFp().updateVatRate(id, updateVatRateData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof VatRatesApi
*/
export function archiveVatRateRaw(id, options) {
    return VatRatesApiFp().archiveVatRate(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {CreateVatRateData} createVatRateData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof VatRatesApi
*/
export function createVatRateRaw(createVatRateData, options) {
    return VatRatesApiFp().createVatRate(createVatRateData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof VatRatesApi
*/
export function getVatRateRaw(id, options) {
    return VatRatesApiFp().getVatRate(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} relationId
        * @param {string} productId
        * @param {'PURCHASE' | 'SALES' | 'PRODUCTION'} useType
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof VatRatesApi
*/
export function getVatRateForRelationAndProductRaw(relationId, productId, useType, criteria, page, size, sort, options) {
    return VatRatesApiFp().getVatRateForRelationAndProduct(relationId, productId, useType, criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof VatRatesApi
*/
export function getVatRatesRaw(criteria, page, size, sort, options) {
    return VatRatesApiFp().getVatRates(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {UpdateVatRateData} updateVatRateData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof VatRatesApi
*/
export function updateVatRateRaw(id, updateVatRateData, options) {
    return VatRatesApiFp().updateVatRate(id, updateVatRateData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
// @ts-nocheck
/**
 * WarehousesApi - axios parameter creator
 * @export
 */
export const WarehousesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveWarehouse: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('archiveWarehouse', 'id', id);
            const localVarPath = `/api/warehouses/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {CreateWarehouseData} createWarehouseData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWarehouse: async (createWarehouseData, options = {}) => {
            // verify required parameter 'createWarehouseData' is not null or undefined
            assertParamExists('createWarehouse', 'createWarehouseData', createWarehouseData);
            const localVarPath = `/api/warehouses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createWarehouseData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWarehouse: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getWarehouse', 'id', id);
            const localVarPath = `/api/warehouses/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWarehouseByNumber: async (number, options = {}) => {
            // verify required parameter 'number' is not null or undefined
            assertParamExists('getWarehouseByNumber', 'number', number);
            const localVarPath = `/api/warehouses/number/{number}`
                .replace(`{${"number"}}`, encodeURIComponent(String(number)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWarehouses: async (criteria, page, size, sort, options = {}) => {
            const localVarPath = `/api/warehouses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (criteria !== undefined) {
                localVarQueryParameter['criteria'] = criteria;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {UpdateWarehouseData} updateWarehouseData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWarehouse: async (id, updateWarehouseData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateWarehouse', 'id', id);
            // verify required parameter 'updateWarehouseData' is not null or undefined
            assertParamExists('updateWarehouse', 'updateWarehouseData', updateWarehouseData);
            const localVarPath = `/api/warehouses/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session_token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Auth-Token", configuration);
            // authentication bearer_token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(updateWarehouseData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * WarehousesApi - functional programming interface
 * @export
 */
export const WarehousesApiFp = function (configuration) {
    const localVarAxiosParamCreator = WarehousesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async archiveWarehouse(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.archiveWarehouse(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {CreateWarehouseData} createWarehouseData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createWarehouse(createWarehouseData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createWarehouse(createWarehouseData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWarehouse(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWarehouse(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWarehouseByNumber(number, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWarehouseByNumber(number, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWarehouses(criteria, page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWarehouses(criteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {UpdateWarehouseData} updateWarehouseData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWarehouse(id, updateWarehouseData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateWarehouse(id, updateWarehouseData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * WarehousesApi - factory interface
 * @export
 */
export const WarehousesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = WarehousesApiFp(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveWarehouse(id, options) {
            return localVarFp.archiveWarehouse(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CreateWarehouseData} createWarehouseData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWarehouse(createWarehouseData, options) {
            return localVarFp.createWarehouse(createWarehouseData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWarehouse(id, options) {
            return localVarFp.getWarehouse(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWarehouseByNumber(number, options) {
            return localVarFp.getWarehouseByNumber(number, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [criteria]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWarehouses(criteria, page, size, sort, options) {
            return localVarFp.getWarehouses(criteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {UpdateWarehouseData} updateWarehouseData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWarehouse(id, updateWarehouseData, options) {
            return localVarFp.updateWarehouse(id, updateWarehouseData, options).then((request) => request(axios, basePath));
        },
    };
};
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof WarehousesApi
*/
export function archiveWarehouse(id, options) {
    return WarehousesApiFp().archiveWarehouse(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {CreateWarehouseData} createWarehouseData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof WarehousesApi
*/
export function createWarehouse(createWarehouseData, options) {
    return WarehousesApiFp().createWarehouse(createWarehouseData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof WarehousesApi
*/
export function getWarehouse(id, options) {
    return WarehousesApiFp().getWarehouse(id, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} number
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof WarehousesApi
*/
export function getWarehouseByNumber(number, options) {
    return WarehousesApiFp().getWarehouseByNumber(number, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof WarehousesApi
*/
export function getWarehouses(criteria, page, size, sort, options) {
    return WarehousesApiFp().getWarehouses(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
        * @param {UpdateWarehouseData} updateWarehouseData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof WarehousesApi
*/
export function updateWarehouse(id, updateWarehouseData, options) {
    return WarehousesApiFp().updateWarehouse(id, updateWarehouseData, options).then((request) => request(globalAxios, QFood.BASE_URL)).then(({ data }) => data);
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof WarehousesApi
*/
export function archiveWarehouseRaw(id, options) {
    return WarehousesApiFp().archiveWarehouse(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {CreateWarehouseData} createWarehouseData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof WarehousesApi
*/
export function createWarehouseRaw(createWarehouseData, options) {
    return WarehousesApiFp().createWarehouse(createWarehouseData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof WarehousesApi
*/
export function getWarehouseRaw(id, options) {
    return WarehousesApiFp().getWarehouse(id, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} number
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof WarehousesApi
*/
export function getWarehouseByNumberRaw(number, options) {
    return WarehousesApiFp().getWarehouseByNumber(number, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} [criteria]
        * @param {number} [page] Zero-based page index (0..N)
        * @param {number} [size] The size of the page to be returned
        * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof WarehousesApi
*/
export function getWarehousesRaw(criteria, page, size, sort, options) {
    return WarehousesApiFp().getWarehouses(criteria, page, size, sort, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
/**
*
        * @param {string} id
        * @param {UpdateWarehouseData} updateWarehouseData
* @param {*} [options] Override http request option.
* @throws {RequiredError}
* @memberof WarehousesApi
*/
export function updateWarehouseRaw(id, updateWarehouseData, options) {
    return WarehousesApiFp().updateWarehouse(id, updateWarehouseData, options).then((request) => request(globalAxios, QFood.BASE_URL));
}
